// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js!../../node_modules/normalize.css/normalize.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../node_modules/css-loader/dist/cjs.js!../../node_modules/react-toastify/dist/ReactToastify.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../../node_modules/css-loader/dist/cjs.js!../../node_modules/react-vis/dist/style.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("config/fonts/sourcesanspro_regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("config/fonts/sourcesanspro_regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("config/fonts/sourcesanspro_italic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("config/fonts/sourcesanspro_italic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("config/fonts/sourcesanspro_light.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("config/fonts/sourcesanspro_light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("config/fonts/sourcesanspro_light_italic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("config/fonts/sourcesanspro_light_italic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("config/fonts/sourcesanspro_semibold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("config/fonts/sourcesanspro_semibold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("config/fonts/sourcesanspro_semibold_italic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("config/fonts/sourcesanspro_semibold_italic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("config/fonts/sourcesanspro_bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("config/fonts/sourcesanspro_bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Source Sans Pro";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff'), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('ttf');
  font-weight: 400;
  font-style: normal;
}
@font-face {
  font-family: "Source Sans Pro";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('woff'), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('ttf');
  font-weight: 400;
  font-style: italic;
}
@font-face {
  font-family: "Source Sans Pro";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('woff'), url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('ttf');
  font-weight: 300;
  font-style: normal;
}
@font-face {
  font-family: "Source Sans Pro";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format('woff'), url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format('ttf');
  font-weight: 300;
  font-style: italic;
}
@font-face {
  font-family: "Source Sans Pro";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format('woff'), url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format('ttf');
  font-weight: 600;
  font-style: normal;
}
@font-face {
  font-family: "Source Sans Pro";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format('woff'), url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format('ttf');
  font-weight: 600;
  font-style: italic;
}
@font-face {
  font-family: "Source Sans Pro";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_12___}) format('woff'), url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format('ttf');
  font-weight: 800;
  font-style: normal;
}
/*

  Variables
  ---------

  Define variables.

*/
/*

  Media
  -----

  Define media queries.

*/
/*

  Base
  ----

  This file contains the site's base styles.
  It also contains styling for markup that's generated server side as it's too
  convoluted to add classes directly to it.

*/
* {
  box-sizing: border-box;
}
html,
body {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: hidden;
  max-height: 100vh;
  min-width: 320px;
}
@media screen and (max-width: 520px) {
  html,
  body {
    height: auto;
    max-height: none;
    overflow-y: auto;
  }
}
body {
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: subpixel-antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-family: "Source Sans Pro", "Arial", sans-serif;
  line-height: 1.5;
  font-size: 16px;
  color: #111111;
  background-color: #FFFFFF;
}
#app {
  position: relative;
  width: 100vw;
  min-height: 100vh;
  overflow-x: hidden;
}
.layout-width-constraint {
  padding-top: 0;
  padding-bottom: 0;
  margin-top: 0;
  margin-bottom: 0;
  margin-left: auto;
  margin-right: auto;
  max-width: 1200px;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
@media screen and (max-width: 768px) {
  .layout-width-constraint {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
}
@media screen and (max-width: 520px) {
  .layout-width-constraint {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }
}
button {
  border: none;
  outline: none;
}
td {
  -webkit-margin-before: 0;
  -webkit-margin-after: 0;
}
a {
  color: #00719F;
}
select {
  -moz-appearance: none;
  -webkit-appearance: none;
}
span.wj {
  font-size: 0 !important;
}
span.fc-em {
  font-style: italic;
}
.loading {
  animation: big-loader 2s infinite linear;
  width: 1em;
  height: 1em;
  border: 0.1em solid;
  border-right-color: transparent;
  border-radius: 50%;
  display: inline-block;
}
@-moz-keyframes big-loader {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes big-loader {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
@keyframes big-loader {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
/*

  Layout
  ------

  Utility classes for layout.

*/
.overflow-auto {
  overflow: auto;
}
.overflow-hidden {
  overflow: hidden;
}
.overflow-y-auto {
  overflow-y: auto;
}
.overflow-visible {
  overflow: visible;
}
.overflow-x-hidden {
  overflow: hidden;
}
.collapse {
  border-collapse: collapse;
  border-spacing: 0;
}
.db {
  display: block;
}
.dib {
  display: inline-block;
}
.di {
  display: inline;
}
.dn {
  display: none;
}
.flex {
  display: flex;
}
.inline-flex {
  display: inline-flex;
}
@media screen and (max-width: 768px) {
  .db-t {
    display: block;
  }
  .dib-t {
    display: inline-block;
  }
  .di-t {
    display: inline;
  }
  .dn-t {
    display: none;
  }
  .flex-t {
    display: flex;
  }
  .inline-flex-t {
    display: inline-flex;
  }
}
@media screen and (max-width: 520px) {
  .db-m {
    display: block;
  }
  .dib-m {
    display: inline-block;
  }
  .di-m {
    display: inline;
  }
  .dn-m {
    display: none;
  }
  .flex-m {
    display: flex;
  }
  .inline-flex-m {
    display: inline-flex;
  }
}
@media screen and (min-width: 769px) {
  .dn-d {
    display: none;
  }
  .db-d {
    display: block;
  }
}
@media screen and (min-width: 1200px) {
  .db-l {
    display: block;
  }
  .dn-l {
    display: none;
  }
  .flex-l {
    display: flex;
  }
}
.flex-column {
  flex-direction: column;
}
.flex-row {
  flex-direction: row;
}
.flex-column-reverse {
  flex-direction: column-reverse;
}
.flex-row-reverse {
  flex-direction: row-reverse;
}
@media screen and (max-width: 768px) {
  .flex-column-t {
    flex-direction: column;
  }
  .flex-row-t {
    flex-direction: row;
  }
  .flex-column-reverse-t {
    flex-direction: column-reverse;
  }
  .flex-row-reverse-t {
    flex-direction: row-reverse;
  }
}
@media screen and (max-width: 520px) {
  .flex-column-m {
    flex-direction: column;
  }
  .flex-row-m {
    flex-direction: row;
  }
  .flex-column-reverse-m {
    flex-direction: column-reverse;
  }
  .flex-row-reverse-m {
    flex-direction: row-reverse;
  }
}
.order-1 {
  order: 1;
}
.order-2 {
  order: 2;
}
.order-3 {
  order: 3;
}
.flex-wrap {
  flex-wrap: wrap;
}
.flex-nowrap {
  flex-wrap: nowrap;
}
.flex-wrap-reverse {
  flex-wrap: wrap-reverse;
}
@media screen and (max-width: 768px) {
  .flex-wrap-t {
    flex-wrap: wrap;
  }
}
@media screen and (max-width: 520px) {
  .flex-wrap-m {
    flex-wrap: wrap;
  }
}
.content-start {
  align-content: flex-start;
}
.content-end {
  align-content: flex-end;
}
.content-center {
  align-content: center;
}
.content-baseline {
  align-content: baseline;
}
.content-stretch {
  align-content: stretch;
}
.items-start {
  align-items: flex-start;
}
.items-end {
  align-items: flex-end;
}
.items-center {
  align-items: center;
}
.items-baseline {
  align-items: baseline;
}
.items-stretch {
  align-items: stretch;
}
@media screen and (max-width: 768px) {
  .items-start-t {
    align-items: flex-start;
  }
  .items-end-t {
    align-items: flex-end;
  }
  .items-center-t {
    align-items: center;
  }
  .items-baseline-t {
    align-items: baseline;
  }
  .items-stretch-t {
    align-items: stretch;
  }
}
@media screen and (max-width: 520px) {
  .items-start-m {
    align-items: flex-start;
  }
  .items-end-m {
    align-items: flex-end;
  }
  .items-center-m {
    align-items: center;
  }
  .items-baseline-m {
    align-items: baseline;
  }
  .items-stretch-m {
    align-items: stretch;
  }
}
.self-end {
  align-self: flex-end;
}
.self-start {
  align-self: flex-start;
}
@media screen and (max-width: 768px) {
  .self-end-t {
    align-self: flex-end;
  }
  .self-start-t {
    align-self: flex-start;
  }
}
.justify-start {
  justify-content: flex-start;
}
.justify-end {
  justify-content: flex-end;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.justify-around {
  justify-content: space-around;
}
.justify-evenly {
  justify-content: space-around;
  justify-content: space-evenly;
}
@media screen and (max-width: 768px) {
  .justify-start-t {
    justify-content: flex-start;
  }
  .justify-end-t {
    justify-content: flex-end;
  }
  .justify-center-t {
    justify-content: center;
  }
  .justify-between-t {
    justify-content: space-between;
  }
  .justify-evenly-t {
    justify-content: space-around;
    justify-content: space-evenly;
  }
}
@media screen and (max-width: 520px) {
  .justify-start-m {
    justify-content: flex-start;
  }
  .justify-end-m {
    justify-content: flex-end;
  }
  .justify-center-m {
    justify-content: center;
  }
  .justify-between-m {
    justify-content: space-between;
  }
  .justify-evenly-m {
    justify-content: space-around;
    justify-content: space-evenly;
  }
}
.valign-top {
  vertical-align: top;
}
.valign-text-top {
  vertical-align: text-top;
}
.valign-middle {
  vertical-align: middle;
}
.valign-bottom {
  vertical-align: bottom;
}
.valign-text-bottom {
  vertical-align: text-bottom;
}
.valign-super {
  vertical-align: super;
}
.valign-sub {
  vertical-align: sub;
}
.basis0 {
  flex-basis: 0;
}
.basis-auto {
  min-width: 0;
  min-height: 0;
  flex-basis: auto;
}
.basis-50 {
  flex-basis: 50%;
}
.basis-100 {
  flex-basis: 100%;
}
@media screen and (max-width: 768px) {
  .basis0-t {
    flex-basis: 0;
  }
  .basis-auto-t {
    min-width: 0;
    min-height: 0;
    flex-basis: auto;
  }
}
.grow-0 {
  flex-grow: 0;
}
.grow-1 {
  flex-grow: 1;
}
.grow-2 {
  flex-grow: 2;
}
.grow-3 {
  flex-grow: 3;
}
.grow-4 {
  flex-grow: 4;
}
.grow-5 {
  flex-grow: 5;
}
.grow-initial {
  flex-grow: initial;
}
@media screen and (max-width: 768px) {
  .grow-0-t {
    flex-grow: 0;
  }
  .grow-1-t {
    flex-grow: 1;
  }
  .grow-2-t {
    flex-grow: 2;
  }
  .grow-3-t {
    flex-grow: 3;
  }
  .grow-4-t {
    flex-grow: 4;
  }
  .grow-5-t {
    flex-grow: 5;
  }
  .grow-initial-t {
    flex-grow: initial;
  }
}
@media screen and (max-width: 520px) {
  .grow-0-m {
    flex-grow: 0;
  }
  .grow-1-m {
    flex-grow: 1;
  }
  .grow-2-m {
    flex-grow: 2;
  }
  .grow-3-m {
    flex-grow: 3;
  }
  .grow-4-m {
    flex-grow: 4;
  }
  .grow-5-m {
    flex-grow: 5;
  }
}
.shrink-0 {
  flex-shrink: 0;
}
.shrink-1 {
  flex-shrink: 1;
}
.shrink-2 {
  flex-shrink: 2;
}
@media screen and (max-width: 768px) {
  .shrink-0-t {
    flex-shrink: 0;
  }
  .shrink-1-t {
    flex-shrink: 1;
  }
}
@media screen and (max-width: 520px) {
  .shrink-0-m {
    flex-shrink: 0;
  }
  .shrink-1-m {
    flex-shrink: 1;
  }
}
.flt-l {
  float: left;
}
.flt-n {
  float: none;
}
.flt-r {
  float: right;
}
.static {
  position: static;
}
.relative {
  position: relative;
}
.absolute {
  position: absolute;
}
.fixed {
  position: fixed;
}
.sticky {
  position: -webkit-sticky;
  position: sticky;
}
@media screen and (min-width: 1200px) {
  .sticky-l {
    position: -webkit-sticky;
    position: sticky;
  }
}
@media screen and (max-width: 768px) {
  .static-t {
    position: static;
  }
  .relative-t {
    position: relative;
  }
  .absolute-t {
    position: absolute;
  }
  .fixed-t {
    position: fixed;
  }
  .sticky-t {
    position: -webkit-sticky;
    position: sticky;
  }
}
@media screen and (max-width: 520px) {
  .static-m {
    position: static;
  }
  .relative-m {
    position: relative;
  }
  .absolute-m {
    position: absolute;
  }
  .fixed-m {
    position: fixed;
  }
  .sticky-m {
    position: -webkit-sticky;
    position: sticky;
  }
}
.z0 {
  z-index: 0;
}
.z5 {
  z-index: 5;
}
.z10 {
  z-index: 10;
}
.z15 {
  z-index: 15;
}
.z20 {
  z-index: 20;
}
.z25 {
  z-index: 25;
}
.z30 {
  z-index: 30;
}
.z35 {
  z-index: 35;
}
.z40 {
  z-index: 40;
}
.z45 {
  z-index: 45;
}
.z50 {
  z-index: 50;
}
.z55 {
  z-index: 55;
}
.z60 {
  z-index: 60;
}
.z105 {
  z-index: 105;
}
.z1055 {
  z-index: 1055;
}
.right0 {
  right: 0;
}
.right2 {
  right: 0.25rem;
}
.right3 {
  right: 0.375rem;
}
.right4 {
  right: 0.5rem;
}
.right5 {
  right: 0.75rem;
}
.right6 {
  right: 1rem;
}
.right7 {
  right: 1.5rem;
}
.right9 {
  right: 3rem;
}
.right-50 {
  right: 50%;
}
.right-100 {
  right: 100%;
}
.-right3 {
  right: -0.375rem;
}
.left0 {
  left: 0;
}
.left2 {
  left: 0.25rem;
}
.left4 {
  left: 0.5rem;
}
.left5 {
  left: 0.75rem;
}
.left6 {
  left: 1rem;
}
.left7 {
  left: 1.5rem;
}
.left8 {
  left: 2rem;
}
.left-50 {
  left: 50%;
}
.left-100 {
  left: 100%;
}
.-left5 {
  left: -0.75rem;
}
.top0 {
  top: 0;
}
.top1 {
  top: 0.125rem;
}
.top2 {
  top: 0.25rem;
}
.top3 {
  top: 0.375rem;
}
.top4 {
  top: 0.5rem;
}
.top5 {
  top: 0.75rem;
}
.top6 {
  top: 1rem;
}
.top7 {
  top: 1.5rem;
}
.top8 {
  top: 2rem;
}
.top9 {
  top: 3rem;
}
.top10 {
  top: 4rem;
}
.top11 {
  top: 6rem;
}
.top12 {
  top: 8rem;
}
.top-15 {
  top: 15%;
}
.top-25 {
  top: 25%;
}
.top-50 {
  top: 50%;
}
.top-100 {
  top: 100%;
}
.-top9 {
  top: -3rem;
}
.-top10 {
  top: -4rem;
}
@media screen and (max-width: 768px) {
  .top4-t {
    top: 0.5rem;
  }
}
.bottom0 {
  bottom: 0;
}
.bottom1 {
  bottom: 0.125rem;
}
.bottom2 {
  bottom: 0.25rem;
}
.bottom3 {
  bottom: 0.375rem;
}
.bottom4 {
  bottom: 0.5rem;
}
.bottom5 {
  bottom: 0.75rem;
}
.bottom6 {
  bottom: 1rem;
}
.bottom7 {
  bottom: 1.5rem;
}
.bottom-50 {
  bottom: 50%;
}
.bottom-100 {
  bottom: 100%;
}
.-bottom5 {
  bottom: -0.75rem;
}
.w0 {
  width: 0;
}
.w1 {
  width: 0.125rem;
}
.w2 {
  width: 0.25rem;
}
.w3 {
  width: 0.375rem;
}
.w4 {
  width: 0.5rem;
}
.w5 {
  width: 0.75rem;
}
.w6 {
  width: 1rem;
}
.w7 {
  width: 1.5rem;
}
.w8 {
  width: 2rem;
}
.w9 {
  width: 3rem;
}
.w10 {
  width: 4rem;
}
.w11 {
  width: 6rem;
}
.w12 {
  width: 8rem;
}
.w13 {
  width: 12rem;
}
.w14 {
  width: 16rem;
}
.w15 {
  width: 32rem;
}
.w16 {
  width: 48rem;
}
.w17 {
  width: 64rem;
}
.w18 {
  width: 96rem;
}
.w-10 {
  width: 10%;
}
.w-20 {
  width: 20%;
}
.w-25 {
  width: 25%;
}
.w-30 {
  width: 30%;
}
.w-33 {
  width: 33%;
}
.w-34 {
  width: 34%;
}
.w-40 {
  width: 40%;
}
.w-50 {
  width: 50%;
}
.w-55 {
  width: 55%;
}
.w-60 {
  width: 60%;
}
.w-65 {
  width: 65%;
}
.w-70 {
  width: 70%;
}
.w-75 {
  width: 75%;
}
.w-80 {
  width: 80%;
}
.w-90 {
  width: 90%;
}
.w-95 {
  width: 95%;
}
.w-100 {
  width: 100%;
}
.w-third {
  width: calc(100% / 3);
}
.w-two-thirds {
  width: calc(100% / 1.5);
}
.w-auto {
  width: auto;
}
.w-max-content {
  width: max-content;
}
.vw-90 {
  width: 90vw;
}
.vw-100 {
  width: 100vw;
}
@media screen and (max-width: 768px) {
  .w13-t {
    width: 12rem;
  }
  .w-100-t {
    width: 100%;
  }
  .w8-t {
    width: 2rem;
  }
  .w-95-t {
    width: 95%;
  }
  .w-100-t {
    width: 100%;
  }
  .vw-100-t {
    width: 100vw;
  }
}
@media screen and (max-width: 520px) {
  .w5-m {
    width: 0.75rem;
  }
  .w6-m {
    width: 1rem;
  }
  .w7-m {
    width: 1.5rem;
  }
  .w8-m {
    width: 2rem;
  }
  .w10-m {
    width: 4rem;
  }
  .w-100-m {
    width: 100%;
  }
  .w-auto-m {
    width: auto;
  }
  .vw-100-m {
    width: 100vw;
  }
}
@media screen and (min-width: 1200px) {
  .w16-l {
    width: 48rem;
  }
  .w-50-l {
    width: 50%;
  }
}
.max-w0 {
  max-width: 0;
}
.max-w1 {
  max-width: 0.125rem;
}
.max-w2 {
  max-width: 0.25rem;
}
.max-w3 {
  max-width: 0.375rem;
}
.max-w4 {
  max-width: 0.5rem;
}
.max-w5 {
  max-width: 0.75rem;
}
.max-w6 {
  max-width: 1rem;
}
.max-w7 {
  max-width: 1.5rem;
}
.max-w8 {
  max-width: 2rem;
}
.max-w9 {
  max-width: 3rem;
}
.max-w10 {
  max-width: 4rem;
}
.max-w11 {
  max-width: 6rem;
}
.max-w12 {
  max-width: 8rem;
}
.max-w13 {
  max-width: 12rem;
}
.max-w14 {
  max-width: 16rem;
}
.max-w15 {
  max-width: 32rem;
}
.max-w16 {
  max-width: 48rem;
}
.max-w17 {
  max-width: 64rem;
}
.max-w18 {
  max-width: 96rem;
}
.max-w-90 {
  max-width: 90%;
}
.max-w-94 {
  max-width: 94%;
}
.max-w-100 {
  max-width: 100%;
}
.max-w-100vw {
  max-width: 100vw;
}
.max-w-none {
  max-width: none;
}
.max-w-inherit {
  max-width: inherit;
}
@media screen and (max-width: 768px) {
  .max-w-none-t {
    max-width: none;
  }
}
.min-w0 {
  min-width: 0;
}
.min-w1 {
  min-width: 0.125rem;
}
.min-w2 {
  min-width: 0.25rem;
}
.min-w3 {
  min-width: 0.375rem;
}
.min-w4 {
  min-width: 0.5rem;
}
.min-w5 {
  min-width: 0.75rem;
}
.min-w6 {
  min-width: 1rem;
}
.min-w7 {
  min-width: 1.5rem;
}
.min-w8 {
  min-width: 2rem;
}
.min-w9 {
  min-width: 3rem;
}
.min-w10 {
  min-width: 4rem;
}
.min-w11 {
  min-width: 6rem;
}
.min-w12 {
  min-width: 8rem;
}
.min-w13 {
  min-width: 12rem;
}
.min-w14 {
  min-width: 16rem;
}
.min-w15 {
  min-width: 32rem;
}
.min-w16 {
  min-width: 48rem;
}
.min-w17 {
  min-width: 64rem;
}
.min-w18 {
  min-width: 96rem;
}
.min-w-80 {
  min-width: 80%;
}
.min-w-100 {
  min-width: 100%;
}
.min-w-none {
  min-width: 0;
}
@media screen and (max-width: 520px) {
  .min-w9-m {
    min-width: 3rem;
  }
}
.h0 {
  height: 0;
}
.h1 {
  height: 1rem;
}
.h2 {
  height: 2rem;
}
.h3 {
  height: 3rem;
}
.h4 {
  height: 4rem;
}
.h5 {
  height: 5rem;
}
.h6 {
  height: 6rem;
}
.h7 {
  height: 7rem;
}
.h8 {
  height: 8rem;
}
.h12 {
  height: 12rem;
}
.h-25 {
  height: 25%;
}
.h-50 {
  height: 50%;
}
.h-75 {
  height: 75%;
}
.h-100 {
  height: 100%;
}
.vh-25 {
  height: 25vh;
}
.vh-50 {
  height: 50vh;
}
.vh-75 {
  height: 75vh;
}
.vh-100 {
  height: 100vh;
}
.h-auto {
  height: auto;
}
.h-inherit {
  height: inherit;
}
@media screen and (max-width: 520px) {
  .h1-m {
    height: 1rem;
  }
  .h2-m {
    height: 2rem;
  }
  .h3-m {
    height: 3rem;
  }
  .h4-m {
    height: 4rem;
  }
  .h5-m {
    height: 5rem;
  }
  .h6-m {
    height: 6rem;
  }
}
.min-h-0 {
  min-height: 0;
}
.min-h2 {
  min-height: 2rem;
}
.min-h3 {
  min-height: 3rem;
}
.min-h4 {
  min-height: 4rem;
}
.min-h8 {
  min-height: 8rem;
}
.min-h12 {
  min-height: 12rem;
}
.min-h-spacing-9 {
  min-height: 3rem;
}
.min-h-spacing-14 {
  min-height: 16rem;
}
.min-h-spacing-15 {
  min-height: 32rem;
}
.min-h-100 {
  min-height: 100%;
}
.min-vh-100 {
  min-height: 100vh;
}
.min-h-inherit {
  min-height: inherit;
}
.max-h7 {
  max-height: 7rem;
}
.max-h8 {
  max-height: 2rem;
}
.max-h-75 {
  max-height: 75%;
}
@media screen and (max-width: 768px) {
  .max-h8-t {
    max-height: 2rem;
  }
}
/*

  Spacing
  -------

  Utility classes for margins and paddings.

*/
.pa0 {
  padding: 0;
}
.pa1 {
  padding: 0.125rem;
}
.pa2 {
  padding: 0.25rem;
}
.pa3 {
  padding: 0.375rem;
}
.pa4 {
  padding: 0.5rem;
}
.pa5 {
  padding: 0.75rem;
}
.pa6 {
  padding: 1rem;
}
.pa7 {
  padding: 1.5rem;
}
.pa8 {
  padding: 2rem;
}
.pa9 {
  padding: 3rem;
}
.pa10 {
  padding: 4rem;
}
.pa11 {
  padding: 6rem;
}
.pa12 {
  padding: 8rem;
}
.pa13 {
  padding: 12rem;
}
.pa14 {
  padding: 16rem;
}
@media screen and (max-width: 768px) {
  .pa0-t {
    padding: 0;
  }
  .pa1-t {
    padding: 0.125rem;
  }
  .pa2-t {
    padding: 0.25rem;
  }
  .pa3-t {
    padding: 0.375rem;
  }
  .pa4-t {
    padding: 0.5rem;
  }
  .pa5-t {
    padding: 0.75rem;
  }
  .pa6-t {
    padding: 1rem;
  }
  .pa7-t {
    padding: 1.5rem;
  }
  .pa8-t {
    padding: 2rem;
  }
  .pa9-t {
    padding: 3rem;
  }
  .pa11-t {
    padding: 4rem;
  }
  .pa10-t {
    padding: 6rem;
  }
  .pa12-t {
    padding: 8rem;
  }
  .pa13-t {
    padding: 12rem;
  }
  .pa14-t {
    padding: 16rem;
  }
}
@media screen and (max-width: 520px) {
  .pa0-m {
    padding: 0;
  }
  .pa1-m {
    padding: 0.125rem;
  }
  .pa2-m {
    padding: 0.25rem;
  }
  .pa3-m {
    padding: 0.375rem;
  }
  .pa4-m {
    padding: 0.5rem;
  }
  .pa5-m {
    padding: 0.75rem;
  }
  .pa6-m {
    padding: 1rem;
  }
  .pa7-m {
    padding: 1.5rem;
  }
  .pa8-m {
    padding: 2rem;
  }
  .pa9-m {
    padding: 3rem;
  }
  .pa11-m {
    padding: 4rem;
  }
  .pa10-m {
    padding: 6rem;
  }
  .pa12-m {
    padding: 8rem;
  }
  .pa13-m {
    padding: 12rem;
  }
  .pa14-m {
    padding: 16rem;
  }
}
.pl0 {
  padding-left: 0;
}
.pl1 {
  padding-left: 0.125rem;
}
.pl2 {
  padding-left: 0.25rem;
}
.pl3 {
  padding-left: 0.375rem;
}
.pl4 {
  padding-left: 0.5rem;
}
.pl5 {
  padding-left: 0.75rem;
}
.pl6 {
  padding-left: 1rem;
}
.pl7 {
  padding-left: 1.5rem;
}
.pl8 {
  padding-left: 2rem;
}
.pl9 {
  padding-left: 3rem;
}
.pl10 {
  padding-left: 4rem;
}
.pl11 {
  padding-left: 6rem;
}
.pl12 {
  padding-left: 8rem;
}
.pl13 {
  padding-left: 12rem;
}
.pl14 {
  padding-left: 16rem;
}
@media screen and (max-width: 768px) {
  .pl0-t {
    padding-left: 0;
  }
  .pl1-t {
    padding-left: 0.125rem;
  }
  .pl2-t {
    padding-left: 0.25rem;
  }
  .pl3-t {
    padding-left: 0.375rem;
  }
  .pl4-t {
    padding-left: 0.5rem;
  }
  .pl5-t {
    padding-left: 0.75rem;
  }
  .pl6-t {
    padding-left: 1rem;
  }
  .pl7-t {
    padding-left: 1.5rem;
  }
  .pl8-t {
    padding-left: 2rem;
  }
  .pl9-t {
    padding-left: 3rem;
  }
  .pl11-t {
    padding-left: 4rem;
  }
  .pl10-t {
    padding-left: 6rem;
  }
  .pl12-t {
    padding-left: 8rem;
  }
  .pl13-t {
    padding-left: 12rem;
  }
  .pl14-t {
    padding-left: 16rem;
  }
}
@media screen and (max-width: 520px) {
  .pl0-m {
    padding-left: 0;
  }
  .pl1-m {
    padding-left: 0.125rem;
  }
  .pl2-m {
    padding-left: 0.25rem;
  }
  .pl3-m {
    padding-left: 0.375rem;
  }
  .pl4-m {
    padding-left: 0.5rem;
  }
  .pl5-m {
    padding-left: 0.75rem;
  }
  .pl6-m {
    padding-left: 1rem;
  }
  .pl7-m {
    padding-left: 1.5rem;
  }
  .pl8-m {
    padding-left: 2rem;
  }
  .pl9-m {
    padding-left: 3rem;
  }
  .pl11-m {
    padding-left: 4rem;
  }
  .pl10-m {
    padding-left: 6rem;
  }
  .pl12-m {
    padding-left: 8rem;
  }
  .pl13-m {
    padding-left: 12rem;
  }
  .pl14-m {
    padding-left: 16rem;
  }
}
@media screen and (min-width: 1200px) {
  .pl5-l {
    padding-left: 0.75rem;
  }
}
.pr0 {
  padding-right: 0;
}
.pr1 {
  padding-right: 0.125rem;
}
.pr2 {
  padding-right: 0.25rem;
}
.pr3 {
  padding-right: 0.375rem;
}
.pr4 {
  padding-right: 0.5rem;
}
.pr5 {
  padding-right: 0.75rem;
}
.pr6 {
  padding-right: 1rem;
}
.pr7 {
  padding-right: 1.5rem;
}
.pr8 {
  padding-right: 2rem;
}
.pr9 {
  padding-right: 3rem;
}
.pr10 {
  padding-right: 4rem;
}
.pr11 {
  padding-right: 6rem;
}
.pr12 {
  padding-right: 8rem;
}
.pr13 {
  padding-right: 12rem;
}
.pr14 {
  padding-right: 16rem;
}
@media screen and (max-width: 768px) {
  .pr0-t {
    padding-right: 0;
  }
  .pr1-t {
    padding-right: 0.125rem;
  }
  .pr2-t {
    padding-right: 0.25rem;
  }
  .pr3-t {
    padding-right: 0.375rem;
  }
  .pr4-t {
    padding-right: 0.5rem;
  }
  .pr5-t {
    padding-right: 0.75rem;
  }
  .pr6-t {
    padding-right: 1rem;
  }
  .pr7-t {
    padding-right: 1.5rem;
  }
  .pr8-t {
    padding-right: 2rem;
  }
  .pr9-t {
    padding-right: 3rem;
  }
  .pr11-t {
    padding-right: 4rem;
  }
  .pr10-t {
    padding-right: 6rem;
  }
  .pr12-t {
    padding-right: 8rem;
  }
  .pr13-t {
    padding-right: 12rem;
  }
  .pr14-t {
    padding-right: 16rem;
  }
}
@media screen and (max-width: 520px) {
  .pr0-m {
    padding-right: 0;
  }
  .pr1-m {
    padding-right: 0.125rem;
  }
  .pr2-m {
    padding-right: 0.25rem;
  }
  .pr3-m {
    padding-right: 0.375rem;
  }
  .pr4-m {
    padding-right: 0.5rem;
  }
  .pr5-m {
    padding-right: 0.75rem;
  }
  .pr6-m {
    padding-right: 1rem;
  }
  .pr7-m {
    padding-right: 1.5rem;
  }
  .pr8-m {
    padding-right: 2rem;
  }
  .pr9-m {
    padding-right: 3rem;
  }
  .pr11-m {
    padding-right: 4rem;
  }
  .pr10-m {
    padding-right: 6rem;
  }
  .pr12-m {
    padding-right: 8rem;
  }
  .pr13-m {
    padding-right: 12rem;
  }
  .pr14-m {
    padding-right: 16rem;
  }
}
@media screen and (min-width: 1200px) {
  .pr5-l {
    padding-right: 0.75rem;
  }
}
.pb0 {
  padding-bottom: 0;
}
.pb1 {
  padding-bottom: 0.125rem;
}
.pb2 {
  padding-bottom: 0.25rem;
}
.pb3 {
  padding-bottom: 0.375rem;
}
.pb4 {
  padding-bottom: 0.5rem;
}
.pb5 {
  padding-bottom: 0.75rem;
}
.pb6 {
  padding-bottom: 1rem;
}
.pb7 {
  padding-bottom: 1.5rem;
}
.pb8 {
  padding-bottom: 2rem;
}
.pb9 {
  padding-bottom: 3rem;
}
.pb10 {
  padding-bottom: 4rem;
}
.pb11 {
  padding-bottom: 6rem;
}
.pb12 {
  padding-bottom: 8rem;
}
.pb13 {
  padding-bottom: 12rem;
}
.pb14 {
  padding-bottom: 16rem;
}
.pb-80 {
  padding-bottom: 80%;
}
@media screen and (max-width: 768px) {
  .pb0-t {
    padding-bottom: 0;
  }
  .pb1-t {
    padding-bottom: 0.125rem;
  }
  .pb2-t {
    padding-bottom: 0.25rem;
  }
  .pb3-t {
    padding-bottom: 0.375rem;
  }
  .pb4-t {
    padding-bottom: 0.5rem;
  }
  .pb5-t {
    padding-bottom: 0.75rem;
  }
  .pb6-t {
    padding-bottom: 1rem;
  }
  .pb7-t {
    padding-bottom: 1.5rem;
  }
  .pb8-t {
    padding-bottom: 2rem;
  }
  .pb9-t {
    padding-bottom: 3rem;
  }
  .pb10-t {
    padding-bottom: 4rem;
  }
  .pb11-t {
    padding-bottom: 6rem;
  }
  .pb12-t {
    padding-bottom: 8rem;
  }
  .pb13-t {
    padding-bottom: 12rem;
  }
  .pb14-t {
    padding-bottom: 16rem;
  }
}
@media screen and (max-width: 520px) {
  .pb0-m {
    padding-bottom: 0;
  }
  .pb1-m {
    padding-bottom: 0.125rem;
  }
  .pb2-m {
    padding-bottom: 0.25rem;
  }
  .pb3-m {
    padding-bottom: 0.375rem;
  }
  .pb4-m {
    padding-bottom: 0.5rem;
  }
  .pb5-m {
    padding-bottom: 0.75rem;
  }
  .pb6-m {
    padding-bottom: 1rem;
  }
  .pb7-m {
    padding-bottom: 1.5rem;
  }
  .pb8-m {
    padding-bottom: 2rem;
  }
  .pb9-m {
    padding-bottom: 3rem;
  }
  .pb11-m {
    padding-bottom: 4rem;
  }
  .pb10-m {
    padding-bottom: 6rem;
  }
  .pb12-m {
    padding-bottom: 8rem;
  }
  .pb13-m {
    padding-bottom: 12rem;
  }
  .pb14-m {
    padding-bottom: 16rem;
  }
  .pb-80-m {
    padding-bottom: 80%;
  }
}
.pt0 {
  padding-top: 0;
}
.pt1 {
  padding-top: 0.125rem;
}
.pt2 {
  padding-top: 0.25rem;
}
.pt3 {
  padding-top: 0.375rem;
}
.pt4 {
  padding-top: 0.5rem;
}
.pt5 {
  padding-top: 0.75rem;
}
.pt6 {
  padding-top: 1rem;
}
.pt7 {
  padding-top: 1.5rem;
}
.pt8 {
  padding-top: 2rem;
}
.pt9 {
  padding-top: 3rem;
}
.pt10 {
  padding-top: 4rem;
}
.pt11 {
  padding-top: 6rem;
}
.pt12 {
  padding-top: 8rem;
}
.pt13 {
  padding-top: 12rem;
}
.pt14 {
  padding-top: 16rem;
}
@media screen and (max-width: 768px) {
  .pt0-t {
    padding-top: 0;
  }
  .pt1-t {
    padding-top: 0.125rem;
  }
  .pt2-t {
    padding-top: 0.25rem;
  }
  .pt3-t {
    padding-top: 0.375rem;
  }
  .pt4-t {
    padding-top: 0.5rem;
  }
  .pt5-t {
    padding-top: 0.75rem;
  }
  .pt6-t {
    padding-top: 1rem;
  }
  .pt7-t {
    padding-top: 1.5rem;
  }
  .pt8-t {
    padding-top: 2rem;
  }
  .pt9-t {
    padding-top: 3rem;
  }
  .pt11-t {
    padding-top: 4rem;
  }
  .pt10-t {
    padding-top: 6rem;
  }
  .pt12-t {
    padding-top: 8rem;
  }
  .pt13-t {
    padding-top: 12rem;
  }
  .pt14-t {
    padding-top: 16rem;
  }
}
@media screen and (max-width: 520px) {
  .pt0-m {
    padding-top: 0;
  }
  .pt1-m {
    padding-top: 0.125rem;
  }
  .pt2-m {
    padding-top: 0.25rem;
  }
  .pt3-m {
    padding-top: 0.375rem;
  }
  .pt4-m {
    padding-top: 0.5rem;
  }
  .pt5-m {
    padding-top: 0.75rem;
  }
  .pt6-m {
    padding-top: 1rem;
  }
  .pt7-m {
    padding-top: 1.5rem;
  }
  .pt8-m {
    padding-top: 2rem;
  }
  .pt9-m {
    padding-top: 3rem;
  }
  .pt11-m {
    padding-top: 4rem;
  }
  .pt10-m {
    padding-top: 6rem;
  }
  .pt12-m {
    padding-top: 8rem;
  }
  .pt13-m {
    padding-top: 12rem;
  }
  .pt14-m {
    padding-top: 16rem;
  }
}
.pv0 {
  padding-top: 0;
  padding-bottom: 0;
}
.pv1 {
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}
.pv2 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.pv3 {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.pv4 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.pv5 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.pv6 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.pv7 {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.pv8 {
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.pv9 {
  padding-top: 3rem;
  padding-bottom: 3rem;
}
.pv10 {
  padding-top: 4rem;
  padding-bottom: 4rem;
}
.pv11 {
  padding-top: 6rem;
  padding-bottom: 6rem;
}
.pv12 {
  padding-top: 8rem;
  padding-bottom: 8rem;
}
.pv13 {
  padding-top: 12rem;
  padding-bottom: 12rem;
}
.pv14 {
  padding-top: 16rem;
  padding-bottom: 16rem;
}
@media screen and (max-width: 768px) {
  .pv0-t {
    padding-top: 0;
    padding-bottom: 0;
  }
  .pv1-t {
    padding-top: 0.125rem;
    padding-bottom: 0.125rem;
  }
  .pv2-t {
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }
  .pv3-t {
    padding-top: 0.375rem;
    padding-bottom: 0.375rem;
  }
  .pv4-t {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }
  .pv5-t {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }
  .pv6-t {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }
  .pv7-t {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }
  .pv8-t {
    padding-top: 2rem;
    padding-bottom: 2rem;
  }
  .pv9-t {
    padding-top: 3rem;
    padding-bottom: 3rem;
  }
  .pv11-t {
    padding-top: 4rem;
    padding-bottom: 4rem;
  }
  .pv10-t {
    padding-top: 6rem;
    padding-bottom: 6rem;
  }
  .pv12-t {
    padding-top: 8rem;
    padding-bottom: 8rem;
  }
  .pv13-t {
    padding-top: 12rem;
    padding-bottom: 12rem;
  }
  .pv14-t {
    padding-top: 16rem;
    padding-bottom: 16rem;
  }
}
@media screen and (max-width: 520px) {
  .pv0-m {
    padding-top: 0;
    padding-bottom: 0;
  }
  .pv1-m {
    padding-top: 0.125rem;
    padding-bottom: 0.125rem;
  }
  .pv2-m {
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }
  .pv3-m {
    padding-top: 0.375rem;
    padding-bottom: 0.375rem;
  }
  .pv4-m {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }
  .pv5-m {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }
  .pv6-m {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }
  .pv7-m {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }
  .pv8-m {
    padding-top: 2rem;
    padding-bottom: 2rem;
  }
  .pv9-m {
    padding-top: 3rem;
    padding-bottom: 3rem;
  }
  .pv11-m {
    padding-top: 4rem;
    padding-bottom: 4rem;
  }
  .pv10-m {
    padding-top: 6rem;
    padding-bottom: 6rem;
  }
  .pv12-m {
    padding-top: 8rem;
    padding-bottom: 8rem;
  }
  .pv13-m {
    padding-top: 12rem;
    padding-bottom: 12rem;
  }
  .pv14-m {
    padding-top: 16rem;
    padding-bottom: 16rem;
  }
}
.ph0 {
  padding-left: 0;
  padding-right: 0;
}
.ph1 {
  padding-left: 0.125rem;
  padding-right: 0.125rem;
}
.ph2 {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.ph3 {
  padding-left: 0.375rem;
  padding-right: 0.375rem;
}
.ph4 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.ph5 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.ph6 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.ph7 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.ph8 {
  padding-left: 2rem;
  padding-right: 2rem;
}
.ph9 {
  padding-left: 3rem;
  padding-right: 3rem;
}
.ph10 {
  padding-left: 4rem;
  padding-right: 4rem;
}
.ph11 {
  padding-left: 6rem;
  padding-right: 6rem;
}
.ph12 {
  padding-left: 8rem;
  padding-right: 8rem;
}
.ph13 {
  padding-left: 12rem;
  padding-right: 12rem;
}
.ph14 {
  padding-left: 16rem;
  padding-right: 16rem;
}
@media screen and (max-width: 768px) {
  .ph0-t {
    padding-left: 0;
    padding-right: 0;
  }
  .ph1-t {
    padding-left: 0.125rem;
    padding-right: 0.125rem;
  }
  .ph2-t {
    padding-left: 0.25rem;
    padding-right: 0.25rem;
  }
  .ph3-t {
    padding-left: 0.375rem;
    padding-right: 0.375rem;
  }
  .ph4-t {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }
  .ph5-t {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }
  .ph6-t {
    padding-left: 1rem;
    padding-right: 1rem;
  }
  .ph7-t {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
  .ph8-t {
    padding-left: 2rem;
    padding-right: 2rem;
  }
  .ph9-t {
    padding-left: 3rem;
    padding-right: 3rem;
  }
  .ph11-t {
    padding-left: 4rem;
    padding-right: 4rem;
  }
  .ph10-t {
    padding-left: 6rem;
    padding-right: 6rem;
  }
  .ph12-t {
    padding-left: 8rem;
    padding-right: 8rem;
  }
  .ph13-t {
    padding-left: 12rem;
    padding-right: 12rem;
  }
  .ph14-t {
    padding-left: 16rem;
    padding-right: 16rem;
  }
}
@media screen and (max-width: 520px) {
  .ph0-m {
    padding-left: 0;
    padding-right: 0;
  }
  .ph1-m {
    padding-left: 0.125rem;
    padding-right: 0.125rem;
  }
  .ph2-m {
    padding-left: 0.25rem;
    padding-right: 0.25rem;
  }
  .ph3-m {
    padding-left: 0.375rem;
    padding-right: 0.375rem;
  }
  .ph4-m {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }
  .ph5-m {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }
  .ph6-m {
    padding-left: 1rem;
    padding-right: 1rem;
  }
  .ph7-m {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
  .ph8-m {
    padding-left: 2rem;
    padding-right: 2rem;
  }
  .ph9-m {
    padding-left: 3rem;
    padding-right: 3rem;
  }
  .ph11-m {
    padding-left: 4rem;
    padding-right: 4rem;
  }
  .ph10-m {
    padding-left: 6rem;
    padding-right: 6rem;
  }
  .ph12-m {
    padding-left: 8rem;
    padding-right: 8rem;
  }
  .ph13-m {
    padding-left: 12rem;
    padding-right: 12rem;
  }
  .ph14-m {
    padding-left: 16rem;
    padding-right: 16rem;
  }
}
.ma0 {
  margin: 0;
}
.ma1 {
  margin: 0.125rem;
}
.ma2 {
  margin: 0.25rem;
}
.ma3 {
  margin: 0.375rem;
}
.ma4 {
  margin: 0.5rem;
}
.ma5 {
  margin: 0.75rem;
}
.ma6 {
  margin: 1rem;
}
.ma7 {
  margin: 1.5rem;
}
.ma8 {
  margin: 2rem;
}
.ma9 {
  margin: 3rem;
}
.ma10 {
  margin: 4rem;
}
.ma11 {
  margin: 6rem;
}
.ma12 {
  margin: 8rem;
}
.ma13 {
  margin: 12rem;
}
.ma14 {
  margin: 16rem;
}
.maauto {
  margin: auto;
}
@media screen and (max-width: 768px) {
  .ma0-t {
    margin: 0;
  }
  .ma1-t {
    margin: 0.125rem;
  }
  .ma2-t {
    margin: 0.25rem;
  }
  .ma3-t {
    margin: 0.375rem;
  }
  .ma4-t {
    margin: 0.5rem;
  }
  .ma5-t {
    margin: 0.75rem;
  }
  .ma6-t {
    margin: 1rem;
  }
  .ma7-t {
    margin: 1.5rem;
  }
  .ma8-t {
    margin: 2rem;
  }
  .ma9-t {
    margin: 3rem;
  }
  .ma11-t {
    margin: 4rem;
  }
  .ma10-t {
    margin: 6rem;
  }
  .ma12-t {
    margin: 8rem;
  }
  .ma13-t {
    margin: 12rem;
  }
  .ma14-t {
    margin: 16rem;
  }
  .maauto-t {
    margin: auto;
  }
}
@media screen and (max-width: 520px) {
  .ma0-m {
    margin: 0;
  }
  .ma1-m {
    margin: 0.125rem;
  }
  .ma2-m {
    margin: 0.25rem;
  }
  .ma3-m {
    margin: 0.375rem;
  }
  .ma4-m {
    margin: 0.5rem;
  }
  .ma5-m {
    margin: 0.75rem;
  }
  .ma6-m {
    margin: 1rem;
  }
  .ma7-m {
    margin: 1.5rem;
  }
  .ma8-m {
    margin: 2rem;
  }
  .ma9-m {
    margin: 3rem;
  }
  .ma11-m {
    margin: 4rem;
  }
  .ma10-m {
    margin: 6rem;
  }
  .ma12-m {
    margin: 8rem;
  }
  .ma13-m {
    margin: 12rem;
  }
  .ma14-m {
    margin: 16rem;
  }
  .maauto-m {
    margin: auto;
  }
}
.ml0 {
  margin-left: 0;
}
.ml1 {
  margin-left: 0.125rem;
}
.ml2 {
  margin-left: 0.25rem;
}
.ml3 {
  margin-left: 0.375rem;
}
.ml4 {
  margin-left: 0.5rem;
}
.ml5 {
  margin-left: 0.75rem;
}
.ml6 {
  margin-left: 1rem;
}
.ml7 {
  margin-left: 1.5rem;
}
.ml8 {
  margin-left: 2rem;
}
.ml9 {
  margin-left: 3rem;
}
.ml10 {
  margin-left: 4rem;
}
.ml11 {
  margin-left: 6rem;
}
.ml12 {
  margin-left: 8rem;
}
.ml13 {
  margin-left: 12rem;
}
.ml14 {
  margin-left: 16rem;
}
.mlauto {
  margin-left: auto;
}
.ml-22 {
  margin-left: 22%;
}
@media screen and (max-width: 768px) {
  .ml0-t {
    margin-left: 0;
  }
  .ml1-t {
    margin-left: 0.125rem;
  }
  .ml2-t {
    margin-left: 0.25rem;
  }
  .ml3-t {
    margin-left: 0.375rem;
  }
  .ml4-t {
    margin-left: 0.5rem;
  }
  .ml5-t {
    margin-left: 0.75rem;
  }
  .ml6-t {
    margin-left: 1rem;
  }
  .ml7-t {
    margin-left: 1.5rem;
  }
  .ml8-t {
    margin-left: 2rem;
  }
  .ml9-t {
    margin-left: 3rem;
  }
  .ml11-t {
    margin-left: 4rem;
  }
  .ml10-t {
    margin-left: 6rem;
  }
  .ml12-t {
    margin-left: 8rem;
  }
  .ml13-t {
    margin-left: 12rem;
  }
  .ml14-t {
    margin-left: 16rem;
  }
  .mlauto-t {
    margin-left: auto;
  }
}
@media screen and (max-width: 520px) {
  .ml0-m {
    margin-left: 0;
  }
  .ml1-m {
    margin-left: 0.125rem;
  }
  .ml2-m {
    margin-left: 0.25rem;
  }
  .ml3-m {
    margin-left: 0.375rem;
  }
  .ml4-m {
    margin-left: 0.5rem;
  }
  .ml5-m {
    margin-left: 0.75rem;
  }
  .ml6-m {
    margin-left: 1rem;
  }
  .ml7-m {
    margin-left: 1.5rem;
  }
  .ml8-m {
    margin-left: 2rem;
  }
  .ml9-m {
    margin-left: 3rem;
  }
  .ml11-m {
    margin-left: 4rem;
  }
  .ml10-m {
    margin-left: 6rem;
  }
  .ml12-m {
    margin-left: 8rem;
  }
  .ml13-m {
    margin-left: 12rem;
  }
  .ml14-m {
    margin-left: 16rem;
  }
  .mlauto-m {
    margin-left: auto;
  }
}
.mr0 {
  margin-right: 0;
}
.mr1 {
  margin-right: 0.125rem;
}
.mr2 {
  margin-right: 0.25rem;
}
.mr3 {
  margin-right: 0.375rem;
}
.mr4 {
  margin-right: 0.5rem;
}
.mr5 {
  margin-right: 0.75rem;
}
.mr6 {
  margin-right: 1rem;
}
.mr7 {
  margin-right: 1.5rem;
}
.mr8 {
  margin-right: 2rem;
}
.mr9 {
  margin-right: 3rem;
}
.mr10 {
  margin-right: 4rem;
}
.mr11 {
  margin-right: 6rem;
}
.mr12 {
  margin-right: 8rem;
}
.mr13 {
  margin-right: 12rem;
}
.mr14 {
  margin-right: 16rem;
}
.mrauto {
  margin-right: auto;
}
@media screen and (min-width: 769px) {
  .mr-0-d {
    margin-right: 0;
  }
}
@media screen and (max-width: 768px) {
  .mr0-t {
    margin-right: 0;
  }
  .mr1-t {
    margin-right: 0.125rem;
  }
  .mr2-t {
    margin-right: 0.25rem;
  }
  .mr3-t {
    margin-right: 0.375rem;
  }
  .mr4-t {
    margin-right: 0.5rem;
  }
  .mr5-t {
    margin-right: 0.75rem;
  }
  .mr6-t {
    margin-right: 1rem;
  }
  .mr7-t {
    margin-right: 1.5rem;
  }
  .mr8-t {
    margin-right: 2rem;
  }
  .mr9-t {
    margin-right: 3rem;
  }
  .mr11-t {
    margin-right: 4rem;
  }
  .mr10-t {
    margin-right: 6rem;
  }
  .mr12-t {
    margin-right: 8rem;
  }
  .mr13-t {
    margin-right: 12rem;
  }
  .mr14-t {
    margin-right: 16rem;
  }
  .mrauto-t {
    margin-right: auto;
  }
}
@media screen and (max-width: 520px) {
  .mr0-m {
    margin-right: 0;
  }
  .mr1-m {
    margin-right: 0.125rem;
  }
  .mr2-m {
    margin-right: 0.25rem;
  }
  .mr3-m {
    margin-right: 0.375rem;
  }
  .mr4-m {
    margin-right: 0.5rem;
  }
  .mr5-m {
    margin-right: 0.75rem;
  }
  .mr6-m {
    margin-right: 1rem;
  }
  .mr7-m {
    margin-right: 1.5rem;
  }
  .mr8-m {
    margin-right: 2rem;
  }
  .mr9-m {
    margin-right: 3rem;
  }
  .mr11-m {
    margin-right: 4rem;
  }
  .mr10-m {
    margin-right: 6rem;
  }
  .mr12-m {
    margin-right: 8rem;
  }
  .mr13-m {
    margin-right: 12rem;
  }
  .mr14-m {
    margin-right: 16rem;
  }
  .mrauto-m {
    margin-right: auto;
  }
}
.mb0 {
  margin-bottom: 0;
}
.mb1 {
  margin-bottom: 0.125rem;
}
.mb2 {
  margin-bottom: 0.25rem;
}
.mb3 {
  margin-bottom: 0.375rem;
}
.mb4 {
  margin-bottom: 0.5rem;
}
.mb5 {
  margin-bottom: 0.75rem;
}
.mb6 {
  margin-bottom: 1rem;
}
.mb7 {
  margin-bottom: 1.5rem;
}
.mb8 {
  margin-bottom: 2rem;
}
.mb9 {
  margin-bottom: 3rem;
}
.mb10 {
  margin-bottom: 4rem;
}
.mb11 {
  margin-bottom: 6rem;
}
.mb12 {
  margin-bottom: 8rem;
}
.mb13 {
  margin-bottom: 12rem;
}
.mb14 {
  margin-bottom: 16rem;
}
.mbauto {
  margin-bottom: auto;
}
.-mb2 {
  margin-bottom: -0.25rem;
}
.-mb4 {
  margin-bottom: -0.5rem;
}
.last-child-mb0:last-child {
  margin-bottom: 0;
}
@media screen and (max-width: 768px) {
  .mb0-t {
    margin-bottom: 0;
  }
  .mb1-t {
    margin-bottom: 0.125rem;
  }
  .mb2-t {
    margin-bottom: 0.25rem;
  }
  .mb3-t {
    margin-bottom: 0.375rem;
  }
  .mb4-t {
    margin-bottom: 0.5rem;
  }
  .mb5-t {
    margin-bottom: 0.75rem;
  }
  .mb6-t {
    margin-bottom: 1rem;
  }
  .mb7-t {
    margin-bottom: 1.5rem;
  }
  .mb8-t {
    margin-bottom: 2rem;
  }
  .mb9-t {
    margin-bottom: 3rem;
  }
  .mb11-t {
    margin-bottom: 4rem;
  }
  .mb10-t {
    margin-bottom: 6rem;
  }
  .mb12-t {
    margin-bottom: 8rem;
  }
  .mb13-t {
    margin-bottom: 12rem;
  }
  .mb14-t {
    margin-bottom: 16rem;
  }
  .mbauto-t {
    margin-bottom: auto;
  }
}
@media screen and (max-width: 520px) {
  .mb0-m {
    margin-bottom: 0;
  }
  .mb1-m {
    margin-bottom: 0.125rem;
  }
  .mb2-m {
    margin-bottom: 0.25rem;
  }
  .mb3-m {
    margin-bottom: 0.375rem;
  }
  .mb4-m {
    margin-bottom: 0.5rem;
  }
  .mb5-m {
    margin-bottom: 0.75rem;
  }
  .mb6-m {
    margin-bottom: 1rem;
  }
  .mb7-m {
    margin-bottom: 1.5rem;
  }
  .mb8-m {
    margin-bottom: 2rem;
  }
  .mb9-m {
    margin-bottom: 3rem;
  }
  .mb11-m {
    margin-bottom: 4rem;
  }
  .mb10-m {
    margin-bottom: 6rem;
  }
  .mb12-m {
    margin-bottom: 8rem;
  }
  .mb13-m {
    margin-bottom: 12rem;
  }
  .mb14-m {
    margin-bottom: 16rem;
  }
  .mbauto-m {
    margin-bottom: auto;
  }
}
.mt0 {
  margin-top: 0;
}
.mt1 {
  margin-top: 0.125rem;
}
.mt2 {
  margin-top: 0.25rem;
}
.mt3 {
  margin-top: 0.375rem;
}
.mt4 {
  margin-top: 0.5rem;
}
.mt5 {
  margin-top: 0.75rem;
}
.mt6 {
  margin-top: 1rem;
}
.mt7 {
  margin-top: 1.5rem;
}
.mt8 {
  margin-top: 2rem;
}
.mt9 {
  margin-top: 3rem;
}
.mt10 {
  margin-top: 4rem;
}
.mt11 {
  margin-top: 6rem;
}
.mt12 {
  margin-top: 8rem;
}
.mt13 {
  margin-top: 12rem;
}
.mt14 {
  margin-top: 16rem;
}
.-mt1 {
  margin-top: -0.125rem;
}
.-mt2 {
  margin-top: -0.25rem;
}
.-mt3 {
  margin-top: -0.375rem;
}
.-mt4 {
  margin-top: -0.5rem;
}
.-mt5 {
  margin-top: -0.75rem;
}
.-mt6 {
  margin-top: -1rem;
}
.-mt7 {
  margin-top: -1.5rem;
}
.-mt8 {
  margin-top: -2rem;
}
.-mt9 {
  margin-top: -3rem;
}
@media screen and (min-width: 1200px) {
  .mt0-l {
    margin-top: 0;
  }
}
@media screen and (max-width: 768px) {
  .mt0-t {
    margin-top: 0;
  }
  .mt1-t {
    margin-top: 0.125rem;
  }
  .mt2-t {
    margin-top: 0.25rem;
  }
  .mt3-t {
    margin-top: 0.375rem;
  }
  .mt4-t {
    margin-top: 0.5rem;
  }
  .mt5-t {
    margin-top: 0.75rem;
  }
  .mt6-t {
    margin-top: 1rem;
  }
  .mt7-t {
    margin-top: 1.5rem;
  }
  .mt8-t {
    margin-top: 2rem;
  }
  .mt9-t {
    margin-top: 3rem;
  }
  .mt11-t {
    margin-top: 4rem;
  }
  .mt10-t {
    margin-top: 6rem;
  }
  .mt12-t {
    margin-top: 8rem;
  }
  .mt13-t {
    margin-top: 12rem;
  }
  .mt14-t {
    margin-top: 16rem;
  }
}
@media screen and (max-width: 520px) {
  .mt0-m {
    margin-top: 0;
  }
  .mt1-m {
    margin-top: 0.125rem;
  }
  .mt2-m {
    margin-top: 0.25rem;
  }
  .mt3-m {
    margin-top: 0.375rem;
  }
  .mt4-m {
    margin-top: 0.5rem;
  }
  .mt5-m {
    margin-top: 0.75rem;
  }
  .mt6-m {
    margin-top: 1rem;
  }
  .mt7-m {
    margin-top: 1.5rem;
  }
  .mt8-m {
    margin-top: 2rem;
  }
  .mt9-m {
    margin-top: 3rem;
  }
  .mt11-m {
    margin-top: 4rem;
  }
  .mt10-m {
    margin-top: 6rem;
  }
  .mt12-m {
    margin-top: 8rem;
  }
  .mt13-m {
    margin-top: 12rem;
  }
  .mt14-m {
    margin-top: 16rem;
  }
}
.mv0 {
  margin-top: 0;
  margin-bottom: 0;
}
.mv1 {
  margin-top: 0.125rem;
  margin-bottom: 0.125rem;
}
.mv2 {
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
.mv3 {
  margin-top: 0.375rem;
  margin-bottom: 0.375rem;
}
.mv4 {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.mv5 {
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
}
.mv6 {
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.mv7 {
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}
.mv8 {
  margin-top: 2rem;
  margin-bottom: 2rem;
}
.mv9 {
  margin-top: 3rem;
  margin-bottom: 3rem;
}
.mv10 {
  margin-top: 4rem;
  margin-bottom: 4rem;
}
.mv11 {
  margin-top: 6rem;
  margin-bottom: 6rem;
}
.mv12 {
  margin-top: 8rem;
  margin-bottom: 8rem;
}
.mv13 {
  margin-top: 12rem;
  margin-bottom: 12rem;
}
.mv14 {
  margin-top: 16rem;
  margin-bottom: 16rem;
}
@media screen and (max-width: 768px) {
  .mv0-t {
    margin-top: 0;
    margin-bottom: 0;
  }
  .mv1-t {
    margin-top: 0.125rem;
    margin-bottom: 0.125rem;
  }
  .mv2-t {
    margin-top: 0.25rem;
    margin-bottom: 0.25rem;
  }
  .mv3-t {
    margin-top: 0.375rem;
    margin-bottom: 0.375rem;
  }
  .mv4-t {
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
  }
  .mv5-t {
    margin-top: 0.75rem;
    margin-bottom: 0.75rem;
  }
  .mv6-t {
    margin-top: 1rem;
    margin-bottom: 1rem;
  }
  .mv7-t {
    margin-top: 1.5rem;
    margin-bottom: 1.5rem;
  }
  .mv8-t {
    margin-top: 2rem;
    margin-bottom: 2rem;
  }
  .mv9-t {
    margin-top: 3rem;
    margin-bottom: 3rem;
  }
  .mv11-t {
    margin-top: 4rem;
    margin-bottom: 4rem;
  }
  .mv10-t {
    margin-top: 6rem;
    margin-bottom: 6rem;
  }
  .mv12-t {
    margin-top: 8rem;
    margin-bottom: 8rem;
  }
  .mv13-t {
    margin-top: 12rem;
    margin-bottom: 12rem;
  }
  .mv14-t {
    margin-top: 16rem;
    margin-bottom: 16rem;
  }
}
@media screen and (max-width: 520px) {
  .mv0-m {
    margin-top: 0;
    margin-bottom: 0;
  }
  .mv1-m {
    margin-top: 0.125rem;
    margin-bottom: 0.125rem;
  }
  .mv2-m {
    margin-top: 0.25rem;
    margin-bottom: 0.25rem;
  }
  .mv3-m {
    margin-top: 0.375rem;
    margin-bottom: 0.375rem;
  }
  .mv4-m {
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
  }
  .mv5-m {
    margin-top: 0.75rem;
    margin-bottom: 0.75rem;
  }
  .mv6-m {
    margin-top: 1rem;
    margin-bottom: 1rem;
  }
  .mv7-m {
    margin-top: 1.5rem;
    margin-bottom: 1.5rem;
  }
  .mv8-m {
    margin-top: 2rem;
    margin-bottom: 2rem;
  }
  .mv9-m {
    margin-top: 3rem;
    margin-bottom: 3rem;
  }
  .mv11-m {
    margin-top: 4rem;
    margin-bottom: 4rem;
  }
  .mv10-m {
    margin-top: 6rem;
    margin-bottom: 6rem;
  }
  .mv12-m {
    margin-top: 8rem;
    margin-bottom: 8rem;
  }
  .mv13-m {
    margin-top: 12rem;
    margin-bottom: 12rem;
  }
  .mv14-m {
    margin-top: 16rem;
    margin-bottom: 16rem;
  }
}
.mh0 {
  margin-left: 0;
  margin-right: 0;
}
.mh1 {
  margin-left: 0.125rem;
  margin-right: 0.125rem;
}
.mh2 {
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}
.mh3 {
  margin-left: 0.375rem;
  margin-right: 0.375rem;
}
.mh4 {
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
.mh5 {
  margin-left: 0.75rem;
  margin-right: 0.75rem;
}
.mh6 {
  margin-left: 1rem;
  margin-right: 1rem;
}
.mh7 {
  margin-left: 1.5rem;
  margin-right: 1.5rem;
}
.mh8 {
  margin-left: 2rem;
  margin-right: 2rem;
}
.mh9 {
  margin-left: 3rem;
  margin-right: 3rem;
}
.mh10 {
  margin-left: 4rem;
  margin-right: 4rem;
}
.mh11 {
  margin-left: 6rem;
  margin-right: 6rem;
}
.mh12 {
  margin-left: 8rem;
  margin-right: 8rem;
}
.mh13 {
  margin-left: 12rem;
  margin-right: 12rem;
}
.mh14 {
  margin-left: 16rem;
  margin-right: 16rem;
}
.mhauto {
  margin-left: auto;
  margin-right: auto;
}
@media screen and (max-width: 768px) {
  .mh0-t {
    margin-left: 0;
    margin-right: 0;
  }
  .mh1-t {
    margin-left: 0.125rem;
    margin-right: 0.125rem;
  }
  .mh2-t {
    margin-left: 0.25rem;
    margin-right: 0.25rem;
  }
  .mh3-t {
    margin-left: 0.375rem;
    margin-right: 0.375rem;
  }
  .mh4-t {
    margin-left: 0.5rem;
    margin-right: 0.5rem;
  }
  .mh5-t {
    margin-left: 0.75rem;
    margin-right: 0.75rem;
  }
  .mh6-t {
    margin-left: 1rem;
    margin-right: 1rem;
  }
  .mh7-t {
    margin-left: 1.5rem;
    margin-right: 1.5rem;
  }
  .mh8-t {
    margin-left: 2rem;
    margin-right: 2rem;
  }
  .mh9-t {
    margin-left: 3rem;
    margin-right: 3rem;
  }
  .mh11-t {
    margin-left: 4rem;
    margin-right: 4rem;
  }
  .mh10-t {
    margin-left: 6rem;
    margin-right: 6rem;
  }
  .mh12-t {
    margin-left: 8rem;
    margin-right: 8rem;
  }
  .mh13-t {
    margin-left: 12rem;
    margin-right: 12rem;
  }
  .mh14-t {
    margin-left: 16rem;
    margin-right: 16rem;
  }
  .mhauto-t {
    margin-left: auto;
    margin-right: auto;
  }
}
@media screen and (max-width: 520px) {
  .mh0-m {
    margin-left: 0;
    margin-right: 0;
  }
  .mh1-m {
    margin-left: 0.125rem;
    margin-right: 0.125rem;
  }
  .mh2-m {
    margin-left: 0.25rem;
    margin-right: 0.25rem;
  }
  .mh3-m {
    margin-left: 0.375rem;
    margin-right: 0.375rem;
  }
  .mh4-m {
    margin-left: 0.5rem;
    margin-right: 0.5rem;
  }
  .mh5-m {
    margin-left: 0.75rem;
    margin-right: 0.75rem;
  }
  .mh6-m {
    margin-left: 1rem;
    margin-right: 1rem;
  }
  .mh7-m {
    margin-left: 1.5rem;
    margin-right: 1.5rem;
  }
  .mh8-m {
    margin-left: 2rem;
    margin-right: 2rem;
  }
  .mh9-m {
    margin-left: 3rem;
    margin-right: 3rem;
  }
  .mh10-m {
    margin-left: 4rem;
    margin-right: 4rem;
  }
  .mh11-m {
    margin-left: 6rem;
    margin-right: 6rem;
  }
  .mh12-m {
    margin-left: 8rem;
    margin-right: 8rem;
  }
  .mh13-m {
    margin-left: 12rem;
    margin-right: 12rem;
  }
  .mh14-m {
    margin-left: 16rem;
    margin-right: 16rem;
  }
  .mhauto-m {
    margin-left: auto;
    margin-right: auto;
  }
}
/*

  Theming
  -------

  Utility classes for theming.

*/
.bicubic {
  -ms-interpolation-mode: bicubic;
  image-rendering: optimizeQuality;
}
.fit-image {
  object-fit: cover;
}
.position-image-50-30 {
  object-position: 50% 30%;
}
.fit-bg-image {
  width: 100%;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: 50% 50%;
}
.hidden {
  visibility: hidden;
}
.no-pointer-events {
  pointer-events: none;
}
.list-reset {
  list-style: none;
}
.list-item-reset {
  list-style-type: none;
}
.list-item-initial {
  list-style-type: initial;
}
.transition-all {
  -webkit-transition: all 0.2s ease;
  -moz-transition: all 0.2s ease;
  -o-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.transition-all-slow {
  -webkit-transition: all 0.4s ease;
  -moz-transition: all 0.4s ease;
  -o-transition: all 0.4s ease;
  transition: all 0.4s ease;
}
.default-cursor {
  cursor: default;
}
.pointer {
  cursor: pointer;
}
.text {
  cursor: text;
}
.disabled-default-cursor:disabled {
  cursor: default;
}
.not-allowed {
  cursor: not-allowed;
}
.wait {
  cursor: wait;
}
.w-resize {
  cursor: w-resize;
}
.outline-0 {
  outline: 0;
  outline: none;
}
.focus-outline-0:focus {
  outline: 0;
  outline: none;
}
.focus-outline-0:focus select:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 #000;
}
.disable-text-area-resize {
  resize: none;
}
.filter-o-40 {
  filter: opacity(40%);
}
.filter-blur {
  filter: blur(2px);
}
.hover-filter-o-40:hover {
  filter: opacity(40%);
}
.o-100 {
  -webkit-opacity: 1;
  -moz-opacity: 1;
  opacity: 1;
}
.o-90 {
  -webkit-opacity: 0.9;
  -moz-opacity: 0.9;
  opacity: 0.9;
}
.o-80 {
  -webkit-opacity: 0.8;
  -moz-opacity: 0.8;
  opacity: 0.8;
}
.o-70 {
  -webkit-opacity: 0.7;
  -moz-opacity: 0.7;
  opacity: 0.7;
}
.o-60 {
  -webkit-opacity: 0.6;
  -moz-opacity: 0.6;
  opacity: 0.6;
}
.o-50 {
  -webkit-opacity: 0.5;
  -moz-opacity: 0.5;
  opacity: 0.5;
}
.o-40 {
  -webkit-opacity: 0.4;
  -moz-opacity: 0.4;
  opacity: 0.4;
}
.o-30 {
  -webkit-opacity: 0.3;
  -moz-opacity: 0.3;
  opacity: 0.3;
}
.o-20 {
  -webkit-opacity: 0.2;
  -moz-opacity: 0.2;
  opacity: 0.2;
}
.o-10 {
  -webkit-opacity: 0.1;
  -moz-opacity: 0.1;
  opacity: 0.1;
}
.o-05 {
  -webkit-opacity: 0.05;
  -moz-opacity: 0.05;
  opacity: 0.05;
}
.o-025 {
  -webkit-opacity: 0.025;
  -moz-opacity: 0.025;
  opacity: 0.025;
}
.o-0 {
  -webkit-opacity: 0;
  -moz-opacity: 0;
  opacity: 0;
}
.hover-o-90:hover {
  -webkit-opacity: 0.9;
  -moz-opacity: 0.9;
  opacity: 0.9;
}
.hover-o-80:hover {
  -webkit-opacity: 0.8;
  -moz-opacity: 0.8;
  opacity: 0.8;
}
.hover-o-100:hover {
  -webkit-opacity: 1;
  -moz-opacity: 1;
  opacity: 1;
}
.black {
  color: #111111;
}
.bluish-grey {
  color: #738897;
}
.cadet-blue {
  color: #6288A5;
}
.charcoal {
  color: #404040;
}
.chocolate {
  color: #C85C17;
}
.crimson {
  color: #CC0033;
}
.dark-cyan {
  color: #00719F;
}
.dark-slate-blue {
  color: #3A447A;
}
.dark-orchid {
  color: #84619C;
}
.dim-grey {
  color: #565656;
}
.gains-boro {
  color: #d8d8d8;
}
.grey {
  color: #73797A;
}
.ghost-grey {
  color: #F7F9FA;
}
.indian-red {
  color: #D95741;
}
.light-coral {
  color: #F1617D;
}
.lite-grey {
  color: #979797;
}
.dark-coral {
  color: #DB3668;
}
.dark-sea-green {
  color: #5CBE75;
}
.dark-sea-green-2 {
  color: #128a93;
}
.dark-sea-green-3 {
  color: #008C9F;
}
.light-sea-green-1 {
  color: #3FC599;
}
.light-sea-green-2 {
  color: #0bb9b5;
}
.light-turquoise {
  color: #81cbd3;
}
.medium-turquoise {
  color: #35b8d3;
}
.medium-aquamarine {
  color: #6ac498;
}
.navy {
  color: #011279;
}
.pale-green {
  color: #a0f6aa;
}
.pale-violet-red {
  color: #e25c8f;
}
.phantom-grey {
  color: #e8e8e8;
}
.precedents-blue {
  color: #004b7a;
}
.phantom-grey {
  color: #e8e8e8;
}
.royal-blue {
  color: #1460D1;
}
.sienna {
  color: #825F48;
}
.teal {
  color: #004b7a;
}
.tomato {
  color: #F87531;
}
.tangerine-dream {
  color: #FFCA28;
}
.white {
  color: #FFFFFF;
}
.placeholder-cadet-blue::placeholder {
  color: #6288A5;
}
.hover-black:hover {
  color: #111111;
}
.hover-cadet-blue:hover {
  color: #6288A5;
}
.hover-dark-sea-green-2:hover {
  color: #128a93;
}
.hover-dark-slate-blue:hover {
  color: #3A447A;
}
.hover-dark-sea-green-2:hover {
  color: #128a93;
}
.hover-dark-sea-green-3:hover {
  color: #008C9F;
}
.hover-gains-boro:hover {
  color: #d8d8d8;
}
.hover-white:hover {
  color: #FFFFFF;
}
.focus-light-sea-green-2:focus {
  color: #0bb9b5;
}
.focus-white:focus {
  color: #FFFFFF;
}
.focus-grey:focus {
  color: #73797A;
}
.color-inherit {
  color: inherit;
}
.link-children-color-inherit a {
  color: inherit;
}
.bg-black {
  background-color: #111111;
}
.bg-cadet-blue {
  background-color: #6288A5;
}
.bg-chocolate {
  background-color: #C85C17;
}
.bg-dark-bluish-grey {
  background-color: #5d6d7b;
}
.bg-dark-coral {
  background-color: #DB3668;
}
.bg-dark-cyan {
  background-color: #00719F;
}
.bg-dark-sea-green {
  background-color: #5CBE75;
}
.bg-dark-sea-green-2 {
  background-color: #128a93;
}
.bg-dark-sea-green-3 {
  background-color: #008C9F;
}
.bg-dark-slate-blue {
  background-color: #3A447A;
}
.bg-dark-orchid {
  background-color: #84619C;
}
.bg-dim-grey {
  background-color: #565656;
}
.bg-faf-grey {
  background-color: #FAFAFF;
}
.bg-gains-boro {
  background-color: #d8d8d8;
}
.bg-grey {
  background-color: #73797A;
}
.bg-ghost-grey {
  background-color: #F7F9FA;
}
.bg-indian-red {
  background-color: #D95741;
}
.bg-ice-blue {
  background-color: #D5ECFF;
}
.bg-light-coral {
  background-color: #F1617D;
}
.bg-light-yellow {
  background-color: #FCF8E3;
}
.bg-light-sea-green-1 {
  background-color: #3FC599;
}
.bg-light-sea-green-2 {
  background-color: #0bb9b5;
}
.bg-light-turquoise {
  background-color: #81cbd3;
}
.bg-medium-aquamarine {
  background-color: #6ac498;
}
.bg-medium-purple {
  background-color: #9c7fb0;
}
.bg-medium-turquoise {
  background-color: #35b8d3;
}
.bg-navy {
  background-color: #011279;
}
.bg-precedents-blue {
  background-color: #004b7a;
}
.bg-pale-green {
  background-color: #a0f6aa;
}
.bg-pale-violet-red {
  background-color: #e25c8f;
}
.bg-pearl-lusta {
  background-color: #fbf2d1;
}
.bg-phantom-grey {
  background-color: #e8e8e8;
}
.bg-royal-blue {
  background-color: #1460D1;
}
.bg-sienna {
  background-color: #825F48;
}
.bg-teal {
  background-color: #004b7a;
}
.bg-tomato {
  background-color: #F87531;
}
.bg-white {
  background-color: #FFFFFF;
}
.bg-tangerine-dream {
  background-color: #FFCA28;
}
.bg-transparent {
  background-color: transparent;
}
.bg-twilight-grey {
  background-color: #EDEDED;
}
.bg-void-grey {
  background-color: #EBF0F4;
}
.bg-inherit {
  background-color: inherit;
}
.bg-transparent {
  background: transparent;
}
.hover-bg-transparent:hover {
  background-color: transparent;
  background: transparent;
}
.hover-bg-cadet-blue:hover {
  background-color: #6288A5;
}
.hover-bg-dark-slate-blue:hover {
  background-color: #3A447A;
}
.hover-bg-dark-sea-green:hover {
  background-color: #5CBE75;
}
.hover-bg-dark-sea-green-2:hover {
  background-color: #128a93;
}
.hover-bg-dark-sea-green-3:hover {
  background-color: #008C9F;
}
.hover-bg-dim-grey:hover {
  background-color: #565656;
}
.hover-bg-gains-boro:hover {
  background-color: #d8d8d8;
}
.hover-bg-ghost-grey:hover {
  background-color: #F7F9FA;
}
.hover-bg-grey:hover {
  background-color: #73797A;
}
.hover-bg-light-turquoise:hover {
  background-color: #81cbd3;
}
.hover-bg-teal:hover {
  background-color: #004b7a;
}
.hover-bg-phantom-grey:hover {
  background-color: #e8e8e8;
}
.hover-bg-twilight-grey:hover {
  background-color: #EDEDED;
}
.hover-bg-white:hover {
  background-color: #FFFFFF;
}
.bg-contain {
  background-size: contain;
}
.bg-center {
  background-position: center;
}
.bg-x-center {
  background-position-x: center;
}
.bg-y-center {
  background-position-y: center;
}
.border-collapse {
  border-collapse: collapse;
}
.bg-no-repeat {
  background-repeat: no-repeat;
}
.ba {
  border-style: solid;
  border-width: 1px;
}
.ba2 {
  border-style: solid;
  border-width: 2px;
}
.bn {
  border-style: none;
  border-width: 0;
}
.bb {
  border-bottom-style: solid;
  border-bottom-width: 1px;
}
.bl {
  border-left-style: solid;
  border-left-width: 1px;
}
.bt {
  border-top-style: solid;
  border-top-width: 1px;
}
.br {
  border-right-style: solid;
  border-right-width: 1px;
}
.bb-thin {
  border-bottom-style: solid;
  border-bottom-width: 1px;
}
.bb-medium {
  border-bottom-style: solid;
  border-bottom-width: 2px;
}
.bb-thick {
  border-bottom-style: solid;
  border-bottom-width: 4px;
}
.bt-medium {
  border-top-style: solid;
  border-top-width: 2px;
}
.bt-thick {
  border-top-style: solid;
  border-top-width: 4px;
}
.bt-xl {
  border-top-style: solid;
  border-top-width: 8px;
}
@media screen and (max-width: 520px) {
  .bn-m {
    border-style: none;
    border-width: 0;
  }
  .ba-m {
    border-style: solid;
    border-width: 1px;
  }
}
.hover-bb-thick:hover {
  border-bottom-style: solid;
  border-bottom-width: 4px;
}
.hover-bb-medium:hover {
  border-bottom-style: solid;
  border-bottom-width: 2px;
}
.hover-bt-thick:hover {
  border-top-style: solid;
  border-top-width: 4px;
}
.last-child-bn:last-child {
  border-style: none;
  border-width: 0;
}
.last-of-type-bn:last-of-type {
  border-style: none;
  border-width: 0;
}
@media screen and (max-width: 768px) {
  .bb-t {
    border-bottom-style: solid;
    border-bottom-width: 1px;
  }
  .bn-t {
    border-style: none;
    border-width: 0;
  }
  .bt-t {
    border-top-style: solid;
    border-top-width: 1px;
  }
}
.b--dashed {
  border-style: dashed;
}
.b--dotted {
  border-style: dotted;
}
.b--none {
  border-style: none;
}
.b--solid {
  border-style: solid;
}
.bt--dashed {
  border-top-style: dashed;
}
.bt--dotted {
  border-top-style: dotted;
}
.bt--none {
  border-top-style: none;
}
.bt--solid {
  border-top-style: solid;
}
.br--dashed {
  border-right-style: dashed;
}
.br--dotted {
  border-right-style: dotted;
}
.br--none {
  border-right-style: none;
}
.br--solid {
  border-right-style: solid;
}
.bb--dashed {
  border-bottom-style: dashed;
}
.bb--dotted {
  border-bottom-style: dotted;
}
.bb--none {
  border-bottom-style: none;
}
.bb--solid {
  border-bottom-style: solid;
}
.bl--dashed {
  border-left-style: dashed;
}
.bl--dotted {
  border-left-style: dotted;
}
.bl--none {
  border-left-style: none;
}
.bl--solid {
  border-left-style: solid;
}
.hover-ba:hover {
  border-style: solid;
  border-width: 1px;
}
.hover-ba2:hover {
  border-style: solid;
  border-width: 2px;
}
.b--black {
  border-color: #111111;
}
.b--cadet-blue {
  border-color: #6288A5;
}
.b--chocolate {
  border-color: #C85C17;
}
.b--dark-cyan {
  border-color: #00719F;
}
.b--dark-slate-blue {
  border-color: #3A447A;
}
.b--dark-orchid {
  border-color: #84619C;
}
.b--dark-sea-green-2 {
  border-color: #128a93;
}
.b--dark-sea-green-3 {
  border-color: #008C9F;
}
.b--dim-grey {
  border-color: #565656;
}
.b--gains-boro {
  border-color: #d8d8d8;
}
.b--grey {
  border-color: #73797A;
}
.b--ghost-grey {
  border-color: #F7F9FA;
}
.b--indian-red {
  border-color: #D95741;
}
.b--light-coral {
  border-color: #F1617D;
}
.b--light-grey {
  border-color: #979797;
}
.b--light-sea-green-1 {
  border-color: #3FC599;
}
.b--light-sea-green-2 {
  border-color: #0bb9b5;
}
.b--lite-grey {
  border-color: #979797;
}
.b--medium-aquamarine {
  border-color: #6ac498;
}
.b--medium-purple {
  border-color: #9c7fb0;
}
.b--medium-turquoise {
  border-color: #35b8d3;
}
.b--navy {
  border-color: #011279;
}
.b--pale-green {
  border-color: #a0f6aa;
}
.b--pale-violet-red {
  border-color: #e25c8f;
}
.b--precedents-blue {
  border-color: #004b7a;
}
.b--royal-blue {
  border-color: #1460D1;
}
.b--sienna {
  border-color: #825F48;
}
.b--tomato {
  border-color: #F87531;
}
.b--phantom-grey {
  border-color: #e8e8e8;
}
.b--white {
  border-color: #FFFFFF;
}
.b--transparent {
  border-color: transparent;
}
.b--inherit {
  border-color: inherit;
}
.bt--transparent {
  border-top-color: transparent;
}
.bt--dark-orchid {
  border-top-color: #84619C;
}
.bt--dark-cyan {
  border-top-color: #00719F;
}
.bt--light-grey {
  border-top-color: #979797;
}
.bt--phantom-grey {
  border-top-color: #e8e8e8;
}
.bt--light-sea-green-2 {
  border-top-color: #0bb9b5;
}
.bt--dark-sea-green-3 {
  border-top-color: #008C9F;
}
.bt--medium-aquamarine {
  border-top-color: #6ac498;
}
.bt--medium-purple {
  border-top-color: #9c7fb0;
}
.bb--chocolate {
  border-bottom-color: #C85C17;
}
.hover-b--black:hover {
  border-color: #111111;
}
.hover-b--inherit:hover {
  border-color: inherit;
}
.hover-b--dark-sea-green-2:hover {
  border-color: #128a93;
}
.focus-b--light-sea-green-2:focus {
  border-color: #0bb9b5;
}
.focus-b--cadet-blue:focus {
  border-color: #6288A5;
}
.br0 {
  border-radius: 0;
}
.br1 {
  border-radius: 0.125rem;
}
.br2 {
  border-radius: 0.25rem;
}
.br3 {
  border-radius: 0.5rem;
}
.br4 {
  border-radius: 1rem;
}
.br-50 {
  border-radius: 50%;
}
.br-100 {
  border-radius: 100%;
}
.br-pill {
  border-radius: 9999px;
}
.br--bottom {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.br--left {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.br--right {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.br--top {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
/**
 * Box Shadow
 * offset-x | offset-y | blur-radius | spread-radius | color
 * NOTE: This naming convention is too verbose so I'm open to better
 * suggestions!
 */
.shadow-none {
  box-shadow: none;
}
.shadow-8-04 {
  box-shadow: 0 0 8px 0 rgba(17, 17, 17, 0.4);
}
.shadow-black-1 {
  -webkit-box-shadow: 0 10px 15px 0px rgba(0, 0, 0, 0.2);
  -moz-box-shadow: 0 10px 15px 0px rgba(0, 0, 0, 0.2);
  box-shadow: 0 10px 15px 0px rgba(0, 0, 0, 0.2);
}
.shadow-black-2 {
  -webkit-box-shadow: 0 5px 5px -5px rgba(17, 17, 17, 0.5);
  -moz-box-shadow: 0 5px 5px -5px rgba(17, 17, 17, 0.5);
  box-shadow: 0 5px 5px -5px rgba(17, 17, 17, 0.5);
}
.shadow-black-3 {
  -webkit-box-shadow: 2px 1px 8px rgba(17, 17, 17, 0.4);
  -moz-box-shadow: 2px 1px 8px rgba(17, 17, 17, 0.4);
  box-shadow: 2px 1px 8px rgba(17, 17, 17, 0.4);
}
.shadow-black-4 {
  -webkit-box-shadow: 0px 0px 1px rgba(17, 17, 17, 0.2);
  -moz-box-shadow: 0px 0px 1px rgba(17, 17, 17, 0.2);
  box-shadow: 0px 0px 1px rgba(17, 17, 17, 0.2);
}
@media screen and (max-width: 520px) {
  .shadow-none-m {
    box-shadow: none;
  }
}
@media screen and (min-width: 1200px) {
  .shadow-none-l {
    box-shadow: none;
  }
}
.x--50-y-50 {
  -webkit-transform: translateX(-50%) translateY(50%);
  -moz-transform: translateX(-50%) translateY(50%);
  -o-transform: translateX(-50%) translateY(50%);
  -ms-transform: translateX(-50%) translateY(50%);
  transform: translateX(-50%) translateY(50%);
}
.x--50-y-100 {
  -webkit-transform: translateX(-50%) translateY(100%);
  -moz-transform: translateX(-50%) translateY(100%);
  -o-transform: translateX(-50%) translateY(100%);
  -ms-transform: translateX(-50%) translateY(100%);
  transform: translateX(-50%) translateY(100%);
}
.x--50-y--50 {
  -webkit-transform: translateX(-50%) translateY(-50%);
  -moz-transform: translateX(-50%) translateY(-50%);
  -o-transform: translateX(-50%) translateY(-50%);
  -ms-transform: translateX(-50%) translateY(-50%);
  transform: translateX(-50%) translateY(-50%);
}
.x--50-y--100 {
  -webkit-transform: translateX(-50%) translateY(-100%);
  -moz-transform: translateX(-50%) translateY(-100%);
  -o-transform: translateX(-50%) translateY(-100%);
  -ms-transform: translateX(-50%) translateY(-100%);
  transform: translateX(-50%) translateY(-100%);
}
.x-50 {
  -webkit-transform: translateX(50%);
  -moz-transform: translateX(50%);
  -o-transform: translateX(50%);
  -ms-transform: translateX(50%);
  transform: translateX(50%);
}
.x-100-y--50 {
  -webkit-transform: translateX(100%) translateY(-50%);
  -moz-transform: translateX(100%) translateY(-50%);
  -o-transform: translateX(100%) translateY(-50%);
  -ms-transform: translateX(100%) translateY(-50%);
  transform: translateX(100%) translateY(-50%);
}
.x-100 {
  -webkit-transform: translateX(100%);
  -moz-transform: translateX(100%);
  -o-transform: translateX(100%);
  -ms-transform: translateX(100%);
  transform: translateX(100%);
}
.x--50 {
  -webkit-transform: translateX(-50%);
  -moz-transform: translateX(-50%);
  -o-transform: translateX(-50%);
  -ms-transform: translateX(-50%);
  transform: translateX(-50%);
}
.x--100 {
  -webkit-transform: translateX(-100%);
  -moz-transform: translateX(-100%);
  -o-transform: translateX(-100%);
  -ms-transform: translateX(-100%);
  transform: translateX(-100%);
}
.x0 {
  -webkit-transform: translateX(0);
  -moz-transform: translateX(0);
  -o-transform: translateX(0);
  -ms-transform: translateX(0);
  transform: translateX(0);
}
.y--50 {
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}
.y--100 {
  -webkit-transform: translateY(-100%);
  -moz-transform: translateY(-100%);
  -o-transform: translateY(-100%);
  -ms-transform: translateY(-100%);
  transform: translateY(-100%);
}
.y-100 {
  -webkit-transform: translateY(100%);
  -moz-transform: translateY(100%);
  -o-transform: translateY(100%);
  -ms-transform: translateY(100%);
  transform: translateY(100%);
}
.y0 {
  -webkit-transform: translateY(0);
  -moz-transform: translateY(0);
  -o-transform: translateY(0);
  -ms-transform: translateY(0);
  transform: translateY(0);
}
.x-vw-100 {
  -webkit-transform: translateX(100vw);
  -moz-transform: translateX(100vw);
  -o-transform: translateX(100vw);
  -ms-transform: translateX(100vw);
  transform: translateX(100vw);
}
.y-vh--100 {
  -webkit-transform: translateY(-100vh);
  -moz-transform: translateY(-100vh);
  -o-transform: translateY(-100vh);
  -ms-transform: translateY(-100vh);
  transform: translateY(-100vh);
}
@media screen and (max-width: 520px) {
  .x--100-m {
    -webkit-transform: translateX(-100%);
    -moz-transform: translateX(-100%);
    -o-transform: translateX(-100%);
    -ms-transform: translateX(-100%);
    transform: translateX(-100%);
  }
}
@media screen and (min-width: 1200px) {
  .x-0-l {
    -webkit-transform: translateX(0);
    -moz-transform: translateX(0);
    -o-transform: translateX(0);
    -ms-transform: translateX(0);
    transform: translateX(0);
  }
}
.rotate-90 {
  -webkit-transform: rotate(90deg);
  -moz-transform: rotate(90deg);
  -o-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
  transform: rotate(90deg);
}
.rotate-180 {
  -webkit-transform: rotate(180deg);
  -moz-transform: rotate(180deg);
  -o-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  transform: rotate(180deg);
}
.aspect-ratio {
  height: 0;
  position: relative;
}
.aspect-ratio--16x9 {
  padding-bottom: 56.25%;
}
.aspect-ratio--9x16 {
  padding-bottom: 177.77%;
}
.aspect-ratio--4x3 {
  padding-bottom: 75%;
}
.aspect-ratio--3x4 {
  padding-bottom: 133.33%;
}
.aspect-ratio--6x4 {
  padding-bottom: 66.6%;
}
.aspect-ratio--4x6 {
  padding-bottom: 150%;
}
.aspect-ratio--8x5 {
  padding-bottom: 62.5%;
}
.aspect-ratio--5x8 {
  padding-bottom: 160%;
}
.aspect-ratio--7x5 {
  padding-bottom: 71.42%;
}
.aspect-ratio--5x7 {
  padding-bottom: 140%;
}
.aspect-ratio--1x1 {
  padding-bottom: 100%;
}
.scroll-touch {
  -webkit-overflow-scrolling: touch;
}
.scroll-auto {
  -webkit-overflow-scrolling: auto;
}
.no-select {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
/*

  Typography
  ----------

  Utility classes for typography.

*/
.font-default {
  font-family: "Source Sans Pro", "Arial", sans-serif;
}
.f1 {
  font-size: 3rem;
}
.f2 {
  font-size: 2.25rem;
}
.f3 {
  font-size: 1.5rem;
}
.f4 {
  font-size: 1.25rem;
}
.f5 {
  font-size: 1rem;
}
.f6 {
  font-size: .875rem;
}
.f7 {
  font-size: .75rem;
}
.f8 {
  font-size: 0.625rem;
}
@media screen and (max-width: 768px) {
  .f1-t {
    font-size: 3rem;
  }
  .f2-t {
    font-size: 2.25rem;
  }
  .f3-t {
    font-size: 1.5rem;
  }
  .f4-t {
    font-size: 1.25rem;
  }
  .f5-t {
    font-size: 1rem;
  }
  .f6-t {
    font-size: .875rem;
  }
  .f7-t {
    font-size: .75rem;
  }
}
@media screen and (max-width: 520px) {
  .f1-m {
    font-size: 3rem;
  }
  .f2-m {
    font-size: 2.25rem;
  }
  .f3-m {
    font-size: 1.5rem;
  }
  .f4-m {
    font-size: 1.25rem;
  }
  .f5-m {
    font-size: 1rem;
  }
  .f6-m {
    font-size: .875rem;
  }
  .f7-m {
    font-size: .75rem;
  }
}
.untracked {
  letter-spacing: normal;
}
.tracked {
  letter-spacing: 0.1rem;
}
.tracked-cosy {
  letter-spacing: -0.005rem;
}
.tracked-tight {
  letter-spacing: -0.05rem;
}
.tracked-mega {
  letter-spacing: 0.25rem;
}
.normal {
  font-weight: normal;
}
.b {
  font-weight: bold;
}
.lighter {
  font-weight: lighter;
}
.fw2 {
  font-weight: 200;
}
.fw3 {
  font-weight: 300;
}
.fw4 {
  font-weight: 400;
}
.fw5 {
  font-weight: 500;
}
.fw6 {
  font-weight: 600;
}
.fw7 {
  font-weight: 700;
}
.fw8 {
  font-weight: 800;
}
.i {
  font-style: italic;
}
.fs-normal {
  font-style: normal;
}
.lh-solid {
  line-height: 1;
}
.lh-headline {
  line-height: 1.17;
}
.lh-title {
  line-height: 1.25;
}
.lh-copy-variant {
  line-height: 1.44;
}
.lh-copy {
  line-height: 1.5;
}
.lh-pagination {
  line-height: 1.75;
}
.lh-copy--spaced {
  line-height: 2.25;
}
.tc {
  text-align: center;
}
.tr {
  text-align: right;
}
.tl {
  text-align: left;
}
@media screen and (max-width: 520px) {
  .tc-m {
    text-align: center;
  }
  .tr-m {
    text-align: right;
  }
  .tl-m {
    text-align: left;
  }
}
.vt {
  vertical-align: top;
}
.vm {
  vertical-align: middle;
}
.vbs {
  vertical-align: baseline;
}
.no-underline {
  text-decoration: none;
}
.underline {
  text-decoration: underline;
}
.decoration-inherit {
  text-decoration: inherit;
}
.hover-underline:hover {
  text-decoration: underline;
}
.hover-no-underline:hover {
  text-decoration: none;
}
.hover-b:hover {
  font-weight: bold;
}
.ws-normal {
  white-space: normal;
}
.nowrap {
  white-space: nowrap;
}
.pre {
  white-space: pre;
}
@media screen and (max-width: 520px) {
  .ws-normal-m {
    white-space: normal;
  }
}
.o-auto {
  overflow: auto;
}
.o-hidden {
  overflow: hidden;
}
.truncate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.ttc {
  text-transform: capitalize;
}
.ttl {
  text-transform: lowercase;
}
.ttn {
  text-transform: none;
}
.ttu {
  text-transform: uppercase;
}
.measure {
  max-width: 30em;
}
.measure-wide {
  max-width: 34em;
}
.measure-narrow {
  max-width: 20em;
}
@media screen and (min-width: 769px) {
  .measure-d {
    max-width: 30em;
  }
  .measure-wide-d {
    max-width: 34em;
  }
  .measure-narrow-d {
    max-width: 20em;
  }
}
.indent {
  text-indent: 1rem;
  margin-top: 0;
  margin-bottom: 0;
}
.disable-select {
  -moz-user-select: none;
  /* Firefox */
  -ms-user-select: none;
  /* Internet Explorer */
  -webkit-user-select: none;
  /* Chrome, Safari, and Opera */
  user-select: none;
}
.ds {
  -moz-user-select: none;
  /* Firefox */
  -ms-user-select: none;
  /* Internet Explorer */
  -webkit-user-select: none;
  /* Chrome, Safari, and Opera */
  user-select: none;
}
.wb-all {
  word-break: break-all;
}
.wb-word {
  word-break: break-word;
}
.wb-keep {
  word-break: keep-all;
}
@media screen and (max-width: 768px) {
  .wb-all-t {
    word-break: break-all;
  }
}
@media screen and (max-width: 520px) {
  .wb-word-m {
    word-break: break-word;
  }
}
.ca-grid-card {
  height: 26.25rem;
}
.ca-grid-card a {
  color: #0bb9b5;
  text-decoration: none;
}
.ca-grid-card a:hover {
  text-decoration: underline;
}
.arrow-link {
  text-decoration: none !important;
}
.arrow-link a {
  color: #6288A5 !important;
}
.arrow-link svg {
  color: #111111 !important;
}
.arrow-link:hover * {
  color: #128a93 !important;
  text-decoration: underline !important;
}
.ca-content a {
  color: #0bb9b5;
  text-decoration: none;
}
.ca-content > ul {
  list-style-type: initial;
  padding-left: 1rem;
}
.ca-tile-title p {
  margin: 0 !important;
}
.ca-article-headline-title {
  line-height: 1.17;
  margin-top: 1.5rem;
  margin-bottom: 0.375rem;
}
.announcements-content div:first-child > h3:first-child {
  margin-top: 0;
}
.announcements-content div:not(:first-child) > h3 {
  margin-top: 3rem;
}
.announcements-content h3 {
  font-size: 1.25rem;
  font-weight: 800;
  margin: 1.25rem 0 0.4rem;
  color: #111111;
}
.announcements-content strong {
  color: #111111;
  letter-spacing: 0.1px;
}
.announcements-content p,
.announcements-content li {
  font-size: 0.9375rem;
  color: #404040;
  line-height: 1.17;
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
}
.announcements-content li {
  letter-spacing: 0.1px;
}
.announcements-content a {
  text-decoration: none;
  color: #0bb9b5;
}
.announcements-content a:hover {
  text-decoration: underline;
}
.announcements-content ul,
.announcements-content ol {
  padding-left: 1.5rem;
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
}
.announcements-content div:first-child > p:first-child {
  margin-top: 0.5rem;
}
.announcements-content div:first-child > ul:first-child {
  margin-top: 0.5rem;
}
.announcements-content div:first-child > ul:first-child > li:first-child {
  margin-top: 0.25rem;
}
.article-page-icons .svg-base {
  margin-left: 0.375rem;
  margin-right: 0.375rem;
  height: 24px !important;
  width: 24px !important;
}
.article-page-icons .MuiIconButton-root {
  color: #6288A5;
  outline: 0;
  padding: 0;
  height: 2.5rem;
  width: 2.5rem;
  font-size: inherit;
}
.article-page-icons .MuiIconButton-root:hover {
  color: #128a93;
}
.share-buttons-container .MuiIconButton-root {
  color: #6288A5 !important;
  outline: 0;
  font-size: inherit;
  padding: 4px;
}
.share-buttons-container .MuiIconButton-root:hover {
  color: #128a93;
}
.submit-form-button .MuiButton-root {
  padding: 1rem 2rem;
  color: #FFFFFF;
  background-color: #0bb9b5;
}
.submit-form-button .MuiButton-root:hover {
  background-color: #128a93;
}
.submit-form-button .MuiButton-root:disabled {
  background-color: #73797A;
}
.article-grid a {
  outline: 0 !important;
}
.article-section {
  min-height: 60rem;
}
@media screen and (max-width: 632px) {
  .article-section {
    height: 64rem;
  }
}
@media screen and (max-width: 566px) {
  .article-section {
    height: 66rem;
  }
}
@media screen and (max-width: 430px) {
  .article-section {
    height: 70rem;
  }
}
@media screen and (max-width: 420px) {
  .article-section {
    height: 72rem;
  }
}
@media screen and (max-width: 382px) {
  .article-section {
    height: 76rem;
  }
}
@media screen and (max-width: 382px) {
  .article-section {
    height: 80rem;
  }
}
.Toastify__progress-bar--default {
  background: #3FC599;
}
.icon-clipboard-container,
.icon-preview-toggle-container {
  width: 32px;
  height: 32px;
}
.icon-clipboard-container .MuiSvgIcon-root,
.icon-preview-toggle-container .MuiSvgIcon-root {
  width: 32px;
  height: 32px;
}
.icon-clipboard-container:hover,
.icon-preview-toggle-container:hover {
  color: #128a93 !important;
}
.expand-more-button {
  width: 100%;
  height: 0;
  text-align: center;
}
.expand-more-button-container {
  background: -webkit-linear-gradient(top, rgba(255, 255, 255, 0) 0%, #ededed 75%);
  background: -moz-linear-gradient(top, rgba(255, 255, 255, 0) 0%, #ededed 75%);
  background: -ms-linear-gradient(top, rgba(255, 255, 255, 0) 0%, #ededed 75%);
  background: -o-linear-gradient(top, rgba(255, 255, 255, 0) 0%, #ededed 75%);
  background: linear-gradient(top, rgba(255, 255, 255, 0) 0%, #ededed 75%);
}
.tile-frosted-bottom {
  background: #ffffff;
  background: linear-gradient(0deg, #ffffff 0%, rgba(255, 255, 255, 0) 100%);
  /*.linear-gradient(top, rgba(255, 255, 255, 0), 0%, rgb(255, 255, 255), 100%);*/
}
.tooltip-wrapper::before {
  position: absolute;
  left: 0;
  width: 1.5rem;
  top: 0;
  bottom: 0;
  content: '';
  z-index: 5;
  background: linear-gradient(270deg, rgba(255, 255, 255, 0) 0%, #ededed 100%);
}
.tooltip-wrapper::after {
  position: absolute;
  right: 0;
  width: 1.5rem;
  top: 0;
  bottom: 0;
  content: '';
  background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, #ededed 100%);
}
.hover-bg-ghost-grey:hover {
  background-color: #F7F9FA;
}
.bg-precedents-blue-30 {
  background-color: rgba(0, 75, 122, 0.3);
}
.bg-precedents-blue-20 {
  background-color: rgba(0, 75, 122, 0.2);
}
.bg-precedents-blue-10 {
  background-color: rgba(0, 75, 122, 0.1);
}
.bg-precedents-blue-5 {
  background-color: rgba(0, 75, 122, 0.05);
}
.hover-bg-precedents-blue-10:hover {
  background-color: rgba(0, 75, 122, 0.1);
}
.hover-bg-precedents-blue-20:hover {
  background-color: rgba(0, 75, 122, 0.2);
}
.precedents-tile .MuiButton-root:hover {
  background-color: rgba(0, 75, 122, 0.1);
}
.precedents-description p {
  margin: 0 0 10px;
}
.bg-precedents-blue-exp {
  background-color: #004b7a !important;
}
.action-buttons button {
  cursor: pointer;
  background-color: #FFFFFF;
}
.menu-list-button {
  -moz-appearance: menulist-button;
  -webkit-appearance: menulist-button;
}
.texteditor .DraftEditor-root {
  padding: 0.5em;
  margin: 0;
  background: rgba(255, 255, 255, 0.5);
  border: 1px solid rgba(0, 0, 0, 0.1);
  min-height: 17rem;
  position: relative;
}
.texteditor .side-toolbar {
  position: absolute;
  top: 25px;
  right: 0;
  bottom: 0;
  left: 0;
  width: 2em;
  transition: top 0.2s;
}
.texteditor .side-toolbar .svg-icon {
  color: rgba(0, 0, 0, 0.2);
  fill: rgba(0, 0, 0, 0.2);
  font-size: 1.4em;
  cursor: pointer;
  vertical-align: middle;
}
.texteditor .side-toolbar .svg-icon.a-menu {
  font-size: 1.4em;
}
.texteditor .public-DraftEditorPlaceholder-root {
  position: absolute;
}
.texteditor .paragraph,
.public-DraftStyleDefault-ul,
.public-DraftStyleDefault-ol {
  margin-bottom: 0;
}
.public-DraftStyleDefault-ul,
.public-DraftStyleDefault-ol {
  margin-top: 0;
}
.texteditor {
  position: relative;
  padding-left: 2em;
}
.texteditor .paragraph {
  margin-bottom: 0.5em;
}
.texteditor blockquote {
  padding: 10px 20px;
  margin: 0 0 20px;
  border-left: 5px solid #eee;
}
.texteditor img {
  max-width: 100%;
}
.texteditor .toolbar {
  position: absolute;
  z-index: 9999;
  height: 2em;
  cursor: default;
  pointer-events: none;
  transition: opacity 0.2s;
  opacity: 0;
}
.texteditor .toolbar.side {
  top: 0;
  left: -1px;
}
.texteditor .toolbar.active {
  opacity: 1;
  pointer-events: all;
}
.texteditor .toolbar.inline {
  font-size: 1.1em;
}
.texteditor .toolbar .toolbar-icons {
  position: relative;
  z-index: 1;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  list-style: none;
  height: 100%;
  margin: 0;
  padding: 0;
  background: #f5f5f5;
  border: 1px solid #ddd;
  font-size: 1em;
}
.texteditor .toolbar .toolbar-icons .toolbar-static {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  background: #ddd;
  width: 2.1em;
  max-width: 2.1em;
}
.texteditor .toolbar .toolbar-icons .toolbar-static .svg-icon {
  fill: #000;
  width: auto;
  height: auto;
  margin: 0;
}
.texteditor .toolbar .toolbar-icons .toolbar-icon {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: baseline;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  height: 100%;
  width: 2.4em;
  line-height: 2.5em;
  max-width: 2.4em;
  font-size: 0.8em;
  color: #aaa;
  transition: all 0.15s linear;
  cursor: pointer;
}
.texteditor .toolbar .toolbar-icons .toolbar-icon.active,
.texteditor .toolbar .toolbar-icons .toolbar-icon:hover {
  color: #222;
}
.texteditor .toolbar .toolbar-icons .toolbar-icon.active .svg-icon,
.texteditor .toolbar .toolbar-icons .toolbar-icon:hover .svg-icon {
  fill: #222;
  color: #222;
}
.texteditor .toolbar-icon:hover .toolbar .toolbar-icons .toolbar-icon i {
  margin: 0;
  padding: 0;
  color: #444;
  font-size: 1.8em;
}
.link-editor {
  display: block;
  max-width: 800px;
  margin: auto;
  width: 96%;
  background: #ffffff;
  padding: 5px 20px 20px;
  font-size: 1.3em;
}
.link-editor .form-actions {
  text-align: right;
  margin-top: 1em;
}
.link-editor .form-actions a {
  display: inline-block;
  font-size: 1em;
  width: 10em;
  margin: 0 0.5em;
}
@media screen and (max-width: 520px) {
  .link-editor .form-actions {
    text-align: center;
    margin: 1em 0;
  }
  .link-editor .form-actions a {
    width: 60%;
    margin: 0.2em 0;
  }
}
.link-editor .input-container {
  padding: 1em 2em;
}
.link-editor .input-container input {
  width: 100%;
  font-size: 1.1em;
  padding: 0.4em;
  outline: none;
  border: 2px solid #eee;
  border-radius: 2px;
}
.group .texteditor {
  padding: 18px 64px 18px 64px;
  font-size: 1.5rem;
  display: block;
  font-weight: 400;
}
.group .toggle-texteditor {
  margin: 0 1em 1em 1em;
}
.group .toggle-texteditor svg {
  fill: #fff;
}
.placeholder-cadet-blue-important input::placeholder {
  color: #6288A5 !important;
  opacity: 1;
}
.date-picker input::placeholder {
  color: #6288A5 !important;
  opacity: 1;
}
.date-picker input {
  background: transparent;
  border: 1px solid;
  width: 11rem;
}
.date-picker .react-datepicker-popper {
  left: -2.25rem !important;
  top: 0 !important;
  z-index: 2;
}
.filter-checkbox-icon {
  width: 1rem;
}
.filter-checkbox-icon svg g {
  stroke: none;
}
.drawer-svg-icon svg {
  top: 0;
}
.header-action-button.MuiButtonBase-root {
  background-color: rgba(255, 202, 40, 0.3);
}
.header-action-button.MuiButtonBase-root:hover {
  background-color: #FFCA28;
}
.header-action-button-disabled.MuiButton-root.Mui-disabled {
  color: #6288A5;
}
.svg-stroke-white svg path,
.svg-stroke-white svg polyline {
  stroke: #FFFFFF;
}
.svg-stroke-cadet-blue svg path,
.svg-stroke-cadet-blue svg polyline {
  stroke: #6288A5;
}
.svg-fill-cadet-blue svg {
  fill: #6288A5;
}
.svg-fill-white svg {
  fill: #FFFFFF;
}
/*

  Fix
  ---

  Fixes! Add a comment explaining what bug it fixes and if you found the
  solution on e.g. StackOverflow then include the link.

*/
.chrome-nested-flex-column-fix {
  min-width: 0;
  min-height: 0;
}
.clearfix:before,
.clearfix:after {
  content: " ";
  display: table;
}
.clearfix:after {
  clear: both;
}
@media screen and (min-width: 769px) {
  .firefox-flex-grow-fix {
    flex-basis: 0;
  }
}
.ie-fix-justify-evenly {
  justify-content: space-around;
}
@supports (-ms-ime-align: auto) {
  .justify-evenly {
    justify-content: space-around;
  }
}
.ie-hide-default-select-chevron::-ms-expand {
  display: none;
}
.margin-collapse-fix:after {
  content: '';
  overflow: auto;
  display: block;
}
.no-csspositionsticky .ie-sticky-fix {
  position: fixed;
}
.safari-border-image-fix {
  border-right: 0 solid transparent;
}
.muiButtonHoverLinesFix.muiButtonHoverLinesFix:hover {
  text-decoration: none;
}
select::-ms-expand {
  display: none;
}
.ie-min-height-flex-items-center-fix {
  padding-top: 0.875rem !important;
  padding-bottom: 0.875rem !important;
}
.ie-min-height-flex-items-center-fix .ie-prefix-hack {
  top: 0.875rem;
}
.popover.bottom > .arrow::after {
  border-bottom-color: #004b7a !important;
}
.ie-layout-fix {
  max-width: 100%;
}
.ie-layout-fix > div {
  padding-top: 0;
  padding-bottom: 0;
  margin-top: 0;
  margin-bottom: 0;
  margin-left: auto;
  margin-right: auto;
  max-width: 1200px;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
@media screen and (max-width: 768px) {
  .ie-layout-fix > div {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
}
@media screen and (max-width: 520px) {
  .ie-layout-fix > div {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }
}
.ie-side {
  display: block;
}
.items-center-ie-fix {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.outline-0 select:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 #000;
}
@media screen and (max-width: 520px) {
  .header-icon-mobile-width {
    width: 2.25rem;
  }
}
/* Stops table wrapping onto new line - see FC-1436*/
@media only screen and (min-width: 1200px) {
  /* Duplicating class selector to increase specificity of rule to overwrite layout-width-constraints max-width */
  .deal-watch-width-constraint {
    width: 72vw !important;
  }
}
.deal-watch-width-constraint {
  width: 96vw;
}
.popover-content a {
  color: #FFFFFF;
}
.new-ticker div p {
  margin: 0;
}
.icon-button-bg-color-active {
  background-color: rgba(0, 0, 0, 0.04);
}
.rich-text-editor .public-DraftEditor-content {
  min-height: 12rem;
}
.ie-basis0-fix {
  flex-basis: auto;
}
/*

  Grid
  ----

  You can use the .grid-with-gutters(@n, @gw) mixin to create a grid structure
  with n items per row and gutter width gw.

  Note that the styles inside the media queries don't apply to smaller screen
  widths!
  i.e. if you want a grid that has 4 items per row on desktop and tablet and 1
  on mobile you would need grid-4-gutter-4-d, grid-4-gutter-4-t and
  grid-1-gutter-4-d.

  This is because the margins on the nth children (which are the outermost items
  in the grid) can't be reliably overridden.

*/
.grid-1-gutter-4 {
  display: flex;
  flex-wrap: wrap;
}
.grid-1-gutter-4 > * {
  width: calc((100% / 1) - 0rem);
  margin: 0.25rem;
}
.grid-1-gutter-4 > *:nth-child(1n - 0) {
  margin-left: 0;
}
.grid-1-gutter-4 > *:nth-child(1n) {
  margin-right: 0;
}
.grid-1-gutter-4 > *:nth-child(-n + 1) {
  margin-top: 0;
}
.grid-1-gutter-4 > *:nth-last-child(-n + 1) {
  margin-bottom: 0;
}
.grid-2-gutter-4 {
  display: flex;
  flex-wrap: wrap;
}
.grid-2-gutter-4 > * {
  width: calc((100% / 2) - 1rem);
  margin: 0.25rem;
}
.grid-2-gutter-4 > *:nth-child(2n - 1) {
  margin-left: 0;
}
.grid-2-gutter-4 > *:nth-child(2n) {
  margin-right: 0;
}
.grid-2-gutter-4 > *:nth-child(-n + 2) {
  margin-top: 0;
}
.grid-2-gutter-4 > *:nth-last-child(-n + 2) {
  margin-bottom: 0;
}
.grid-3-gutter-4 {
  display: flex;
  flex-wrap: wrap;
}
.grid-3-gutter-4 > * {
  width: calc((100% / 3) - 1rem);
  margin: 0.25rem;
}
.grid-3-gutter-4 > *:nth-child(3n - 2) {
  margin-left: 0;
}
.grid-3-gutter-4 > *:nth-child(3n) {
  margin-right: 0;
}
.grid-3-gutter-4 > *:nth-child(-n + 3) {
  margin-top: 0;
}
.grid-3-gutter-4 > *:nth-last-child(-n + 3) {
  margin-bottom: 0;
}
.grid-4-gutter-4 {
  display: flex;
  flex-wrap: wrap;
}
.grid-4-gutter-4 > * {
  width: calc((100% / 4) - 1rem);
  margin: 0.25rem;
}
.grid-4-gutter-4 > *:nth-child(4n - 3) {
  margin-left: 0;
}
.grid-4-gutter-4 > *:nth-child(4n) {
  margin-right: 0;
}
.grid-4-gutter-4 > *:nth-child(-n + 4) {
  margin-top: 0;
}
.grid-4-gutter-4 > *:nth-last-child(-n + 4) {
  margin-bottom: 0;
}
.grid-5-gutter-4 {
  display: flex;
  flex-wrap: wrap;
}
.grid-5-gutter-4 > * {
  width: calc((100% / 5) - 1rem);
  margin: 0.25rem;
}
.grid-5-gutter-4 > *:nth-child(5n - 4) {
  margin-left: 0;
}
.grid-5-gutter-4 > *:nth-child(5n) {
  margin-right: 0;
}
.grid-5-gutter-4 > *:nth-child(-n + 5) {
  margin-top: 0;
}
.grid-5-gutter-4 > *:nth-last-child(-n + 5) {
  margin-bottom: 0;
}
@media screen and (min-width: 769px) {
  .grid-1-gutter-4-d {
    display: flex;
    flex-wrap: wrap;
  }
  .grid-1-gutter-4-d > * {
    width: calc((100% / 1) - 0rem);
    margin: 0.25rem;
  }
  .grid-1-gutter-4-d > *:nth-child(1n - 0) {
    margin-left: 0;
  }
  .grid-1-gutter-4-d > *:nth-child(1n) {
    margin-right: 0;
  }
  .grid-1-gutter-4-d > *:nth-child(-n + 1) {
    margin-top: 0;
  }
  .grid-1-gutter-4-d > *:nth-last-child(-n + 1) {
    margin-bottom: 0;
  }
  .grid-2-gutter-4-d {
    display: flex;
    flex-wrap: wrap;
  }
  .grid-2-gutter-4-d > * {
    width: calc((100% / 2) - 1rem);
    margin: 0.25rem;
  }
  .grid-2-gutter-4-d > *:nth-child(2n - 1) {
    margin-left: 0;
  }
  .grid-2-gutter-4-d > *:nth-child(2n) {
    margin-right: 0;
  }
  .grid-2-gutter-4-d > *:nth-child(-n + 2) {
    margin-top: 0;
  }
  .grid-2-gutter-4-d > *:nth-last-child(-n + 2) {
    margin-bottom: 0;
  }
  .grid-3-gutter-4-d {
    display: flex;
    flex-wrap: wrap;
  }
  .grid-3-gutter-4-d > * {
    width: calc((100% / 3) - 1rem);
    margin: 0.25rem;
  }
  .grid-3-gutter-4-d > *:nth-child(3n - 2) {
    margin-left: 0;
  }
  .grid-3-gutter-4-d > *:nth-child(3n) {
    margin-right: 0;
  }
  .grid-3-gutter-4-d > *:nth-child(-n + 3) {
    margin-top: 0;
  }
  .grid-3-gutter-4-d > *:nth-last-child(-n + 3) {
    margin-bottom: 0;
  }
  .grid-4-gutter-4-d {
    display: flex;
    flex-wrap: wrap;
  }
  .grid-4-gutter-4-d > * {
    width: calc((100% / 4) - 1rem);
    margin: 0.25rem;
  }
  .grid-4-gutter-4-d > *:nth-child(4n - 3) {
    margin-left: 0;
  }
  .grid-4-gutter-4-d > *:nth-child(4n) {
    margin-right: 0;
  }
  .grid-4-gutter-4-d > *:nth-child(-n + 4) {
    margin-top: 0;
  }
  .grid-4-gutter-4-d > *:nth-last-child(-n + 4) {
    margin-bottom: 0;
  }
  .grid-5-gutter-4-d {
    display: flex;
    flex-wrap: wrap;
  }
  .grid-5-gutter-4-d > * {
    width: calc((100% / 5) - 1rem);
    margin: 0.25rem;
  }
  .grid-5-gutter-4-d > *:nth-child(5n - 4) {
    margin-left: 0;
  }
  .grid-5-gutter-4-d > *:nth-child(5n) {
    margin-right: 0;
  }
  .grid-5-gutter-4-d > *:nth-child(-n + 5) {
    margin-top: 0;
  }
  .grid-5-gutter-4-d > *:nth-last-child(-n + 5) {
    margin-bottom: 0;
  }
}
@media screen and (min-width: 520px) and (max-width: 768px) {
  .grid-1-gutter-4-t {
    display: flex;
    flex-wrap: wrap;
  }
  .grid-1-gutter-4-t > * {
    width: calc((100% / 1) - 0rem);
    margin: 0.25rem;
  }
  .grid-1-gutter-4-t > *:nth-child(1n - 0) {
    margin-left: 0;
  }
  .grid-1-gutter-4-t > *:nth-child(1n) {
    margin-right: 0;
  }
  .grid-1-gutter-4-t > *:nth-child(-n + 1) {
    margin-top: 0;
  }
  .grid-1-gutter-4-t > *:nth-last-child(-n + 1) {
    margin-bottom: 0;
  }
  .grid-2-gutter-4-t {
    display: flex;
    flex-wrap: wrap;
  }
  .grid-2-gutter-4-t > * {
    width: calc((100% / 2) - 1rem);
    margin: 0.25rem;
  }
  .grid-2-gutter-4-t > *:nth-child(2n - 1) {
    margin-left: 0;
  }
  .grid-2-gutter-4-t > *:nth-child(2n) {
    margin-right: 0;
  }
  .grid-2-gutter-4-t > *:nth-child(-n + 2) {
    margin-top: 0;
  }
  .grid-2-gutter-4-t > *:nth-last-child(-n + 2) {
    margin-bottom: 0;
  }
  .grid-3-gutter-4-t {
    display: flex;
    flex-wrap: wrap;
  }
  .grid-3-gutter-4-t > * {
    width: calc((100% / 3) - 1rem);
    margin: 0.25rem;
  }
  .grid-3-gutter-4-t > *:nth-child(3n - 2) {
    margin-left: 0;
  }
  .grid-3-gutter-4-t > *:nth-child(3n) {
    margin-right: 0;
  }
  .grid-3-gutter-4-t > *:nth-child(-n + 3) {
    margin-top: 0;
  }
  .grid-3-gutter-4-t > *:nth-last-child(-n + 3) {
    margin-bottom: 0;
  }
  .grid-4-gutter-4-t {
    display: flex;
    flex-wrap: wrap;
  }
  .grid-4-gutter-4-t > * {
    width: calc((100% / 4) - 1rem);
    margin: 0.25rem;
  }
  .grid-4-gutter-4-t > *:nth-child(4n - 3) {
    margin-left: 0;
  }
  .grid-4-gutter-4-t > *:nth-child(4n) {
    margin-right: 0;
  }
  .grid-4-gutter-4-t > *:nth-child(-n + 4) {
    margin-top: 0;
  }
  .grid-4-gutter-4-t > *:nth-last-child(-n + 4) {
    margin-bottom: 0;
  }
  .grid-5-gutter-4-t {
    display: flex;
    flex-wrap: wrap;
  }
  .grid-5-gutter-4-t > * {
    width: calc((100% / 5) - 1rem);
    margin: 0.25rem;
  }
  .grid-5-gutter-4-t > *:nth-child(5n - 4) {
    margin-left: 0;
  }
  .grid-5-gutter-4-t > *:nth-child(5n) {
    margin-right: 0;
  }
  .grid-5-gutter-4-t > *:nth-child(-n + 5) {
    margin-top: 0;
  }
  .grid-5-gutter-4-t > *:nth-last-child(-n + 5) {
    margin-bottom: 0;
  }
}
@media screen and (max-width: 520px) {
  .grid-1-gutter-4-m {
    display: flex;
    flex-wrap: wrap;
  }
  .grid-1-gutter-4-m > * {
    width: calc((100% / 1) - 0rem);
    margin: 0.25rem;
  }
  .grid-1-gutter-4-m > *:nth-child(1n - 0) {
    margin-left: 0;
  }
  .grid-1-gutter-4-m > *:nth-child(1n) {
    margin-right: 0;
  }
  .grid-1-gutter-4-m > *:nth-child(-n + 1) {
    margin-top: 0;
  }
  .grid-1-gutter-4-m > *:nth-last-child(-n + 1) {
    margin-bottom: 0;
  }
  .grid-2-gutter-4-m {
    display: flex;
    flex-wrap: wrap;
  }
  .grid-2-gutter-4-m > * {
    width: calc((100% / 2) - 1rem);
    margin: 0.25rem;
  }
  .grid-2-gutter-4-m > *:nth-child(2n - 1) {
    margin-left: 0;
  }
  .grid-2-gutter-4-m > *:nth-child(2n) {
    margin-right: 0;
  }
  .grid-2-gutter-4-m > *:nth-child(-n + 2) {
    margin-top: 0;
  }
  .grid-2-gutter-4-m > *:nth-last-child(-n + 2) {
    margin-bottom: 0;
  }
  .grid-3-gutter-4-m {
    display: flex;
    flex-wrap: wrap;
  }
  .grid-3-gutter-4-m > * {
    width: calc((100% / 3) - 1rem);
    margin: 0.25rem;
  }
  .grid-3-gutter-4-m > *:nth-child(3n - 2) {
    margin-left: 0;
  }
  .grid-3-gutter-4-m > *:nth-child(3n) {
    margin-right: 0;
  }
  .grid-3-gutter-4-m > *:nth-child(-n + 3) {
    margin-top: 0;
  }
  .grid-3-gutter-4-m > *:nth-last-child(-n + 3) {
    margin-bottom: 0;
  }
  .grid-4-gutter-4-m {
    display: flex;
    flex-wrap: wrap;
  }
  .grid-4-gutter-4-m > * {
    width: calc((100% / 4) - 1rem);
    margin: 0.25rem;
  }
  .grid-4-gutter-4-m > *:nth-child(4n - 3) {
    margin-left: 0;
  }
  .grid-4-gutter-4-m > *:nth-child(4n) {
    margin-right: 0;
  }
  .grid-4-gutter-4-m > *:nth-child(-n + 4) {
    margin-top: 0;
  }
  .grid-4-gutter-4-m > *:nth-last-child(-n + 4) {
    margin-bottom: 0;
  }
  .grid-5-gutter-4-m {
    display: flex;
    flex-wrap: wrap;
  }
  .grid-5-gutter-4-m > * {
    width: calc((100% / 5) - 1rem);
    margin: 0.25rem;
  }
  .grid-5-gutter-4-m > *:nth-child(5n - 4) {
    margin-left: 0;
  }
  .grid-5-gutter-4-m > *:nth-child(5n) {
    margin-right: 0;
  }
  .grid-5-gutter-4-m > *:nth-child(-n + 5) {
    margin-top: 0;
  }
  .grid-5-gutter-4-m > *:nth-last-child(-n + 5) {
    margin-bottom: 0;
  }
}
/*

  Helpers
  -------

  This file is for mixins and helpful generic classes that aren't simple enough
  to be considered a utility class. Should be used sparingly!

*/
.screen-reader-text {
  border: 0;
  clip: rect(1px, 1px, 1px, 1px);
  clip-path: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute !important;
  width: 1px;
  word-wrap: normal !important;
}
.center {
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -o-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
.center-h {
  left: 50%;
  -webkit-transform: translateX(-50%);
  -moz-transform: translateX(-50%);
  -o-transform: translateX(-50%);
  -ms-transform: translateX(-50%);
  transform: translateX(-50%);
}
.center-v {
  top: 50%;
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}
/*
 * Hamburgers
 * @description Tasty CSS-animated hamburgers
 * @author Jonathan Suh @jonsuh
 * @site https://jonsuh.com/hamburgers
 * @link https://github.com/jonsuh/hamburgers
 */
.hamburger {
  padding: 0;
  display: inline-block;
  cursor: pointer;
  transition-property: opacity, filter;
  transition-duration: 0.15s;
  transition-timing-function: linear;
  font: inherit;
  color: inherit;
  text-transform: none;
  background-color: transparent;
  border: 0;
  margin: 0;
  overflow: visible;
  position: relative;
  width: 100%;
  height: 100%;
}
.hamburger:hover {
  opacity: 0.7;
}
.hamburger-box {
  width: 100%;
  height: 100%;
  display: inline-block;
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -o-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
.hamburger-inner {
  display: block;
  width: 100%;
  height: 2px;
  border-radius: 4px;
  position: absolute;
  background-color: #111111;
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}
.hamburger-inner-1 {
  top: 0;
}
.hamburger-inner-2 {
  top: 50%;
}
.hamburger-inner-3 {
  top: 100%;
}
/*

  Custom
  ------

  Add any styling that can't be constructed from the generic styles to this
  file. Include a comment explaining what the styling does.

  This file should be used as a last resort.

*/
.logo-width {
  width: 12rem;
}
@media screen and (max-width: 768px) {
  .logo-width {
    width: 3rem;
  }
}
@media screen and (max-width: 520px) {
  .logo-width {
    width: 2rem;
  }
}
.nav-full-right {
  width: 16rem;
  -webkit-transform: translate(16rem, 0);
  -moz-transform: translate(16rem, 0);
  -o-transform: translate(16rem, 0);
  -ms-transform: translate(16rem, 0);
  transform: translate(16rem, 0);
}
.application-header,
.application-content,
.nav-full-right {
  -webkit-transition: transform 0.3s;
  -moz-transition: transform 0.3s;
  -ms-transition: transform 0.3s;
  -o-transition: transform 0.3s;
  transition: transform 0.3s;
}
.show-navigation .application-header,
.show-navigation .application-content {
  -webkit-transform: translate(-16rem, 0);
  -moz-transform: translate(-16rem, 0);
  -o-transform: translate(-16rem, 0);
  -ms-transform: translate(-16rem, 0);
  transform: translate(-16rem, 0);
}
.show-navigation .nav-full-right {
  -webkit-transform: translate(0.0001px, 0);
  -moz-transform: translate(0.0001px, 0);
  -o-transform: translate(0.0001px, 0);
  -ms-transform: translate(0.0001px, 0);
  transform: translate(0.0001px, 0);
}
.accordion-header-center {
  line-height: 3rem;
}
.pop-faqs-icon svg {
  margin-top: 4px;
}
.o-50-hover:hover {
  -webkit-opacity: 0.5;
  -moz-opacity: 0.5;
  opacity: 0.5;
}
.feedback-container {
  position: relative;
  min-height: 8rem;
  -webkit-transition: all 0.2s ease;
  -moz-transition: all 0.2s ease;
  -o-transition: all 0.2s ease;
  transition: all 0.2s ease;
  width: 32rem;
}
@media screen and (max-width: 555px) {
  .feedback-container {
    max-width: 390px;
  }
}
@media screen and (max-width: 425px) {
  .feedback-container {
    max-width: 380px;
  }
}
@media screen and (max-width: 375px) {
  .feedback-container {
    max-width: 330px;
  }
}
@media screen and (max-width: 320px) {
  .feedback-container {
    max-width: 280px;
  }
}
.feedback-button {
  left: 0;
  transform: rotate(270deg) translateY(-5rem) translateX(-2.95rem);
}
.fade-out-overlay::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(rgba(255, 255, 255, 0), #F7F9FA);
}
.account-item-rows > a,
.account-item-rows > div,
.account-item-rows > li {
  text-decoration: none;
}
.account-item-rows > a:nth-child(even),
.account-item-rows > div:nth-child(even),
.account-item-rows > li:nth-child(even) {
  background-color: #FFFFFF;
}
.account-overlay {
  max-width: 800px;
  margin: auto;
  width: 96%;
  background: #FFFFFF;
  padding: 5px 20px 20px;
  flex-direction: column;
}
.careerText p {
  margin-bottom: 1rem;
}
@media screen and (max-width: 520px) {
  .mob-team-img-position {
    background-position: 50% 30%;
  }
}
.legislation-tile .MuiButton-root:hover {
  background-color: rgba(132, 97, 156, 0.1);
}
.hover-default-tab-button-bg:hover {
  background-color: rgba(0, 140, 159, 0.15);
}
.qa-tile-full .MuiButton-root:hover {
  background-color: rgba(53, 184, 211, 0.1);
}
.qa-tile-semi .MuiButton-root:hover {
  background-color: rgba(63, 197, 153, 0.1);
}
.qa-tile-skimmed .MuiButton-root:hover {
  background-color: rgba(241, 97, 125, 0.1);
}
.MuiIconButton-colorSecondary.Mui-checked {
  color: inherit;
}
.MuiIconButton-colorSecondary:hover {
  background-color: inherit;
}
.bg-news-publication {
  background-color: #eaf7f0 !important;
}
.bg-news-publication:hover {
  background-color: #c5e8d7 !important;
}
.bg-news-publication.darker {
  background-color: #b3e1cb !important;
}
.bg-flavour-full {
  background-color: #ddf3f7 !important;
}
.bg-flavour-full.darker,
.bg-flavour-full:hover {
  background-color: #b3e4ee !important;
}
.bg-flavour-full .MuiCheckbox-colorSecondary {
  color: #35b8d3 !important;
}
.bg-flavour-full .MuiCheckbox-colorSecondary:hover {
  background-color: rgba(53, 184, 211, 0.1) !important;
}
.bg-flavour-full .MuiCheckbox-colorSecondary .MuiIconButton-colorSecondary:hover {
  color: #35b8d3 !important;
}
.full .MuiCheckbox-colorSecondary {
  color: #35b8d3 !important;
}
.full .MuiCheckbox-colorSecondary:hover {
  background-color: rgba(53, 184, 211, 0.1) !important;
}
.full .MuiCheckbox-colorSecondary .MuiIconButton-colorSecondary:hover {
  color: #35b8d3 !important;
}
.bg-flavour-semi {
  background-color: #dcf4ec !important;
}
.bg-flavour-semi.darker,
.bg-flavour-semi:hover {
  background-color: #b5e8d7 !important;
}
.bg-flavour-semi .MuiCheckbox-colorSecondary {
  color: #3FC599 !important;
}
.bg-flavour-semi .MuiCheckbox-colorSecondary:hover {
  background-color: rgba(63, 197, 153, 0.1) !important;
}
.bg-flavour-semi .MuiCheckbox-colorSecondary .MuiIconButton-colorSecondary:hover {
  color: #3FC599 !important;
}
.semi .MuiCheckbox-colorSecondary {
  color: #3FC599 !important;
}
.semi .MuiCheckbox-colorSecondary:hover {
  background-color: rgba(63, 197, 153, 0.1) !important;
}
.semi .MuiCheckbox-colorSecondary .MuiIconButton-colorSecondary:hover {
  color: #3FC599 !important;
}
.bg-flavour-skimmed {
  background-color: #fdeef1 !important;
}
.bg-flavour-skimmed.darker,
.bg-flavour-skimmed:hover {
  background-color: #f9bfca !important;
}
.bg-flavour-skimmed .MuiCheckbox-colorSecondary {
  color: #F1617D !important;
}
.bg-flavour-skimmed .MuiCheckbox-colorSecondary:hover {
  background-color: rgba(241, 97, 125, 0.1) !important;
}
.bg-flavour-skimmed .MuiCheckbox-colorSecondary .MuiIconButton-colorSecondary:hover {
  color: #F1617D !important;
}
.skimmed .MuiCheckbox-colorSecondary {
  color: #F1617D !important;
}
.skimmed .MuiCheckbox-colorSecondary:hover {
  background-color: rgba(241, 97, 125, 0.1) !important;
}
.skimmed .MuiCheckbox-colorSecondary .MuiIconButton-colorSecondary:hover {
  color: #F1617D !important;
}
.b--flavour-full {
  border-color: #35b8d3;
}
.b--flavour-semi {
  border-color: #3FC599;
}
.b--flavour-skimmed {
  border-color: #F1617D;
}
.hover-bg-flavour-full:hover {
  background-color: #ddf3f7 !important;
}
.hover-bg-flavour-full:hover.darker,
.hover-bg-flavour-full:hover:hover {
  background-color: #b3e4ee !important;
}
.hover-bg-flavour-full:hover .MuiCheckbox-colorSecondary {
  color: #35b8d3 !important;
}
.hover-bg-flavour-full:hover .MuiCheckbox-colorSecondary:hover {
  background-color: rgba(53, 184, 211, 0.1) !important;
}
.hover-bg-flavour-full:hover .MuiCheckbox-colorSecondary .MuiIconButton-colorSecondary:hover {
  color: #35b8d3 !important;
}
.hover-bg-flavour-semi:hover {
  background-color: #dcf4ec !important;
}
.hover-bg-flavour-semi:hover.darker,
.hover-bg-flavour-semi:hover:hover {
  background-color: #b5e8d7 !important;
}
.hover-bg-flavour-semi:hover .MuiCheckbox-colorSecondary {
  color: #3FC599 !important;
}
.hover-bg-flavour-semi:hover .MuiCheckbox-colorSecondary:hover {
  background-color: rgba(63, 197, 153, 0.1) !important;
}
.hover-bg-flavour-semi:hover .MuiCheckbox-colorSecondary .MuiIconButton-colorSecondary:hover {
  color: #3FC599 !important;
}
.hover-bg-flavour-skimmed:hover {
  background-color: #fdeef1 !important;
}
.hover-bg-flavour-skimmed:hover.darker,
.hover-bg-flavour-skimmed:hover:hover {
  background-color: #f9bfca !important;
}
.hover-bg-flavour-skimmed:hover .MuiCheckbox-colorSecondary {
  color: #F1617D !important;
}
.hover-bg-flavour-skimmed:hover .MuiCheckbox-colorSecondary:hover {
  background-color: rgba(241, 97, 125, 0.1) !important;
}
.hover-bg-flavour-skimmed:hover .MuiCheckbox-colorSecondary .MuiIconButton-colorSecondary:hover {
  color: #F1617D !important;
}
.btc--flavour-full {
  border-top-color: #35b8d3;
}
.btc--flavour-semi {
  border-top-color: #3FC599;
}
.btc--flavour-skimmed {
  border-top-color: #F1617D;
}
.highlight-yellow {
  background-color: #FCF8E3 !important;
}
.flavour-tabs {
  font-size: 0.65rem;
}
.h1-5 {
  height: 1.5rem;
}
mark {
  background-color: #fcf8e3;
  color: inherit;
}
.pseudo-arrows > li::after {
  content: ' > ';
  margin: 0 0.25rem;
}
.pseudo-arrows > li:last-child::after {
  content: '';
}
.w-date {
  width: 14.28571429%;
}
.bg-teal-darken-10 {
  background-color: #002c47;
}
.bg-teal-darken-5 {
  background-color: #003b61;
}
.hover-bg-teal-darken-5:hover {
  background-color: #003b61;
}
.hover-bg-teal-darken-10:hover {
  background-color: #002c47;
}
.MuiSpeedDial-actions.comment-menu-speed-dial-actions {
  margin-top: -1.5rem;
  padding-top: 2rem;
}
.side-width,
.ca-left-width {
  width: 20rem;
}
.marketplace-search-button,
.marketplace-search-button.Mui-disabled,
.account-nav-button.Mui-disabled {
  background-color: #0bb9b5;
}
.qa-search-button,
.qa-search-button.Mui-disabled {
  background-color: #35b8d3;
}
.search-drop-down-menu.qa-search-button.MuiButton-contained:hover,
.search-drop-down-menu.marketplace-search-button.MuiButton-contained:hover {
  background-color: #2698af;
}
.dashboard .qa-search-button,
.dashboard .qa-search-button.Mui-disabled {
  background-color: #0bb9b5;
}
.dashboard .search-drop-down-menu.qa-search-button.MuiButton-contained:hover,
.dashboard .search-drop-down-menu.marketplace-search-button.MuiButton-contained:hover {
  background-color: #088986;
}
.faq-header-expanded {
  background-color: #c7fcfa;
}
.faq-header-expanded-content {
  background-color: #088986;
}
.legislation-search-button,
.legislation-search-button.Mui-disabled {
  background-color: #84619C;
}
.search-drop-down-menu.legislation-search-button.MuiButton-contained:hover {
  background-color: #694d7d;
}
.news-search-button,
.news-search-button.Mui-disabled {
  background-color: #0bb9b5;
}
.search-drop-down-menu.news-search-button.MuiButton-contained:hover {
  background-color: #088986;
}
.precedents-search-button,
.precedents-search-button.Mui-disabled {
  background-color: #004b7a;
}
.search-drop-down-menu.precedents-search-button.MuiButton-contained:hover {
  background-color: #002c47;
}
.markets-search-button,
.markets-search-button.Mui-disabled {
  background-color: #008C9F;
}
.search-drop-down-menu.markets-search-button.MuiButton-contained:hover {
  background-color: #005f6c;
}
.news-date-picker-search-button.MuiButton-root:hover {
  background-color: #5CBE75;
}
.search-drop-down-menu.news-date-picker-search-button.MuiButton-contained:hover {
  background-color: #42a55b;
}
.bg-qa-tab::before {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  height: 3px;
  width: 100%;
  -webkit-transition: all 0.2s ease;
  -moz-transition: all 0.2s ease;
  -o-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.bg-qa-tab.selected::before {
  height: 100%;
}
.bg-qa-tab.full:hover::before,
.bg-qa-tab.full.selected::before {
  background-color: #35b8d3;
}
.bg-qa-tab.semi:hover::before,
.bg-qa-tab.semi.selected::before {
  background-color: #3FC599;
}
.bg-qa-tab.skimmed:hover::before,
.bg-qa-tab.skimmed.selected::before {
  background-color: #F1617D;
}
.bg-qa-tab.archive:hover::before,
.bg-qa-tab.archive.selected::before {
  background-color: #73797A;
}
.bg-qa-tab.legislation:hover::before,
.bg-qa-tab.legislation.selected::before {
  background-color: #83619C;
}
.popover.bottom > .arrow {
  position: absolute;
  top: -11px;
}
.popover.bottom > .arrow::after {
  content: ' ';
  top: 1px;
  margin-left: -10px;
  border-width: 10px;
  border-top-width: 0;
  position: absolute;
  display: block;
  width: 0;
  height: 0;
  border-style: solid;
  border-color: transparent;
}
.ca-filter-link:hover {
  color: #5CBE75;
}
.privacy-filter-link:hover svg g {
  stroke: #004b7a;
}
.filter-link:hover svg g {
  stroke: #008C9F;
}
.account-input-label:hover svg g {
  stroke: #004b7a;
}
.account-input-label:hover svg {
  fill: #004b7a;
}
.account-input-checked svg {
  color: #004b7a;
}
.teal-save-button.MuiButton-root:hover {
  background-color: #002c47;
}
.white-cancel-button.MuiButton-root:hover {
  background-color: #e6e6e6;
}
.react-datepicker__navigation {
  border: 0.45rem solid transparent;
}
.react-datepicker__navigation--next {
  border-left-color: #ccc;
}
.react-datepicker__navigation--previous {
  border-right-color: #ccc;
}
.ca-homepage ol li,
.ca-homepage ul li {
  margin: 0.5rem 0;
}
.folder-badge {
  min-width: 1.5rem;
  height: 1.5rem;
  border-radius: 0.75rem;
}
.form-submit-button:hover {
  background-color: #0bb9b5;
}
.form-cancel-button:hover:hover {
  background-color: #D5ECFF;
}
.trial-select-organisation-button:hover {
  background-color: #008C9F;
}
.trial-select-individual-button:hover {
  background-color: #008C9F;
}
.trial-thank-you-finish-button:hover {
  background-color: #5CBE75;
}
.ca-search-date-submit-button:hover {
  background-color: #5CBE75;
}
.dealwatch-search-date-submit-button:hover {
  background-color: #128a93;
}
@media screen and (max-width: 346px) {
  .MuiPickersBasePicker-pickerView {
    padding-right: 1.25rem;
  }
}
.speech-bubble {
  background-color: #ebf0f4;
  padding: 10px 16px;
  position: relative;
  -webkit-border-radius: 12px;
  -moz-border-radius: 12px;
  border-radius: 12px;
}
.speech-bubble:after {
  content: "";
  position: absolute;
  bottom: -2.25rem;
  /* value = - border-top-width - border-bottom-width */
  left: 5.25rem;
  /* controls horizontal position */
  border-width: 2.25rem 3rem 0 0;
  /* vary these values to change the angle of the vertex */
  border-style: solid;
  border-color: #ebf0f3 transparent;
  /* reduce the damage in FF3.0 */
  display: block;
  width: 0;
}
.markets-overview-tile {
  font-size: 18px;
}
.markets-overview-tile:hover {
  background: #d3fdff;
}
.overlay-parameter-header:before {
  content: ' ';
  position: absolute;
  width: 10px;
  height: 10px;
  background: #979797;
}
.overlay-parameter-header-enabled:before {
  background: #73797A;
}
.deal-increase {
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-bottom: 5px solid #5CBE75;
}
.deal-decrease {
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid #CC0033;
}
.comment-controls .mini-speed-dial {
  min-height: 2rem;
  height: 2rem;
  width: 2rem;
}
.comment-controls .MuiSpeedDial-directionDown .MuiSpeedDial-actions {
  padding-top: 42px;
}
.transition-fade-out-slow {
  animation: fadeOut 500ms forwards;
  animation-delay: 0s;
}
@keyframes fadeOut {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    display: none;
  }
}
.indented-section {
  display: block;
  padding-left: 2rem;
}
.esv-interview-label > p {
  margin: 0;
  word-wrap: break-word;
}
.esv-interview-hide-break > br {
  display: none;
}
.esv-interview-toolbar-width {
  width: 100%;
}
@media screen and (min-width: 1200px) {
  .esv-interview-toolbar-width {
    width: calc(100% - 20rem);
  }
}
@media screen and (min-width: 1500px) {
  .esv-interview-toolbar-spacing,
  .esv-footer-spacing {
    margin-left: auto;
    margin-right: auto;
  }
}
@media screen and (min-width: 1450px) {
  .esv-interview-db-l {
    display: block;
  }
  .esv-interview-dn-l {
    display: none;
  }
  .esv-interview-preview-width-l {
    width: 50rem;
  }
}
.angled-text .rv-xy-plot__axis__tick__text {
  transform: rotate(-45deg) translate(-2em, 0.5em);
}
.compact .rv-discrete-color-legend-item {
  padding: 0.1rem 0.2rem;
}
.rv-discrete-color-legend.vertical {
  display: flex;
  flex-wrap: wrap;
  margin-top: 1rem;
}
.rv-discrete-color-legend-item {
  display: flex;
  align-items: center;
  width: 50%;
  flex-grow: 1;
}
.rv-discrete-color-legend-item.vertical {
  padding-bottom: 0;
}
.rv-discrete-color-legend-item .rv-discrete-color-legend-item__color__path {
  stroke-width: 0.5rem;
}
.rv-discrete-color-legend-item .rv-discrete-color-legend-item__color {
  vertical-align: baseline;
}
/* Copyright 2014 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
.textLayer {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  opacity: 0.2;
  line-height: 1.0;
}
.textLayer > div {
  color: transparent;
  position: absolute;
  white-space: pre;
  cursor: text;
  -webkit-transform-origin: 0% 0%;
  -moz-transform-origin: 0% 0%;
  -o-transform-origin: 0% 0%;
  -ms-transform-origin: 0% 0%;
  transform-origin: 0% 0%;
}
.textLayer .highlight {
  margin: -1px;
  padding: 1px;
  background-color: #b400aa;
  border-radius: 4px;
}
.textLayer .highlight.begin {
  border-radius: 4px 0px 0px 4px;
}
.textLayer .highlight.end {
  border-radius: 0px 4px 4px 0px;
}
.textLayer .highlight.middle {
  border-radius: 0px;
}
.textLayer .highlight.selected {
  background-color: #006400;
}
.textLayer ::selection {
  background: #0000ff;
}
.textLayer ::-moz-selection {
  background: #0000ff;
}
.textLayer .endOfContent {
  display: block;
  position: absolute;
  left: 0px;
  top: 100%;
  right: 0px;
  bottom: 0px;
  z-index: -1;
  cursor: default;
  -webkit-user-select: none;
  -ms-user-select: none;
  -moz-user-select: none;
}
.textLayer .endOfContent.active {
  top: 0px;
}
.annotationLayer section {
  position: absolute;
}
.annotationLayer .linkAnnotation > a {
  position: absolute;
  font-size: 1em;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.annotationLayer .linkAnnotation > a {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_14___}) 0 0 repeat;
}
.annotationLayer .linkAnnotation > a:hover {
  opacity: 0.2;
  background: #ff0;
  box-shadow: 0px 2px 10px #ff0;
}
.annotationLayer .textAnnotation img {
  position: absolute;
  cursor: pointer;
}
.annotationLayer .textWidgetAnnotation input,
.annotationLayer .textWidgetAnnotation textarea,
.annotationLayer .choiceWidgetAnnotation select,
.annotationLayer .buttonWidgetAnnotation.checkBox input,
.annotationLayer .buttonWidgetAnnotation.radioButton input {
  background-color: rgba(0, 54, 255, 0.13);
  border: 1px solid transparent;
  box-sizing: border-box;
  font-size: 9px;
  height: 100%;
  padding: 0 3px;
  vertical-align: top;
  width: 100%;
}
.annotationLayer .textWidgetAnnotation textarea {
  font: message-box;
  font-size: 9px;
  resize: none;
}
.annotationLayer .textWidgetAnnotation input[disabled],
.annotationLayer .textWidgetAnnotation textarea[disabled],
.annotationLayer .choiceWidgetAnnotation select[disabled],
.annotationLayer .buttonWidgetAnnotation.checkBox input[disabled],
.annotationLayer .buttonWidgetAnnotation.radioButton input[disabled] {
  background: none;
  border: 1px solid transparent;
  cursor: not-allowed;
}
.annotationLayer .textWidgetAnnotation input:hover,
.annotationLayer .textWidgetAnnotation textarea:hover,
.annotationLayer .choiceWidgetAnnotation select:hover,
.annotationLayer .buttonWidgetAnnotation.checkBox input:hover,
.annotationLayer .buttonWidgetAnnotation.radioButton input:hover {
  border: 1px solid #000;
}
.annotationLayer .textWidgetAnnotation input:focus,
.annotationLayer .textWidgetAnnotation textarea:focus,
.annotationLayer .choiceWidgetAnnotation select:focus {
  background: none;
  border: 1px solid transparent;
}
.annotationLayer .textWidgetAnnotation input.comb {
  font-family: monospace;
  padding-left: 2px;
  padding-right: 0;
}
.annotationLayer .textWidgetAnnotation input.comb:focus {
  /*
   * Letter spacing is placed on the right side of each character. Hence, the
   * letter spacing of the last character may be placed outside the visible
   * area, causing horizontal scrolling. We avoid this by extending the width
   * when the element has focus and revert this when it loses focus.
   */
  width: 115%;
}
.annotationLayer .buttonWidgetAnnotation.checkBox input,
.annotationLayer .buttonWidgetAnnotation.radioButton input {
  -webkit-appearance: none;
  -moz-appearance: none;
  -ms-appearance: none;
  appearance: none;
}
.annotationLayer .popupWrapper {
  position: absolute;
  width: 20em;
}
.annotationLayer .popup {
  position: absolute;
  z-index: 200;
  max-width: 20em;
  background-color: #FFFF99;
  box-shadow: 0px 2px 5px #333;
  border-radius: 2px;
  padding: 0.6em;
  margin-left: 5px;
  cursor: pointer;
  word-wrap: break-word;
}
.annotationLayer .popup h1 {
  font-size: 1em;
  border-bottom: 1px solid #000000;
  padding-bottom: 0.2em;
}
.annotationLayer .popup p {
  padding-top: 0.2em;
}
.annotationLayer .highlightAnnotation,
.annotationLayer .underlineAnnotation,
.annotationLayer .squigglyAnnotation,
.annotationLayer .strikeoutAnnotation,
.annotationLayer .lineAnnotation svg line,
.annotationLayer .fileAttachmentAnnotation {
  cursor: pointer;
}
#pdfViewer {
  flex: 1;
  overflow: auto;
  position: relative;
  max-height: calc(100vh - 13rem);
  max-width: 1000px;
  width: 100%;
  margin: auto;
}
.pdfViewer .canvasWrapper {
  overflow: hidden;
}
.pdfViewer .page {
  direction: ltr;
  width: 816px;
  height: 1056px;
  margin: 20px auto;
  position: relative;
  overflow: visible;
  border: none;
  background-clip: content-box;
  box-shadow: 0 2px 4px 2px rgba(0, 0, 0, 0.2);
  background-color: white;
}
.pdfViewer.removePageBorders .page {
  margin: 0px auto 10px auto;
  border: none;
}
.pdfViewer.singlePageView {
  display: inline-block;
}
.pdfViewer.singlePageView .page {
  margin: 0;
  border: none;
}
.pdfViewer .page canvas {
  margin: 0;
  display: block;
}
.pdfViewer .page canvas[hidden] {
  display: none;
}
.pdfViewer .page .loadingIcon {
  position: absolute;
  display: block;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
}
.pdfPresentationMode:-webkit-full-screen .pdfViewer .page {
  margin-bottom: 100%;
  border: 0;
}
.pdfPresentationMode:-moz-full-screen .pdfViewer .page {
  margin-bottom: 100%;
  border: 0;
}
.pdfPresentationMode:-ms-fullscreen .pdfViewer .page {
  margin-bottom: 100% !important;
  border: 0;
}
.pdfPresentationMode:fullscreen .pdfViewer .page {
  margin-bottom: 100%;
  border: 0;
}
.navigation-item-title .archived-label {
  display: none;
}
.archived-label {
  font-style: normal;
  font-size: 0.9rem;
  background: #83619C;
  padding: 5px;
  padding-right: 5px;
  padding-left: 5px;
  padding-left: 10px;
  padding-right: 10px;
  border-radius: 9999px;
  margin-left: 15px;
  margin-top: -2px;
  color: #fff;
}
.cd-accordion-menu {
  /*background: @color-accordion-base;*/
  list-style: none;
  margin: 0 auto 1.2em auto;
  padding: 0;
}
.cd-accordion-menu a {
  text-decoration: none;
}
.cd-accordion-menu ul.group {
  list-style: none;
  padding: 0;
  margin: 0;
  position: relative;
  z-index: 2;
}
.cd-accordion-menu .sticky,
.cd-accordion-menu .toggle {
  position: relative;
  z-index: 2;
}
.cd-accordion-menu .toggle {
  background: #FFFFFF;
}
.cd-accordion-menu li {
  padding: 0;
  margin: 0;
  position: relative;
  top: 0;
  left: 0;
}
.cd-accordion-menu input[type=checkbox] {
  /* hide native checkbox */
  position: absolute;
  opacity: 0;
}
.cd-accordion-menu .prefix {
  position: absolute;
  top: 0;
  left: 0;
  font-size: 1.4em;
  height: 100%;
  width: 64px;
  min-width: 10px;
  padding: 19px 0 0 0;
  text-transform: uppercase;
  text-align: center;
  font-weight: bold;
  z-index: 20;
  color: #000;
  text-decoration: none;
  line-height: 1.8em;
}
@media screen and (max-width: 520px) {
  .cd-accordion-menu .prefix {
    width: 28px;
    font-size: 1.2em;
    line-height: 1em;
  }
}
.cd-accordion-menu .comment,
.cd-accordion-menu .selector {
  cursor: pointer;
  font-size: 1.4em;
  width: 2em;
  height: 4.5em;
  text-align: center;
  position: absolute;
  z-index: 20;
  box-shadow: none;
  background: transparent;
  color: inherit;
  padding: 0;
}
@media screen and (max-width: 520px) {
  .cd-accordion-menu .comment,
  .cd-accordion-menu .selector {
    height: 3.4em;
  }
}
.cd-accordion-menu .comment {
  right: 3em;
}
.cd-accordion-menu .comment i {
  font-size: 1.2em;
  margin-top: 1px;
  position: absolute;
  display: block;
  top: 50%;
  left: 0;
  width: 100%;
  letter-spacing: -1px;
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}
.cd-accordion-menu .no-title .comment {
  right: 1em;
}
@media screen and (max-width: 520px) {
  .cd-accordion-menu .no-title .comment {
    display: none;
  }
}
.cd-accordion-menu .selector {
  right: 1em;
}
.cd-accordion-menu .selector .indicator {
  position: absolute;
  display: block;
  top: 50%;
  left: 0;
  width: 100%;
  letter-spacing: -1px;
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}
.cd-accordion-menu .selector .indicator .svg-icon {
  position: relative;
  font-size: 1.2em;
}
.cd-accordion-menu .group-prefix {
  display: inline-block;
  font-weight: lighter;
  vertical-align: middle;
  font-size: 0.8em;
  text-transform: uppercase;
  margin-right: 1em;
}
.cd-accordion-menu .sticky-bottom {
  position: absolute;
  bottom: 0;
  width: 100%;
  display: block;
  z-index: 1;
}
.cd-accordion-menu .sticky-bottom.show.depth-1 {
  z-index: 34;
}
.cd-accordion-menu .sticky-bottom.show.depth-2 {
  z-index: 35;
}
.cd-accordion-menu .sticky-bottom.show.depth-3 {
  z-index: 36;
}
.cd-accordion-menu .sticky-bottom.show.depth-4 {
  z-index: 37;
}
.cd-accordion-menu .sticky-bottom.show.depth-5 {
  z-index: 38;
}
.cd-accordion-menu .sticky-bottom.show.depth-6 {
  z-index: 39;
}
.cd-accordion-menu .sticky-bottom.show.depth-7 {
  z-index: 40;
}
.cd-accordion-menu .highlight.content,
.cd-accordion-menu .highlight.group,
.cd-accordion-menu .highlight.content label.content {
  background: #fcf8e3 !important;
}
.cd-accordion-menu label .before {
  /* icons */
  content: '';
  display: inline-block;
  width: 16px;
  height: 16px;
  position: absolute;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
  margin: -0.1em 0 0 -0.1em;
}
.cd-accordion-menu label {
  cursor: pointer;
}
.cd-accordion-menu label.group .before {
  background-image: none;
  color: inherit;
  line-height: 1em;
  font-size: 1em;
  /* arrow icon */
  left: 18px;
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}
.cd-accordion-menu label .suffix {
  float: right;
  font-size: 0.8em;
  line-height: 1.8em;
  font-weight: lighter;
}
.cd-accordion-menu label.group-header-archived {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.cd-accordion-menu .is-loading label::before {
  content: ' ';
  animation: accordion-loader 1.2s infinite linear;
  border: 2px solid;
  border-right-color: transparent;
  border-radius: 50%;
}
.cd-accordion-menu .is-loading label .before {
  display: none;
}
@-moz-keyframes accordion-loader {
  0% {
    transform: translateY(-50%) rotate(0deg);
  }
  100% {
    transform: translateY(-50%) rotate(360deg);
  }
}
@-webkit-keyframes accordion-loader {
  0% {
    transform: translateY(-50%) rotate(0deg);
  }
  100% {
    transform: translateY(-50%) rotate(360deg);
  }
}
@keyframes accordion-loader {
  0% {
    transform: translateY(-50%) rotate(0deg);
  }
  100% {
    transform: translateY(-50%) rotate(360deg);
  }
}
.cd-accordion-menu input[type=checkbox]:checked + label .before {
  /* rotate arrow */
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}
.cd-accordion-menu input[type=checkbox]:checked + label::after {
  /* show open folder icon if item is checked */
  background-position: -32px 0;
}
.cd-accordion-menu input[type=checkbox]:checked + label + ul,
.cd-accordion-menu input[type=checkbox]:checked + label:nth-of-type(n) + ul {
  /* use label:nth-of-type(n) to fix a bug on safari (<= 8.0.8) with multiple adjacent-sibling selectors*/
  /* show children when item is checked */
  display: block;
}
.no-touch .cd-accordion-menu ul.group label:hover {
  background: #ededed;
}
.cd-accordion-menu li.depth-1 {
  margin-bottom: 2px;
}
.cd-accordion-menu li.depth-1.group {
  margin-bottom: 0;
}
.cd-accordion-menu label.depth-1.group {
  color: #222;
  fill: #222;
  background: #FFF;
  box-shadow: 0 0 0 1px rgba(127, 127, 127, 0.2) inset;
  padding-left: 38px;
}
.cd-accordion-menu label.depth-1.group .before {
  left: 16px;
}
.cd-accordion-menu label.depth-1.group.expanded {
  background: #555;
}
.cd-accordion-menu label.depth-1.group.expanded:hover {
  background: #4f4f4f;
}
.cd-accordion-menu label.depth-2.group.expanded {
  background: #767676;
}
.cd-accordion-menu label.depth-2.group.expanded:hover {
  background: #707070;
}
.cd-accordion-menu .disabled label.depth-1.group,
.cd-accordion-menu .disabled label.depth-2.group {
  color: #666;
  fill: #666;
}
.cd-accordion-menu label.depth-1.group.expanded,
.cd-accordion-menu label.depth-2.group.expanded {
  color: #FFF !important;
  fill: #FFF !important;
  box-shadow: none !important;
}
.cd-accordion-menu .selector.expanded .indicator,
.cd-accordion-menu .depth-1.pinned .selector .indicator,
.cd-accordion-menu .depth-2.pinned .selector .indicator {
  color: #FFF;
  fill: #FFF;
}
.cd-accordion-menu .depth-3 .selector.expanded .indicator {
  color: inherit;
  fill: inherit;
}
.cd-accordion-menu label.depth-2.group,
.cd-accordion-menu label.depth-3.group,
.cd-accordion-menu label.depth-4.group,
.cd-accordion-menu label.depth-5.group,
.cd-accordion-menu label.depth-6.group {
  color: #222;
  fill: #222;
  box-shadow: 0 -1px 0 0 rgba(127, 127, 127, 0.2) inset, -1px 0 0 0 rgba(127, 127, 127, 0.2) inset, 1px 0 0 0 rgba(127, 127, 127, 0.2) inset, 0 -1px 0 0 rgba(127, 127, 127, 0.2) inset;
}
.cd-accordion-menu label.depth-2.group {
  background: #e6e6e6;
  padding-left: 56px;
}
.cd-accordion-menu label.depth-2.group .before {
  left: 34px;
}
.cd-accordion-menu label.depth-2.group:hover {
  background: #dfdfdf;
}
.cd-accordion-menu label.depth-3.group {
  background: #ececec;
  padding-left: 74px;
}
.cd-accordion-menu label.depth-3.group .before {
  left: 52px;
}
.cd-accordion-menu label.depth-3.group:hover {
  background: #e6e6e6;
}
.cd-accordion-menu label.depth-4.group {
  background: #f2f2f2;
  padding-left: 92px;
}
.cd-accordion-menu label.depth-4.group .before {
  left: 70px;
}
.cd-accordion-menu label.depth-4.group:hover {
  background: #ececec;
}
.cd-accordion-menu label.depth-5.group {
  background: #f9f9f9;
  padding-left: 110px;
}
.cd-accordion-menu label.depth-5.group .before {
  left: 88px;
}
.cd-accordion-menu label.depth-5.group:hover {
  background: #f2f2f2;
}
.cd-accordion-menu label.depth-6.group {
  background: #ffffff;
  padding-left: 128px;
}
.cd-accordion-menu label.depth-6.group .before {
  left: 106px;
}
.cd-accordion-menu label.depth-6.group:hover {
  background: #f9f9f9;
}
.cd-accordion-menu label.content {
  padding-left: 64px;
}
.cd-accordion-menu .selectable label.content,
.cd-accordion-menu .selectable label.group {
  padding-right: 4em;
}
.cd-accordion-menu .content,
.cd-accordion-menu .content label.content {
  background: #FFFFFF !important;
  color: #222222;
  fill: #222222;
}
.cd-accordion-menu .content .selector .indicator,
.cd-accordion-menu .content label.content .selector .indicator {
  color: #222222;
  fill: #222222;
}
.cd-accordion-menu .highlight-yellow .content,
.cd-accordion-menu .highlight-yellow .content label.content {
  background-color: #FCF8E3 !important;
}
.cd-accordion-menu .content label .before,
.cd-accordion-menu .content label::after {
  display: none;
}
.cd-accordion-menu .content label .prefix {
  left: 6px;
  width: 54px;
  text-align: center;
  display: inline-block;
  position: absolute;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
  letter-spacing: -0.8px;
}
.cd-accordion-menu .content .content-text {
  padding: 18px 64px 18px 0;
  font-size: 1.2em;
  display: block;
  font-weight: 400;
}
@media screen and (max-width: 520px) {
  .cd-accordion-menu .content .content-text {
    padding: 0 0.5rem 0 0;
  }
}
.cd-accordion-menu .content .content-text p,
.cd-accordion-menu .content .content-text ul li {
  margin: 0.5em 0;
}
.cd-accordion-menu label::before {
  /* this class is used if you're using jquery to animate the accordion */
  -webkit-transition: transform 0.1s;
  -moz-transition: transform 0.1s;
  -ms-transition: transform 0.1s;
  -o-transition: transform 0.1s;
  transition: transform 0.1s;
}
.flavour-full.flavoured .cd-accordion-menu label.depth-1.group.expanded {
  background: #35b8d3;
}
.flavour-full.flavoured .cd-accordion-menu label.depth-1.group.expanded:hover {
  background: #2db3ce;
}
.flavour-full.flavoured .cd-accordion-menu label.depth-2.group.expanded {
  background: #71c8d9;
}
.flavour-full.flavoured .cd-accordion-menu label.depth-2.group.expanded:hover {
  background: #67c4d7;
}
.flavour-full.flavoured .cd-accordion-menu .disabled label.depth-1.group,
.flavour-full.flavoured .cd-accordion-menu .disabled label.depth-2.group {
  color: #666;
  fill: #666;
}
.flavour-semi.flavoured .cd-accordion-menu label.depth-1.group.expanded {
  background: #3fc599;
}
.flavour-semi.flavoured .cd-accordion-menu label.depth-1.group.expanded:hover {
  background: #39be92;
}
.flavour-semi.flavoured .cd-accordion-menu label.depth-2.group.expanded {
  background: #77cfb2;
}
.flavour-semi.flavoured .cd-accordion-menu label.depth-2.group.expanded:hover {
  background: #6eccad;
}
.flavour-semi.flavoured .cd-accordion-menu .disabled label.depth-1.group,
.flavour-semi.flavoured .cd-accordion-menu .disabled label.depth-2.group {
  color: #666;
  fill: #666;
}
.flavour-skimmed.flavoured .cd-accordion-menu label.depth-1.group.expanded {
  background: #f1617d;
}
.flavour-skimmed.flavoured .cd-accordion-menu label.depth-1.group.expanded:hover {
  background: #f05573;
}
.flavour-skimmed.flavoured .cd-accordion-menu label.depth-2.group.expanded {
  background: #f3a1b1;
}
.flavour-skimmed.flavoured .cd-accordion-menu label.depth-2.group.expanded:hover {
  background: #f296a8;
}
.flavour-skimmed.flavoured .cd-accordion-menu .disabled label.depth-1.group,
.flavour-skimmed.flavoured .cd-accordion-menu .disabled label.depth-2.group {
  color: #666;
  fill: #666;
}
.legislation .cd-accordion-menu label.depth-1.group.expanded {
  background: #83619C;
}
.legislation .cd-accordion-menu label.depth-1.group.expanded:hover {
  background: #7c5c94;
}
.legislation .cd-accordion-menu label.depth-2.group.expanded {
  background: #a28fb0;
}
.legislation .cd-accordion-menu label.depth-2.group.expanded:hover {
  background: #9c88ab;
}
.legislation .cd-accordion-menu .disabled label.depth-1.group,
.legislation .cd-accordion-menu .disabled label.depth-2.group {
  color: #666;
  fill: #666;
}
.legislation.flavour-archive .cd-accordion-menu label.depth-1.group.expanded {
  background: #73797a;
}
.legislation.flavour-archive .cd-accordion-menu label.depth-1.group.expanded:hover {
  background: #6d7273;
}
.legislation.flavour-archive .cd-accordion-menu label.depth-2.group.expanded {
  background: #989898;
}
.legislation.flavour-archive .cd-accordion-menu label.depth-2.group.expanded:hover {
  background: #919191;
}
.legislation.flavour-archive .cd-accordion-menu .disabled label.depth-1.group,
.legislation.flavour-archive .cd-accordion-menu .disabled label.depth-2.group {
  color: #666;
  fill: #666;
}
.precedents .cd-accordion-menu label.depth-1.group.expanded {
  background: #011aac;
}
.precedents .cd-accordion-menu label.depth-1.group.expanded:hover {
  background: #01189f;
}
.precedents .cd-accordion-menu label.depth-2.group.expanded {
  background: #0928e6;
}
.precedents .cd-accordion-menu label.depth-2.group.expanded:hover {
  background: #0926da;
}
.precedents .cd-accordion-menu .disabled label.depth-1.group,
.precedents .cd-accordion-menu .disabled label.depth-2.group {
  color: #666;
  fill: #666;
}
.content-review .cd-accordion-menu label .before {
  display: none !important;
}
.content-review .cd-accordion-menu label {
  cursor: default !important;
}
.ca .cd-accordion-menu label.depth-1,
.ca .cd-accordion-menu label.depth-1.group.expanded {
  background: #FFF;
  color: #F87531 !important;
  padding-left: 0;
  font-size: 1.7em;
  box-shadow: inset 0 -1px #fdd8c5 !important;
}
.ca .cd-accordion-menu label.depth-1:hover,
.ca .cd-accordion-menu label.depth-1.group.expanded:hover {
  background: #FFF;
}
.ca .cd-accordion-menu label.group .before {
  display: none;
}
.ca .cd-accordion-menu label.selector {
  color: #222;
  fill: #222;
}
.cd-accordion-header {
  /*position: absolute;
  width: 96%;
  left: 50%;
  height: 0;
  margin: 0;
  max-width: @page-max-width;
  margin-left: auto;
  margin-right: auto;*/
  background: transparent;
  bottom: -3px;
  /*.transform(translate(-50%, 0));*/
}
.cd-accordion-header .prefix.selectable .indicator {
  border-bottom: 3px solid #EEE;
  width: auto;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -o-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
.cd-accordion-header .prefix.selectable .indicator::after {
  display: none;
}
.cd-accordion-header .prefix.selectable.selected .indicator {
  border-bottom: 3px solid;
}
.cd-accordion-header .selectable .selector {
  height: 2.7em;
}
@media screen and (max-width: 520px) {
  .cd-accordion-header .selectable .selector {
    height: 2.1em;
  }
}
.cd-accordion-header .prefix {
  pointer-events: none;
}
.cd-accordion-header .cd-accordion-menu {
  width: 100%;
  margin: 0;
}
.cd-accordion-header .cd-accordion-menu .content label {
  box-shadow: inset 0 -1px rgba(0, 0, 0, 0.2);
}
.cd-accordion-header .cd-list-container {
  width: 100%;
  /*margin: 0;
    max-width: @page-max-width;
    .transform(translate(0,0));
    -webkit-transition: -webkit-transform 0.2s cubic-bezier(0.2,0.3,0.25,0.9), opacity 0.2s;
    -moz-transition: -moz-transform 0.2s cubic-bezier(0.2,0.3,0.25,0.9), opacity 0.2s;
    transition: transform 0.2s cubic-bezier(0.2,0.3,0.25,0.9), opacity 0.2s;*/
  position: relative;
  /*    top: 0;
    left: 0;*/
}
.cd-accordion-header .fadeout {
  display: none;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #FFFFFF;
  opacity: 0.6;
  z-index: 2;
}
.cd-accordion-header.view-right {
  /*max-width: @page-max-width !important;*/
}
.cd-accordion-header.view-right .cd-list-container {
  /*width: 96%;
      margin: auto;*/
  -webkit-transform: translate(-700px, 0);
  -moz-transform: translate(-700px, 0);
  -o-transform: translate(-700px, 0);
  -ms-transform: translate(-700px, 0);
  transform: translate(-700px, 0);
  pointer-events: none;
}
.cd-accordion-header.view-right .cd-list-container .fadeout {
  display: block;
}
@media screen and (min-width: 1270px) {
  .cd-accordion-header.view-right .cd-list-container {
    -webkit-transform: translate(-550px, 0);
    -moz-transform: translate(-550px, 0);
    -o-transform: translate(-550px, 0);
    -ms-transform: translate(-550px, 0);
    transform: translate(-550px, 0);
  }
}
@media screen and (min-width: 1570px) {
  .cd-accordion-header.view-right .cd-list-container {
    pointer-events: all;
    -webkit-transform: translate(-300px, 0);
    -moz-transform: translate(-300px, 0);
    -o-transform: translate(-300px, 0);
    -ms-transform: translate(-300px, 0);
    transform: translate(-300px, 0);
  }
  .cd-accordion-header.view-right .cd-list-container .fadeout {
    display: none;
  }
}
@media screen and (max-width: 768px) {
  .cd-accordion-header.view-right .cd-list-container {
    -webkit-transform: translate(-520px, 0);
    -moz-transform: translate(-520px, 0);
    -o-transform: translate(-520px, 0);
    -ms-transform: translate(-520px, 0);
    transform: translate(-520px, 0);
  }
}
@media screen and (max-width: 520px) {
  .cd-accordion-header.view-right .cd-list-container {
    -webkit-transform: translate(-325px, 0);
    -moz-transform: translate(-325px, 0);
    -o-transform: translate(-325px, 0);
    -ms-transform: translate(-325px, 0);
    transform: translate(-325px, 0);
  }
}
.cd-accordion-header.view-left {
  max-width: 970px !important;
  pointer-events: none;
}
.cd-accordion-header.view-left .cd-list-container {
  width: 100%;
  margin: auto;
  -webkit-transform: translate(300px, 0);
  -moz-transform: translate(300px, 0);
  -o-transform: translate(300px, 0);
  -ms-transform: translate(300px, 0);
  transform: translate(300px, 0);
}
.cd-accordion-header li label {
  -webkit-transition: padding 0.1s;
  -moz-transition: padding 0.1s;
  -ms-transition: padding 0.1s;
  -o-transition: padding 0.1s;
  transition: padding 0.1s;
}
.cd-accordion-header li {
  position: relative;
  top: 0;
  left: 0;
  z-index: 2;
}
.cd-accordion-header li label {
  padding-top: 7px;
  padding-bottom: 7px;
}
@media screen and (max-width: 520px) {
  .cd-accordion-header li label {
    padding-top: 4px;
    padding-bottom: 4px;
  }
}
.cd-accordion-header .prefix {
  padding-top: 7px;
}
.cd-accordion-header li:last-child {
  z-index: 1;
}
@media screen and (min-width: 1270px) {
  .has-left .cd-accordion-header.view-left,
  .has-left .cd-accordion-header.view-main {
    max-width: 970px !important;
  }
  .has-left .cd-accordion-header.view-left .cd-list-container,
  .has-left .cd-accordion-header.view-main .cd-list-container {
    width: 96%;
    margin: auto;
    -webkit-transform: translate(150px, 0);
    -moz-transform: translate(150px, 0);
    -o-transform: translate(150px, 0);
    -ms-transform: translate(150px, 0);
    transform: translate(150px, 0);
  }
}
.browser-ie .cd-list-container {
  -ms-transition: none !important;
  transition: none !important;
}
.accordion-comments {
  padding: 18px 64px 18px 64px;
  font-size: 1.8em;
  display: block;
  font-weight: 400;
}
@media screen and (max-width: 520px) {
  .accordion-comments {
    font-size: 1.5em;
    padding: 18px 0 18px 18px;
  }
}
.accordion-navigator {
  font-size: 1.4em;
  line-height: 1.3;
  margin: 0.6em 0 0 1em;
}
.accordion-navigator .navigation-group {
  margin: 0;
}
.accordion-navigator .navigation-group.depth-1 {
  margin: 0;
  padding: 0;
  border: none;
}
.accordion-navigator .navigation-group.depth-1 > .navigation-item {
  border-left: none;
  padding-left: 0;
}
.accordion-navigator .navigation-group.depth-1 > .navigation-item:before,
.accordion-navigator .navigation-group.depth-1 > .navigation-item:after {
  display: none;
}
.accordion-navigator .navigation-item {
  padding: 0.5em 0 0em 0.7em;
  border-left: 2px solid #FAFAFA;
  position: relative;
  margin-left: 3px;
  transition: border-color 0.2s;
}
.accordion-navigator a {
  color: inherit;
  margin: 0;
}
.accordion-navigator .navigation-item-title {
  display: block;
  white-space: normal;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-bottom: 0.5em;
  color: #AAA;
  fill: #AAA;
}
.accordion-navigator .navigation-item-title .prefix {
  text-transform: uppercase;
  font-size: 0.8em;
  font-weight: lighter;
  margin-right: 0.6em;
}
.accordion-navigator .navigation-item-title a {
  cursor: pointer;
  transition: color 0.2s;
}
.accordion-navigator .navigation-item-title a:hover {
  text-decoration: none;
  color: #000;
  fill: #000;
}
.accordion-navigator .active > .navigation-item-title {
  color: #000;
  fill: #000;
}
.accordion-navigator .active-after.navigation-item {
  border-color: #000;
}
.accordion-navigator .navigation-item:before {
  content: " ";
  display: block;
  position: absolute;
  height: 1.3em;
  width: 0;
  top: 0;
  border-left: 2px solid transparent;
  left: -2px;
  transition: border-color 0.2s;
}
.accordion-navigator .navigation-item.active:before {
  border-left: 2px solid #000 !important;
}
.accordion-navigator .navigation-item:last-child {
  border-left: 2px solid transparent;
}
.accordion-navigator .navigation-item:last-child:before {
  border-left: 2px solid #FAFAFA;
}
.accordion-navigator .navigation-item:after {
  content: " ";
  display: block;
  position: absolute;
  top: 1.2em;
  height: 0;
  width: 0.3em;
  border-bottom: 0.2em solid transparent;
  left: -2px;
  transition: border-color 0.2s;
}
.accordion-navigator .navigation-item.active:after {
  border-bottom-color: #000;
}
.key-picks.row::before {
  content: '';
  display: table;
}
.key-picks.row::after {
  content: '';
  display: table;
  clear: both;
}
.content-view {
  /* === Sections / Targetted Styles === */
  /* Smaller Section styles */
  /* Level 2 heading */
  /* Level 3 heading */
  /* === Typography/Headings Styles === */
  /* Questions - Collapsable */
  /* === Section / Level Specific Styles === */
  /* Mobile Devices */
}
.content-view.table-of-contents {
  font-size: 1.2em;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: hidden;
}
.content-view.table-of-contents ul {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  list-style: none;
  padding-left: 0;
  -webkit-transition: top ease-in-out 250ms;
  -moz-transition: top ease-in-out 250ms;
  -ms-transition: top ease-in-out 250ms;
  -o-transition: top ease-in-out 250ms;
  transition: top ease-in-out 250ms;
}
.content-view.table-of-contents ul li {
  padding: 0.5em 1em 0.5em 0.5em;
  color: #AAA;
}
.content-view.table-of-contents ul li a {
  display: block;
  text-decoration: none !important;
  color: inherit;
}
.content-view.table-of-contents ul li.highlight {
  color: #000000;
}
.content-view.table-of-contents ul .depth-1 {
  padding-left: 1.5em;
  font-weight: bold;
}
.content-view.table-of-contents ul .depth-2 {
  padding-left: 1.5em;
}
.content-view.table-of-contents ul .depth-3 {
  padding-left: 2.5em;
}
.content-view.table-of-contents ul .depth-4 {
  padding-left: 3.5em;
}
.content-view.table-of-contents ul .depth-5 {
  padding-left: 4.5em;
}
.content-view.table-of-contents ul .depth-6 {
  padding-left: 5.5em;
}
.content-view.table-of-contents ul li:last-child {
  margin-bottom: 1em;
}
.content-view .lr-treeheader {
  display: block;
  font-size: 1.8em;
  padding: 0.5em;
}
.content-view .lr-treeheader a {
  color: #000;
  font-weight: 600;
}
.content-view .lr-treeheader.lr-container {
  box-shadow: inset 0 -1px rgba(0, 0, 0, 0.2);
}
.content-view .lr-treeheader.lr-container.depth-1 {
  padding-left: 1em;
  background: #dfdfdf;
}
.content-view .lr-treeheader.lr-container.depth-2 {
  padding-left: 2em;
  background: #e6e6e6;
}
.content-view .lr-treeheader.lr-container.depth-3 {
  padding-left: 3em;
  background: #ececec;
}
.content-view .lr-treeheader.lr-container.depth-4 {
  padding-left: 4em;
  background: #f2f2f2;
}
.content-view .lr-treeheader.lr-container.depth-5 {
  padding-left: 5em;
  background: #f9f9f9;
}
.content-view .lr-treeheader.lr-container.depth-6 {
  padding-left: 6em;
  background: #ffffff;
}
.content-view .lr-treeheader a.fc-question {
  font-size: 1em;
}
.content-view .lr-treeheader a:hover {
  text-decoration: underline !important;
}
.content-view .lr-treeheader .lr-breadcrumbs {
  display: block;
  font-size: 0.7em;
  margin-top: 0.2em;
}
.content-view .lr-treeheader .lr-breadcrumbs a {
  color: #006621;
}
.content-view .lr-treeheader .lr-breadcrumbs span + span::before {
  content: " > ";
  color: #006621;
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.content-view .lr-treeheader.lr-leaf.depth-1 {
  margin-top: 1em;
}
.content-view .lr-treenode .fc-qa {
  box-shadow: inset 0 -1px rgba(0, 0, 0, 0.2);
}
.content-view .ca-heading-heading {
  display: flex;
  flex-direction: column;
}
.content-view .section-heading {
  font-weight: 700;
  font-size: 2.4em;
  line-height: 1.4;
  z-index: 2;
  position: relative;
  background-color: #FFFFFF;
}
.content-view .section-heading a {
  color: inherit;
}
.content-view .section-heading a:hover {
  text-decoration: none;
}
@media screen and (max-width: 768px) {
  .content-view .section-heading {
    font-size: 2.4em;
  }
}
@media screen and (max-width: 520px) {
  .content-view .section-heading {
    font-size: 2.2em;
  }
}
.content-view .section-heading .right-align {
  font-size: 0.6em;
  font-weight: normal;
  float: right;
  color: #999;
  fill: #999;
  line-height: 2.6em;
}
.content-view .section-heading .right-align i {
  font-size: 2em;
  vertical-align: middle;
}
.content-view .section-heading .right-align a,
.content-view .section-heading .right-align a:hover {
  text-decoration: none;
  display: inline;
}
.content-view .section-heading .right-align .svg-icon {
  font-size: 1.4em;
  position: relative;
  top: 0.1em;
  margin: 0 0.3em;
}
.content-view .section-heading .right-align a:hover {
  color: #666;
  fill: #666;
}
.content-view .section-heading .right-align .spacer {
  margin: 0 1em 0 2em;
}
.content-view .section-heading .right-align .spacer::before {
  content: "|";
}
.content-view .section-heading .right-align .flavoured {
  font-weight: bold;
}
.content-view table:not(.tinymce-generated-content) {
  width: 100%;
}
.content-view table:not(.tinymce-generated-content) td {
  vertical-align: top;
}
.content-view table:not(.tinymce-generated-content) td.button {
  width: 1em;
  font-weight: normal;
}
.content-view table:not(.tinymce-generated-content) td.button a {
  color: inherit;
}
.content-view table:not(.tinymce-generated-content) .align-middle {
  vertical-align: middle;
}
.content-view .ca-content table {
  width: unset;
}
.content-view .ca-content table td {
  vertical-align: unset;
}
.content-view .checkbox-widget {
  margin: 0;
  font-size: 18px;
}
.content-view.header {
  width: 100%;
  background-color: #E5E5E5;
}
.content-view.header .container {
  max-width: 970px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  padding: 0;
}
@media screen and (max-width: 970px) {
  .content-view.header .container {
    width: 96%;
  }
}
.content-view.header .container .fc-section-header {
  padding-left: 0;
  padding-right: 0;
}
.content-view.header .fc-section-checkbox {
  display: block;
  background-color: #e5e5e5;
  font-size: 1.8em;
  line-height: 1.1em;
  color: #000000;
  font-weight: 400;
  padding: 0.5em 5px;
}
@media screen and (max-width: 520px) {
  .content-view.header .fc-section-checkbox {
    font-size: 1.5em;
    padding: 0.5em 0;
  }
  .content-view.header .fc-section-checkbox table tr td.button {
    padding: 0 5px;
  }
  .content-view.header .fc-section-checkbox table tr td.button.big {
    padding: 0 5px 0 0;
  }
}
.content-view.header .fc-section-checkbox table td {
  vertical-align: middle;
  height: inherit;
}
.content-view.header .fc-section-checkbox table td.button {
  padding: 0 10px 0 5px;
}
.content-view.header .fc-section-checkbox table td.button.big {
  padding: 0 5px;
  font-size: 1.1em;
}
.content-view.header .fc-section-checkbox input {
  height: 1.7em;
  border: 1px solid #000000;
  padding: 0 10px;
  font-size: 0.8em;
  margin-left: 5%;
  width: 94%;
  outline: none;
  display: inline-block;
  vertical-align: top;
}
.content-view .excerpt {
  font-size: 1.8em;
  font-weight: 200;
  margin: 0 0 2em;
}
@media screen and (max-width: 520px) {
  .content-view .excerpt {
    padding: 0 18px;
    font-size: 1.3em;
  }
}
.content-view .navigation {
  font-size: 1.9em;
}
.content-view .navigation a {
  display: block;
  padding: 0.3em 0.5em;
  background: #666;
  color: #FFF;
  text-decoration: none;
}
.content-view .navigation a:focus {
  text-decoration: none;
}
@media screen and (max-width: 520px) {
  .content-view .navigation {
    font-size: 1.4em;
  }
}
.content-view .indented {
  font-size: 7px;
}
.content-view .indented .node-crossheading {
  margin-left: 2em;
}
.content-view .indented a {
  color: inherit;
  display: block;
  text-decoration: underline;
}
.content-view .indented .fc-section-header {
  padding-right: 15px;
}
.content-view .indented .header-depth-1 {
  padding-left: 10px;
}
.content-view .indented .header-depth-2 {
  padding-left: 20px;
}
.content-view .indented .header-depth-3 {
  padding-left: 30px;
}
.content-view .indented .header-depth-4 {
  padding-left: 40px;
}
.content-view .indented .header-depth-5 {
  padding-left: 50px;
}
.content-view .indented .header-depth-6 {
  padding-left: 60px;
}
@media screen and (max-width: 520px) {
  .content-view .indented .header-depth-1 {
    padding-left: 1em;
  }
  .content-view .indented .header-depth-2 {
    padding-left: 2em;
  }
  .content-view .indented .header-depth-3 {
    padding-left: 2.5em;
    font-size: 1.5em;
  }
  .content-view .indented .header-depth-4 {
    padding-left: 3em;
  }
  .content-view .indented .header-depth-5 {
    padding-left: 3.5em;
  }
  .content-view .indented .header-depth-6 {
    padding-left: 4em;
  }
}
.content-view .padded .fc-section-header,
.content-view .padded .fc-qa {
  padding-left: 15px;
  padding-right: 15px;
}
.content-view .fc-section-header {
  border: none;
  background-color: #000000;
  margin: 0px 0;
  line-height: 1.2em;
  padding: 0.5em 0;
  width: 100%;
  margin: 0;
}
.content-view .fc-section-header .number {
  display: inline-block;
  margin-right: 1em;
  font-size: 0.7em;
  line-height: 1.8em;
  vertical-align: top;
  text-transform: uppercase;
}
.content-view .fc-section-header.header-depth-1 {
  border-bottom: none;
  font-size: 3.0em;
  color: #FFFFFF;
}
.content-view .fc-section-header.header-depth-1 table td.button {
  color: #FFFFFF;
}
.content-view .fc-section-header.header-depth-2 {
  background-color: #E5E5E5;
  border-bottom: none;
  font-weight: 500;
  font-size: 2.6em;
}
.content-view .fc-section-header.header-depth-3 {
  background-color: #fff;
  color: #002a5b;
  border-bottom: 1px solid #E5E5E5;
  font-size: 2.4em;
}
.content-view .fc-section-header.header-depth-4 {
  background-color: #fff;
  color: #002a5b;
  border-bottom: 1px solid #E5E5E5;
  font-size: 2.2em;
}
.content-view .fc-section-header.header-depth-5 {
  background-color: #fff;
  color: #002a5b;
  font-size: 2.0em;
}
.content-view .fc-section-header.header-depth-6 {
  background-color: #fff;
  color: #002a5b;
  font-size: 2.0em;
}
@media screen and (max-width: 520px) {
  .content-view .fc-section-header.header-depth-1 {
    font-size: 2em;
  }
  .content-view .fc-section-header.header-depth-2 {
    font-size: 1.8em;
  }
  .content-view .fc-section-header.header-depth-3 {
    font-size: 1.7em;
  }
  .content-view .fc-section-header.header-depth-4 {
    font-size: 1.6em;
  }
  .content-view .fc-section-header.header-depth-5 {
    font-size: 1.5em;
  }
  .content-view .fc-section-header.header-depth-6 {
    font-size: 1.4em;
  }
}
.content-view .space-maker {
  opacity: 0;
}
.content-view > .fc-section-tree {
  margin-top: 9px;
}
.content-view .small-sections .fc-section-header h1,
.content-view .small-sections .fc-section-header h2,
.content-view .small-sections .fc-section-header h3 {
  line-height: 55px;
  font-size: 30px;
}
.content-view .small-sections .fc-section-header h3,
.content-view .small-sections .fc-section-header h4,
.content-view .small-sections .fc-section-header h5 {
  padding: 0px;
}
.content-view .small-sections .pull-right {
  height: 55px;
}
.content-view .fc-section-body .fc-section-header,
.content-view .panel {
  background-color: #E5E5E5;
}
.content-view .fc-section-tree .fc-section-children .fc-section-body .fc-section-header {
  background-color: #fff;
  color: #002a5b;
}
.content-view h3,
.content-view h4,
.content-view h5,
.content-view h6 {
  color: #2c2e83;
}
.content-view h1 {
  font-size: 3.6em;
  line-height: 40px;
  padding: 19px 0px 21px 0;
}
.content-view h2 {
  font-size: 3.4em;
  line-height: 41px;
}
.content-view h3 {
  font-size: 2.8em;
  line-height: 33px;
}
.content-view h4 {
  font-size: 2.4em;
  line-height: 28px;
}
.content-view h5 {
  font-size: 2.2em;
  line-height: 26px;
}
.content-view h6 {
  font-size: 2.0em;
  line-height: 24px;
}
.content-view section h1 {
  font-size: 3em;
}
.content-view ol:not(.tinymce-generated-content) {
  counter-reset: li;
}
.content-view ol:not(.tinymce-generated-content) > li {
  position: relative;
  list-style: none;
  margin-bottom: 0.2em;
}
.content-view ol:not(.tinymce-generated-content) > li::before {
  content: "(" counter(li, lower-alpha) ")";
  counter-increment: li;
  position: absolute;
  left: -2em;
  font-size: 0.9em;
  line-height: 1.7em;
  color: #444;
}
.content-view ol:not(.tinymce-generated-content) ol li::before {
  content: "(" counter(li, lower-roman) ")";
}
.content-view .ca-content ol:not(.tinymce-generated-content) > li {
  list-style: inherit;
}
.content-view .ca-content ol:not(.tinymce-generated-content) > li::before {
  content: none;
}
.content-view .ca-content ol:not(.tinymce-generated-content) ol li::before {
  content: none;
}
.content-view .capitalize::first-letter {
  text-transform: uppercase;
}
.content-view .no-border {
  border: none !important;
}
.content-view .fc-qa {
  padding: 0.7em 2.0em 0.8em 0;
}
@media screen and (max-width: 520px) {
  .content-view .fc-qa {
    padding: 0.7em 0.5em 0.8em 0;
  }
}
.content-view .fc-qa.expanded {
  border-bottom: 1px solid #e5e5e5;
}
.content-view .fc-qa:last-child {
  padding-bottom: 2em;
}
@media screen and (max-width: 520px) {
  .content-view .fc-qa:last-child {
    padding-bottom: 0;
  }
}
.content-view .fc-qa:last-child .fc-answer {
  border-bottom: none;
  margin-bottom: 0px;
}
.content-view .fc-qa:first-child {
  padding-top: 1.5em;
}
@media screen and (max-width: 520px) {
  .content-view .fc-qa:first-child {
    padding-top: 1em;
  }
}
.content-view .fc-qa.selected:last-child {
  border-bottom: none;
}
.content-view .fc-qa.selected + .fc-qa {
  margin-top: 8px;
}
.content-view .fc-qa.selected.highlight {
  margin: 8px 0;
  border-left: 8px solid #e5e5e5;
  padding-left: 10px;
}
.content-view .fc-qa table td.button,
.content-view .fc-section-header table td.button {
  font-size: 18px;
  color: #000000;
  padding: 0 11px;
}
@media screen and (max-width: 520px) {
  .content-view .fc-qa table td.button,
  .content-view .fc-section-header table td.button {
    padding: 0 5px;
  }
}
.content-view .fc-answer.section-content {
  font-size: 1.6em;
}
@media screen and (max-width: 520px) {
}
.content-view .fc-em {
  font-style: italic;
}
.content-view .fc-p,
.content-view .fc-indent {
  padding-left: 2.2em;
  display: block;
  position: relative;
  top: 0;
  left: 0;
  margin: 0.5em 0;
}
.content-view .fc-p .reference,
.content-view .fc-indent .reference,
.content-view .fc-p .fc-reference,
.content-view .fc-indent .fc-reference {
  position: absolute;
  top: 0;
  left: 0.2em;
  color: inherit;
  display: block;
  font-size: 0.9em;
  line-height: 1.7em;
  font-weight: normal;
}
.content-view .fc-p .reference .fc-stacked-reference-2,
.content-view .fc-indent .reference .fc-stacked-reference-2,
.content-view .fc-p .fc-reference .fc-stacked-reference-2,
.content-view .fc-indent .fc-reference .fc-stacked-reference-2 {
  position: absolute;
  left: -2.6em;
}
.content-view .fc-p .reference .fc-stacked-reference-3,
.content-view .fc-indent .reference .fc-stacked-reference-3,
.content-view .fc-p .fc-reference .fc-stacked-reference-3,
.content-view .fc-indent .fc-reference .fc-stacked-reference-3 {
  position: absolute;
  left: -5.2em;
}
.content-view .fc-p .reference .fc-stacked-reference-4,
.content-view .fc-indent .reference .fc-stacked-reference-4,
.content-view .fc-p .fc-reference .fc-stacked-reference-4,
.content-view .fc-indent .fc-reference .fc-stacked-reference-4 {
  position: absolute;
  left: -7.8em;
}
.content-view .fc-p.mark,
.content-view .fc-indent.mark {
  background-color: #FCF8E3;
  padding: 0 0 0 2.2em;
}
@media screen and (max-width: 520px) {
  .content-view .fc-p,
  .content-view .fc-indent {
    padding-left: 1.3em;
  }
  .content-view .fc-p .reference,
  .content-view .fc-indent .reference,
  .content-view .fc-p .fc-reference,
  .content-view .fc-indent .fc-reference {
    left: 0;
  }
  .content-view .fc-p .reference .fc-stacked-reference-2,
  .content-view .fc-indent .reference .fc-stacked-reference-2,
  .content-view .fc-p .fc-reference .fc-stacked-reference-2,
  .content-view .fc-indent .fc-reference .fc-stacked-reference-2 {
    position: absolute;
    left: -1.6em;
  }
  .content-view .fc-p .reference .fc-stacked-reference-3,
  .content-view .fc-indent .reference .fc-stacked-reference-3,
  .content-view .fc-p .fc-reference .fc-stacked-reference-3,
  .content-view .fc-indent .fc-reference .fc-stacked-reference-3 {
    position: absolute;
    left: -3.2em;
  }
  .content-view .fc-p .reference .fc-stacked-reference-4,
  .content-view .fc-indent .reference .fc-stacked-reference-4,
  .content-view .fc-p .fc-reference .fc-stacked-reference-4,
  .content-view .fc-indent .fc-reference .fc-stacked-reference-4 {
    position: absolute;
    left: -4.8em;
  }
}
.content-view .fc-indent {
  margin-left: 2.2em;
}
.content-view .fc-indent .fc-indent {
  margin-left: 0;
}
.content-view .fc-amend {
  display: block;
  position: relative;
  margin: 2em 0;
  padding-left: 1em;
  border-left: 3px solid #EEEEEE;
}
.content-view .fc-amend .fc-crossheading > .fc-title {
  font-weight: bold;
  margin: 0 0 1em -1em;
}
.content-view .fc-amend .fc-schedule {
  padding-left: 2.2em;
  position: relative;
}
.content-view .fc-amend .fc-schedule .fc-title {
  margin: 0 0 0 1em;
}
.content-view .fc-amend .fc-schedule .fc-part {
  display: block;
}
.content-view .fc-amend .fc-schedule > .reference {
  left: -1em;
  font-weight: bold;
  font-size: 0.8em;
  line-height: 1.7em;
}
.content-view .fc-amend .fc-crossheading,
.content-view .fc-amend .fc-section,
.content-view .fc-amend .fc-part,
.content-view .fc-amend .fc-chapter {
  padding-left: 2.2em;
  position: relative;
}
.content-view .fc-amend .fc-crossheading > .reference,
.content-view .fc-amend .fc-section > .reference,
.content-view .fc-amend .fc-part > .reference,
.content-view .fc-amend .fc-chapter > .reference {
  left: -1em;
  font-weight: bold;
  font-size: 0.8em;
  line-height: 1.7em;
}
.content-view .fc-amend .fc-section {
  display: block;
}
.content-view .fc-title {
  font-weight: bold;
  position: relative;
}
.content-view .fc-title .reference {
  display: inline-block;
  position: relative;
  margin-left: -2em;
  margin-right: 0.5em;
  font-size: 1em;
  font-weight: bold;
}
.content-view .fc-table {
  display: table;
  padding: 0 2em;
  margin: 1em 0 3em;
  width: 100%;
}
.content-view .fc-table .fc-tr {
  display: table-row;
}
.content-view .fc-table .fc-td {
  display: table-cell;
  padding: 0.2em 1em;
}
.content-view .fc-table .fc-td > .fc-p {
  padding-left: 0;
}
.content-view .fc-section-qas {
  border-bottom: 1px solid #E5E5E5;
}
.content-view .fc-question {
  display: table-row;
  color: #1460d1;
  font-size: 1.8em;
  padding: 11px 0px 0px 0px;
  line-height: 1.3em;
  margin-bottom: 0px;
  /*25*/
  font-weight: 700;
  text-decoration: none !important;
}
.content-view .fc-question .fc-question-number {
  vertical-align: top;
  display: table-cell;
  white-space: nowrap;
  padding-right: 0.4em;
}
.content-view .fc-question .fc-question {
  vertical-align: top;
  display: table-cell;
  font-size: 1em;
  padding: 0;
}
.content-view .fc-question .fc-question-number,
.content-view .fc-question .fc-question {
  padding-top: 0.1em;
}
@media screen and (max-width: 768px) {
  .content-view .fc-question .fc-question-number,
  .content-view .fc-question .fc-question {
    padding-top: 0.3em;
  }
}
.content-view .fc-question .path {
  font-weight: normal;
  font-size: 0.75em;
  color: #006621;
  margin: 0.5em 0 0;
}
.content-view .fc-question .path span + span:before {
  content: " > ";
  color: #006621;
}
.content-view .row .col-fluid {
  display: table-cell;
  vertical-align: top;
  width: 100%;
  padding: 0 17px;
}
.content-view .row .col-checkbox {
  display: table-cell;
  vertical-align: top;
}
.content-view .row .col-checkbox:first-child {
  padding: 0 0 0 17px;
}
.content-view .row .col-checkbox:last-child {
  padding: 0 17px 0 0;
}
@media screen and (max-width: 768px) {
  .content-view .row .col-checkbox:last-child {
    padding-right: 8px;
  }
  .content-view .row .col-checkbox:first-child {
    padding-left: 8px;
  }
  .content-view .row .col-fluid {
    padding: 0 8px;
  }
}
.content-view .fc-qa.review,
.content-view .fc-section-header.review {
  padding-left: 18px;
}
.content-view .fc-answer.collapse.in {
  margin-bottom: 8px;
}
.content-view .fc-answer {
  display: block;
  padding-bottom: 0.8em;
}
.content-view .fc-answer p {
  margin: 0.5em 0;
}
.content-view .fc-answer p:last-child {
  margin-bottom: 0;
}
.content-view .fc-answer ol {
  list-style-type: lower-alpha;
  padding-left: 2em;
  margin-bottom: 0px;
}
.content-view .fc-answer ol ol {
  list-style-type: lower-roman;
}
.content-view .fc-answer a {
  overflow: hidden;
  display: inline;
  vertical-align: top;
}
.content-view .fc-answer-wrap p,
.content-view .fc-glossary,
.content-view .fc-legislation {
  font-weight: 400;
  color: #231F20;
  font-size: 1em;
}
.content-view .fc-legislation {
  border-bottom: 1px dashed #A6A6A6;
  top: 0;
  left: 0;
  outline: none;
  cursor: pointer;
}
.content-view .fc-legislation .fc-reference,
.content-view .fc-legislation .fc-labels {
  display: none;
}
.content-view .fc-legislation .fc-glossary {
  border-bottom: none;
}
.content-view .legislation-reference-title {
  width: 100%;
}
.content-view .legislation-reference-title td.title {
  max-width: 0;
  padding-bottom: 0.4em;
}
.content-view .legislation-reference-title a {
  text-overflow: ellipsis;
  display: block;
  white-space: nowrap;
  overflow: hidden;
}
.content-view .legislation-reference-body {
  position: absolute;
  overflow-x: hidden;
  overflow-y: scroll;
  -ms-overflow-style: -ms-autohiding-scrollbar;
  bottom: 0;
  top: 6em;
  z-index: 1;
  padding-right: 10px;
  right: 0;
  left: 15px;
}
.content-view .legislation-reference-body .fc-section-body .fc-section-header {
  background: none;
  border-bottom: none;
}
.content-view .legislation-reference-body .fc-section-body .header-depth-2 {
  font-size: 1.8em;
  font-weight: bold;
}
.content-view .legislation-reference-body .fc-section-body .header-depth-3 {
  font-size: 1.8em;
  font-weight: bold;
}
.content-view .legislation-reference-body .fc-section-body .header-depth-4 {
  font-size: 1.8em;
  margin-left: 1em;
}
.content-view .legislation-reference-body .fc-section-qas {
  border-bottom: none;
}
.content-view .legislation-reference-body .fc-section-qas .fc-qa {
  border-bottom: none;
  padding: 0 !important;
}
@media screen and (max-width: 768px) {
  .content-view .legislation-reference-body {
    top: 6em;
  }
}
.content-view .fc-answer-wrap ul,
.content-view .fc-answer-wrap ol {
  font-weight: 400;
}
.content-view .fc-glossary {
  white-space: nowrap;
  border-bottom: 1px dashed #A6A6A6;
  top: 0;
  left: 0;
  outline: none;
  cursor: pointer;
}
.content-view .fc-glossary.focus {
  position: relative;
}
@media screen and (max-width: 520px) {
  .content-view .fc-glossary.focus {
    background: #DDDDDD;
  }
}
.content-view a.fc-cross-reference {
  color: #1460D1;
  cursor: pointer;
  display: inline;
}
.content-view a.fc-cross-reference:hover {
  text-decoration: underline;
}
.content-view li p {
  margin-bottom: 0px;
}
.content-view p {
  margin-bottom: 9px;
}
.content-view p a {
  color: #1460D1;
}
.content-view .fc-legislation-reference,
.content-view .fc-legislation-reference-range,
.content-view .fc-canonical-case-reference {
  display: none;
  visibility: hidden;
}
.content-view .fc-case-reference {
  font-weight: bold;
}
.content-view .popover {
  max-width: 300px;
}
.content-view .fc-partialnote,
.content-view .fc-jurisdictionnote {
  font-size: 0.8em;
  font-style: italic;
  color: #555;
  display: inline-block;
  font-weight: normal;
  padding: 0.4em 1em;
  background: #EEE;
}
@media screen and (max-width: 768px) {
  .content-view {
    /* Targetted */
  }
  .content-view h1,
  .content-view .fc-section-header h1 {
    font-size: 1.7em;
  }
  .content-view .fc-section-header h2 {
    font-size: 1.8em;
  }
  .content-view .fc-section-header h3 {
    font-size: 1.7em;
  }
  .content-view .fc-section-header h4 {
    font-size: 1.6em;
  }
  .content-view .fc-section-header h5 {
    font-size: 1.6em;
  }
  .content-view .fc-section-header h6 {
    font-size: 1.6em;
  }
  .content-view .fc-question {
    padding-left: 0px;
    padding-right: 20px;
    font-size: 1.4em;
  }
  .content-view .fc-answer > p {
    padding-left: 0px;
    padding-right: 20px;
  }
  .content-view .fc-answer ol {
    padding-left: 1.5em;
    padding-right: 1.5em;
    margin-bottom: 1em;
  }
  .content-view > section > .fc-section-body > .fc-section-children > section > .fc-section-body > .fc-section-children > section > .fc-section-header h3 {
    padding: 12px 1px 12px 0px;
  }
}
.content-view .reference-range {
  font-size: 14px;
}
@media screen and (max-width: 520px) {
  .content-view .reference-range {
    font-size: 11px;
  }
}
@media screen and (max-width: 520px) {
  .content-view .fc-answer ol {
    padding-left: 18px;
  }
  .content-view .fc-qa:last-child {
    margin-bottom: 16px;
  }
  .content-view .fc-qa:last-child .fc-answer-wrap {
    padding-bottom: 0px;
  }
}
.content-view.content-review .fc-answer-wrap {
  font-size: 1.8em;
  margin: 1.4em 0 0;
  display: block;
}
.content-view .copyright-footer {
  font-size: 1.4em;
  line-height: 1.3;
  padding: 1.5em 2em;
  color: #888;
}
.content-view .large {
  font-size: 1.8em;
}
.content-view .content-text > :not(.ca-content) table:not(.tinymce-generated-content),
.content-view .content-text > table:not(.tinymce-generated-content) {
  border-spacing: 1.5em;
  border-collapse: separate;
  margin: 0 -1.5em;
}
.content-view .content-text [class^="icon-bottle"] {
  font-size: 1.5em;
  vertical-align: sub;
}
.content-view .bottle-icon {
  display: inline-block;
  vertical-align: middle;
  width: 2.4em;
  height: 2.4em;
  background-size: 2.4em !important;
}
.content-view .nowrap {
  white-space: nowrap;
}
span.wj {
  font-size: 0 !important;
}
.flavour-full .section-heading .right-align .flavoured,
.color-full {
  color: #35b8d3;
  fill: #35b8d3;
}
.flavour-full .section-heading .right-align .flavoured.active,
.color-full.active {
  color: #FFFFFF;
  fill: #FFFFFF;
}
.flavour-semi .section-heading .right-align .flavoured,
.color-semi {
  color: #3fc599;
  fill: #3fc599;
}
.flavour-semi .section-heading .right-align .flavoured.active,
.color-semi.active {
  color: #FFFFFF;
  fill: #FFFFFF;
}
.flavour-skimmed .section-heading .right-align .flavoured,
.color-skimmed {
  color: #f1617d;
  fill: #f1617d;
}
.flavour-skimmed .section-heading .right-align .flavoured.active,
.color-skimmed.active {
  color: #FFFFFF;
  fill: #FFFFFF;
}
.flavour-archive .section-heading .right-align .flavoured,
.color-archive {
  color: #73797a;
  fill: #73797a;
}
.flavour-archive .section-heading .right-align .flavoured.active,
.color-archive.active {
  color: #FFFFFF;
  fill: #FFFFFF;
}
.color-legislation {
  color: #83619C;
  fill: #83619C;
}
.color-legislation.active {
  color: #FFFFFF;
  fill: #FFFFFF;
}
.content-depth {
  font-size: 1em;
  color: #FFF;
  margin-right: 0.2em;
  margin-left: 1em;
}
.content-depth .content-depth-text {
  display: inline-block;
  vertical-align: middle;
}
.content-depth .desc {
  color: #666;
}
.content-depth i {
  font-size: 1.7em !important;
  vertical-align: sub;
}
.content-depth.full {
  color: #35b8d3;
}
.content-depth.semi {
  color: #3fc599;
}
.content-depth.skimmed {
  color: #f1617d;
}
.popover-container {
  font-size: 1.6em;
}
.popover-container .popover {
  margin-top: 10px;
  max-width: 450px;
  font-size: 0.8em;
  -webkit-transition: opacity 0.2s;
  -moz-transition: opacity 0.2s;
  -ms-transition: opacity 0.2s;
  -o-transition: opacity 0.2s;
  transition: opacity 0.2s;
}
.popover-container .popover p {
  margin: 0;
}
.popover-container .popover p + p {
  margin: 1em 0 0;
}
@media screen and (max-width: 520px) {
  .popover-container .popover {
    font-size: 1em;
  }
}
.popover-container .popover.show {
  opacity: 1;
}
.popover-container .popover.show.fade-leave-active {
  opacity: 0;
}
.comment-body .public-DraftEditor-content h1,
.comment-body .content-view h1 {
  font-size: 1.4em;
  font-weight: normal;
  margin: 0 0 0.3em;
  padding: 0;
  line-height: normal;
}
.comment-body .public-DraftEditor-content h2,
.comment-body .content-view h2,
.comment-body .public-DraftEditor-content h3,
.comment-body .content-view h3,
.comment-body .public-DraftEditor-content h4,
.comment-body .content-view h4,
.comment-body .public-DraftEditor-content h5,
.comment-body .content-view h5,
.comment-body .public-DraftEditor-content h6,
.comment-body .content-view h6 {
  font-size: 1.2em;
  font-weight: normal;
  margin: 0 0 0.4em 0.8em;
  padding: 0;
  line-height: normal;
}
.comment-body .public-DraftEditor-content p,
.comment-body .content-view p,
.comment-body .public-DraftEditor-content .paragraph,
.comment-body .content-view .paragraph {
  margin: 0 0 0.5em 1em;
}
.comment-body .public-DraftEditor-content ol,
.comment-body .content-view ol,
.comment-body .public-DraftEditor-content ul,
.comment-body .content-view ul {
  margin-left: 0.5em;
}
.comment-body .public-DraftEditor-content ol li::before,
.comment-body .content-view ol li::before {
  content: "(" counter(li) ")";
}
.comment-body .public-DraftEditor-content .paragraph {
  margin: 0 0 0.5rem 0;
}
.svg-base {
  display: inline-block;
  line-height: 1;
}
.svg-base svg {
  fill: currentColor;
  vertical-align: middle;
  width: 100%;
  height: 100%;
}
.svg-base svg g {
  stroke: currentColor;
}
.svg-base svg path {
  fill: inherit;
}
.icon-base {
  position: relative;
  height: auto;
}
.icon-base svg {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
}
.icon-base:after {
  content: "";
  display: block;
  padding-bottom: 100%;
}
`, "",{"version":3,"sources":["webpack://./styles/index.less"],"names":[],"mappings":"AAGA;EACE,8BAA8B;EAC9B,kHAA+H;EAC/H,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,8BAA8B;EAC9B,kHAA6H;EAC7H,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,8BAA8B;EAC9B,kHAA2H;EAC3H,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,8BAA8B;EAC9B,kHAAyI;EACzI,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,8BAA8B;EAC9B,kHAAiI;EACjI,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,8BAA8B;EAC9B,oHAA+I;EAC/I,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,8BAA8B;EAC9B,oHAAyH;EACzH,gBAAgB;EAChB,kBAAkB;AACpB;AACA;;;;;;;CAOC;AACD;;;;;;;CAOC;AACD;;;;;;;;;CASC;AACD;EACE,sBAAsB;AACxB;AACA;;EAEE,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE;;IAEE,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;EAClB;AACF;AACA;EACE,kCAAkC;EAClC,4CAA4C;EAC5C,kCAAkC;EAClC,mDAAmD;EACnD,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,qBAAqB;AACvB;AACA;EACE;IACE,oBAAoB;IACpB,qBAAqB;EACvB;AACF;AACA;EACE;IACE,qBAAqB;IACrB,sBAAsB;EACxB;AACF;AACA;EACE,YAAY;EACZ,aAAa;AACf;AACA;EACE,wBAAwB;EACxB,uBAAuB;AACzB;AACA;EACE,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,wBAAwB;AAC1B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,wCAAwC;EACxC,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,+BAA+B;EAC/B,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;AACA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;AACA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;AACA;;;;;;;CAOC;AACD;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,oBAAoB;AACtB;AACA;EACE;IACE,cAAc;EAChB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,oBAAoB;EACtB;AACF;AACA;EACE;IACE,cAAc;EAChB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,oBAAoB;EACtB;AACF;AACA;EACE;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;AACF;AACA;EACE;IACE,cAAc;EAChB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;AACF;AACA;EACE,sBAAsB;AACxB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,2BAA2B;AAC7B;AACA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,8BAA8B;EAChC;EACA;IACE,2BAA2B;EAC7B;AACF;AACA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,8BAA8B;EAChC;EACA;IACE,2BAA2B;EAC7B;AACF;AACA;EACE,QAAQ;AACV;AACA;EACE,QAAQ;AACV;AACA;EACE,QAAQ;AACV;AACA;EACE,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,uBAAuB;AACzB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,oBAAoB;AACtB;AACA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,oBAAoB;EACtB;AACF;AACA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,oBAAoB;EACtB;AACF;AACA;EACE,oBAAoB;AACtB;AACA;EACE,sBAAsB;AACxB;AACA;EACE;IACE,oBAAoB;EACtB;EACA;IACE,sBAAsB;EACxB;AACF;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;EAC7B,6BAA6B;AAC/B;AACA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,8BAA8B;EAChC;EACA;IACE,6BAA6B;IAC7B,6BAA6B;EAC/B;AACF;AACA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,8BAA8B;EAChC;EACA;IACE,6BAA6B;IAC7B,6BAA6B;EAC/B;AACF;AACA;EACE,mBAAmB;AACrB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE;IACE,aAAa;EACf;EACA;IACE,YAAY;IACZ,aAAa;IACb,gBAAgB;EAClB;AACF;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;AACA;EACE;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,kBAAkB;EACpB;AACF;AACA;EACE;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;AACF;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;AACF;AACA;EACE;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;AACF;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;AACA;EACE;IACE,wBAAwB;IACxB,gBAAgB;EAClB;AACF;AACA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;EACA;IACE,wBAAwB;IACxB,gBAAgB;EAClB;AACF;AACA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;EACA;IACE,wBAAwB;IACxB,gBAAgB;EAClB;AACF;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,QAAQ;AACV;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;AACb;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;AACA;EACE,OAAO;AACT;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,UAAU;AACZ;AACA;EACE,YAAY;AACd;AACA;EACE,UAAU;AACZ;AACA;EACE,SAAS;AACX;AACA;EACE,UAAU;AACZ;AACA;EACE,cAAc;AAChB;AACA;EACE,MAAM;AACR;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,SAAS;AACX;AACA;EACE,WAAW;AACb;AACA;EACE,SAAS;AACX;AACA;EACE,SAAS;AACX;AACA;EACE,SAAS;AACX;AACA;EACE,SAAS;AACX;AACA;EACE,SAAS;AACX;AACA;EACE,QAAQ;AACV;AACA;EACE,QAAQ;AACV;AACA;EACE,QAAQ;AACV;AACA;EACE,SAAS;AACX;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE;IACE,WAAW;EACb;AACF;AACA;EACE,SAAS;AACX;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,QAAQ;AACV;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE,qBAAqB;AACvB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,WAAW;AACb;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE;IACE,YAAY;EACd;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;AACF;AACA;EACE;IACE,cAAc;EAChB;EACA;IACE,WAAW;EACb;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;AACF;AACA;EACE;IACE,YAAY;EACd;EACA;IACE,UAAU;EACZ;AACF;AACA;EACE,YAAY;AACd;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,YAAY;AACd;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,SAAS;AACX;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;AACjB;AACA;EACE;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;AACF;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;;;;;;;CAOC;AACD;EACE,UAAU;AACZ;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;AACF;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;AACF;AACA;EACE,eAAe;AACjB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE;IACE,eAAe;EACjB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;AACF;AACA;EACE;IACE,eAAe;EACjB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;AACF;AACA;EACE;IACE,qBAAqB;EACvB;AACF;AACA;EACE,gBAAgB;AAClB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;AACF;AACA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;AACF;AACA;EACE;IACE,sBAAsB;EACxB;AACF;AACA;EACE,iBAAiB;AACnB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;AACF;AACA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;AACF;AACA;EACE,cAAc;AAChB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE;IACE,cAAc;EAChB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;AACF;AACA;EACE;IACE,cAAc;EAChB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;AACF;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,qBAAqB;EACrB,wBAAwB;AAC1B;AACA;EACE,oBAAoB;EACpB,uBAAuB;AACzB;AACA;EACE,qBAAqB;EACrB,wBAAwB;AAC1B;AACA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,oBAAoB;EACpB,uBAAuB;AACzB;AACA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE;IACE,cAAc;IACd,iBAAiB;EACnB;EACA;IACE,qBAAqB;IACrB,wBAAwB;EAC1B;EACA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,wBAAwB;EAC1B;EACA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;AACF;AACA;EACE;IACE,cAAc;IACd,iBAAiB;EACnB;EACA;IACE,qBAAqB;IACrB,wBAAwB;EAC1B;EACA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,wBAAwB;EAC1B;EACA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;AACF;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;AACA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;EACA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;AACF;AACA;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;EACA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;AACF;AACA;EACE,SAAS;AACX;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;AACd;AACA;EACE;IACE,SAAS;EACX;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;EACd;EACA;IACE,cAAc;EAChB;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,YAAY;EACd;AACF;AACA;EACE;IACE,SAAS;EACX;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;EACd;EACA;IACE,cAAc;EAChB;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,YAAY;EACd;AACF;AACA;EACE,cAAc;AAChB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE;IACE,cAAc;EAChB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;AACF;AACA;EACE;IACE,cAAc;EAChB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;AACF;AACA;EACE,eAAe;AACjB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;EACjB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;AACF;AACA;EACE;IACE,eAAe;EACjB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;AACF;AACA;EACE,gBAAgB;AAClB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,gBAAgB;AAClB;AACA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,mBAAmB;EACrB;AACF;AACA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,mBAAmB;EACrB;AACF;AACA;EACE,aAAa;AACf;AACA;EACE,oBAAoB;AACtB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,aAAa;EACf;EACA;IACE,oBAAoB;EACtB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;AACF;AACA;EACE;IACE,aAAa;EACf;EACA;IACE,oBAAoB;EACtB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;AACF;AACA;EACE,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,uBAAuB;AACzB;AACA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,oBAAoB;EACpB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE;IACE,aAAa;IACb,gBAAgB;EAClB;EACA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;AACF;AACA;EACE;IACE,aAAa;IACb,gBAAgB;EAClB;EACA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;AACF;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;AACA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE;IACE,cAAc;IACd,eAAe;EACjB;EACA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;EACA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;AACF;AACA;EACE;IACE,cAAc;IACd,eAAe;EACjB;EACA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;EACA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;AACF;AACA;;;;;;;CAOC;AACD;EACE,+BAA+B;EAC/B,gCAAgC;AAClC;AACA;EACE,iBAAiB;AACnB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,WAAW;EACX,sBAAsB;EACtB,4BAA4B;EAC5B,4BAA4B;AAC9B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,iCAAiC;EACjC,8BAA8B;EAC9B,4BAA4B;EAC5B,yBAAyB;AAC3B;AACA;EACE,iCAAiC;EACjC,8BAA8B;EAC9B,4BAA4B;EAC5B,yBAAyB;AAC3B;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,aAAa;AACf;AACA;EACE,UAAU;EACV,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,uBAAuB;AACzB;AACA;EACE,YAAY;AACd;AACA;EACE,oBAAoB;AACtB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,UAAU;AACZ;AACA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,UAAU;AACZ;AACA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,UAAU;AACZ;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,6BAA6B;EAC7B,uBAAuB;AACzB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,0BAA0B;EAC1B,wBAAwB;AAC1B;AACA;EACE,wBAAwB;EACxB,sBAAsB;AACxB;AACA;EACE,uBAAuB;EACvB,qBAAqB;AACvB;AACA;EACE,yBAAyB;EACzB,uBAAuB;AACzB;AACA;EACE,0BAA0B;EAC1B,wBAAwB;AAC1B;AACA;EACE,0BAA0B;EAC1B,wBAAwB;AAC1B;AACA;EACE,0BAA0B;EAC1B,wBAAwB;AAC1B;AACA;EACE,uBAAuB;EACvB,qBAAqB;AACvB;AACA;EACE,uBAAuB;EACvB,qBAAqB;AACvB;AACA;EACE,uBAAuB;EACvB,qBAAqB;AACvB;AACA;EACE;IACE,kBAAkB;IAClB,eAAe;EACjB;EACA;IACE,mBAAmB;IACnB,iBAAiB;EACnB;AACF;AACA;EACE,0BAA0B;EAC1B,wBAAwB;AAC1B;AACA;EACE,0BAA0B;EAC1B,wBAAwB;AAC1B;AACA;EACE,uBAAuB;EACvB,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE;IACE,0BAA0B;IAC1B,wBAAwB;EAC1B;EACA;IACE,kBAAkB;IAClB,eAAe;EACjB;EACA;IACE,uBAAuB;IACvB,qBAAqB;EACvB;AACF;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;AACA;EACE,0BAA0B;EAC1B,6BAA6B;AAC/B;AACA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;AACA;;;;;EAKE;AACF;EACE,gBAAgB;AAClB;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,sDAAsD;EACtD,mDAAmD;EACnD,8CAA8C;AAChD;AACA;EACE,wDAAwD;EACxD,qDAAqD;EACrD,gDAAgD;AAClD;AACA;EACE,qDAAqD;EACrD,kDAAkD;EAClD,6CAA6C;AAC/C;AACA;EACE,qDAAqD;EACrD,kDAAkD;EAClD,6CAA6C;AAC/C;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE,mDAAmD;EACnD,gDAAgD;EAChD,8CAA8C;EAC9C,+CAA+C;EAC/C,2CAA2C;AAC7C;AACA;EACE,oDAAoD;EACpD,iDAAiD;EACjD,+CAA+C;EAC/C,gDAAgD;EAChD,4CAA4C;AAC9C;AACA;EACE,oDAAoD;EACpD,iDAAiD;EACjD,+CAA+C;EAC/C,gDAAgD;EAChD,4CAA4C;AAC9C;AACA;EACE,qDAAqD;EACrD,kDAAkD;EAClD,gDAAgD;EAChD,iDAAiD;EACjD,6CAA6C;AAC/C;AACA;EACE,kCAAkC;EAClC,+BAA+B;EAC/B,6BAA6B;EAC7B,8BAA8B;EAC9B,0BAA0B;AAC5B;AACA;EACE,oDAAoD;EACpD,iDAAiD;EACjD,+CAA+C;EAC/C,gDAAgD;EAChD,4CAA4C;AAC9C;AACA;EACE,mCAAmC;EACnC,gCAAgC;EAChC,8BAA8B;EAC9B,+BAA+B;EAC/B,2BAA2B;AAC7B;AACA;EACE,mCAAmC;EACnC,gCAAgC;EAChC,8BAA8B;EAC9B,+BAA+B;EAC/B,2BAA2B;AAC7B;AACA;EACE,oCAAoC;EACpC,iCAAiC;EACjC,+BAA+B;EAC/B,gCAAgC;EAChC,4BAA4B;AAC9B;AACA;EACE,gCAAgC;EAChC,6BAA6B;EAC7B,2BAA2B;EAC3B,4BAA4B;EAC5B,wBAAwB;AAC1B;AACA;EACE,mCAAmC;EACnC,gCAAgC;EAChC,8BAA8B;EAC9B,+BAA+B;EAC/B,2BAA2B;AAC7B;AACA;EACE,oCAAoC;EACpC,iCAAiC;EACjC,+BAA+B;EAC/B,gCAAgC;EAChC,4BAA4B;AAC9B;AACA;EACE,mCAAmC;EACnC,gCAAgC;EAChC,8BAA8B;EAC9B,+BAA+B;EAC/B,2BAA2B;AAC7B;AACA;EACE,gCAAgC;EAChC,6BAA6B;EAC7B,2BAA2B;EAC3B,4BAA4B;EAC5B,wBAAwB;AAC1B;AACA;EACE,oCAAoC;EACpC,iCAAiC;EACjC,+BAA+B;EAC/B,gCAAgC;EAChC,4BAA4B;AAC9B;AACA;EACE,qCAAqC;EACrC,kCAAkC;EAClC,gCAAgC;EAChC,iCAAiC;EACjC,6BAA6B;AAC/B;AACA;EACE;IACE,oCAAoC;IACpC,iCAAiC;IACjC,+BAA+B;IAC/B,gCAAgC;IAChC,4BAA4B;EAC9B;AACF;AACA;EACE;IACE,gCAAgC;IAChC,6BAA6B;IAC7B,2BAA2B;IAC3B,4BAA4B;IAC5B,wBAAwB;EAC1B;AACF;AACA;EACE,gCAAgC;EAChC,6BAA6B;EAC7B,2BAA2B;EAC3B,4BAA4B;EAC5B,wBAAwB;AAC1B;AACA;EACE,iCAAiC;EACjC,8BAA8B;EAC9B,4BAA4B;EAC5B,6BAA6B;EAC7B,yBAAyB;AAC3B;AACA;EACE,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,iCAAiC;AACnC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;AACnB;AACA;;;;;;;CAOC;AACD;EACE,mDAAmD;AACrD;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;AACF;AACA;EACE;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;AACF;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;AACF;AACA;EACE,mBAAmB;AACrB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,oBAAoB;AACtB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,YAAY;EACZ,qBAAqB;EACrB,sBAAsB;EACtB,yBAAyB;EACzB,8BAA8B;EAC9B,iBAAiB;AACnB;AACA;EACE,sBAAsB;EACtB,YAAY;EACZ,qBAAqB;EACrB,sBAAsB;EACtB,yBAAyB;EACzB,8BAA8B;EAC9B,iBAAiB;AACnB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,oBAAoB;AACtB;AACA;EACE;IACE,qBAAqB;EACvB;AACF;AACA;EACE;IACE,sBAAsB;EACxB;AACF;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,gCAAgC;AAClC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,qCAAqC;AACvC;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,wBAAwB;EACxB,kBAAkB;AACpB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;AACzB;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,cAAc;AAChB;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;;EAEE,oBAAoB;EACpB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,0BAA0B;AAC5B;AACA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,uBAAuB;EACvB,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,UAAU;EACV,UAAU;EACV,cAAc;EACd,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,UAAU;EACV,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,iBAAiB;AACnB;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,WAAW;EACX,YAAY;AACd;AACA;;EAEE,WAAW;EACX,YAAY;AACd;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,gFAAgF;EAChF,6EAA6E;EAC7E,4EAA4E;EAC5E,2EAA2E;EAC3E,wEAAwE;AAC1E;AACA;EACE,mBAAmB;EACnB,0EAA0E;EAC1E,+EAA+E;AACjF;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,aAAa;EACb,MAAM;EACN,SAAS;EACT,WAAW;EACX,UAAU;EACV,4EAA4E;AAC9E;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,MAAM;EACN,SAAS;EACT,WAAW;EACX,2EAA2E;AAC7E;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,uCAAuC;AACzC;AACA;EACE,uCAAuC;AACzC;AACA;EACE,uCAAuC;AACzC;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,uCAAuC;AACzC;AACA;EACE,uCAAuC;AACzC;AACA;EACE,uCAAuC;AACzC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,oCAAoC;AACtC;AACA;EACE,eAAe;EACf,yBAAyB;AAC3B;AACA;EACE,gCAAgC;EAChC,mCAAmC;AACrC;AACA;EACE,cAAc;EACd,SAAS;EACT,oCAAoC;EACpC,oCAAoC;EACpC,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,SAAS;EACT,OAAO;EACP,UAAU;EACV,oBAAoB;AACtB;AACA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,gBAAgB;EAChB,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;;;EAGE,gBAAgB;AAClB;AACA;;EAEE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;AAC7B;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,eAAe;EACf,oBAAoB;EACpB,wBAAwB;EACxB,UAAU;AACZ;AACA;EACE,MAAM;EACN,UAAU;AACZ;AACA;EACE,UAAU;EACV,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,qBAAqB;EACrB,oBAAoB;EACpB,aAAa;EACb,2BAA2B;EAC3B,sBAAsB;EACtB,mBAAmB;EACnB,sCAAsC;EACtC,sBAAsB;EACtB,8BAA8B;EAC9B,gBAAgB;EAChB,YAAY;EACZ,SAAS;EACT,UAAU;EACV,mBAAmB;EACnB,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,aAAa;EACb,2BAA2B;EAC3B,sBAAsB;EACtB,mBAAmB;EACnB,+BAA+B;EAC/B,qBAAqB;EACrB,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,WAAW;EACX,YAAY;EACZ,SAAS;AACX;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,aAAa;EACb,2BAA2B;EAC3B,sBAAsB;EACtB,qBAAqB;EACrB,+BAA+B;EAC/B,qBAAqB;EACrB,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,4BAA4B;EAC5B,eAAe;AACjB;AACA;;EAEE,WAAW;AACb;AACA;;EAEE,UAAU;EACV,WAAW;AACb;AACA;EACE,SAAS;EACT,UAAU;EACV,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,cAAc;EACd,WAAW;EACX,eAAe;AACjB;AACA;EACE;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,UAAU;IACV,eAAe;EACjB;AACF;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,UAAU;AACZ;AACA;EACE,yBAAyB;EACzB,UAAU;AACZ;AACA;EACE,yBAAyB;EACzB,UAAU;AACZ;AACA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,MAAM;AACR;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;;EAEE,eAAe;AACjB;AACA;;EAEE,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;;;;;;;;CAQC;AACD;EACE,YAAY;EACZ,aAAa;AACf;AACA;;EAEE,YAAY;EACZ,cAAc;AAChB;AACA;EACE,WAAW;AACb;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,6BAA6B;AAC/B;AACA;EACE;IACE,6BAA6B;EAC/B;AACF;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,cAAc;EACd,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,iCAAiC;AACnC;AACA;EACE,qBAAqB;AACvB;AACA;EACE,aAAa;AACf;AACA;EACE,gCAAgC;EAChC,mCAAmC;AACrC;AACA;EACE,aAAa;AACf;AACA;EACE,uCAAuC;AACzC;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,qBAAqB;AACvB;AACA;EACE;IACE,oBAAoB;IACpB,qBAAqB;EACvB;AACF;AACA;EACE;IACE,qBAAqB;IACrB,sBAAsB;EACxB;AACF;AACA;EACE,cAAc;AAChB;AACA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,uBAAuB;AACzB;AACA;EACE;IACE,cAAc;EAChB;AACF;AACA,oDAAoD;AACpD;EACE,+GAA+G;EAC/G;IACE,sBAAsB;EACxB;AACF;AACA;EACE,WAAW;AACb;AACA;EACE,cAAc;AAChB;AACA;EACE,SAAS;AACX;AACA;EACE,qCAAqC;AACvC;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;;;;;;;;;;;;;;;;;CAiBC;AACD;EACE,aAAa;EACb,eAAe;AACjB;AACA;EACE,8BAA8B;EAC9B,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,eAAe;AACjB;AACA;EACE,8BAA8B;EAC9B,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,eAAe;AACjB;AACA;EACE,8BAA8B;EAC9B,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,eAAe;AACjB;AACA;EACE,8BAA8B;EAC9B,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,eAAe;AACjB;AACA;EACE,8BAA8B;EAC9B,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;EACE;IACE,aAAa;IACb,eAAe;EACjB;EACA;IACE,8BAA8B;IAC9B,eAAe;EACjB;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;IACb,eAAe;EACjB;EACA;IACE,8BAA8B;IAC9B,eAAe;EACjB;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;IACb,eAAe;EACjB;EACA;IACE,8BAA8B;IAC9B,eAAe;EACjB;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;IACb,eAAe;EACjB;EACA;IACE,8BAA8B;IAC9B,eAAe;EACjB;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;IACb,eAAe;EACjB;EACA;IACE,8BAA8B;IAC9B,eAAe;EACjB;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,aAAa;IACb,eAAe;EACjB;EACA;IACE,8BAA8B;IAC9B,eAAe;EACjB;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;IACb,eAAe;EACjB;EACA;IACE,8BAA8B;IAC9B,eAAe;EACjB;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;IACb,eAAe;EACjB;EACA;IACE,8BAA8B;IAC9B,eAAe;EACjB;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;IACb,eAAe;EACjB;EACA;IACE,8BAA8B;IAC9B,eAAe;EACjB;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;IACb,eAAe;EACjB;EACA;IACE,8BAA8B;IAC9B,eAAe;EACjB;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,aAAa;IACb,eAAe;EACjB;EACA;IACE,8BAA8B;IAC9B,eAAe;EACjB;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;IACb,eAAe;EACjB;EACA;IACE,8BAA8B;IAC9B,eAAe;EACjB;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;IACb,eAAe;EACjB;EACA;IACE,8BAA8B;IAC9B,eAAe;EACjB;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;IACb,eAAe;EACjB;EACA;IACE,8BAA8B;IAC9B,eAAe;EACjB;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;IACb,eAAe;EACjB;EACA;IACE,8BAA8B;IAC9B,eAAe;EACjB;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;AACF;AACA;;;;;;;;CAQC;AACD;EACE,SAAS;EACT,8BAA8B;EAC9B,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,6BAA6B;EAC7B,UAAU;EACV,4BAA4B;AAC9B;AACA;EACE,QAAQ;EACR,SAAS;EACT,wCAAwC;EACxC,qCAAqC;EACrC,mCAAmC;EACnC,oCAAoC;EACpC,gCAAgC;AAClC;AACA;EACE,SAAS;EACT,mCAAmC;EACnC,gCAAgC;EAChC,8BAA8B;EAC9B,+BAA+B;EAC/B,2BAA2B;AAC7B;AACA;EACE,QAAQ;EACR,mCAAmC;EACnC,gCAAgC;EAChC,8BAA8B;EAC9B,+BAA+B;EAC/B,2BAA2B;AAC7B;AACA;;;;;;EAME;AACF;EACE,UAAU;EACV,qBAAqB;EACrB,eAAe;EACf,oCAAoC;EACpC,0BAA0B;EAC1B,kCAAkC;EAClC,aAAa;EACb,cAAc;EACd,oBAAoB;EACpB,6BAA6B;EAC7B,SAAS;EACT,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,wCAAwC;EACxC,qCAAqC;EACrC,mCAAmC;EACnC,oCAAoC;EACpC,gCAAgC;AAClC;AACA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,mCAAmC;EACnC,gCAAgC;EAChC,8BAA8B;EAC9B,+BAA+B;EAC/B,2BAA2B;AAC7B;AACA;EACE,MAAM;AACR;AACA;EACE,QAAQ;AACV;AACA;EACE,SAAS;AACX;AACA;;;;;;;;;;CAUC;AACD;EACE,YAAY;AACd;AACA;EACE;IACE,WAAW;EACb;AACF;AACA;EACE;IACE,WAAW;EACb;AACF;AACA;EACE,YAAY;EACZ,sCAAsC;EACtC,mCAAmC;EACnC,iCAAiC;EACjC,kCAAkC;EAClC,8BAA8B;AAChC;AACA;;;EAGE,kCAAkC;EAClC,+BAA+B;EAC/B,8BAA8B;EAC9B,6BAA6B;EAC7B,0BAA0B;AAC5B;AACA;;EAEE,uCAAuC;EACvC,oCAAoC;EACpC,kCAAkC;EAClC,mCAAmC;EACnC,+BAA+B;AACjC;AACA;EACE,yCAAyC;EACzC,sCAAsC;EACtC,oCAAoC;EACpC,qCAAqC;EACrC,iCAAiC;AACnC;AACA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;EACjC,8BAA8B;EAC9B,4BAA4B;EAC5B,yBAAyB;EACzB,YAAY;AACd;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE,OAAO;EACP,gEAAgE;AAClE;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,4DAA4D;AAC9D;AACA;;;EAGE,qBAAqB;AACvB;AACA;;;EAGE,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,sBAAsB;EACtB,sBAAsB;AACxB;AACA;EACE,mBAAmB;AACrB;AACA;EACE;IACE,4BAA4B;EAC9B;AACF;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;;EAEE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,oDAAoD;AACtD;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,oDAAoD;AACtD;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,oCAAoC;AACtC;AACA;;EAEE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,oDAAoD;AACtD;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,oDAAoD;AACtD;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,oCAAoC;AACtC;AACA;;EAEE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,oDAAoD;AACtD;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,oDAAoD;AACtD;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,oCAAoC;AACtC;AACA;;EAEE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,oDAAoD;AACtD;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,oCAAoC;AACtC;AACA;;EAEE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,oDAAoD;AACtD;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,oCAAoC;AACtC;AACA;;EAEE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,oDAAoD;AACtD;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,oCAAoC;AACtC;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;AACA;;EAEE,YAAY;AACd;AACA;;;EAGE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,WAAW;EACX,iCAAiC;EACjC,8BAA8B;EAC9B,4BAA4B;EAC5B,yBAAyB;AAC3B;AACA;EACE,YAAY;AACd;AACA;;EAEE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,YAAY;EACZ,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,QAAQ;EACR,SAAS;EACT,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,iCAAiC;AACnC;AACA;EACE,uBAAuB;AACzB;AACA;EACE,wBAAwB;AAC1B;AACA;;EAEE,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,sBAAsB;AACxB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE;IACE,sBAAsB;EACxB;AACF;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,2BAA2B;EAC3B,wBAAwB;EACxB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,qDAAqD;EACrD,aAAa;EACb,iCAAiC;EACjC,8BAA8B;EAC9B,wDAAwD;EACxD,mBAAmB;EACnB,iCAAiC;EACjC,+BAA+B;EAC/B,cAAc;EACd,QAAQ;AACV;AACA;EACE,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kCAAkC;EAClC,mCAAmC;EACnC,gCAAgC;AAClC;AACA;EACE,kCAAkC;EAClC,mCAAmC;EACnC,6BAA6B;AAC/B;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;AACb;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iCAAiC;EACjC,mBAAmB;AACrB;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;IACV,aAAa;EACf;AACF;AACA;EACE,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,SAAS;EACT,qBAAqB;AACvB;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;AACb;AACA;EACE;IACE,yBAAyB;EAC3B;AACF;AACA;EACE;;IAEE,iBAAiB;IACjB,kBAAkB;EACpB;AACF;AACA;EACE;IACE,cAAc;EAChB;EACA;IACE,aAAa;EACf;EACA;IACE,YAAY;EACd;AACF;AACA;EACE,gDAAgD;AAClD;AACA;EACE,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,YAAY;AACd;AACA;EACE,iBAAiB;AACnB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,wBAAwB;AAC1B;AACA;;;;;;;;;;;;;EAaE;AACF;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,QAAQ;EACR,SAAS;EACT,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,+BAA+B;EAC/B,4BAA4B;EAC5B,0BAA0B;EAC1B,2BAA2B;EAC3B,uBAAuB;AACzB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,kBAAkB;AACpB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,UAAU;EACV,WAAW;EACX,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,QAAQ;AACV;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;AACd;AACA;EACE,+DAA4G;AAC9G;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,6BAA6B;AAC/B;AACA;EACE,kBAAkB;EAClB,eAAe;AACjB;AACA;;;;;EAKE,wCAAwC;EACxC,6BAA6B;EAC7B,sBAAsB;EACtB,cAAc;EACd,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,YAAY;AACd;AACA;;;;;EAKE,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;AACrB;AACA;;;;;EAKE,sBAAsB;AACxB;AACA;;;EAGE,gBAAgB;EAChB,6BAA6B;AAC/B;AACA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE;;;;;IAKE;EACF,WAAW;AACb;AACA;;EAEE,wBAAwB;EACxB,qBAAqB;EACrB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,4BAA4B;EAC5B,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,gCAAgC;EAChC,qBAAqB;AACvB;AACA;EACE,kBAAkB;AACpB;AACA;;;;;;EAME,eAAe;AACjB;AACA;EACE,OAAO;EACP,cAAc;EACd,kBAAkB;EAClB,+BAA+B;EAC/B,iBAAiB;EACjB,WAAW;EACX,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,4BAA4B;EAC5B,4CAA4C;EAC5C,uBAAuB;AACzB;AACA;EACE,0BAA0B;EAC1B,YAAY;AACd;AACA;EACE,qBAAqB;AACvB;AACA;EACE,SAAS;EACT,YAAY;AACd;AACA;EACE,SAAS;EACT,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,OAAO;EACP,MAAM;EACN,QAAQ;EACR,SAAS;AACX;AACA;EACE,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,8BAA8B;EAC9B,SAAS;AACX;AACA;EACE,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,yBAAyB;EACzB,UAAU;AACZ;AACA;EACE,qBAAqB;AACvB;AACA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,UAAU;AACZ;AACA;;EAEE,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,WAAW;EACX,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE;IACE,WAAW;IACX,gBAAgB;IAChB,gBAAgB;EAClB;AACF;AACA;;EAEE,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,UAAU;AACZ;AACA;EACE;;IAEE,aAAa;EACf;AACF;AACA;EACE,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,QAAQ;EACR,OAAO;EACP,WAAW;EACX,oBAAoB;EACpB,mCAAmC;EACnC,gCAAgC;EAChC,8BAA8B;EAC9B,+BAA+B;EAC/B,2BAA2B;AAC7B;AACA;EACE,UAAU;AACZ;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,QAAQ;EACR,OAAO;EACP,WAAW;EACX,oBAAoB;EACpB,mCAAmC;EACnC,gCAAgC;EAChC,8BAA8B;EAC9B,+BAA+B;EAC/B,2BAA2B;AAC7B;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;EACzB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,cAAc;EACd,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;;;EAGE,8BAA8B;AAChC;AACA;EACE,UAAU;EACV,WAAW;EACX,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,mCAAmC;EACnC,gCAAgC;EAChC,8BAA8B;EAC9B,+BAA+B;EAC/B,2BAA2B;EAC3B,yBAAyB;AAC3B;AACA;EACE,eAAe;AACjB;AACA;EACE,sBAAsB;EACtB,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,UAAU;EACV,mCAAmC;EACnC,gCAAgC;EAChC,8BAA8B;EAC9B,+BAA+B;EAC/B,2BAA2B;AAC7B;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,gDAAgD;EAChD,iBAAiB;EACjB,+BAA+B;EAC/B,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE;IACE,wCAAwC;EAC1C;EACA;IACE,0CAA0C;EAC5C;AACF;AACA;EACE;IACE,wCAAwC;EAC1C;EACA;IACE,0CAA0C;EAC5C;AACF;AACA;EACE;IACE,wCAAwC;EAC1C;EACA;IACE,0CAA0C;EAC5C;AACF;AACA;EACE,iBAAiB;EACjB,mCAAmC;EACnC,gCAAgC;EAChC,8BAA8B;EAC9B,+BAA+B;EAC/B,2BAA2B;AAC7B;AACA;EACE,6CAA6C;EAC7C,4BAA4B;AAC9B;AACA;;EAEE,uGAAuG;EACvG,uCAAuC;EACvC,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,UAAU;EACV,gBAAgB;EAChB,oDAAoD;EACpD,kBAAkB;AACpB;AACA;EACE,UAAU;AACZ;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,WAAW;EACX,UAAU;AACZ;AACA;;EAEE,sBAAsB;EACtB,qBAAqB;EACrB,2BAA2B;AAC7B;AACA;;;EAGE,WAAW;EACX,UAAU;AACZ;AACA;EACE,cAAc;EACd,aAAa;AACf;AACA;;;;;EAKE,WAAW;EACX,UAAU;EACV,qLAAqL;AACvL;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,UAAU;AACZ;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,UAAU;AACZ;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,UAAU;AACZ;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,UAAU;AACZ;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;;EAEE,kBAAkB;AACpB;AACA;;EAEE,8BAA8B;EAC9B,cAAc;EACd,aAAa;AACf;AACA;;EAEE,cAAc;EACd,aAAa;AACf;AACA;;EAEE,oCAAoC;AACtC;AACA;;EAEE,aAAa;AACf;AACA;EACE,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,QAAQ;EACR,mCAAmC;EACnC,gCAAgC;EAChC,8BAA8B;EAC9B,+BAA+B;EAC/B,2BAA2B;EAC3B,sBAAsB;AACxB;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE;IACE,qBAAqB;EACvB;AACF;AACA;;EAEE,eAAe;AACjB;AACA;EACE,uEAAuE;EACvE,kCAAkC;EAClC,+BAA+B;EAC/B,8BAA8B;EAC9B,6BAA6B;EAC7B,0BAA0B;AAC5B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,WAAW;EACX,UAAU;AACZ;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,WAAW;EACX,UAAU;AACZ;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,WAAW;EACX,UAAU;AACZ;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,WAAW;EACX,UAAU;AACZ;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,WAAW;EACX,UAAU;AACZ;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,WAAW;EACX,UAAU;AACZ;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,0BAA0B;AAC5B;AACA;;EAEE,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,2CAA2C;AAC7C;AACA;;EAEE,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,UAAU;AACZ;AACA;EACE;;;;;;;sBAOoB;EACpB,uBAAuB;EACvB,YAAY;EACZ,kCAAkC;AACpC;AACA;EACE,6BAA6B;EAC7B,WAAW;EACX,SAAS;EACT,wCAAwC;EACxC,qCAAqC;EACrC,mCAAmC;EACnC,oCAAoC;EACpC,gCAAgC;AAClC;AACA;EACE,aAAa;AACf;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,aAAa;AACf;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,SAAS;AACX;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,WAAW;EACX;;;;;6EAK2E;EAC3E,kBAAkB;EAClB;aACW;AACb;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,UAAU;AACZ;AACA;EACE,yCAAyC;AAC3C;AACA;EACE;oBACkB;EAClB,uCAAuC;EACvC,oCAAoC;EACpC,kCAAkC;EAClC,mCAAmC;EACnC,+BAA+B;EAC/B,oBAAoB;AACtB;AACA;EACE,cAAc;AAChB;AACA;EACE;IACE,uCAAuC;IACvC,oCAAoC;IACpC,kCAAkC;IAClC,mCAAmC;IACnC,+BAA+B;EACjC;AACF;AACA;EACE;IACE,mBAAmB;IACnB,uCAAuC;IACvC,oCAAoC;IACpC,kCAAkC;IAClC,mCAAmC;IACnC,+BAA+B;EACjC;EACA;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,uCAAuC;IACvC,oCAAoC;IACpC,kCAAkC;IAClC,mCAAmC;IACnC,+BAA+B;EACjC;AACF;AACA;EACE;IACE,uCAAuC;IACvC,oCAAoC;IACpC,kCAAkC;IAClC,mCAAmC;IACnC,+BAA+B;EACjC;AACF;AACA;EACE,2BAA2B;EAC3B,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,YAAY;EACZ,sCAAsC;EACtC,mCAAmC;EACnC,iCAAiC;EACjC,kCAAkC;EAClC,8BAA8B;AAChC;AACA;EACE,gCAAgC;EAChC,6BAA6B;EAC7B,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;AAC1B;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE;IACE,gBAAgB;IAChB,mBAAmB;EACrB;AACF;AACA;EACE,gBAAgB;AAClB;AACA;EACE,UAAU;AACZ;AACA;EACE;;IAEE,2BAA2B;EAC7B;EACA;;IAEE,UAAU;IACV,YAAY;IACZ,sCAAsC;IACtC,mCAAmC;IACnC,iCAAiC;IACjC,kCAAkC;IAClC,8BAA8B;EAChC;AACF;AACA;EACE,+BAA+B;EAC/B,2BAA2B;AAC7B;AACA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE;IACE,gBAAgB;IAChB,yBAAyB;EAC3B;AACF;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,SAAS;AACX;AACA;EACE,SAAS;EACT,UAAU;EACV,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,eAAe;AACjB;AACA;;EAEE,aAAa;AACf;AACA;EACE,0BAA0B;EAC1B,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;AAC/B;AACA;EACE,cAAc;EACd,SAAS;AACX;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;EACrB,WAAW;EACX,UAAU;AACZ;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,qBAAqB;EACrB,WAAW;EACX,UAAU;AACZ;AACA;EACE,WAAW;EACX,UAAU;AACZ;AACA;EACE,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,QAAQ;EACR,MAAM;EACN,kCAAkC;EAClC,UAAU;EACV,6BAA6B;AAC/B;AACA;EACE,sCAAsC;AACxC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,YAAY;EACZ,sCAAsC;EACtC,UAAU;EACV,6BAA6B;AAC/B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,cAAc;AAChB;AACA;EACE,WAAW;EACX,cAAc;EACd,WAAW;AACb;AACA;EACE,wCAAwC;EACxC,2BAA2B;EAC3B,oBAAoB;EACpB,oBAAoB;EACpB,uCAAuC;EACvC,4BAA4B;EAC5B,4CAA4C;EAC5C,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,yCAAyC;EACzC,sCAAsC;EACtC,qCAAqC;EACrC,oCAAoC;EACpC,iCAAiC;AACnC;AACA;EACE,8BAA8B;EAC9B,WAAW;AACb;AACA;EACE,cAAc;EACd,gCAAgC;EAChC,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,qCAAqC;AACvC;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,cAAc;EACd,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,eAAe;AACjB;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;EACE,qBAAqB;AACvB;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,sBAAsB;AACxB;AACA;;EAEE,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,eAAe;AACjB;AACA;EACE,WAAW;EACX,UAAU;AACZ;AACA;EACE,mBAAmB;AACrB;AACA;EACE,YAAY;AACd;AACA;EACE,iBAAiB;AACnB;AACA;EACE,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,YAAY;AACd;AACA;EACE,qBAAqB;AACvB;AACA;EACE,SAAS;EACT,eAAe;AACjB;AACA;EACE,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE;IACE,UAAU;EACZ;AACF;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE;IACE,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IACE,cAAc;EAChB;EACA;IACE,kBAAkB;EACpB;AACF;AACA;EACE,sBAAsB;EACtB,eAAe;AACjB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,UAAU;EACV,aAAa;EACb,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,oBAAoB;EACpB,gBAAgB;EAChB,WAAW;EACX,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,cAAc;EACd,0BAA0B;AAC5B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;IACnB,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;AACF;AACA;;EAEE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,SAAS;AACX;AACA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,cAAc;EACd,gCAAgC;EAChC,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,cAAc;EACd,gCAAgC;EAChC,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE;IACE,cAAc;EAChB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;AACF;AACA;EACE,UAAU;AACZ;AACA;EACE,eAAe;AACjB;AACA;;;EAGE,iBAAiB;EACjB,eAAe;AACjB;AACA;;;EAGE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,sBAAsB;EACtB,cAAc;AAChB;AACA;;;;EAIE,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;AAC1B;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,yCAAyC;EACzC,qBAAqB;EACrB,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE;IACE,4BAA4B;EAC9B;AACF;AACA;EACE,gCAAgC;AAClC;AACA;EACE,mBAAmB;AACrB;AACA;EACE;IACE,iBAAiB;EACnB;AACF;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;AACpB;AACA;;EAEE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;AACA;EACE;;IAEE,cAAc;EAChB;AACF;AACA;EACE,gBAAgB;AAClB;AACA;AACA;AACA;EACE,kBAAkB;AACpB;AACA;;EAEE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,eAAe;AACjB;AACA;;;;EAIE,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;;;;EAIE,kBAAkB;EAClB,YAAY;AACd;AACA;;;;EAIE,kBAAkB;EAClB,YAAY;AACd;AACA;;;;EAIE,kBAAkB;EAClB,YAAY;AACd;AACA;;EAEE,yBAAyB;EACzB,oBAAoB;AACtB;AACA;EACE;;IAEE,mBAAmB;EACrB;EACA;;;;IAIE,OAAO;EACT;EACA;;;;IAIE,kBAAkB;IAClB,YAAY;EACd;EACA;;;;IAIE,kBAAkB;IAClB,YAAY;EACd;EACA;;;;IAIE,kBAAkB;IAClB,YAAY;EACd;AACF;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,8BAA8B;AAChC;AACA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,UAAU;EACV,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;;;;EAIE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;;;;EAIE,UAAU;EACV,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,cAAc;EACd,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,KAAK;EACL,gBAAgB;EAChB,gCAAgC;AAClC;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,UAAU;AACZ;AACA;;EAEE,kBAAkB;AACpB;AACA;EACE;;IAEE,kBAAkB;EACpB;AACF;AACA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,cAAc;EAChB;AACF;AACA;;EAEE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;AACA;;;EAGE,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;AACA;EACE,iCAAiC;EACjC,MAAM;EACN,OAAO;EACP,aAAa;EACb,eAAe;AACjB;AACA;;EAEE,aAAa;AACf;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;EACZ,qBAAqB;AACvB;AACA;EACE,uBAAuB;EACvB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,4CAA4C;EAC5C,SAAS;EACT,QAAQ;EACR,UAAU;EACV,mBAAmB;EACnB,QAAQ;EACR,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE;IACE,QAAQ;EACV;AACF;AACA;;EAEE,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,iCAAiC;EACjC,MAAM;EACN,OAAO;EACP,aAAa;EACb,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;;;EAGE,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;;EAEE,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE;IACE,cAAc;EAChB;EACA;;IAEE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;EAClB;EACA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;EACA;IACE,mBAAmB;IACnB,oBAAoB;IACpB,kBAAkB;EACpB;EACA;IACE,0BAA0B;EAC5B;AACF;AACA;EACE,eAAe;AACjB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;AACF;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;AACA;;EAEE,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,iCAAiC;AACnC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,uBAAuB;AACzB;AACA;;EAEE,cAAc;EACd,aAAa;AACf;AACA;;EAEE,cAAc;EACd,aAAa;AACf;AACA;;EAEE,cAAc;EACd,aAAa;AACf;AACA;;EAEE,cAAc;EACd,aAAa;AACf;AACA;;EAEE,cAAc;EACd,aAAa;AACf;AACA;;EAEE,cAAc;EACd,aAAa;AACf;AACA;;EAEE,cAAc;EACd,aAAa;AACf;AACA;;EAEE,cAAc;EACd,aAAa;AACf;AACA;EACE,cAAc;EACd,aAAa;AACf;AACA;EACE,cAAc;EACd,aAAa;AACf;AACA;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,WAAW;AACb;AACA;EACE,2BAA2B;EAC3B,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gCAAgC;EAChC,6BAA6B;EAC7B,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;AAC1B;AACA;EACE,SAAS;AACX;AACA;EACE,eAAe;AACjB;AACA;EACE;IACE,cAAc;EAChB;AACF;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;;EAEE,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,UAAU;EACV,mBAAmB;AACrB;AACA;;;;;;;;;;EAUE,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,mBAAmB;AACrB;AACA;;;;EAIE,qBAAqB;AACvB;AACA;;;;EAIE,kBAAkB;AACpB;AACA;;EAEE,4BAA4B;AAC9B;AACA;EACE,oBAAoB;AACtB;AACA;EACE,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,YAAY;AACd;AACA;EACE,oBAAoB;AACtB;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,QAAQ;EACR,OAAO;AACT;AACA;EACE,WAAW;EACX,cAAc;EACd,oBAAoB;AACtB","sourcesContent":["@import '../../node_modules/normalize.css/normalize.css';\n@import '../../node_modules/react-toastify/dist/ReactToastify.css';\n@import '../../node_modules/react-vis/dist/style.css';\n@font-face {\n  font-family: \"Source Sans Pro\";\n  src: url('config/fonts/sourcesanspro_regular.woff') format('woff'), url('config/fonts/sourcesanspro_regular.ttf') format('ttf');\n  font-weight: 400;\n  font-style: normal;\n}\n@font-face {\n  font-family: \"Source Sans Pro\";\n  src: url('config/fonts/sourcesanspro_italic.woff') format('woff'), url('config/fonts/sourcesanspro_italic.ttf') format('ttf');\n  font-weight: 400;\n  font-style: italic;\n}\n@font-face {\n  font-family: \"Source Sans Pro\";\n  src: url('config/fonts/sourcesanspro_light.woff') format('woff'), url('config/fonts/sourcesanspro_light.ttf') format('ttf');\n  font-weight: 300;\n  font-style: normal;\n}\n@font-face {\n  font-family: \"Source Sans Pro\";\n  src: url('config/fonts/sourcesanspro_light_italic.woff') format('woff'), url('config/fonts/sourcesanspro_light_italic.ttf') format('ttf');\n  font-weight: 300;\n  font-style: italic;\n}\n@font-face {\n  font-family: \"Source Sans Pro\";\n  src: url('config/fonts/sourcesanspro_semibold.woff') format('woff'), url('config/fonts/sourcesanspro_semibold.ttf') format('ttf');\n  font-weight: 600;\n  font-style: normal;\n}\n@font-face {\n  font-family: \"Source Sans Pro\";\n  src: url('config/fonts/sourcesanspro_semibold_italic.woff') format('woff'), url('config/fonts/sourcesanspro_semibold_italic.ttf') format('ttf');\n  font-weight: 600;\n  font-style: italic;\n}\n@font-face {\n  font-family: \"Source Sans Pro\";\n  src: url('config/fonts/sourcesanspro_bold.woff') format('woff'), url('config/fonts/sourcesanspro_bold.ttf') format('ttf');\n  font-weight: 800;\n  font-style: normal;\n}\n/*\n\n  Variables\n  ---------\n\n  Define variables.\n\n*/\n/*\n\n  Media\n  -----\n\n  Define media queries.\n\n*/\n/*\n\n  Base\n  ----\n\n  This file contains the site's base styles.\n  It also contains styling for markup that's generated server side as it's too\n  convoluted to add classes directly to it.\n\n*/\n* {\n  box-sizing: border-box;\n}\nhtml,\nbody {\n  margin: 0;\n  padding: 0;\n  width: 100%;\n  height: 100%;\n  overflow-x: hidden;\n  overflow-y: hidden;\n  max-height: 100vh;\n  min-width: 320px;\n}\n@media screen and (max-width: 520px) {\n  html,\n  body {\n    height: auto;\n    max-height: none;\n    overflow-y: auto;\n  }\n}\nbody {\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: subpixel-antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  font-family: \"Source Sans Pro\", \"Arial\", sans-serif;\n  line-height: 1.5;\n  font-size: 16px;\n  color: #111111;\n  background-color: #FFFFFF;\n}\n#app {\n  position: relative;\n  width: 100vw;\n  min-height: 100vh;\n  overflow-x: hidden;\n}\n.layout-width-constraint {\n  padding-top: 0;\n  padding-bottom: 0;\n  margin-top: 0;\n  margin-bottom: 0;\n  margin-left: auto;\n  margin-right: auto;\n  max-width: 1200px;\n  padding-left: 1.5rem;\n  padding-right: 1.5rem;\n}\n@media screen and (max-width: 768px) {\n  .layout-width-constraint {\n    padding-left: 1.5rem;\n    padding-right: 1.5rem;\n  }\n}\n@media screen and (max-width: 520px) {\n  .layout-width-constraint {\n    padding-left: 0.75rem;\n    padding-right: 0.75rem;\n  }\n}\nbutton {\n  border: none;\n  outline: none;\n}\ntd {\n  -webkit-margin-before: 0;\n  -webkit-margin-after: 0;\n}\na {\n  color: #00719F;\n}\nselect {\n  -moz-appearance: none;\n  -webkit-appearance: none;\n}\nspan.wj {\n  font-size: 0 !important;\n}\nspan.fc-em {\n  font-style: italic;\n}\n.loading {\n  animation: big-loader 2s infinite linear;\n  width: 1em;\n  height: 1em;\n  border: 0.1em solid;\n  border-right-color: transparent;\n  border-radius: 50%;\n  display: inline-block;\n}\n@-moz-keyframes big-loader {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n@-webkit-keyframes big-loader {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n@keyframes big-loader {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n/*\n\n  Layout\n  ------\n\n  Utility classes for layout.\n\n*/\n.overflow-auto {\n  overflow: auto;\n}\n.overflow-hidden {\n  overflow: hidden;\n}\n.overflow-y-auto {\n  overflow-y: auto;\n}\n.overflow-visible {\n  overflow: visible;\n}\n.overflow-x-hidden {\n  overflow: hidden;\n}\n.collapse {\n  border-collapse: collapse;\n  border-spacing: 0;\n}\n.db {\n  display: block;\n}\n.dib {\n  display: inline-block;\n}\n.di {\n  display: inline;\n}\n.dn {\n  display: none;\n}\n.flex {\n  display: flex;\n}\n.inline-flex {\n  display: inline-flex;\n}\n@media screen and (max-width: 768px) {\n  .db-t {\n    display: block;\n  }\n  .dib-t {\n    display: inline-block;\n  }\n  .di-t {\n    display: inline;\n  }\n  .dn-t {\n    display: none;\n  }\n  .flex-t {\n    display: flex;\n  }\n  .inline-flex-t {\n    display: inline-flex;\n  }\n}\n@media screen and (max-width: 520px) {\n  .db-m {\n    display: block;\n  }\n  .dib-m {\n    display: inline-block;\n  }\n  .di-m {\n    display: inline;\n  }\n  .dn-m {\n    display: none;\n  }\n  .flex-m {\n    display: flex;\n  }\n  .inline-flex-m {\n    display: inline-flex;\n  }\n}\n@media screen and (min-width: 769px) {\n  .dn-d {\n    display: none;\n  }\n  .db-d {\n    display: block;\n  }\n}\n@media screen and (min-width: 1200px) {\n  .db-l {\n    display: block;\n  }\n  .dn-l {\n    display: none;\n  }\n  .flex-l {\n    display: flex;\n  }\n}\n.flex-column {\n  flex-direction: column;\n}\n.flex-row {\n  flex-direction: row;\n}\n.flex-column-reverse {\n  flex-direction: column-reverse;\n}\n.flex-row-reverse {\n  flex-direction: row-reverse;\n}\n@media screen and (max-width: 768px) {\n  .flex-column-t {\n    flex-direction: column;\n  }\n  .flex-row-t {\n    flex-direction: row;\n  }\n  .flex-column-reverse-t {\n    flex-direction: column-reverse;\n  }\n  .flex-row-reverse-t {\n    flex-direction: row-reverse;\n  }\n}\n@media screen and (max-width: 520px) {\n  .flex-column-m {\n    flex-direction: column;\n  }\n  .flex-row-m {\n    flex-direction: row;\n  }\n  .flex-column-reverse-m {\n    flex-direction: column-reverse;\n  }\n  .flex-row-reverse-m {\n    flex-direction: row-reverse;\n  }\n}\n.order-1 {\n  order: 1;\n}\n.order-2 {\n  order: 2;\n}\n.order-3 {\n  order: 3;\n}\n.flex-wrap {\n  flex-wrap: wrap;\n}\n.flex-nowrap {\n  flex-wrap: nowrap;\n}\n.flex-wrap-reverse {\n  flex-wrap: wrap-reverse;\n}\n@media screen and (max-width: 768px) {\n  .flex-wrap-t {\n    flex-wrap: wrap;\n  }\n}\n@media screen and (max-width: 520px) {\n  .flex-wrap-m {\n    flex-wrap: wrap;\n  }\n}\n.content-start {\n  align-content: flex-start;\n}\n.content-end {\n  align-content: flex-end;\n}\n.content-center {\n  align-content: center;\n}\n.content-baseline {\n  align-content: baseline;\n}\n.content-stretch {\n  align-content: stretch;\n}\n.items-start {\n  align-items: flex-start;\n}\n.items-end {\n  align-items: flex-end;\n}\n.items-center {\n  align-items: center;\n}\n.items-baseline {\n  align-items: baseline;\n}\n.items-stretch {\n  align-items: stretch;\n}\n@media screen and (max-width: 768px) {\n  .items-start-t {\n    align-items: flex-start;\n  }\n  .items-end-t {\n    align-items: flex-end;\n  }\n  .items-center-t {\n    align-items: center;\n  }\n  .items-baseline-t {\n    align-items: baseline;\n  }\n  .items-stretch-t {\n    align-items: stretch;\n  }\n}\n@media screen and (max-width: 520px) {\n  .items-start-m {\n    align-items: flex-start;\n  }\n  .items-end-m {\n    align-items: flex-end;\n  }\n  .items-center-m {\n    align-items: center;\n  }\n  .items-baseline-m {\n    align-items: baseline;\n  }\n  .items-stretch-m {\n    align-items: stretch;\n  }\n}\n.self-end {\n  align-self: flex-end;\n}\n.self-start {\n  align-self: flex-start;\n}\n@media screen and (max-width: 768px) {\n  .self-end-t {\n    align-self: flex-end;\n  }\n  .self-start-t {\n    align-self: flex-start;\n  }\n}\n.justify-start {\n  justify-content: flex-start;\n}\n.justify-end {\n  justify-content: flex-end;\n}\n.justify-center {\n  justify-content: center;\n}\n.justify-between {\n  justify-content: space-between;\n}\n.justify-around {\n  justify-content: space-around;\n}\n.justify-evenly {\n  justify-content: space-around;\n  justify-content: space-evenly;\n}\n@media screen and (max-width: 768px) {\n  .justify-start-t {\n    justify-content: flex-start;\n  }\n  .justify-end-t {\n    justify-content: flex-end;\n  }\n  .justify-center-t {\n    justify-content: center;\n  }\n  .justify-between-t {\n    justify-content: space-between;\n  }\n  .justify-evenly-t {\n    justify-content: space-around;\n    justify-content: space-evenly;\n  }\n}\n@media screen and (max-width: 520px) {\n  .justify-start-m {\n    justify-content: flex-start;\n  }\n  .justify-end-m {\n    justify-content: flex-end;\n  }\n  .justify-center-m {\n    justify-content: center;\n  }\n  .justify-between-m {\n    justify-content: space-between;\n  }\n  .justify-evenly-m {\n    justify-content: space-around;\n    justify-content: space-evenly;\n  }\n}\n.valign-top {\n  vertical-align: top;\n}\n.valign-text-top {\n  vertical-align: text-top;\n}\n.valign-middle {\n  vertical-align: middle;\n}\n.valign-bottom {\n  vertical-align: bottom;\n}\n.valign-text-bottom {\n  vertical-align: text-bottom;\n}\n.valign-super {\n  vertical-align: super;\n}\n.valign-sub {\n  vertical-align: sub;\n}\n.basis0 {\n  flex-basis: 0;\n}\n.basis-auto {\n  min-width: 0;\n  min-height: 0;\n  flex-basis: auto;\n}\n.basis-50 {\n  flex-basis: 50%;\n}\n.basis-100 {\n  flex-basis: 100%;\n}\n@media screen and (max-width: 768px) {\n  .basis0-t {\n    flex-basis: 0;\n  }\n  .basis-auto-t {\n    min-width: 0;\n    min-height: 0;\n    flex-basis: auto;\n  }\n}\n.grow-0 {\n  flex-grow: 0;\n}\n.grow-1 {\n  flex-grow: 1;\n}\n.grow-2 {\n  flex-grow: 2;\n}\n.grow-3 {\n  flex-grow: 3;\n}\n.grow-4 {\n  flex-grow: 4;\n}\n.grow-5 {\n  flex-grow: 5;\n}\n.grow-initial {\n  flex-grow: initial;\n}\n@media screen and (max-width: 768px) {\n  .grow-0-t {\n    flex-grow: 0;\n  }\n  .grow-1-t {\n    flex-grow: 1;\n  }\n  .grow-2-t {\n    flex-grow: 2;\n  }\n  .grow-3-t {\n    flex-grow: 3;\n  }\n  .grow-4-t {\n    flex-grow: 4;\n  }\n  .grow-5-t {\n    flex-grow: 5;\n  }\n  .grow-initial-t {\n    flex-grow: initial;\n  }\n}\n@media screen and (max-width: 520px) {\n  .grow-0-m {\n    flex-grow: 0;\n  }\n  .grow-1-m {\n    flex-grow: 1;\n  }\n  .grow-2-m {\n    flex-grow: 2;\n  }\n  .grow-3-m {\n    flex-grow: 3;\n  }\n  .grow-4-m {\n    flex-grow: 4;\n  }\n  .grow-5-m {\n    flex-grow: 5;\n  }\n}\n.shrink-0 {\n  flex-shrink: 0;\n}\n.shrink-1 {\n  flex-shrink: 1;\n}\n.shrink-2 {\n  flex-shrink: 2;\n}\n@media screen and (max-width: 768px) {\n  .shrink-0-t {\n    flex-shrink: 0;\n  }\n  .shrink-1-t {\n    flex-shrink: 1;\n  }\n}\n@media screen and (max-width: 520px) {\n  .shrink-0-m {\n    flex-shrink: 0;\n  }\n  .shrink-1-m {\n    flex-shrink: 1;\n  }\n}\n.flt-l {\n  float: left;\n}\n.flt-n {\n  float: none;\n}\n.flt-r {\n  float: right;\n}\n.static {\n  position: static;\n}\n.relative {\n  position: relative;\n}\n.absolute {\n  position: absolute;\n}\n.fixed {\n  position: fixed;\n}\n.sticky {\n  position: -webkit-sticky;\n  position: sticky;\n}\n@media screen and (min-width: 1200px) {\n  .sticky-l {\n    position: -webkit-sticky;\n    position: sticky;\n  }\n}\n@media screen and (max-width: 768px) {\n  .static-t {\n    position: static;\n  }\n  .relative-t {\n    position: relative;\n  }\n  .absolute-t {\n    position: absolute;\n  }\n  .fixed-t {\n    position: fixed;\n  }\n  .sticky-t {\n    position: -webkit-sticky;\n    position: sticky;\n  }\n}\n@media screen and (max-width: 520px) {\n  .static-m {\n    position: static;\n  }\n  .relative-m {\n    position: relative;\n  }\n  .absolute-m {\n    position: absolute;\n  }\n  .fixed-m {\n    position: fixed;\n  }\n  .sticky-m {\n    position: -webkit-sticky;\n    position: sticky;\n  }\n}\n.z0 {\n  z-index: 0;\n}\n.z5 {\n  z-index: 5;\n}\n.z10 {\n  z-index: 10;\n}\n.z15 {\n  z-index: 15;\n}\n.z20 {\n  z-index: 20;\n}\n.z25 {\n  z-index: 25;\n}\n.z30 {\n  z-index: 30;\n}\n.z35 {\n  z-index: 35;\n}\n.z40 {\n  z-index: 40;\n}\n.z45 {\n  z-index: 45;\n}\n.z50 {\n  z-index: 50;\n}\n.z55 {\n  z-index: 55;\n}\n.z60 {\n  z-index: 60;\n}\n.z105 {\n  z-index: 105;\n}\n.z1055 {\n  z-index: 1055;\n}\n.right0 {\n  right: 0;\n}\n.right2 {\n  right: 0.25rem;\n}\n.right3 {\n  right: 0.375rem;\n}\n.right4 {\n  right: 0.5rem;\n}\n.right5 {\n  right: 0.75rem;\n}\n.right6 {\n  right: 1rem;\n}\n.right7 {\n  right: 1.5rem;\n}\n.right9 {\n  right: 3rem;\n}\n.right-50 {\n  right: 50%;\n}\n.right-100 {\n  right: 100%;\n}\n.-right3 {\n  right: -0.375rem;\n}\n.left0 {\n  left: 0;\n}\n.left2 {\n  left: 0.25rem;\n}\n.left4 {\n  left: 0.5rem;\n}\n.left5 {\n  left: 0.75rem;\n}\n.left6 {\n  left: 1rem;\n}\n.left7 {\n  left: 1.5rem;\n}\n.left8 {\n  left: 2rem;\n}\n.left-50 {\n  left: 50%;\n}\n.left-100 {\n  left: 100%;\n}\n.-left5 {\n  left: -0.75rem;\n}\n.top0 {\n  top: 0;\n}\n.top1 {\n  top: 0.125rem;\n}\n.top2 {\n  top: 0.25rem;\n}\n.top3 {\n  top: 0.375rem;\n}\n.top4 {\n  top: 0.5rem;\n}\n.top5 {\n  top: 0.75rem;\n}\n.top6 {\n  top: 1rem;\n}\n.top7 {\n  top: 1.5rem;\n}\n.top8 {\n  top: 2rem;\n}\n.top9 {\n  top: 3rem;\n}\n.top10 {\n  top: 4rem;\n}\n.top11 {\n  top: 6rem;\n}\n.top12 {\n  top: 8rem;\n}\n.top-15 {\n  top: 15%;\n}\n.top-25 {\n  top: 25%;\n}\n.top-50 {\n  top: 50%;\n}\n.top-100 {\n  top: 100%;\n}\n.-top9 {\n  top: -3rem;\n}\n.-top10 {\n  top: -4rem;\n}\n@media screen and (max-width: 768px) {\n  .top4-t {\n    top: 0.5rem;\n  }\n}\n.bottom0 {\n  bottom: 0;\n}\n.bottom1 {\n  bottom: 0.125rem;\n}\n.bottom2 {\n  bottom: 0.25rem;\n}\n.bottom3 {\n  bottom: 0.375rem;\n}\n.bottom4 {\n  bottom: 0.5rem;\n}\n.bottom5 {\n  bottom: 0.75rem;\n}\n.bottom6 {\n  bottom: 1rem;\n}\n.bottom7 {\n  bottom: 1.5rem;\n}\n.bottom-50 {\n  bottom: 50%;\n}\n.bottom-100 {\n  bottom: 100%;\n}\n.-bottom5 {\n  bottom: -0.75rem;\n}\n.w0 {\n  width: 0;\n}\n.w1 {\n  width: 0.125rem;\n}\n.w2 {\n  width: 0.25rem;\n}\n.w3 {\n  width: 0.375rem;\n}\n.w4 {\n  width: 0.5rem;\n}\n.w5 {\n  width: 0.75rem;\n}\n.w6 {\n  width: 1rem;\n}\n.w7 {\n  width: 1.5rem;\n}\n.w8 {\n  width: 2rem;\n}\n.w9 {\n  width: 3rem;\n}\n.w10 {\n  width: 4rem;\n}\n.w11 {\n  width: 6rem;\n}\n.w12 {\n  width: 8rem;\n}\n.w13 {\n  width: 12rem;\n}\n.w14 {\n  width: 16rem;\n}\n.w15 {\n  width: 32rem;\n}\n.w16 {\n  width: 48rem;\n}\n.w17 {\n  width: 64rem;\n}\n.w18 {\n  width: 96rem;\n}\n.w-10 {\n  width: 10%;\n}\n.w-20 {\n  width: 20%;\n}\n.w-25 {\n  width: 25%;\n}\n.w-30 {\n  width: 30%;\n}\n.w-33 {\n  width: 33%;\n}\n.w-34 {\n  width: 34%;\n}\n.w-40 {\n  width: 40%;\n}\n.w-50 {\n  width: 50%;\n}\n.w-55 {\n  width: 55%;\n}\n.w-60 {\n  width: 60%;\n}\n.w-65 {\n  width: 65%;\n}\n.w-70 {\n  width: 70%;\n}\n.w-75 {\n  width: 75%;\n}\n.w-80 {\n  width: 80%;\n}\n.w-90 {\n  width: 90%;\n}\n.w-95 {\n  width: 95%;\n}\n.w-100 {\n  width: 100%;\n}\n.w-third {\n  width: calc(100% / 3);\n}\n.w-two-thirds {\n  width: calc(100% / 1.5);\n}\n.w-auto {\n  width: auto;\n}\n.w-max-content {\n  width: max-content;\n}\n.vw-90 {\n  width: 90vw;\n}\n.vw-100 {\n  width: 100vw;\n}\n@media screen and (max-width: 768px) {\n  .w13-t {\n    width: 12rem;\n  }\n  .w-100-t {\n    width: 100%;\n  }\n  .w8-t {\n    width: 2rem;\n  }\n  .w-95-t {\n    width: 95%;\n  }\n  .w-100-t {\n    width: 100%;\n  }\n  .vw-100-t {\n    width: 100vw;\n  }\n}\n@media screen and (max-width: 520px) {\n  .w5-m {\n    width: 0.75rem;\n  }\n  .w6-m {\n    width: 1rem;\n  }\n  .w7-m {\n    width: 1.5rem;\n  }\n  .w8-m {\n    width: 2rem;\n  }\n  .w10-m {\n    width: 4rem;\n  }\n  .w-100-m {\n    width: 100%;\n  }\n  .w-auto-m {\n    width: auto;\n  }\n  .vw-100-m {\n    width: 100vw;\n  }\n}\n@media screen and (min-width: 1200px) {\n  .w16-l {\n    width: 48rem;\n  }\n  .w-50-l {\n    width: 50%;\n  }\n}\n.max-w0 {\n  max-width: 0;\n}\n.max-w1 {\n  max-width: 0.125rem;\n}\n.max-w2 {\n  max-width: 0.25rem;\n}\n.max-w3 {\n  max-width: 0.375rem;\n}\n.max-w4 {\n  max-width: 0.5rem;\n}\n.max-w5 {\n  max-width: 0.75rem;\n}\n.max-w6 {\n  max-width: 1rem;\n}\n.max-w7 {\n  max-width: 1.5rem;\n}\n.max-w8 {\n  max-width: 2rem;\n}\n.max-w9 {\n  max-width: 3rem;\n}\n.max-w10 {\n  max-width: 4rem;\n}\n.max-w11 {\n  max-width: 6rem;\n}\n.max-w12 {\n  max-width: 8rem;\n}\n.max-w13 {\n  max-width: 12rem;\n}\n.max-w14 {\n  max-width: 16rem;\n}\n.max-w15 {\n  max-width: 32rem;\n}\n.max-w16 {\n  max-width: 48rem;\n}\n.max-w17 {\n  max-width: 64rem;\n}\n.max-w18 {\n  max-width: 96rem;\n}\n.max-w-90 {\n  max-width: 90%;\n}\n.max-w-94 {\n  max-width: 94%;\n}\n.max-w-100 {\n  max-width: 100%;\n}\n.max-w-100vw {\n  max-width: 100vw;\n}\n.max-w-none {\n  max-width: none;\n}\n.max-w-inherit {\n  max-width: inherit;\n}\n@media screen and (max-width: 768px) {\n  .max-w-none-t {\n    max-width: none;\n  }\n}\n.min-w0 {\n  min-width: 0;\n}\n.min-w1 {\n  min-width: 0.125rem;\n}\n.min-w2 {\n  min-width: 0.25rem;\n}\n.min-w3 {\n  min-width: 0.375rem;\n}\n.min-w4 {\n  min-width: 0.5rem;\n}\n.min-w5 {\n  min-width: 0.75rem;\n}\n.min-w6 {\n  min-width: 1rem;\n}\n.min-w7 {\n  min-width: 1.5rem;\n}\n.min-w8 {\n  min-width: 2rem;\n}\n.min-w9 {\n  min-width: 3rem;\n}\n.min-w10 {\n  min-width: 4rem;\n}\n.min-w11 {\n  min-width: 6rem;\n}\n.min-w12 {\n  min-width: 8rem;\n}\n.min-w13 {\n  min-width: 12rem;\n}\n.min-w14 {\n  min-width: 16rem;\n}\n.min-w15 {\n  min-width: 32rem;\n}\n.min-w16 {\n  min-width: 48rem;\n}\n.min-w17 {\n  min-width: 64rem;\n}\n.min-w18 {\n  min-width: 96rem;\n}\n.min-w-80 {\n  min-width: 80%;\n}\n.min-w-100 {\n  min-width: 100%;\n}\n.min-w-none {\n  min-width: 0;\n}\n@media screen and (max-width: 520px) {\n  .min-w9-m {\n    min-width: 3rem;\n  }\n}\n.h0 {\n  height: 0;\n}\n.h1 {\n  height: 1rem;\n}\n.h2 {\n  height: 2rem;\n}\n.h3 {\n  height: 3rem;\n}\n.h4 {\n  height: 4rem;\n}\n.h5 {\n  height: 5rem;\n}\n.h6 {\n  height: 6rem;\n}\n.h7 {\n  height: 7rem;\n}\n.h8 {\n  height: 8rem;\n}\n.h12 {\n  height: 12rem;\n}\n.h-25 {\n  height: 25%;\n}\n.h-50 {\n  height: 50%;\n}\n.h-75 {\n  height: 75%;\n}\n.h-100 {\n  height: 100%;\n}\n.vh-25 {\n  height: 25vh;\n}\n.vh-50 {\n  height: 50vh;\n}\n.vh-75 {\n  height: 75vh;\n}\n.vh-100 {\n  height: 100vh;\n}\n.h-auto {\n  height: auto;\n}\n.h-inherit {\n  height: inherit;\n}\n@media screen and (max-width: 520px) {\n  .h1-m {\n    height: 1rem;\n  }\n  .h2-m {\n    height: 2rem;\n  }\n  .h3-m {\n    height: 3rem;\n  }\n  .h4-m {\n    height: 4rem;\n  }\n  .h5-m {\n    height: 5rem;\n  }\n  .h6-m {\n    height: 6rem;\n  }\n}\n.min-h-0 {\n  min-height: 0;\n}\n.min-h2 {\n  min-height: 2rem;\n}\n.min-h3 {\n  min-height: 3rem;\n}\n.min-h4 {\n  min-height: 4rem;\n}\n.min-h8 {\n  min-height: 8rem;\n}\n.min-h12 {\n  min-height: 12rem;\n}\n.min-h-spacing-9 {\n  min-height: 3rem;\n}\n.min-h-spacing-14 {\n  min-height: 16rem;\n}\n.min-h-spacing-15 {\n  min-height: 32rem;\n}\n.min-h-100 {\n  min-height: 100%;\n}\n.min-vh-100 {\n  min-height: 100vh;\n}\n.min-h-inherit {\n  min-height: inherit;\n}\n.max-h7 {\n  max-height: 7rem;\n}\n.max-h8 {\n  max-height: 2rem;\n}\n.max-h-75 {\n  max-height: 75%;\n}\n@media screen and (max-width: 768px) {\n  .max-h8-t {\n    max-height: 2rem;\n  }\n}\n/*\n\n  Spacing\n  -------\n\n  Utility classes for margins and paddings.\n\n*/\n.pa0 {\n  padding: 0;\n}\n.pa1 {\n  padding: 0.125rem;\n}\n.pa2 {\n  padding: 0.25rem;\n}\n.pa3 {\n  padding: 0.375rem;\n}\n.pa4 {\n  padding: 0.5rem;\n}\n.pa5 {\n  padding: 0.75rem;\n}\n.pa6 {\n  padding: 1rem;\n}\n.pa7 {\n  padding: 1.5rem;\n}\n.pa8 {\n  padding: 2rem;\n}\n.pa9 {\n  padding: 3rem;\n}\n.pa10 {\n  padding: 4rem;\n}\n.pa11 {\n  padding: 6rem;\n}\n.pa12 {\n  padding: 8rem;\n}\n.pa13 {\n  padding: 12rem;\n}\n.pa14 {\n  padding: 16rem;\n}\n@media screen and (max-width: 768px) {\n  .pa0-t {\n    padding: 0;\n  }\n  .pa1-t {\n    padding: 0.125rem;\n  }\n  .pa2-t {\n    padding: 0.25rem;\n  }\n  .pa3-t {\n    padding: 0.375rem;\n  }\n  .pa4-t {\n    padding: 0.5rem;\n  }\n  .pa5-t {\n    padding: 0.75rem;\n  }\n  .pa6-t {\n    padding: 1rem;\n  }\n  .pa7-t {\n    padding: 1.5rem;\n  }\n  .pa8-t {\n    padding: 2rem;\n  }\n  .pa9-t {\n    padding: 3rem;\n  }\n  .pa11-t {\n    padding: 4rem;\n  }\n  .pa10-t {\n    padding: 6rem;\n  }\n  .pa12-t {\n    padding: 8rem;\n  }\n  .pa13-t {\n    padding: 12rem;\n  }\n  .pa14-t {\n    padding: 16rem;\n  }\n}\n@media screen and (max-width: 520px) {\n  .pa0-m {\n    padding: 0;\n  }\n  .pa1-m {\n    padding: 0.125rem;\n  }\n  .pa2-m {\n    padding: 0.25rem;\n  }\n  .pa3-m {\n    padding: 0.375rem;\n  }\n  .pa4-m {\n    padding: 0.5rem;\n  }\n  .pa5-m {\n    padding: 0.75rem;\n  }\n  .pa6-m {\n    padding: 1rem;\n  }\n  .pa7-m {\n    padding: 1.5rem;\n  }\n  .pa8-m {\n    padding: 2rem;\n  }\n  .pa9-m {\n    padding: 3rem;\n  }\n  .pa11-m {\n    padding: 4rem;\n  }\n  .pa10-m {\n    padding: 6rem;\n  }\n  .pa12-m {\n    padding: 8rem;\n  }\n  .pa13-m {\n    padding: 12rem;\n  }\n  .pa14-m {\n    padding: 16rem;\n  }\n}\n.pl0 {\n  padding-left: 0;\n}\n.pl1 {\n  padding-left: 0.125rem;\n}\n.pl2 {\n  padding-left: 0.25rem;\n}\n.pl3 {\n  padding-left: 0.375rem;\n}\n.pl4 {\n  padding-left: 0.5rem;\n}\n.pl5 {\n  padding-left: 0.75rem;\n}\n.pl6 {\n  padding-left: 1rem;\n}\n.pl7 {\n  padding-left: 1.5rem;\n}\n.pl8 {\n  padding-left: 2rem;\n}\n.pl9 {\n  padding-left: 3rem;\n}\n.pl10 {\n  padding-left: 4rem;\n}\n.pl11 {\n  padding-left: 6rem;\n}\n.pl12 {\n  padding-left: 8rem;\n}\n.pl13 {\n  padding-left: 12rem;\n}\n.pl14 {\n  padding-left: 16rem;\n}\n@media screen and (max-width: 768px) {\n  .pl0-t {\n    padding-left: 0;\n  }\n  .pl1-t {\n    padding-left: 0.125rem;\n  }\n  .pl2-t {\n    padding-left: 0.25rem;\n  }\n  .pl3-t {\n    padding-left: 0.375rem;\n  }\n  .pl4-t {\n    padding-left: 0.5rem;\n  }\n  .pl5-t {\n    padding-left: 0.75rem;\n  }\n  .pl6-t {\n    padding-left: 1rem;\n  }\n  .pl7-t {\n    padding-left: 1.5rem;\n  }\n  .pl8-t {\n    padding-left: 2rem;\n  }\n  .pl9-t {\n    padding-left: 3rem;\n  }\n  .pl11-t {\n    padding-left: 4rem;\n  }\n  .pl10-t {\n    padding-left: 6rem;\n  }\n  .pl12-t {\n    padding-left: 8rem;\n  }\n  .pl13-t {\n    padding-left: 12rem;\n  }\n  .pl14-t {\n    padding-left: 16rem;\n  }\n}\n@media screen and (max-width: 520px) {\n  .pl0-m {\n    padding-left: 0;\n  }\n  .pl1-m {\n    padding-left: 0.125rem;\n  }\n  .pl2-m {\n    padding-left: 0.25rem;\n  }\n  .pl3-m {\n    padding-left: 0.375rem;\n  }\n  .pl4-m {\n    padding-left: 0.5rem;\n  }\n  .pl5-m {\n    padding-left: 0.75rem;\n  }\n  .pl6-m {\n    padding-left: 1rem;\n  }\n  .pl7-m {\n    padding-left: 1.5rem;\n  }\n  .pl8-m {\n    padding-left: 2rem;\n  }\n  .pl9-m {\n    padding-left: 3rem;\n  }\n  .pl11-m {\n    padding-left: 4rem;\n  }\n  .pl10-m {\n    padding-left: 6rem;\n  }\n  .pl12-m {\n    padding-left: 8rem;\n  }\n  .pl13-m {\n    padding-left: 12rem;\n  }\n  .pl14-m {\n    padding-left: 16rem;\n  }\n}\n@media screen and (min-width: 1200px) {\n  .pl5-l {\n    padding-left: 0.75rem;\n  }\n}\n.pr0 {\n  padding-right: 0;\n}\n.pr1 {\n  padding-right: 0.125rem;\n}\n.pr2 {\n  padding-right: 0.25rem;\n}\n.pr3 {\n  padding-right: 0.375rem;\n}\n.pr4 {\n  padding-right: 0.5rem;\n}\n.pr5 {\n  padding-right: 0.75rem;\n}\n.pr6 {\n  padding-right: 1rem;\n}\n.pr7 {\n  padding-right: 1.5rem;\n}\n.pr8 {\n  padding-right: 2rem;\n}\n.pr9 {\n  padding-right: 3rem;\n}\n.pr10 {\n  padding-right: 4rem;\n}\n.pr11 {\n  padding-right: 6rem;\n}\n.pr12 {\n  padding-right: 8rem;\n}\n.pr13 {\n  padding-right: 12rem;\n}\n.pr14 {\n  padding-right: 16rem;\n}\n@media screen and (max-width: 768px) {\n  .pr0-t {\n    padding-right: 0;\n  }\n  .pr1-t {\n    padding-right: 0.125rem;\n  }\n  .pr2-t {\n    padding-right: 0.25rem;\n  }\n  .pr3-t {\n    padding-right: 0.375rem;\n  }\n  .pr4-t {\n    padding-right: 0.5rem;\n  }\n  .pr5-t {\n    padding-right: 0.75rem;\n  }\n  .pr6-t {\n    padding-right: 1rem;\n  }\n  .pr7-t {\n    padding-right: 1.5rem;\n  }\n  .pr8-t {\n    padding-right: 2rem;\n  }\n  .pr9-t {\n    padding-right: 3rem;\n  }\n  .pr11-t {\n    padding-right: 4rem;\n  }\n  .pr10-t {\n    padding-right: 6rem;\n  }\n  .pr12-t {\n    padding-right: 8rem;\n  }\n  .pr13-t {\n    padding-right: 12rem;\n  }\n  .pr14-t {\n    padding-right: 16rem;\n  }\n}\n@media screen and (max-width: 520px) {\n  .pr0-m {\n    padding-right: 0;\n  }\n  .pr1-m {\n    padding-right: 0.125rem;\n  }\n  .pr2-m {\n    padding-right: 0.25rem;\n  }\n  .pr3-m {\n    padding-right: 0.375rem;\n  }\n  .pr4-m {\n    padding-right: 0.5rem;\n  }\n  .pr5-m {\n    padding-right: 0.75rem;\n  }\n  .pr6-m {\n    padding-right: 1rem;\n  }\n  .pr7-m {\n    padding-right: 1.5rem;\n  }\n  .pr8-m {\n    padding-right: 2rem;\n  }\n  .pr9-m {\n    padding-right: 3rem;\n  }\n  .pr11-m {\n    padding-right: 4rem;\n  }\n  .pr10-m {\n    padding-right: 6rem;\n  }\n  .pr12-m {\n    padding-right: 8rem;\n  }\n  .pr13-m {\n    padding-right: 12rem;\n  }\n  .pr14-m {\n    padding-right: 16rem;\n  }\n}\n@media screen and (min-width: 1200px) {\n  .pr5-l {\n    padding-right: 0.75rem;\n  }\n}\n.pb0 {\n  padding-bottom: 0;\n}\n.pb1 {\n  padding-bottom: 0.125rem;\n}\n.pb2 {\n  padding-bottom: 0.25rem;\n}\n.pb3 {\n  padding-bottom: 0.375rem;\n}\n.pb4 {\n  padding-bottom: 0.5rem;\n}\n.pb5 {\n  padding-bottom: 0.75rem;\n}\n.pb6 {\n  padding-bottom: 1rem;\n}\n.pb7 {\n  padding-bottom: 1.5rem;\n}\n.pb8 {\n  padding-bottom: 2rem;\n}\n.pb9 {\n  padding-bottom: 3rem;\n}\n.pb10 {\n  padding-bottom: 4rem;\n}\n.pb11 {\n  padding-bottom: 6rem;\n}\n.pb12 {\n  padding-bottom: 8rem;\n}\n.pb13 {\n  padding-bottom: 12rem;\n}\n.pb14 {\n  padding-bottom: 16rem;\n}\n.pb-80 {\n  padding-bottom: 80%;\n}\n@media screen and (max-width: 768px) {\n  .pb0-t {\n    padding-bottom: 0;\n  }\n  .pb1-t {\n    padding-bottom: 0.125rem;\n  }\n  .pb2-t {\n    padding-bottom: 0.25rem;\n  }\n  .pb3-t {\n    padding-bottom: 0.375rem;\n  }\n  .pb4-t {\n    padding-bottom: 0.5rem;\n  }\n  .pb5-t {\n    padding-bottom: 0.75rem;\n  }\n  .pb6-t {\n    padding-bottom: 1rem;\n  }\n  .pb7-t {\n    padding-bottom: 1.5rem;\n  }\n  .pb8-t {\n    padding-bottom: 2rem;\n  }\n  .pb9-t {\n    padding-bottom: 3rem;\n  }\n  .pb10-t {\n    padding-bottom: 4rem;\n  }\n  .pb11-t {\n    padding-bottom: 6rem;\n  }\n  .pb12-t {\n    padding-bottom: 8rem;\n  }\n  .pb13-t {\n    padding-bottom: 12rem;\n  }\n  .pb14-t {\n    padding-bottom: 16rem;\n  }\n}\n@media screen and (max-width: 520px) {\n  .pb0-m {\n    padding-bottom: 0;\n  }\n  .pb1-m {\n    padding-bottom: 0.125rem;\n  }\n  .pb2-m {\n    padding-bottom: 0.25rem;\n  }\n  .pb3-m {\n    padding-bottom: 0.375rem;\n  }\n  .pb4-m {\n    padding-bottom: 0.5rem;\n  }\n  .pb5-m {\n    padding-bottom: 0.75rem;\n  }\n  .pb6-m {\n    padding-bottom: 1rem;\n  }\n  .pb7-m {\n    padding-bottom: 1.5rem;\n  }\n  .pb8-m {\n    padding-bottom: 2rem;\n  }\n  .pb9-m {\n    padding-bottom: 3rem;\n  }\n  .pb11-m {\n    padding-bottom: 4rem;\n  }\n  .pb10-m {\n    padding-bottom: 6rem;\n  }\n  .pb12-m {\n    padding-bottom: 8rem;\n  }\n  .pb13-m {\n    padding-bottom: 12rem;\n  }\n  .pb14-m {\n    padding-bottom: 16rem;\n  }\n  .pb-80-m {\n    padding-bottom: 80%;\n  }\n}\n.pt0 {\n  padding-top: 0;\n}\n.pt1 {\n  padding-top: 0.125rem;\n}\n.pt2 {\n  padding-top: 0.25rem;\n}\n.pt3 {\n  padding-top: 0.375rem;\n}\n.pt4 {\n  padding-top: 0.5rem;\n}\n.pt5 {\n  padding-top: 0.75rem;\n}\n.pt6 {\n  padding-top: 1rem;\n}\n.pt7 {\n  padding-top: 1.5rem;\n}\n.pt8 {\n  padding-top: 2rem;\n}\n.pt9 {\n  padding-top: 3rem;\n}\n.pt10 {\n  padding-top: 4rem;\n}\n.pt11 {\n  padding-top: 6rem;\n}\n.pt12 {\n  padding-top: 8rem;\n}\n.pt13 {\n  padding-top: 12rem;\n}\n.pt14 {\n  padding-top: 16rem;\n}\n@media screen and (max-width: 768px) {\n  .pt0-t {\n    padding-top: 0;\n  }\n  .pt1-t {\n    padding-top: 0.125rem;\n  }\n  .pt2-t {\n    padding-top: 0.25rem;\n  }\n  .pt3-t {\n    padding-top: 0.375rem;\n  }\n  .pt4-t {\n    padding-top: 0.5rem;\n  }\n  .pt5-t {\n    padding-top: 0.75rem;\n  }\n  .pt6-t {\n    padding-top: 1rem;\n  }\n  .pt7-t {\n    padding-top: 1.5rem;\n  }\n  .pt8-t {\n    padding-top: 2rem;\n  }\n  .pt9-t {\n    padding-top: 3rem;\n  }\n  .pt11-t {\n    padding-top: 4rem;\n  }\n  .pt10-t {\n    padding-top: 6rem;\n  }\n  .pt12-t {\n    padding-top: 8rem;\n  }\n  .pt13-t {\n    padding-top: 12rem;\n  }\n  .pt14-t {\n    padding-top: 16rem;\n  }\n}\n@media screen and (max-width: 520px) {\n  .pt0-m {\n    padding-top: 0;\n  }\n  .pt1-m {\n    padding-top: 0.125rem;\n  }\n  .pt2-m {\n    padding-top: 0.25rem;\n  }\n  .pt3-m {\n    padding-top: 0.375rem;\n  }\n  .pt4-m {\n    padding-top: 0.5rem;\n  }\n  .pt5-m {\n    padding-top: 0.75rem;\n  }\n  .pt6-m {\n    padding-top: 1rem;\n  }\n  .pt7-m {\n    padding-top: 1.5rem;\n  }\n  .pt8-m {\n    padding-top: 2rem;\n  }\n  .pt9-m {\n    padding-top: 3rem;\n  }\n  .pt11-m {\n    padding-top: 4rem;\n  }\n  .pt10-m {\n    padding-top: 6rem;\n  }\n  .pt12-m {\n    padding-top: 8rem;\n  }\n  .pt13-m {\n    padding-top: 12rem;\n  }\n  .pt14-m {\n    padding-top: 16rem;\n  }\n}\n.pv0 {\n  padding-top: 0;\n  padding-bottom: 0;\n}\n.pv1 {\n  padding-top: 0.125rem;\n  padding-bottom: 0.125rem;\n}\n.pv2 {\n  padding-top: 0.25rem;\n  padding-bottom: 0.25rem;\n}\n.pv3 {\n  padding-top: 0.375rem;\n  padding-bottom: 0.375rem;\n}\n.pv4 {\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n}\n.pv5 {\n  padding-top: 0.75rem;\n  padding-bottom: 0.75rem;\n}\n.pv6 {\n  padding-top: 1rem;\n  padding-bottom: 1rem;\n}\n.pv7 {\n  padding-top: 1.5rem;\n  padding-bottom: 1.5rem;\n}\n.pv8 {\n  padding-top: 2rem;\n  padding-bottom: 2rem;\n}\n.pv9 {\n  padding-top: 3rem;\n  padding-bottom: 3rem;\n}\n.pv10 {\n  padding-top: 4rem;\n  padding-bottom: 4rem;\n}\n.pv11 {\n  padding-top: 6rem;\n  padding-bottom: 6rem;\n}\n.pv12 {\n  padding-top: 8rem;\n  padding-bottom: 8rem;\n}\n.pv13 {\n  padding-top: 12rem;\n  padding-bottom: 12rem;\n}\n.pv14 {\n  padding-top: 16rem;\n  padding-bottom: 16rem;\n}\n@media screen and (max-width: 768px) {\n  .pv0-t {\n    padding-top: 0;\n    padding-bottom: 0;\n  }\n  .pv1-t {\n    padding-top: 0.125rem;\n    padding-bottom: 0.125rem;\n  }\n  .pv2-t {\n    padding-top: 0.25rem;\n    padding-bottom: 0.25rem;\n  }\n  .pv3-t {\n    padding-top: 0.375rem;\n    padding-bottom: 0.375rem;\n  }\n  .pv4-t {\n    padding-top: 0.5rem;\n    padding-bottom: 0.5rem;\n  }\n  .pv5-t {\n    padding-top: 0.75rem;\n    padding-bottom: 0.75rem;\n  }\n  .pv6-t {\n    padding-top: 1rem;\n    padding-bottom: 1rem;\n  }\n  .pv7-t {\n    padding-top: 1.5rem;\n    padding-bottom: 1.5rem;\n  }\n  .pv8-t {\n    padding-top: 2rem;\n    padding-bottom: 2rem;\n  }\n  .pv9-t {\n    padding-top: 3rem;\n    padding-bottom: 3rem;\n  }\n  .pv11-t {\n    padding-top: 4rem;\n    padding-bottom: 4rem;\n  }\n  .pv10-t {\n    padding-top: 6rem;\n    padding-bottom: 6rem;\n  }\n  .pv12-t {\n    padding-top: 8rem;\n    padding-bottom: 8rem;\n  }\n  .pv13-t {\n    padding-top: 12rem;\n    padding-bottom: 12rem;\n  }\n  .pv14-t {\n    padding-top: 16rem;\n    padding-bottom: 16rem;\n  }\n}\n@media screen and (max-width: 520px) {\n  .pv0-m {\n    padding-top: 0;\n    padding-bottom: 0;\n  }\n  .pv1-m {\n    padding-top: 0.125rem;\n    padding-bottom: 0.125rem;\n  }\n  .pv2-m {\n    padding-top: 0.25rem;\n    padding-bottom: 0.25rem;\n  }\n  .pv3-m {\n    padding-top: 0.375rem;\n    padding-bottom: 0.375rem;\n  }\n  .pv4-m {\n    padding-top: 0.5rem;\n    padding-bottom: 0.5rem;\n  }\n  .pv5-m {\n    padding-top: 0.75rem;\n    padding-bottom: 0.75rem;\n  }\n  .pv6-m {\n    padding-top: 1rem;\n    padding-bottom: 1rem;\n  }\n  .pv7-m {\n    padding-top: 1.5rem;\n    padding-bottom: 1.5rem;\n  }\n  .pv8-m {\n    padding-top: 2rem;\n    padding-bottom: 2rem;\n  }\n  .pv9-m {\n    padding-top: 3rem;\n    padding-bottom: 3rem;\n  }\n  .pv11-m {\n    padding-top: 4rem;\n    padding-bottom: 4rem;\n  }\n  .pv10-m {\n    padding-top: 6rem;\n    padding-bottom: 6rem;\n  }\n  .pv12-m {\n    padding-top: 8rem;\n    padding-bottom: 8rem;\n  }\n  .pv13-m {\n    padding-top: 12rem;\n    padding-bottom: 12rem;\n  }\n  .pv14-m {\n    padding-top: 16rem;\n    padding-bottom: 16rem;\n  }\n}\n.ph0 {\n  padding-left: 0;\n  padding-right: 0;\n}\n.ph1 {\n  padding-left: 0.125rem;\n  padding-right: 0.125rem;\n}\n.ph2 {\n  padding-left: 0.25rem;\n  padding-right: 0.25rem;\n}\n.ph3 {\n  padding-left: 0.375rem;\n  padding-right: 0.375rem;\n}\n.ph4 {\n  padding-left: 0.5rem;\n  padding-right: 0.5rem;\n}\n.ph5 {\n  padding-left: 0.75rem;\n  padding-right: 0.75rem;\n}\n.ph6 {\n  padding-left: 1rem;\n  padding-right: 1rem;\n}\n.ph7 {\n  padding-left: 1.5rem;\n  padding-right: 1.5rem;\n}\n.ph8 {\n  padding-left: 2rem;\n  padding-right: 2rem;\n}\n.ph9 {\n  padding-left: 3rem;\n  padding-right: 3rem;\n}\n.ph10 {\n  padding-left: 4rem;\n  padding-right: 4rem;\n}\n.ph11 {\n  padding-left: 6rem;\n  padding-right: 6rem;\n}\n.ph12 {\n  padding-left: 8rem;\n  padding-right: 8rem;\n}\n.ph13 {\n  padding-left: 12rem;\n  padding-right: 12rem;\n}\n.ph14 {\n  padding-left: 16rem;\n  padding-right: 16rem;\n}\n@media screen and (max-width: 768px) {\n  .ph0-t {\n    padding-left: 0;\n    padding-right: 0;\n  }\n  .ph1-t {\n    padding-left: 0.125rem;\n    padding-right: 0.125rem;\n  }\n  .ph2-t {\n    padding-left: 0.25rem;\n    padding-right: 0.25rem;\n  }\n  .ph3-t {\n    padding-left: 0.375rem;\n    padding-right: 0.375rem;\n  }\n  .ph4-t {\n    padding-left: 0.5rem;\n    padding-right: 0.5rem;\n  }\n  .ph5-t {\n    padding-left: 0.75rem;\n    padding-right: 0.75rem;\n  }\n  .ph6-t {\n    padding-left: 1rem;\n    padding-right: 1rem;\n  }\n  .ph7-t {\n    padding-left: 1.5rem;\n    padding-right: 1.5rem;\n  }\n  .ph8-t {\n    padding-left: 2rem;\n    padding-right: 2rem;\n  }\n  .ph9-t {\n    padding-left: 3rem;\n    padding-right: 3rem;\n  }\n  .ph11-t {\n    padding-left: 4rem;\n    padding-right: 4rem;\n  }\n  .ph10-t {\n    padding-left: 6rem;\n    padding-right: 6rem;\n  }\n  .ph12-t {\n    padding-left: 8rem;\n    padding-right: 8rem;\n  }\n  .ph13-t {\n    padding-left: 12rem;\n    padding-right: 12rem;\n  }\n  .ph14-t {\n    padding-left: 16rem;\n    padding-right: 16rem;\n  }\n}\n@media screen and (max-width: 520px) {\n  .ph0-m {\n    padding-left: 0;\n    padding-right: 0;\n  }\n  .ph1-m {\n    padding-left: 0.125rem;\n    padding-right: 0.125rem;\n  }\n  .ph2-m {\n    padding-left: 0.25rem;\n    padding-right: 0.25rem;\n  }\n  .ph3-m {\n    padding-left: 0.375rem;\n    padding-right: 0.375rem;\n  }\n  .ph4-m {\n    padding-left: 0.5rem;\n    padding-right: 0.5rem;\n  }\n  .ph5-m {\n    padding-left: 0.75rem;\n    padding-right: 0.75rem;\n  }\n  .ph6-m {\n    padding-left: 1rem;\n    padding-right: 1rem;\n  }\n  .ph7-m {\n    padding-left: 1.5rem;\n    padding-right: 1.5rem;\n  }\n  .ph8-m {\n    padding-left: 2rem;\n    padding-right: 2rem;\n  }\n  .ph9-m {\n    padding-left: 3rem;\n    padding-right: 3rem;\n  }\n  .ph11-m {\n    padding-left: 4rem;\n    padding-right: 4rem;\n  }\n  .ph10-m {\n    padding-left: 6rem;\n    padding-right: 6rem;\n  }\n  .ph12-m {\n    padding-left: 8rem;\n    padding-right: 8rem;\n  }\n  .ph13-m {\n    padding-left: 12rem;\n    padding-right: 12rem;\n  }\n  .ph14-m {\n    padding-left: 16rem;\n    padding-right: 16rem;\n  }\n}\n.ma0 {\n  margin: 0;\n}\n.ma1 {\n  margin: 0.125rem;\n}\n.ma2 {\n  margin: 0.25rem;\n}\n.ma3 {\n  margin: 0.375rem;\n}\n.ma4 {\n  margin: 0.5rem;\n}\n.ma5 {\n  margin: 0.75rem;\n}\n.ma6 {\n  margin: 1rem;\n}\n.ma7 {\n  margin: 1.5rem;\n}\n.ma8 {\n  margin: 2rem;\n}\n.ma9 {\n  margin: 3rem;\n}\n.ma10 {\n  margin: 4rem;\n}\n.ma11 {\n  margin: 6rem;\n}\n.ma12 {\n  margin: 8rem;\n}\n.ma13 {\n  margin: 12rem;\n}\n.ma14 {\n  margin: 16rem;\n}\n.maauto {\n  margin: auto;\n}\n@media screen and (max-width: 768px) {\n  .ma0-t {\n    margin: 0;\n  }\n  .ma1-t {\n    margin: 0.125rem;\n  }\n  .ma2-t {\n    margin: 0.25rem;\n  }\n  .ma3-t {\n    margin: 0.375rem;\n  }\n  .ma4-t {\n    margin: 0.5rem;\n  }\n  .ma5-t {\n    margin: 0.75rem;\n  }\n  .ma6-t {\n    margin: 1rem;\n  }\n  .ma7-t {\n    margin: 1.5rem;\n  }\n  .ma8-t {\n    margin: 2rem;\n  }\n  .ma9-t {\n    margin: 3rem;\n  }\n  .ma11-t {\n    margin: 4rem;\n  }\n  .ma10-t {\n    margin: 6rem;\n  }\n  .ma12-t {\n    margin: 8rem;\n  }\n  .ma13-t {\n    margin: 12rem;\n  }\n  .ma14-t {\n    margin: 16rem;\n  }\n  .maauto-t {\n    margin: auto;\n  }\n}\n@media screen and (max-width: 520px) {\n  .ma0-m {\n    margin: 0;\n  }\n  .ma1-m {\n    margin: 0.125rem;\n  }\n  .ma2-m {\n    margin: 0.25rem;\n  }\n  .ma3-m {\n    margin: 0.375rem;\n  }\n  .ma4-m {\n    margin: 0.5rem;\n  }\n  .ma5-m {\n    margin: 0.75rem;\n  }\n  .ma6-m {\n    margin: 1rem;\n  }\n  .ma7-m {\n    margin: 1.5rem;\n  }\n  .ma8-m {\n    margin: 2rem;\n  }\n  .ma9-m {\n    margin: 3rem;\n  }\n  .ma11-m {\n    margin: 4rem;\n  }\n  .ma10-m {\n    margin: 6rem;\n  }\n  .ma12-m {\n    margin: 8rem;\n  }\n  .ma13-m {\n    margin: 12rem;\n  }\n  .ma14-m {\n    margin: 16rem;\n  }\n  .maauto-m {\n    margin: auto;\n  }\n}\n.ml0 {\n  margin-left: 0;\n}\n.ml1 {\n  margin-left: 0.125rem;\n}\n.ml2 {\n  margin-left: 0.25rem;\n}\n.ml3 {\n  margin-left: 0.375rem;\n}\n.ml4 {\n  margin-left: 0.5rem;\n}\n.ml5 {\n  margin-left: 0.75rem;\n}\n.ml6 {\n  margin-left: 1rem;\n}\n.ml7 {\n  margin-left: 1.5rem;\n}\n.ml8 {\n  margin-left: 2rem;\n}\n.ml9 {\n  margin-left: 3rem;\n}\n.ml10 {\n  margin-left: 4rem;\n}\n.ml11 {\n  margin-left: 6rem;\n}\n.ml12 {\n  margin-left: 8rem;\n}\n.ml13 {\n  margin-left: 12rem;\n}\n.ml14 {\n  margin-left: 16rem;\n}\n.mlauto {\n  margin-left: auto;\n}\n.ml-22 {\n  margin-left: 22%;\n}\n@media screen and (max-width: 768px) {\n  .ml0-t {\n    margin-left: 0;\n  }\n  .ml1-t {\n    margin-left: 0.125rem;\n  }\n  .ml2-t {\n    margin-left: 0.25rem;\n  }\n  .ml3-t {\n    margin-left: 0.375rem;\n  }\n  .ml4-t {\n    margin-left: 0.5rem;\n  }\n  .ml5-t {\n    margin-left: 0.75rem;\n  }\n  .ml6-t {\n    margin-left: 1rem;\n  }\n  .ml7-t {\n    margin-left: 1.5rem;\n  }\n  .ml8-t {\n    margin-left: 2rem;\n  }\n  .ml9-t {\n    margin-left: 3rem;\n  }\n  .ml11-t {\n    margin-left: 4rem;\n  }\n  .ml10-t {\n    margin-left: 6rem;\n  }\n  .ml12-t {\n    margin-left: 8rem;\n  }\n  .ml13-t {\n    margin-left: 12rem;\n  }\n  .ml14-t {\n    margin-left: 16rem;\n  }\n  .mlauto-t {\n    margin-left: auto;\n  }\n}\n@media screen and (max-width: 520px) {\n  .ml0-m {\n    margin-left: 0;\n  }\n  .ml1-m {\n    margin-left: 0.125rem;\n  }\n  .ml2-m {\n    margin-left: 0.25rem;\n  }\n  .ml3-m {\n    margin-left: 0.375rem;\n  }\n  .ml4-m {\n    margin-left: 0.5rem;\n  }\n  .ml5-m {\n    margin-left: 0.75rem;\n  }\n  .ml6-m {\n    margin-left: 1rem;\n  }\n  .ml7-m {\n    margin-left: 1.5rem;\n  }\n  .ml8-m {\n    margin-left: 2rem;\n  }\n  .ml9-m {\n    margin-left: 3rem;\n  }\n  .ml11-m {\n    margin-left: 4rem;\n  }\n  .ml10-m {\n    margin-left: 6rem;\n  }\n  .ml12-m {\n    margin-left: 8rem;\n  }\n  .ml13-m {\n    margin-left: 12rem;\n  }\n  .ml14-m {\n    margin-left: 16rem;\n  }\n  .mlauto-m {\n    margin-left: auto;\n  }\n}\n.mr0 {\n  margin-right: 0;\n}\n.mr1 {\n  margin-right: 0.125rem;\n}\n.mr2 {\n  margin-right: 0.25rem;\n}\n.mr3 {\n  margin-right: 0.375rem;\n}\n.mr4 {\n  margin-right: 0.5rem;\n}\n.mr5 {\n  margin-right: 0.75rem;\n}\n.mr6 {\n  margin-right: 1rem;\n}\n.mr7 {\n  margin-right: 1.5rem;\n}\n.mr8 {\n  margin-right: 2rem;\n}\n.mr9 {\n  margin-right: 3rem;\n}\n.mr10 {\n  margin-right: 4rem;\n}\n.mr11 {\n  margin-right: 6rem;\n}\n.mr12 {\n  margin-right: 8rem;\n}\n.mr13 {\n  margin-right: 12rem;\n}\n.mr14 {\n  margin-right: 16rem;\n}\n.mrauto {\n  margin-right: auto;\n}\n@media screen and (min-width: 769px) {\n  .mr-0-d {\n    margin-right: 0;\n  }\n}\n@media screen and (max-width: 768px) {\n  .mr0-t {\n    margin-right: 0;\n  }\n  .mr1-t {\n    margin-right: 0.125rem;\n  }\n  .mr2-t {\n    margin-right: 0.25rem;\n  }\n  .mr3-t {\n    margin-right: 0.375rem;\n  }\n  .mr4-t {\n    margin-right: 0.5rem;\n  }\n  .mr5-t {\n    margin-right: 0.75rem;\n  }\n  .mr6-t {\n    margin-right: 1rem;\n  }\n  .mr7-t {\n    margin-right: 1.5rem;\n  }\n  .mr8-t {\n    margin-right: 2rem;\n  }\n  .mr9-t {\n    margin-right: 3rem;\n  }\n  .mr11-t {\n    margin-right: 4rem;\n  }\n  .mr10-t {\n    margin-right: 6rem;\n  }\n  .mr12-t {\n    margin-right: 8rem;\n  }\n  .mr13-t {\n    margin-right: 12rem;\n  }\n  .mr14-t {\n    margin-right: 16rem;\n  }\n  .mrauto-t {\n    margin-right: auto;\n  }\n}\n@media screen and (max-width: 520px) {\n  .mr0-m {\n    margin-right: 0;\n  }\n  .mr1-m {\n    margin-right: 0.125rem;\n  }\n  .mr2-m {\n    margin-right: 0.25rem;\n  }\n  .mr3-m {\n    margin-right: 0.375rem;\n  }\n  .mr4-m {\n    margin-right: 0.5rem;\n  }\n  .mr5-m {\n    margin-right: 0.75rem;\n  }\n  .mr6-m {\n    margin-right: 1rem;\n  }\n  .mr7-m {\n    margin-right: 1.5rem;\n  }\n  .mr8-m {\n    margin-right: 2rem;\n  }\n  .mr9-m {\n    margin-right: 3rem;\n  }\n  .mr11-m {\n    margin-right: 4rem;\n  }\n  .mr10-m {\n    margin-right: 6rem;\n  }\n  .mr12-m {\n    margin-right: 8rem;\n  }\n  .mr13-m {\n    margin-right: 12rem;\n  }\n  .mr14-m {\n    margin-right: 16rem;\n  }\n  .mrauto-m {\n    margin-right: auto;\n  }\n}\n.mb0 {\n  margin-bottom: 0;\n}\n.mb1 {\n  margin-bottom: 0.125rem;\n}\n.mb2 {\n  margin-bottom: 0.25rem;\n}\n.mb3 {\n  margin-bottom: 0.375rem;\n}\n.mb4 {\n  margin-bottom: 0.5rem;\n}\n.mb5 {\n  margin-bottom: 0.75rem;\n}\n.mb6 {\n  margin-bottom: 1rem;\n}\n.mb7 {\n  margin-bottom: 1.5rem;\n}\n.mb8 {\n  margin-bottom: 2rem;\n}\n.mb9 {\n  margin-bottom: 3rem;\n}\n.mb10 {\n  margin-bottom: 4rem;\n}\n.mb11 {\n  margin-bottom: 6rem;\n}\n.mb12 {\n  margin-bottom: 8rem;\n}\n.mb13 {\n  margin-bottom: 12rem;\n}\n.mb14 {\n  margin-bottom: 16rem;\n}\n.mbauto {\n  margin-bottom: auto;\n}\n.-mb2 {\n  margin-bottom: -0.25rem;\n}\n.-mb4 {\n  margin-bottom: -0.5rem;\n}\n.last-child-mb0:last-child {\n  margin-bottom: 0;\n}\n@media screen and (max-width: 768px) {\n  .mb0-t {\n    margin-bottom: 0;\n  }\n  .mb1-t {\n    margin-bottom: 0.125rem;\n  }\n  .mb2-t {\n    margin-bottom: 0.25rem;\n  }\n  .mb3-t {\n    margin-bottom: 0.375rem;\n  }\n  .mb4-t {\n    margin-bottom: 0.5rem;\n  }\n  .mb5-t {\n    margin-bottom: 0.75rem;\n  }\n  .mb6-t {\n    margin-bottom: 1rem;\n  }\n  .mb7-t {\n    margin-bottom: 1.5rem;\n  }\n  .mb8-t {\n    margin-bottom: 2rem;\n  }\n  .mb9-t {\n    margin-bottom: 3rem;\n  }\n  .mb11-t {\n    margin-bottom: 4rem;\n  }\n  .mb10-t {\n    margin-bottom: 6rem;\n  }\n  .mb12-t {\n    margin-bottom: 8rem;\n  }\n  .mb13-t {\n    margin-bottom: 12rem;\n  }\n  .mb14-t {\n    margin-bottom: 16rem;\n  }\n  .mbauto-t {\n    margin-bottom: auto;\n  }\n}\n@media screen and (max-width: 520px) {\n  .mb0-m {\n    margin-bottom: 0;\n  }\n  .mb1-m {\n    margin-bottom: 0.125rem;\n  }\n  .mb2-m {\n    margin-bottom: 0.25rem;\n  }\n  .mb3-m {\n    margin-bottom: 0.375rem;\n  }\n  .mb4-m {\n    margin-bottom: 0.5rem;\n  }\n  .mb5-m {\n    margin-bottom: 0.75rem;\n  }\n  .mb6-m {\n    margin-bottom: 1rem;\n  }\n  .mb7-m {\n    margin-bottom: 1.5rem;\n  }\n  .mb8-m {\n    margin-bottom: 2rem;\n  }\n  .mb9-m {\n    margin-bottom: 3rem;\n  }\n  .mb11-m {\n    margin-bottom: 4rem;\n  }\n  .mb10-m {\n    margin-bottom: 6rem;\n  }\n  .mb12-m {\n    margin-bottom: 8rem;\n  }\n  .mb13-m {\n    margin-bottom: 12rem;\n  }\n  .mb14-m {\n    margin-bottom: 16rem;\n  }\n  .mbauto-m {\n    margin-bottom: auto;\n  }\n}\n.mt0 {\n  margin-top: 0;\n}\n.mt1 {\n  margin-top: 0.125rem;\n}\n.mt2 {\n  margin-top: 0.25rem;\n}\n.mt3 {\n  margin-top: 0.375rem;\n}\n.mt4 {\n  margin-top: 0.5rem;\n}\n.mt5 {\n  margin-top: 0.75rem;\n}\n.mt6 {\n  margin-top: 1rem;\n}\n.mt7 {\n  margin-top: 1.5rem;\n}\n.mt8 {\n  margin-top: 2rem;\n}\n.mt9 {\n  margin-top: 3rem;\n}\n.mt10 {\n  margin-top: 4rem;\n}\n.mt11 {\n  margin-top: 6rem;\n}\n.mt12 {\n  margin-top: 8rem;\n}\n.mt13 {\n  margin-top: 12rem;\n}\n.mt14 {\n  margin-top: 16rem;\n}\n.-mt1 {\n  margin-top: -0.125rem;\n}\n.-mt2 {\n  margin-top: -0.25rem;\n}\n.-mt3 {\n  margin-top: -0.375rem;\n}\n.-mt4 {\n  margin-top: -0.5rem;\n}\n.-mt5 {\n  margin-top: -0.75rem;\n}\n.-mt6 {\n  margin-top: -1rem;\n}\n.-mt7 {\n  margin-top: -1.5rem;\n}\n.-mt8 {\n  margin-top: -2rem;\n}\n.-mt9 {\n  margin-top: -3rem;\n}\n@media screen and (min-width: 1200px) {\n  .mt0-l {\n    margin-top: 0;\n  }\n}\n@media screen and (max-width: 768px) {\n  .mt0-t {\n    margin-top: 0;\n  }\n  .mt1-t {\n    margin-top: 0.125rem;\n  }\n  .mt2-t {\n    margin-top: 0.25rem;\n  }\n  .mt3-t {\n    margin-top: 0.375rem;\n  }\n  .mt4-t {\n    margin-top: 0.5rem;\n  }\n  .mt5-t {\n    margin-top: 0.75rem;\n  }\n  .mt6-t {\n    margin-top: 1rem;\n  }\n  .mt7-t {\n    margin-top: 1.5rem;\n  }\n  .mt8-t {\n    margin-top: 2rem;\n  }\n  .mt9-t {\n    margin-top: 3rem;\n  }\n  .mt11-t {\n    margin-top: 4rem;\n  }\n  .mt10-t {\n    margin-top: 6rem;\n  }\n  .mt12-t {\n    margin-top: 8rem;\n  }\n  .mt13-t {\n    margin-top: 12rem;\n  }\n  .mt14-t {\n    margin-top: 16rem;\n  }\n}\n@media screen and (max-width: 520px) {\n  .mt0-m {\n    margin-top: 0;\n  }\n  .mt1-m {\n    margin-top: 0.125rem;\n  }\n  .mt2-m {\n    margin-top: 0.25rem;\n  }\n  .mt3-m {\n    margin-top: 0.375rem;\n  }\n  .mt4-m {\n    margin-top: 0.5rem;\n  }\n  .mt5-m {\n    margin-top: 0.75rem;\n  }\n  .mt6-m {\n    margin-top: 1rem;\n  }\n  .mt7-m {\n    margin-top: 1.5rem;\n  }\n  .mt8-m {\n    margin-top: 2rem;\n  }\n  .mt9-m {\n    margin-top: 3rem;\n  }\n  .mt11-m {\n    margin-top: 4rem;\n  }\n  .mt10-m {\n    margin-top: 6rem;\n  }\n  .mt12-m {\n    margin-top: 8rem;\n  }\n  .mt13-m {\n    margin-top: 12rem;\n  }\n  .mt14-m {\n    margin-top: 16rem;\n  }\n}\n.mv0 {\n  margin-top: 0;\n  margin-bottom: 0;\n}\n.mv1 {\n  margin-top: 0.125rem;\n  margin-bottom: 0.125rem;\n}\n.mv2 {\n  margin-top: 0.25rem;\n  margin-bottom: 0.25rem;\n}\n.mv3 {\n  margin-top: 0.375rem;\n  margin-bottom: 0.375rem;\n}\n.mv4 {\n  margin-top: 0.5rem;\n  margin-bottom: 0.5rem;\n}\n.mv5 {\n  margin-top: 0.75rem;\n  margin-bottom: 0.75rem;\n}\n.mv6 {\n  margin-top: 1rem;\n  margin-bottom: 1rem;\n}\n.mv7 {\n  margin-top: 1.5rem;\n  margin-bottom: 1.5rem;\n}\n.mv8 {\n  margin-top: 2rem;\n  margin-bottom: 2rem;\n}\n.mv9 {\n  margin-top: 3rem;\n  margin-bottom: 3rem;\n}\n.mv10 {\n  margin-top: 4rem;\n  margin-bottom: 4rem;\n}\n.mv11 {\n  margin-top: 6rem;\n  margin-bottom: 6rem;\n}\n.mv12 {\n  margin-top: 8rem;\n  margin-bottom: 8rem;\n}\n.mv13 {\n  margin-top: 12rem;\n  margin-bottom: 12rem;\n}\n.mv14 {\n  margin-top: 16rem;\n  margin-bottom: 16rem;\n}\n@media screen and (max-width: 768px) {\n  .mv0-t {\n    margin-top: 0;\n    margin-bottom: 0;\n  }\n  .mv1-t {\n    margin-top: 0.125rem;\n    margin-bottom: 0.125rem;\n  }\n  .mv2-t {\n    margin-top: 0.25rem;\n    margin-bottom: 0.25rem;\n  }\n  .mv3-t {\n    margin-top: 0.375rem;\n    margin-bottom: 0.375rem;\n  }\n  .mv4-t {\n    margin-top: 0.5rem;\n    margin-bottom: 0.5rem;\n  }\n  .mv5-t {\n    margin-top: 0.75rem;\n    margin-bottom: 0.75rem;\n  }\n  .mv6-t {\n    margin-top: 1rem;\n    margin-bottom: 1rem;\n  }\n  .mv7-t {\n    margin-top: 1.5rem;\n    margin-bottom: 1.5rem;\n  }\n  .mv8-t {\n    margin-top: 2rem;\n    margin-bottom: 2rem;\n  }\n  .mv9-t {\n    margin-top: 3rem;\n    margin-bottom: 3rem;\n  }\n  .mv11-t {\n    margin-top: 4rem;\n    margin-bottom: 4rem;\n  }\n  .mv10-t {\n    margin-top: 6rem;\n    margin-bottom: 6rem;\n  }\n  .mv12-t {\n    margin-top: 8rem;\n    margin-bottom: 8rem;\n  }\n  .mv13-t {\n    margin-top: 12rem;\n    margin-bottom: 12rem;\n  }\n  .mv14-t {\n    margin-top: 16rem;\n    margin-bottom: 16rem;\n  }\n}\n@media screen and (max-width: 520px) {\n  .mv0-m {\n    margin-top: 0;\n    margin-bottom: 0;\n  }\n  .mv1-m {\n    margin-top: 0.125rem;\n    margin-bottom: 0.125rem;\n  }\n  .mv2-m {\n    margin-top: 0.25rem;\n    margin-bottom: 0.25rem;\n  }\n  .mv3-m {\n    margin-top: 0.375rem;\n    margin-bottom: 0.375rem;\n  }\n  .mv4-m {\n    margin-top: 0.5rem;\n    margin-bottom: 0.5rem;\n  }\n  .mv5-m {\n    margin-top: 0.75rem;\n    margin-bottom: 0.75rem;\n  }\n  .mv6-m {\n    margin-top: 1rem;\n    margin-bottom: 1rem;\n  }\n  .mv7-m {\n    margin-top: 1.5rem;\n    margin-bottom: 1.5rem;\n  }\n  .mv8-m {\n    margin-top: 2rem;\n    margin-bottom: 2rem;\n  }\n  .mv9-m {\n    margin-top: 3rem;\n    margin-bottom: 3rem;\n  }\n  .mv11-m {\n    margin-top: 4rem;\n    margin-bottom: 4rem;\n  }\n  .mv10-m {\n    margin-top: 6rem;\n    margin-bottom: 6rem;\n  }\n  .mv12-m {\n    margin-top: 8rem;\n    margin-bottom: 8rem;\n  }\n  .mv13-m {\n    margin-top: 12rem;\n    margin-bottom: 12rem;\n  }\n  .mv14-m {\n    margin-top: 16rem;\n    margin-bottom: 16rem;\n  }\n}\n.mh0 {\n  margin-left: 0;\n  margin-right: 0;\n}\n.mh1 {\n  margin-left: 0.125rem;\n  margin-right: 0.125rem;\n}\n.mh2 {\n  margin-left: 0.25rem;\n  margin-right: 0.25rem;\n}\n.mh3 {\n  margin-left: 0.375rem;\n  margin-right: 0.375rem;\n}\n.mh4 {\n  margin-left: 0.5rem;\n  margin-right: 0.5rem;\n}\n.mh5 {\n  margin-left: 0.75rem;\n  margin-right: 0.75rem;\n}\n.mh6 {\n  margin-left: 1rem;\n  margin-right: 1rem;\n}\n.mh7 {\n  margin-left: 1.5rem;\n  margin-right: 1.5rem;\n}\n.mh8 {\n  margin-left: 2rem;\n  margin-right: 2rem;\n}\n.mh9 {\n  margin-left: 3rem;\n  margin-right: 3rem;\n}\n.mh10 {\n  margin-left: 4rem;\n  margin-right: 4rem;\n}\n.mh11 {\n  margin-left: 6rem;\n  margin-right: 6rem;\n}\n.mh12 {\n  margin-left: 8rem;\n  margin-right: 8rem;\n}\n.mh13 {\n  margin-left: 12rem;\n  margin-right: 12rem;\n}\n.mh14 {\n  margin-left: 16rem;\n  margin-right: 16rem;\n}\n.mhauto {\n  margin-left: auto;\n  margin-right: auto;\n}\n@media screen and (max-width: 768px) {\n  .mh0-t {\n    margin-left: 0;\n    margin-right: 0;\n  }\n  .mh1-t {\n    margin-left: 0.125rem;\n    margin-right: 0.125rem;\n  }\n  .mh2-t {\n    margin-left: 0.25rem;\n    margin-right: 0.25rem;\n  }\n  .mh3-t {\n    margin-left: 0.375rem;\n    margin-right: 0.375rem;\n  }\n  .mh4-t {\n    margin-left: 0.5rem;\n    margin-right: 0.5rem;\n  }\n  .mh5-t {\n    margin-left: 0.75rem;\n    margin-right: 0.75rem;\n  }\n  .mh6-t {\n    margin-left: 1rem;\n    margin-right: 1rem;\n  }\n  .mh7-t {\n    margin-left: 1.5rem;\n    margin-right: 1.5rem;\n  }\n  .mh8-t {\n    margin-left: 2rem;\n    margin-right: 2rem;\n  }\n  .mh9-t {\n    margin-left: 3rem;\n    margin-right: 3rem;\n  }\n  .mh11-t {\n    margin-left: 4rem;\n    margin-right: 4rem;\n  }\n  .mh10-t {\n    margin-left: 6rem;\n    margin-right: 6rem;\n  }\n  .mh12-t {\n    margin-left: 8rem;\n    margin-right: 8rem;\n  }\n  .mh13-t {\n    margin-left: 12rem;\n    margin-right: 12rem;\n  }\n  .mh14-t {\n    margin-left: 16rem;\n    margin-right: 16rem;\n  }\n  .mhauto-t {\n    margin-left: auto;\n    margin-right: auto;\n  }\n}\n@media screen and (max-width: 520px) {\n  .mh0-m {\n    margin-left: 0;\n    margin-right: 0;\n  }\n  .mh1-m {\n    margin-left: 0.125rem;\n    margin-right: 0.125rem;\n  }\n  .mh2-m {\n    margin-left: 0.25rem;\n    margin-right: 0.25rem;\n  }\n  .mh3-m {\n    margin-left: 0.375rem;\n    margin-right: 0.375rem;\n  }\n  .mh4-m {\n    margin-left: 0.5rem;\n    margin-right: 0.5rem;\n  }\n  .mh5-m {\n    margin-left: 0.75rem;\n    margin-right: 0.75rem;\n  }\n  .mh6-m {\n    margin-left: 1rem;\n    margin-right: 1rem;\n  }\n  .mh7-m {\n    margin-left: 1.5rem;\n    margin-right: 1.5rem;\n  }\n  .mh8-m {\n    margin-left: 2rem;\n    margin-right: 2rem;\n  }\n  .mh9-m {\n    margin-left: 3rem;\n    margin-right: 3rem;\n  }\n  .mh10-m {\n    margin-left: 4rem;\n    margin-right: 4rem;\n  }\n  .mh11-m {\n    margin-left: 6rem;\n    margin-right: 6rem;\n  }\n  .mh12-m {\n    margin-left: 8rem;\n    margin-right: 8rem;\n  }\n  .mh13-m {\n    margin-left: 12rem;\n    margin-right: 12rem;\n  }\n  .mh14-m {\n    margin-left: 16rem;\n    margin-right: 16rem;\n  }\n  .mhauto-m {\n    margin-left: auto;\n    margin-right: auto;\n  }\n}\n/*\n\n  Theming\n  -------\n\n  Utility classes for theming.\n\n*/\n.bicubic {\n  -ms-interpolation-mode: bicubic;\n  image-rendering: optimizeQuality;\n}\n.fit-image {\n  object-fit: cover;\n}\n.position-image-50-30 {\n  object-position: 50% 30%;\n}\n.fit-bg-image {\n  width: 100%;\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: 50% 50%;\n}\n.hidden {\n  visibility: hidden;\n}\n.no-pointer-events {\n  pointer-events: none;\n}\n.list-reset {\n  list-style: none;\n}\n.list-item-reset {\n  list-style-type: none;\n}\n.list-item-initial {\n  list-style-type: initial;\n}\n.transition-all {\n  -webkit-transition: all 0.2s ease;\n  -moz-transition: all 0.2s ease;\n  -o-transition: all 0.2s ease;\n  transition: all 0.2s ease;\n}\n.transition-all-slow {\n  -webkit-transition: all 0.4s ease;\n  -moz-transition: all 0.4s ease;\n  -o-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.default-cursor {\n  cursor: default;\n}\n.pointer {\n  cursor: pointer;\n}\n.text {\n  cursor: text;\n}\n.disabled-default-cursor:disabled {\n  cursor: default;\n}\n.not-allowed {\n  cursor: not-allowed;\n}\n.wait {\n  cursor: wait;\n}\n.w-resize {\n  cursor: w-resize;\n}\n.outline-0 {\n  outline: 0;\n  outline: none;\n}\n.focus-outline-0:focus {\n  outline: 0;\n  outline: none;\n}\n.focus-outline-0:focus select:-moz-focusring {\n  color: transparent;\n  text-shadow: 0 0 0 #000;\n}\n.disable-text-area-resize {\n  resize: none;\n}\n.filter-o-40 {\n  filter: opacity(40%);\n}\n.filter-blur {\n  filter: blur(2px);\n}\n.hover-filter-o-40:hover {\n  filter: opacity(40%);\n}\n.o-100 {\n  -webkit-opacity: 1;\n  -moz-opacity: 1;\n  opacity: 1;\n}\n.o-90 {\n  -webkit-opacity: 0.9;\n  -moz-opacity: 0.9;\n  opacity: 0.9;\n}\n.o-80 {\n  -webkit-opacity: 0.8;\n  -moz-opacity: 0.8;\n  opacity: 0.8;\n}\n.o-70 {\n  -webkit-opacity: 0.7;\n  -moz-opacity: 0.7;\n  opacity: 0.7;\n}\n.o-60 {\n  -webkit-opacity: 0.6;\n  -moz-opacity: 0.6;\n  opacity: 0.6;\n}\n.o-50 {\n  -webkit-opacity: 0.5;\n  -moz-opacity: 0.5;\n  opacity: 0.5;\n}\n.o-40 {\n  -webkit-opacity: 0.4;\n  -moz-opacity: 0.4;\n  opacity: 0.4;\n}\n.o-30 {\n  -webkit-opacity: 0.3;\n  -moz-opacity: 0.3;\n  opacity: 0.3;\n}\n.o-20 {\n  -webkit-opacity: 0.2;\n  -moz-opacity: 0.2;\n  opacity: 0.2;\n}\n.o-10 {\n  -webkit-opacity: 0.1;\n  -moz-opacity: 0.1;\n  opacity: 0.1;\n}\n.o-05 {\n  -webkit-opacity: 0.05;\n  -moz-opacity: 0.05;\n  opacity: 0.05;\n}\n.o-025 {\n  -webkit-opacity: 0.025;\n  -moz-opacity: 0.025;\n  opacity: 0.025;\n}\n.o-0 {\n  -webkit-opacity: 0;\n  -moz-opacity: 0;\n  opacity: 0;\n}\n.hover-o-90:hover {\n  -webkit-opacity: 0.9;\n  -moz-opacity: 0.9;\n  opacity: 0.9;\n}\n.hover-o-80:hover {\n  -webkit-opacity: 0.8;\n  -moz-opacity: 0.8;\n  opacity: 0.8;\n}\n.hover-o-100:hover {\n  -webkit-opacity: 1;\n  -moz-opacity: 1;\n  opacity: 1;\n}\n.black {\n  color: #111111;\n}\n.bluish-grey {\n  color: #738897;\n}\n.cadet-blue {\n  color: #6288A5;\n}\n.charcoal {\n  color: #404040;\n}\n.chocolate {\n  color: #C85C17;\n}\n.crimson {\n  color: #CC0033;\n}\n.dark-cyan {\n  color: #00719F;\n}\n.dark-slate-blue {\n  color: #3A447A;\n}\n.dark-orchid {\n  color: #84619C;\n}\n.dim-grey {\n  color: #565656;\n}\n.gains-boro {\n  color: #d8d8d8;\n}\n.grey {\n  color: #73797A;\n}\n.ghost-grey {\n  color: #F7F9FA;\n}\n.indian-red {\n  color: #D95741;\n}\n.light-coral {\n  color: #F1617D;\n}\n.lite-grey {\n  color: #979797;\n}\n.dark-coral {\n  color: #DB3668;\n}\n.dark-sea-green {\n  color: #5CBE75;\n}\n.dark-sea-green-2 {\n  color: #128a93;\n}\n.dark-sea-green-3 {\n  color: #008C9F;\n}\n.light-sea-green-1 {\n  color: #3FC599;\n}\n.light-sea-green-2 {\n  color: #0bb9b5;\n}\n.light-turquoise {\n  color: #81cbd3;\n}\n.medium-turquoise {\n  color: #35b8d3;\n}\n.medium-aquamarine {\n  color: #6ac498;\n}\n.navy {\n  color: #011279;\n}\n.pale-green {\n  color: #a0f6aa;\n}\n.pale-violet-red {\n  color: #e25c8f;\n}\n.phantom-grey {\n  color: #e8e8e8;\n}\n.precedents-blue {\n  color: #004b7a;\n}\n.phantom-grey {\n  color: #e8e8e8;\n}\n.royal-blue {\n  color: #1460D1;\n}\n.sienna {\n  color: #825F48;\n}\n.teal {\n  color: #004b7a;\n}\n.tomato {\n  color: #F87531;\n}\n.tangerine-dream {\n  color: #FFCA28;\n}\n.white {\n  color: #FFFFFF;\n}\n.placeholder-cadet-blue::placeholder {\n  color: #6288A5;\n}\n.hover-black:hover {\n  color: #111111;\n}\n.hover-cadet-blue:hover {\n  color: #6288A5;\n}\n.hover-dark-sea-green-2:hover {\n  color: #128a93;\n}\n.hover-dark-slate-blue:hover {\n  color: #3A447A;\n}\n.hover-dark-sea-green-2:hover {\n  color: #128a93;\n}\n.hover-dark-sea-green-3:hover {\n  color: #008C9F;\n}\n.hover-gains-boro:hover {\n  color: #d8d8d8;\n}\n.hover-white:hover {\n  color: #FFFFFF;\n}\n.focus-light-sea-green-2:focus {\n  color: #0bb9b5;\n}\n.focus-white:focus {\n  color: #FFFFFF;\n}\n.focus-grey:focus {\n  color: #73797A;\n}\n.color-inherit {\n  color: inherit;\n}\n.link-children-color-inherit a {\n  color: inherit;\n}\n.bg-black {\n  background-color: #111111;\n}\n.bg-cadet-blue {\n  background-color: #6288A5;\n}\n.bg-chocolate {\n  background-color: #C85C17;\n}\n.bg-dark-bluish-grey {\n  background-color: #5d6d7b;\n}\n.bg-dark-coral {\n  background-color: #DB3668;\n}\n.bg-dark-cyan {\n  background-color: #00719F;\n}\n.bg-dark-sea-green {\n  background-color: #5CBE75;\n}\n.bg-dark-sea-green-2 {\n  background-color: #128a93;\n}\n.bg-dark-sea-green-3 {\n  background-color: #008C9F;\n}\n.bg-dark-slate-blue {\n  background-color: #3A447A;\n}\n.bg-dark-orchid {\n  background-color: #84619C;\n}\n.bg-dim-grey {\n  background-color: #565656;\n}\n.bg-faf-grey {\n  background-color: #FAFAFF;\n}\n.bg-gains-boro {\n  background-color: #d8d8d8;\n}\n.bg-grey {\n  background-color: #73797A;\n}\n.bg-ghost-grey {\n  background-color: #F7F9FA;\n}\n.bg-indian-red {\n  background-color: #D95741;\n}\n.bg-ice-blue {\n  background-color: #D5ECFF;\n}\n.bg-light-coral {\n  background-color: #F1617D;\n}\n.bg-light-yellow {\n  background-color: #FCF8E3;\n}\n.bg-light-sea-green-1 {\n  background-color: #3FC599;\n}\n.bg-light-sea-green-2 {\n  background-color: #0bb9b5;\n}\n.bg-light-turquoise {\n  background-color: #81cbd3;\n}\n.bg-medium-aquamarine {\n  background-color: #6ac498;\n}\n.bg-medium-purple {\n  background-color: #9c7fb0;\n}\n.bg-medium-turquoise {\n  background-color: #35b8d3;\n}\n.bg-navy {\n  background-color: #011279;\n}\n.bg-precedents-blue {\n  background-color: #004b7a;\n}\n.bg-pale-green {\n  background-color: #a0f6aa;\n}\n.bg-pale-violet-red {\n  background-color: #e25c8f;\n}\n.bg-pearl-lusta {\n  background-color: #fbf2d1;\n}\n.bg-phantom-grey {\n  background-color: #e8e8e8;\n}\n.bg-royal-blue {\n  background-color: #1460D1;\n}\n.bg-sienna {\n  background-color: #825F48;\n}\n.bg-teal {\n  background-color: #004b7a;\n}\n.bg-tomato {\n  background-color: #F87531;\n}\n.bg-white {\n  background-color: #FFFFFF;\n}\n.bg-tangerine-dream {\n  background-color: #FFCA28;\n}\n.bg-transparent {\n  background-color: transparent;\n}\n.bg-twilight-grey {\n  background-color: #EDEDED;\n}\n.bg-void-grey {\n  background-color: #EBF0F4;\n}\n.bg-inherit {\n  background-color: inherit;\n}\n.bg-transparent {\n  background: transparent;\n}\n.hover-bg-transparent:hover {\n  background-color: transparent;\n  background: transparent;\n}\n.hover-bg-cadet-blue:hover {\n  background-color: #6288A5;\n}\n.hover-bg-dark-slate-blue:hover {\n  background-color: #3A447A;\n}\n.hover-bg-dark-sea-green:hover {\n  background-color: #5CBE75;\n}\n.hover-bg-dark-sea-green-2:hover {\n  background-color: #128a93;\n}\n.hover-bg-dark-sea-green-3:hover {\n  background-color: #008C9F;\n}\n.hover-bg-dim-grey:hover {\n  background-color: #565656;\n}\n.hover-bg-gains-boro:hover {\n  background-color: #d8d8d8;\n}\n.hover-bg-ghost-grey:hover {\n  background-color: #F7F9FA;\n}\n.hover-bg-grey:hover {\n  background-color: #73797A;\n}\n.hover-bg-light-turquoise:hover {\n  background-color: #81cbd3;\n}\n.hover-bg-teal:hover {\n  background-color: #004b7a;\n}\n.hover-bg-phantom-grey:hover {\n  background-color: #e8e8e8;\n}\n.hover-bg-twilight-grey:hover {\n  background-color: #EDEDED;\n}\n.hover-bg-white:hover {\n  background-color: #FFFFFF;\n}\n.bg-contain {\n  background-size: contain;\n}\n.bg-center {\n  background-position: center;\n}\n.bg-x-center {\n  background-position-x: center;\n}\n.bg-y-center {\n  background-position-y: center;\n}\n.border-collapse {\n  border-collapse: collapse;\n}\n.bg-no-repeat {\n  background-repeat: no-repeat;\n}\n.ba {\n  border-style: solid;\n  border-width: 1px;\n}\n.ba2 {\n  border-style: solid;\n  border-width: 2px;\n}\n.bn {\n  border-style: none;\n  border-width: 0;\n}\n.bb {\n  border-bottom-style: solid;\n  border-bottom-width: 1px;\n}\n.bl {\n  border-left-style: solid;\n  border-left-width: 1px;\n}\n.bt {\n  border-top-style: solid;\n  border-top-width: 1px;\n}\n.br {\n  border-right-style: solid;\n  border-right-width: 1px;\n}\n.bb-thin {\n  border-bottom-style: solid;\n  border-bottom-width: 1px;\n}\n.bb-medium {\n  border-bottom-style: solid;\n  border-bottom-width: 2px;\n}\n.bb-thick {\n  border-bottom-style: solid;\n  border-bottom-width: 4px;\n}\n.bt-medium {\n  border-top-style: solid;\n  border-top-width: 2px;\n}\n.bt-thick {\n  border-top-style: solid;\n  border-top-width: 4px;\n}\n.bt-xl {\n  border-top-style: solid;\n  border-top-width: 8px;\n}\n@media screen and (max-width: 520px) {\n  .bn-m {\n    border-style: none;\n    border-width: 0;\n  }\n  .ba-m {\n    border-style: solid;\n    border-width: 1px;\n  }\n}\n.hover-bb-thick:hover {\n  border-bottom-style: solid;\n  border-bottom-width: 4px;\n}\n.hover-bb-medium:hover {\n  border-bottom-style: solid;\n  border-bottom-width: 2px;\n}\n.hover-bt-thick:hover {\n  border-top-style: solid;\n  border-top-width: 4px;\n}\n.last-child-bn:last-child {\n  border-style: none;\n  border-width: 0;\n}\n.last-of-type-bn:last-of-type {\n  border-style: none;\n  border-width: 0;\n}\n@media screen and (max-width: 768px) {\n  .bb-t {\n    border-bottom-style: solid;\n    border-bottom-width: 1px;\n  }\n  .bn-t {\n    border-style: none;\n    border-width: 0;\n  }\n  .bt-t {\n    border-top-style: solid;\n    border-top-width: 1px;\n  }\n}\n.b--dashed {\n  border-style: dashed;\n}\n.b--dotted {\n  border-style: dotted;\n}\n.b--none {\n  border-style: none;\n}\n.b--solid {\n  border-style: solid;\n}\n.bt--dashed {\n  border-top-style: dashed;\n}\n.bt--dotted {\n  border-top-style: dotted;\n}\n.bt--none {\n  border-top-style: none;\n}\n.bt--solid {\n  border-top-style: solid;\n}\n.br--dashed {\n  border-right-style: dashed;\n}\n.br--dotted {\n  border-right-style: dotted;\n}\n.br--none {\n  border-right-style: none;\n}\n.br--solid {\n  border-right-style: solid;\n}\n.bb--dashed {\n  border-bottom-style: dashed;\n}\n.bb--dotted {\n  border-bottom-style: dotted;\n}\n.bb--none {\n  border-bottom-style: none;\n}\n.bb--solid {\n  border-bottom-style: solid;\n}\n.bl--dashed {\n  border-left-style: dashed;\n}\n.bl--dotted {\n  border-left-style: dotted;\n}\n.bl--none {\n  border-left-style: none;\n}\n.bl--solid {\n  border-left-style: solid;\n}\n.hover-ba:hover {\n  border-style: solid;\n  border-width: 1px;\n}\n.hover-ba2:hover {\n  border-style: solid;\n  border-width: 2px;\n}\n.b--black {\n  border-color: #111111;\n}\n.b--cadet-blue {\n  border-color: #6288A5;\n}\n.b--chocolate {\n  border-color: #C85C17;\n}\n.b--dark-cyan {\n  border-color: #00719F;\n}\n.b--dark-slate-blue {\n  border-color: #3A447A;\n}\n.b--dark-orchid {\n  border-color: #84619C;\n}\n.b--dark-sea-green-2 {\n  border-color: #128a93;\n}\n.b--dark-sea-green-3 {\n  border-color: #008C9F;\n}\n.b--dim-grey {\n  border-color: #565656;\n}\n.b--gains-boro {\n  border-color: #d8d8d8;\n}\n.b--grey {\n  border-color: #73797A;\n}\n.b--ghost-grey {\n  border-color: #F7F9FA;\n}\n.b--indian-red {\n  border-color: #D95741;\n}\n.b--light-coral {\n  border-color: #F1617D;\n}\n.b--light-grey {\n  border-color: #979797;\n}\n.b--light-sea-green-1 {\n  border-color: #3FC599;\n}\n.b--light-sea-green-2 {\n  border-color: #0bb9b5;\n}\n.b--lite-grey {\n  border-color: #979797;\n}\n.b--medium-aquamarine {\n  border-color: #6ac498;\n}\n.b--medium-purple {\n  border-color: #9c7fb0;\n}\n.b--medium-turquoise {\n  border-color: #35b8d3;\n}\n.b--navy {\n  border-color: #011279;\n}\n.b--pale-green {\n  border-color: #a0f6aa;\n}\n.b--pale-violet-red {\n  border-color: #e25c8f;\n}\n.b--precedents-blue {\n  border-color: #004b7a;\n}\n.b--royal-blue {\n  border-color: #1460D1;\n}\n.b--sienna {\n  border-color: #825F48;\n}\n.b--tomato {\n  border-color: #F87531;\n}\n.b--phantom-grey {\n  border-color: #e8e8e8;\n}\n.b--white {\n  border-color: #FFFFFF;\n}\n.b--transparent {\n  border-color: transparent;\n}\n.b--inherit {\n  border-color: inherit;\n}\n.bt--transparent {\n  border-top-color: transparent;\n}\n.bt--dark-orchid {\n  border-top-color: #84619C;\n}\n.bt--dark-cyan {\n  border-top-color: #00719F;\n}\n.bt--light-grey {\n  border-top-color: #979797;\n}\n.bt--phantom-grey {\n  border-top-color: #e8e8e8;\n}\n.bt--light-sea-green-2 {\n  border-top-color: #0bb9b5;\n}\n.bt--dark-sea-green-3 {\n  border-top-color: #008C9F;\n}\n.bt--medium-aquamarine {\n  border-top-color: #6ac498;\n}\n.bt--medium-purple {\n  border-top-color: #9c7fb0;\n}\n.bb--chocolate {\n  border-bottom-color: #C85C17;\n}\n.hover-b--black:hover {\n  border-color: #111111;\n}\n.hover-b--inherit:hover {\n  border-color: inherit;\n}\n.hover-b--dark-sea-green-2:hover {\n  border-color: #128a93;\n}\n.focus-b--light-sea-green-2:focus {\n  border-color: #0bb9b5;\n}\n.focus-b--cadet-blue:focus {\n  border-color: #6288A5;\n}\n.br0 {\n  border-radius: 0;\n}\n.br1 {\n  border-radius: 0.125rem;\n}\n.br2 {\n  border-radius: 0.25rem;\n}\n.br3 {\n  border-radius: 0.5rem;\n}\n.br4 {\n  border-radius: 1rem;\n}\n.br-50 {\n  border-radius: 50%;\n}\n.br-100 {\n  border-radius: 100%;\n}\n.br-pill {\n  border-radius: 9999px;\n}\n.br--bottom {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n.br--left {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.br--right {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.br--top {\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n}\n/**\n * Box Shadow\n * offset-x | offset-y | blur-radius | spread-radius | color\n * NOTE: This naming convention is too verbose so I'm open to better\n * suggestions!\n */\n.shadow-none {\n  box-shadow: none;\n}\n.shadow-8-04 {\n  box-shadow: 0 0 8px 0 rgba(17, 17, 17, 0.4);\n}\n.shadow-black-1 {\n  -webkit-box-shadow: 0 10px 15px 0px rgba(0, 0, 0, 0.2);\n  -moz-box-shadow: 0 10px 15px 0px rgba(0, 0, 0, 0.2);\n  box-shadow: 0 10px 15px 0px rgba(0, 0, 0, 0.2);\n}\n.shadow-black-2 {\n  -webkit-box-shadow: 0 5px 5px -5px rgba(17, 17, 17, 0.5);\n  -moz-box-shadow: 0 5px 5px -5px rgba(17, 17, 17, 0.5);\n  box-shadow: 0 5px 5px -5px rgba(17, 17, 17, 0.5);\n}\n.shadow-black-3 {\n  -webkit-box-shadow: 2px 1px 8px rgba(17, 17, 17, 0.4);\n  -moz-box-shadow: 2px 1px 8px rgba(17, 17, 17, 0.4);\n  box-shadow: 2px 1px 8px rgba(17, 17, 17, 0.4);\n}\n.shadow-black-4 {\n  -webkit-box-shadow: 0px 0px 1px rgba(17, 17, 17, 0.2);\n  -moz-box-shadow: 0px 0px 1px rgba(17, 17, 17, 0.2);\n  box-shadow: 0px 0px 1px rgba(17, 17, 17, 0.2);\n}\n@media screen and (max-width: 520px) {\n  .shadow-none-m {\n    box-shadow: none;\n  }\n}\n@media screen and (min-width: 1200px) {\n  .shadow-none-l {\n    box-shadow: none;\n  }\n}\n.x--50-y-50 {\n  -webkit-transform: translateX(-50%) translateY(50%);\n  -moz-transform: translateX(-50%) translateY(50%);\n  -o-transform: translateX(-50%) translateY(50%);\n  -ms-transform: translateX(-50%) translateY(50%);\n  transform: translateX(-50%) translateY(50%);\n}\n.x--50-y-100 {\n  -webkit-transform: translateX(-50%) translateY(100%);\n  -moz-transform: translateX(-50%) translateY(100%);\n  -o-transform: translateX(-50%) translateY(100%);\n  -ms-transform: translateX(-50%) translateY(100%);\n  transform: translateX(-50%) translateY(100%);\n}\n.x--50-y--50 {\n  -webkit-transform: translateX(-50%) translateY(-50%);\n  -moz-transform: translateX(-50%) translateY(-50%);\n  -o-transform: translateX(-50%) translateY(-50%);\n  -ms-transform: translateX(-50%) translateY(-50%);\n  transform: translateX(-50%) translateY(-50%);\n}\n.x--50-y--100 {\n  -webkit-transform: translateX(-50%) translateY(-100%);\n  -moz-transform: translateX(-50%) translateY(-100%);\n  -o-transform: translateX(-50%) translateY(-100%);\n  -ms-transform: translateX(-50%) translateY(-100%);\n  transform: translateX(-50%) translateY(-100%);\n}\n.x-50 {\n  -webkit-transform: translateX(50%);\n  -moz-transform: translateX(50%);\n  -o-transform: translateX(50%);\n  -ms-transform: translateX(50%);\n  transform: translateX(50%);\n}\n.x-100-y--50 {\n  -webkit-transform: translateX(100%) translateY(-50%);\n  -moz-transform: translateX(100%) translateY(-50%);\n  -o-transform: translateX(100%) translateY(-50%);\n  -ms-transform: translateX(100%) translateY(-50%);\n  transform: translateX(100%) translateY(-50%);\n}\n.x-100 {\n  -webkit-transform: translateX(100%);\n  -moz-transform: translateX(100%);\n  -o-transform: translateX(100%);\n  -ms-transform: translateX(100%);\n  transform: translateX(100%);\n}\n.x--50 {\n  -webkit-transform: translateX(-50%);\n  -moz-transform: translateX(-50%);\n  -o-transform: translateX(-50%);\n  -ms-transform: translateX(-50%);\n  transform: translateX(-50%);\n}\n.x--100 {\n  -webkit-transform: translateX(-100%);\n  -moz-transform: translateX(-100%);\n  -o-transform: translateX(-100%);\n  -ms-transform: translateX(-100%);\n  transform: translateX(-100%);\n}\n.x0 {\n  -webkit-transform: translateX(0);\n  -moz-transform: translateX(0);\n  -o-transform: translateX(0);\n  -ms-transform: translateX(0);\n  transform: translateX(0);\n}\n.y--50 {\n  -webkit-transform: translateY(-50%);\n  -moz-transform: translateY(-50%);\n  -o-transform: translateY(-50%);\n  -ms-transform: translateY(-50%);\n  transform: translateY(-50%);\n}\n.y--100 {\n  -webkit-transform: translateY(-100%);\n  -moz-transform: translateY(-100%);\n  -o-transform: translateY(-100%);\n  -ms-transform: translateY(-100%);\n  transform: translateY(-100%);\n}\n.y-100 {\n  -webkit-transform: translateY(100%);\n  -moz-transform: translateY(100%);\n  -o-transform: translateY(100%);\n  -ms-transform: translateY(100%);\n  transform: translateY(100%);\n}\n.y0 {\n  -webkit-transform: translateY(0);\n  -moz-transform: translateY(0);\n  -o-transform: translateY(0);\n  -ms-transform: translateY(0);\n  transform: translateY(0);\n}\n.x-vw-100 {\n  -webkit-transform: translateX(100vw);\n  -moz-transform: translateX(100vw);\n  -o-transform: translateX(100vw);\n  -ms-transform: translateX(100vw);\n  transform: translateX(100vw);\n}\n.y-vh--100 {\n  -webkit-transform: translateY(-100vh);\n  -moz-transform: translateY(-100vh);\n  -o-transform: translateY(-100vh);\n  -ms-transform: translateY(-100vh);\n  transform: translateY(-100vh);\n}\n@media screen and (max-width: 520px) {\n  .x--100-m {\n    -webkit-transform: translateX(-100%);\n    -moz-transform: translateX(-100%);\n    -o-transform: translateX(-100%);\n    -ms-transform: translateX(-100%);\n    transform: translateX(-100%);\n  }\n}\n@media screen and (min-width: 1200px) {\n  .x-0-l {\n    -webkit-transform: translateX(0);\n    -moz-transform: translateX(0);\n    -o-transform: translateX(0);\n    -ms-transform: translateX(0);\n    transform: translateX(0);\n  }\n}\n.rotate-90 {\n  -webkit-transform: rotate(90deg);\n  -moz-transform: rotate(90deg);\n  -o-transform: rotate(90deg);\n  -ms-transform: rotate(90deg);\n  transform: rotate(90deg);\n}\n.rotate-180 {\n  -webkit-transform: rotate(180deg);\n  -moz-transform: rotate(180deg);\n  -o-transform: rotate(180deg);\n  -ms-transform: rotate(180deg);\n  transform: rotate(180deg);\n}\n.aspect-ratio {\n  height: 0;\n  position: relative;\n}\n.aspect-ratio--16x9 {\n  padding-bottom: 56.25%;\n}\n.aspect-ratio--9x16 {\n  padding-bottom: 177.77%;\n}\n.aspect-ratio--4x3 {\n  padding-bottom: 75%;\n}\n.aspect-ratio--3x4 {\n  padding-bottom: 133.33%;\n}\n.aspect-ratio--6x4 {\n  padding-bottom: 66.6%;\n}\n.aspect-ratio--4x6 {\n  padding-bottom: 150%;\n}\n.aspect-ratio--8x5 {\n  padding-bottom: 62.5%;\n}\n.aspect-ratio--5x8 {\n  padding-bottom: 160%;\n}\n.aspect-ratio--7x5 {\n  padding-bottom: 71.42%;\n}\n.aspect-ratio--5x7 {\n  padding-bottom: 140%;\n}\n.aspect-ratio--1x1 {\n  padding-bottom: 100%;\n}\n.scroll-touch {\n  -webkit-overflow-scrolling: touch;\n}\n.scroll-auto {\n  -webkit-overflow-scrolling: auto;\n}\n.no-select {\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n/*\n\n  Typography\n  ----------\n\n  Utility classes for typography.\n\n*/\n.font-default {\n  font-family: \"Source Sans Pro\", \"Arial\", sans-serif;\n}\n.f1 {\n  font-size: 3rem;\n}\n.f2 {\n  font-size: 2.25rem;\n}\n.f3 {\n  font-size: 1.5rem;\n}\n.f4 {\n  font-size: 1.25rem;\n}\n.f5 {\n  font-size: 1rem;\n}\n.f6 {\n  font-size: .875rem;\n}\n.f7 {\n  font-size: .75rem;\n}\n.f8 {\n  font-size: 0.625rem;\n}\n@media screen and (max-width: 768px) {\n  .f1-t {\n    font-size: 3rem;\n  }\n  .f2-t {\n    font-size: 2.25rem;\n  }\n  .f3-t {\n    font-size: 1.5rem;\n  }\n  .f4-t {\n    font-size: 1.25rem;\n  }\n  .f5-t {\n    font-size: 1rem;\n  }\n  .f6-t {\n    font-size: .875rem;\n  }\n  .f7-t {\n    font-size: .75rem;\n  }\n}\n@media screen and (max-width: 520px) {\n  .f1-m {\n    font-size: 3rem;\n  }\n  .f2-m {\n    font-size: 2.25rem;\n  }\n  .f3-m {\n    font-size: 1.5rem;\n  }\n  .f4-m {\n    font-size: 1.25rem;\n  }\n  .f5-m {\n    font-size: 1rem;\n  }\n  .f6-m {\n    font-size: .875rem;\n  }\n  .f7-m {\n    font-size: .75rem;\n  }\n}\n.untracked {\n  letter-spacing: normal;\n}\n.tracked {\n  letter-spacing: 0.1rem;\n}\n.tracked-cosy {\n  letter-spacing: -0.005rem;\n}\n.tracked-tight {\n  letter-spacing: -0.05rem;\n}\n.tracked-mega {\n  letter-spacing: 0.25rem;\n}\n.normal {\n  font-weight: normal;\n}\n.b {\n  font-weight: bold;\n}\n.lighter {\n  font-weight: lighter;\n}\n.fw2 {\n  font-weight: 200;\n}\n.fw3 {\n  font-weight: 300;\n}\n.fw4 {\n  font-weight: 400;\n}\n.fw5 {\n  font-weight: 500;\n}\n.fw6 {\n  font-weight: 600;\n}\n.fw7 {\n  font-weight: 700;\n}\n.fw8 {\n  font-weight: 800;\n}\n.i {\n  font-style: italic;\n}\n.fs-normal {\n  font-style: normal;\n}\n.lh-solid {\n  line-height: 1;\n}\n.lh-headline {\n  line-height: 1.17;\n}\n.lh-title {\n  line-height: 1.25;\n}\n.lh-copy-variant {\n  line-height: 1.44;\n}\n.lh-copy {\n  line-height: 1.5;\n}\n.lh-pagination {\n  line-height: 1.75;\n}\n.lh-copy--spaced {\n  line-height: 2.25;\n}\n.tc {\n  text-align: center;\n}\n.tr {\n  text-align: right;\n}\n.tl {\n  text-align: left;\n}\n@media screen and (max-width: 520px) {\n  .tc-m {\n    text-align: center;\n  }\n  .tr-m {\n    text-align: right;\n  }\n  .tl-m {\n    text-align: left;\n  }\n}\n.vt {\n  vertical-align: top;\n}\n.vm {\n  vertical-align: middle;\n}\n.vbs {\n  vertical-align: baseline;\n}\n.no-underline {\n  text-decoration: none;\n}\n.underline {\n  text-decoration: underline;\n}\n.decoration-inherit {\n  text-decoration: inherit;\n}\n.hover-underline:hover {\n  text-decoration: underline;\n}\n.hover-no-underline:hover {\n  text-decoration: none;\n}\n.hover-b:hover {\n  font-weight: bold;\n}\n.ws-normal {\n  white-space: normal;\n}\n.nowrap {\n  white-space: nowrap;\n}\n.pre {\n  white-space: pre;\n}\n@media screen and (max-width: 520px) {\n  .ws-normal-m {\n    white-space: normal;\n  }\n}\n.o-auto {\n  overflow: auto;\n}\n.o-hidden {\n  overflow: hidden;\n}\n.truncate {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.ttc {\n  text-transform: capitalize;\n}\n.ttl {\n  text-transform: lowercase;\n}\n.ttn {\n  text-transform: none;\n}\n.ttu {\n  text-transform: uppercase;\n}\n.measure {\n  max-width: 30em;\n}\n.measure-wide {\n  max-width: 34em;\n}\n.measure-narrow {\n  max-width: 20em;\n}\n@media screen and (min-width: 769px) {\n  .measure-d {\n    max-width: 30em;\n  }\n  .measure-wide-d {\n    max-width: 34em;\n  }\n  .measure-narrow-d {\n    max-width: 20em;\n  }\n}\n.indent {\n  text-indent: 1rem;\n  margin-top: 0;\n  margin-bottom: 0;\n}\n.disable-select {\n  -moz-user-select: none;\n  /* Firefox */\n  -ms-user-select: none;\n  /* Internet Explorer */\n  -webkit-user-select: none;\n  /* Chrome, Safari, and Opera */\n  user-select: none;\n}\n.ds {\n  -moz-user-select: none;\n  /* Firefox */\n  -ms-user-select: none;\n  /* Internet Explorer */\n  -webkit-user-select: none;\n  /* Chrome, Safari, and Opera */\n  user-select: none;\n}\n.wb-all {\n  word-break: break-all;\n}\n.wb-word {\n  word-break: break-word;\n}\n.wb-keep {\n  word-break: keep-all;\n}\n@media screen and (max-width: 768px) {\n  .wb-all-t {\n    word-break: break-all;\n  }\n}\n@media screen and (max-width: 520px) {\n  .wb-word-m {\n    word-break: break-word;\n  }\n}\n.ca-grid-card {\n  height: 26.25rem;\n}\n.ca-grid-card a {\n  color: #0bb9b5;\n  text-decoration: none;\n}\n.ca-grid-card a:hover {\n  text-decoration: underline;\n}\n.arrow-link {\n  text-decoration: none !important;\n}\n.arrow-link a {\n  color: #6288A5 !important;\n}\n.arrow-link svg {\n  color: #111111 !important;\n}\n.arrow-link:hover * {\n  color: #128a93 !important;\n  text-decoration: underline !important;\n}\n.ca-content a {\n  color: #0bb9b5;\n  text-decoration: none;\n}\n.ca-content > ul {\n  list-style-type: initial;\n  padding-left: 1rem;\n}\n.ca-tile-title p {\n  margin: 0 !important;\n}\n.ca-article-headline-title {\n  line-height: 1.17;\n  margin-top: 1.5rem;\n  margin-bottom: 0.375rem;\n}\n.announcements-content div:first-child > h3:first-child {\n  margin-top: 0;\n}\n.announcements-content div:not(:first-child) > h3 {\n  margin-top: 3rem;\n}\n.announcements-content h3 {\n  font-size: 1.25rem;\n  font-weight: 800;\n  margin: 1.25rem 0 0.4rem;\n  color: #111111;\n}\n.announcements-content strong {\n  color: #111111;\n  letter-spacing: 0.1px;\n}\n.announcements-content p,\n.announcements-content li {\n  font-size: 0.9375rem;\n  color: #404040;\n  line-height: 1.17;\n  margin-top: 0.75rem;\n  margin-bottom: 0.75rem;\n}\n.announcements-content li {\n  letter-spacing: 0.1px;\n}\n.announcements-content a {\n  text-decoration: none;\n  color: #0bb9b5;\n}\n.announcements-content a:hover {\n  text-decoration: underline;\n}\n.announcements-content ul,\n.announcements-content ol {\n  padding-left: 1.5rem;\n  margin-top: 0.75rem;\n  margin-bottom: 0.75rem;\n}\n.announcements-content div:first-child > p:first-child {\n  margin-top: 0.5rem;\n}\n.announcements-content div:first-child > ul:first-child {\n  margin-top: 0.5rem;\n}\n.announcements-content div:first-child > ul:first-child > li:first-child {\n  margin-top: 0.25rem;\n}\n.article-page-icons .svg-base {\n  margin-left: 0.375rem;\n  margin-right: 0.375rem;\n  height: 24px !important;\n  width: 24px !important;\n}\n.article-page-icons .MuiIconButton-root {\n  color: #6288A5;\n  outline: 0;\n  padding: 0;\n  height: 2.5rem;\n  width: 2.5rem;\n  font-size: inherit;\n}\n.article-page-icons .MuiIconButton-root:hover {\n  color: #128a93;\n}\n.share-buttons-container .MuiIconButton-root {\n  color: #6288A5 !important;\n  outline: 0;\n  font-size: inherit;\n  padding: 4px;\n}\n.share-buttons-container .MuiIconButton-root:hover {\n  color: #128a93;\n}\n.submit-form-button .MuiButton-root {\n  padding: 1rem 2rem;\n  color: #FFFFFF;\n  background-color: #0bb9b5;\n}\n.submit-form-button .MuiButton-root:hover {\n  background-color: #128a93;\n}\n.submit-form-button .MuiButton-root:disabled {\n  background-color: #73797A;\n}\n.article-grid a {\n  outline: 0 !important;\n}\n.article-section {\n  min-height: 60rem;\n}\n@media screen and (max-width: 632px) {\n  .article-section {\n    height: 64rem;\n  }\n}\n@media screen and (max-width: 566px) {\n  .article-section {\n    height: 66rem;\n  }\n}\n@media screen and (max-width: 430px) {\n  .article-section {\n    height: 70rem;\n  }\n}\n@media screen and (max-width: 420px) {\n  .article-section {\n    height: 72rem;\n  }\n}\n@media screen and (max-width: 382px) {\n  .article-section {\n    height: 76rem;\n  }\n}\n@media screen and (max-width: 382px) {\n  .article-section {\n    height: 80rem;\n  }\n}\n.Toastify__progress-bar--default {\n  background: #3FC599;\n}\n.icon-clipboard-container,\n.icon-preview-toggle-container {\n  width: 32px;\n  height: 32px;\n}\n.icon-clipboard-container .MuiSvgIcon-root,\n.icon-preview-toggle-container .MuiSvgIcon-root {\n  width: 32px;\n  height: 32px;\n}\n.icon-clipboard-container:hover,\n.icon-preview-toggle-container:hover {\n  color: #128a93 !important;\n}\n.expand-more-button {\n  width: 100%;\n  height: 0;\n  text-align: center;\n}\n.expand-more-button-container {\n  background: -webkit-linear-gradient(top, rgba(255, 255, 255, 0) 0%, #ededed 75%);\n  background: -moz-linear-gradient(top, rgba(255, 255, 255, 0) 0%, #ededed 75%);\n  background: -ms-linear-gradient(top, rgba(255, 255, 255, 0) 0%, #ededed 75%);\n  background: -o-linear-gradient(top, rgba(255, 255, 255, 0) 0%, #ededed 75%);\n  background: linear-gradient(top, rgba(255, 255, 255, 0) 0%, #ededed 75%);\n}\n.tile-frosted-bottom {\n  background: #ffffff;\n  background: linear-gradient(0deg, #ffffff 0%, rgba(255, 255, 255, 0) 100%);\n  /*.linear-gradient(top, rgba(255, 255, 255, 0), 0%, rgb(255, 255, 255), 100%);*/\n}\n.tooltip-wrapper::before {\n  position: absolute;\n  left: 0;\n  width: 1.5rem;\n  top: 0;\n  bottom: 0;\n  content: '';\n  z-index: 5;\n  background: linear-gradient(270deg, rgba(255, 255, 255, 0) 0%, #ededed 100%);\n}\n.tooltip-wrapper::after {\n  position: absolute;\n  right: 0;\n  width: 1.5rem;\n  top: 0;\n  bottom: 0;\n  content: '';\n  background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, #ededed 100%);\n}\n.hover-bg-ghost-grey:hover {\n  background-color: #F7F9FA;\n}\n.bg-precedents-blue-30 {\n  background-color: rgba(0, 75, 122, 0.3);\n}\n.bg-precedents-blue-20 {\n  background-color: rgba(0, 75, 122, 0.2);\n}\n.bg-precedents-blue-10 {\n  background-color: rgba(0, 75, 122, 0.1);\n}\n.bg-precedents-blue-5 {\n  background-color: rgba(0, 75, 122, 0.05);\n}\n.hover-bg-precedents-blue-10:hover {\n  background-color: rgba(0, 75, 122, 0.1);\n}\n.hover-bg-precedents-blue-20:hover {\n  background-color: rgba(0, 75, 122, 0.2);\n}\n.precedents-tile .MuiButton-root:hover {\n  background-color: rgba(0, 75, 122, 0.1);\n}\n.precedents-description p {\n  margin: 0 0 10px;\n}\n.bg-precedents-blue-exp {\n  background-color: #004b7a !important;\n}\n.action-buttons button {\n  cursor: pointer;\n  background-color: #FFFFFF;\n}\n.menu-list-button {\n  -moz-appearance: menulist-button;\n  -webkit-appearance: menulist-button;\n}\n.texteditor .DraftEditor-root {\n  padding: 0.5em;\n  margin: 0;\n  background: rgba(255, 255, 255, 0.5);\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  min-height: 17rem;\n  position: relative;\n}\n.texteditor .side-toolbar {\n  position: absolute;\n  top: 25px;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  width: 2em;\n  transition: top 0.2s;\n}\n.texteditor .side-toolbar .svg-icon {\n  color: rgba(0, 0, 0, 0.2);\n  fill: rgba(0, 0, 0, 0.2);\n  font-size: 1.4em;\n  cursor: pointer;\n  vertical-align: middle;\n}\n.texteditor .side-toolbar .svg-icon.a-menu {\n  font-size: 1.4em;\n}\n.texteditor .public-DraftEditorPlaceholder-root {\n  position: absolute;\n}\n.texteditor .paragraph,\n.public-DraftStyleDefault-ul,\n.public-DraftStyleDefault-ol {\n  margin-bottom: 0;\n}\n.public-DraftStyleDefault-ul,\n.public-DraftStyleDefault-ol {\n  margin-top: 0;\n}\n.texteditor {\n  position: relative;\n  padding-left: 2em;\n}\n.texteditor .paragraph {\n  margin-bottom: 0.5em;\n}\n.texteditor blockquote {\n  padding: 10px 20px;\n  margin: 0 0 20px;\n  border-left: 5px solid #eee;\n}\n.texteditor img {\n  max-width: 100%;\n}\n.texteditor .toolbar {\n  position: absolute;\n  z-index: 9999;\n  height: 2em;\n  cursor: default;\n  pointer-events: none;\n  transition: opacity 0.2s;\n  opacity: 0;\n}\n.texteditor .toolbar.side {\n  top: 0;\n  left: -1px;\n}\n.texteditor .toolbar.active {\n  opacity: 1;\n  pointer-events: all;\n}\n.texteditor .toolbar.inline {\n  font-size: 1.1em;\n}\n.texteditor .toolbar .toolbar-icons {\n  position: relative;\n  z-index: 1;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-align-items: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-justify-content: space-between;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n  list-style: none;\n  height: 100%;\n  margin: 0;\n  padding: 0;\n  background: #f5f5f5;\n  border: 1px solid #ddd;\n  font-size: 1em;\n}\n.texteditor .toolbar .toolbar-icons .toolbar-static {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-align-items: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  background: #ddd;\n  width: 2.1em;\n  max-width: 2.1em;\n}\n.texteditor .toolbar .toolbar-icons .toolbar-static .svg-icon {\n  fill: #000;\n  width: auto;\n  height: auto;\n  margin: 0;\n}\n.texteditor .toolbar .toolbar-icons .toolbar-icon {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-align-items: center;\n  -ms-flex-align: center;\n  align-items: baseline;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  height: 100%;\n  width: 2.4em;\n  line-height: 2.5em;\n  max-width: 2.4em;\n  font-size: 0.8em;\n  color: #aaa;\n  transition: all 0.15s linear;\n  cursor: pointer;\n}\n.texteditor .toolbar .toolbar-icons .toolbar-icon.active,\n.texteditor .toolbar .toolbar-icons .toolbar-icon:hover {\n  color: #222;\n}\n.texteditor .toolbar .toolbar-icons .toolbar-icon.active .svg-icon,\n.texteditor .toolbar .toolbar-icons .toolbar-icon:hover .svg-icon {\n  fill: #222;\n  color: #222;\n}\n.texteditor .toolbar-icon:hover .toolbar .toolbar-icons .toolbar-icon i {\n  margin: 0;\n  padding: 0;\n  color: #444;\n  font-size: 1.8em;\n}\n.link-editor {\n  display: block;\n  max-width: 800px;\n  margin: auto;\n  width: 96%;\n  background: #ffffff;\n  padding: 5px 20px 20px;\n  font-size: 1.3em;\n}\n.link-editor .form-actions {\n  text-align: right;\n  margin-top: 1em;\n}\n.link-editor .form-actions a {\n  display: inline-block;\n  font-size: 1em;\n  width: 10em;\n  margin: 0 0.5em;\n}\n@media screen and (max-width: 520px) {\n  .link-editor .form-actions {\n    text-align: center;\n    margin: 1em 0;\n  }\n  .link-editor .form-actions a {\n    width: 60%;\n    margin: 0.2em 0;\n  }\n}\n.link-editor .input-container {\n  padding: 1em 2em;\n}\n.link-editor .input-container input {\n  width: 100%;\n  font-size: 1.1em;\n  padding: 0.4em;\n  outline: none;\n  border: 2px solid #eee;\n  border-radius: 2px;\n}\n.group .texteditor {\n  padding: 18px 64px 18px 64px;\n  font-size: 1.5rem;\n  display: block;\n  font-weight: 400;\n}\n.group .toggle-texteditor {\n  margin: 0 1em 1em 1em;\n}\n.group .toggle-texteditor svg {\n  fill: #fff;\n}\n.placeholder-cadet-blue-important input::placeholder {\n  color: #6288A5 !important;\n  opacity: 1;\n}\n.date-picker input::placeholder {\n  color: #6288A5 !important;\n  opacity: 1;\n}\n.date-picker input {\n  background: transparent;\n  border: 1px solid;\n  width: 11rem;\n}\n.date-picker .react-datepicker-popper {\n  left: -2.25rem !important;\n  top: 0 !important;\n  z-index: 2;\n}\n.filter-checkbox-icon {\n  width: 1rem;\n}\n.filter-checkbox-icon svg g {\n  stroke: none;\n}\n.drawer-svg-icon svg {\n  top: 0;\n}\n.header-action-button.MuiButtonBase-root {\n  background-color: rgba(255, 202, 40, 0.3);\n}\n.header-action-button.MuiButtonBase-root:hover {\n  background-color: #FFCA28;\n}\n.header-action-button-disabled.MuiButton-root.Mui-disabled {\n  color: #6288A5;\n}\n.svg-stroke-white svg path,\n.svg-stroke-white svg polyline {\n  stroke: #FFFFFF;\n}\n.svg-stroke-cadet-blue svg path,\n.svg-stroke-cadet-blue svg polyline {\n  stroke: #6288A5;\n}\n.svg-fill-cadet-blue svg {\n  fill: #6288A5;\n}\n.svg-fill-white svg {\n  fill: #FFFFFF;\n}\n/*\n\n  Fix\n  ---\n\n  Fixes! Add a comment explaining what bug it fixes and if you found the\n  solution on e.g. StackOverflow then include the link.\n\n*/\n.chrome-nested-flex-column-fix {\n  min-width: 0;\n  min-height: 0;\n}\n.clearfix:before,\n.clearfix:after {\n  content: \" \";\n  display: table;\n}\n.clearfix:after {\n  clear: both;\n}\n@media screen and (min-width: 769px) {\n  .firefox-flex-grow-fix {\n    flex-basis: 0;\n  }\n}\n.ie-fix-justify-evenly {\n  justify-content: space-around;\n}\n@supports (-ms-ime-align: auto) {\n  .justify-evenly {\n    justify-content: space-around;\n  }\n}\n.ie-hide-default-select-chevron::-ms-expand {\n  display: none;\n}\n.margin-collapse-fix:after {\n  content: '';\n  overflow: auto;\n  display: block;\n}\n.no-csspositionsticky .ie-sticky-fix {\n  position: fixed;\n}\n.safari-border-image-fix {\n  border-right: 0 solid transparent;\n}\n.muiButtonHoverLinesFix.muiButtonHoverLinesFix:hover {\n  text-decoration: none;\n}\nselect::-ms-expand {\n  display: none;\n}\n.ie-min-height-flex-items-center-fix {\n  padding-top: 0.875rem !important;\n  padding-bottom: 0.875rem !important;\n}\n.ie-min-height-flex-items-center-fix .ie-prefix-hack {\n  top: 0.875rem;\n}\n.popover.bottom > .arrow::after {\n  border-bottom-color: #004b7a !important;\n}\n.ie-layout-fix {\n  max-width: 100%;\n}\n.ie-layout-fix > div {\n  padding-top: 0;\n  padding-bottom: 0;\n  margin-top: 0;\n  margin-bottom: 0;\n  margin-left: auto;\n  margin-right: auto;\n  max-width: 1200px;\n  padding-left: 1.5rem;\n  padding-right: 1.5rem;\n}\n@media screen and (max-width: 768px) {\n  .ie-layout-fix > div {\n    padding-left: 1.5rem;\n    padding-right: 1.5rem;\n  }\n}\n@media screen and (max-width: 520px) {\n  .ie-layout-fix > div {\n    padding-left: 0.75rem;\n    padding-right: 0.75rem;\n  }\n}\n.ie-side {\n  display: block;\n}\n.items-center-ie-fix {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n.outline-0 select:-moz-focusring {\n  color: transparent;\n  text-shadow: 0 0 0 #000;\n}\n@media screen and (max-width: 520px) {\n  .header-icon-mobile-width {\n    width: 2.25rem;\n  }\n}\n/* Stops table wrapping onto new line - see FC-1436*/\n@media only screen and (min-width: 1200px) {\n  /* Duplicating class selector to increase specificity of rule to overwrite layout-width-constraints max-width */\n  .deal-watch-width-constraint {\n    width: 72vw !important;\n  }\n}\n.deal-watch-width-constraint {\n  width: 96vw;\n}\n.popover-content a {\n  color: #FFFFFF;\n}\n.new-ticker div p {\n  margin: 0;\n}\n.icon-button-bg-color-active {\n  background-color: rgba(0, 0, 0, 0.04);\n}\n.rich-text-editor .public-DraftEditor-content {\n  min-height: 12rem;\n}\n.ie-basis0-fix {\n  flex-basis: auto;\n}\n/*\n\n  Grid\n  ----\n\n  You can use the .grid-with-gutters(@n, @gw) mixin to create a grid structure\n  with n items per row and gutter width gw.\n\n  Note that the styles inside the media queries don't apply to smaller screen\n  widths!\n  i.e. if you want a grid that has 4 items per row on desktop and tablet and 1\n  on mobile you would need grid-4-gutter-4-d, grid-4-gutter-4-t and\n  grid-1-gutter-4-d.\n\n  This is because the margins on the nth children (which are the outermost items\n  in the grid) can't be reliably overridden.\n\n*/\n.grid-1-gutter-4 {\n  display: flex;\n  flex-wrap: wrap;\n}\n.grid-1-gutter-4 > * {\n  width: calc((100% / 1) - 0rem);\n  margin: 0.25rem;\n}\n.grid-1-gutter-4 > *:nth-child(1n - 0) {\n  margin-left: 0;\n}\n.grid-1-gutter-4 > *:nth-child(1n) {\n  margin-right: 0;\n}\n.grid-1-gutter-4 > *:nth-child(-n + 1) {\n  margin-top: 0;\n}\n.grid-1-gutter-4 > *:nth-last-child(-n + 1) {\n  margin-bottom: 0;\n}\n.grid-2-gutter-4 {\n  display: flex;\n  flex-wrap: wrap;\n}\n.grid-2-gutter-4 > * {\n  width: calc((100% / 2) - 1rem);\n  margin: 0.25rem;\n}\n.grid-2-gutter-4 > *:nth-child(2n - 1) {\n  margin-left: 0;\n}\n.grid-2-gutter-4 > *:nth-child(2n) {\n  margin-right: 0;\n}\n.grid-2-gutter-4 > *:nth-child(-n + 2) {\n  margin-top: 0;\n}\n.grid-2-gutter-4 > *:nth-last-child(-n + 2) {\n  margin-bottom: 0;\n}\n.grid-3-gutter-4 {\n  display: flex;\n  flex-wrap: wrap;\n}\n.grid-3-gutter-4 > * {\n  width: calc((100% / 3) - 1rem);\n  margin: 0.25rem;\n}\n.grid-3-gutter-4 > *:nth-child(3n - 2) {\n  margin-left: 0;\n}\n.grid-3-gutter-4 > *:nth-child(3n) {\n  margin-right: 0;\n}\n.grid-3-gutter-4 > *:nth-child(-n + 3) {\n  margin-top: 0;\n}\n.grid-3-gutter-4 > *:nth-last-child(-n + 3) {\n  margin-bottom: 0;\n}\n.grid-4-gutter-4 {\n  display: flex;\n  flex-wrap: wrap;\n}\n.grid-4-gutter-4 > * {\n  width: calc((100% / 4) - 1rem);\n  margin: 0.25rem;\n}\n.grid-4-gutter-4 > *:nth-child(4n - 3) {\n  margin-left: 0;\n}\n.grid-4-gutter-4 > *:nth-child(4n) {\n  margin-right: 0;\n}\n.grid-4-gutter-4 > *:nth-child(-n + 4) {\n  margin-top: 0;\n}\n.grid-4-gutter-4 > *:nth-last-child(-n + 4) {\n  margin-bottom: 0;\n}\n.grid-5-gutter-4 {\n  display: flex;\n  flex-wrap: wrap;\n}\n.grid-5-gutter-4 > * {\n  width: calc((100% / 5) - 1rem);\n  margin: 0.25rem;\n}\n.grid-5-gutter-4 > *:nth-child(5n - 4) {\n  margin-left: 0;\n}\n.grid-5-gutter-4 > *:nth-child(5n) {\n  margin-right: 0;\n}\n.grid-5-gutter-4 > *:nth-child(-n + 5) {\n  margin-top: 0;\n}\n.grid-5-gutter-4 > *:nth-last-child(-n + 5) {\n  margin-bottom: 0;\n}\n@media screen and (min-width: 769px) {\n  .grid-1-gutter-4-d {\n    display: flex;\n    flex-wrap: wrap;\n  }\n  .grid-1-gutter-4-d > * {\n    width: calc((100% / 1) - 0rem);\n    margin: 0.25rem;\n  }\n  .grid-1-gutter-4-d > *:nth-child(1n - 0) {\n    margin-left: 0;\n  }\n  .grid-1-gutter-4-d > *:nth-child(1n) {\n    margin-right: 0;\n  }\n  .grid-1-gutter-4-d > *:nth-child(-n + 1) {\n    margin-top: 0;\n  }\n  .grid-1-gutter-4-d > *:nth-last-child(-n + 1) {\n    margin-bottom: 0;\n  }\n  .grid-2-gutter-4-d {\n    display: flex;\n    flex-wrap: wrap;\n  }\n  .grid-2-gutter-4-d > * {\n    width: calc((100% / 2) - 1rem);\n    margin: 0.25rem;\n  }\n  .grid-2-gutter-4-d > *:nth-child(2n - 1) {\n    margin-left: 0;\n  }\n  .grid-2-gutter-4-d > *:nth-child(2n) {\n    margin-right: 0;\n  }\n  .grid-2-gutter-4-d > *:nth-child(-n + 2) {\n    margin-top: 0;\n  }\n  .grid-2-gutter-4-d > *:nth-last-child(-n + 2) {\n    margin-bottom: 0;\n  }\n  .grid-3-gutter-4-d {\n    display: flex;\n    flex-wrap: wrap;\n  }\n  .grid-3-gutter-4-d > * {\n    width: calc((100% / 3) - 1rem);\n    margin: 0.25rem;\n  }\n  .grid-3-gutter-4-d > *:nth-child(3n - 2) {\n    margin-left: 0;\n  }\n  .grid-3-gutter-4-d > *:nth-child(3n) {\n    margin-right: 0;\n  }\n  .grid-3-gutter-4-d > *:nth-child(-n + 3) {\n    margin-top: 0;\n  }\n  .grid-3-gutter-4-d > *:nth-last-child(-n + 3) {\n    margin-bottom: 0;\n  }\n  .grid-4-gutter-4-d {\n    display: flex;\n    flex-wrap: wrap;\n  }\n  .grid-4-gutter-4-d > * {\n    width: calc((100% / 4) - 1rem);\n    margin: 0.25rem;\n  }\n  .grid-4-gutter-4-d > *:nth-child(4n - 3) {\n    margin-left: 0;\n  }\n  .grid-4-gutter-4-d > *:nth-child(4n) {\n    margin-right: 0;\n  }\n  .grid-4-gutter-4-d > *:nth-child(-n + 4) {\n    margin-top: 0;\n  }\n  .grid-4-gutter-4-d > *:nth-last-child(-n + 4) {\n    margin-bottom: 0;\n  }\n  .grid-5-gutter-4-d {\n    display: flex;\n    flex-wrap: wrap;\n  }\n  .grid-5-gutter-4-d > * {\n    width: calc((100% / 5) - 1rem);\n    margin: 0.25rem;\n  }\n  .grid-5-gutter-4-d > *:nth-child(5n - 4) {\n    margin-left: 0;\n  }\n  .grid-5-gutter-4-d > *:nth-child(5n) {\n    margin-right: 0;\n  }\n  .grid-5-gutter-4-d > *:nth-child(-n + 5) {\n    margin-top: 0;\n  }\n  .grid-5-gutter-4-d > *:nth-last-child(-n + 5) {\n    margin-bottom: 0;\n  }\n}\n@media screen and (min-width: 520px) and (max-width: 768px) {\n  .grid-1-gutter-4-t {\n    display: flex;\n    flex-wrap: wrap;\n  }\n  .grid-1-gutter-4-t > * {\n    width: calc((100% / 1) - 0rem);\n    margin: 0.25rem;\n  }\n  .grid-1-gutter-4-t > *:nth-child(1n - 0) {\n    margin-left: 0;\n  }\n  .grid-1-gutter-4-t > *:nth-child(1n) {\n    margin-right: 0;\n  }\n  .grid-1-gutter-4-t > *:nth-child(-n + 1) {\n    margin-top: 0;\n  }\n  .grid-1-gutter-4-t > *:nth-last-child(-n + 1) {\n    margin-bottom: 0;\n  }\n  .grid-2-gutter-4-t {\n    display: flex;\n    flex-wrap: wrap;\n  }\n  .grid-2-gutter-4-t > * {\n    width: calc((100% / 2) - 1rem);\n    margin: 0.25rem;\n  }\n  .grid-2-gutter-4-t > *:nth-child(2n - 1) {\n    margin-left: 0;\n  }\n  .grid-2-gutter-4-t > *:nth-child(2n) {\n    margin-right: 0;\n  }\n  .grid-2-gutter-4-t > *:nth-child(-n + 2) {\n    margin-top: 0;\n  }\n  .grid-2-gutter-4-t > *:nth-last-child(-n + 2) {\n    margin-bottom: 0;\n  }\n  .grid-3-gutter-4-t {\n    display: flex;\n    flex-wrap: wrap;\n  }\n  .grid-3-gutter-4-t > * {\n    width: calc((100% / 3) - 1rem);\n    margin: 0.25rem;\n  }\n  .grid-3-gutter-4-t > *:nth-child(3n - 2) {\n    margin-left: 0;\n  }\n  .grid-3-gutter-4-t > *:nth-child(3n) {\n    margin-right: 0;\n  }\n  .grid-3-gutter-4-t > *:nth-child(-n + 3) {\n    margin-top: 0;\n  }\n  .grid-3-gutter-4-t > *:nth-last-child(-n + 3) {\n    margin-bottom: 0;\n  }\n  .grid-4-gutter-4-t {\n    display: flex;\n    flex-wrap: wrap;\n  }\n  .grid-4-gutter-4-t > * {\n    width: calc((100% / 4) - 1rem);\n    margin: 0.25rem;\n  }\n  .grid-4-gutter-4-t > *:nth-child(4n - 3) {\n    margin-left: 0;\n  }\n  .grid-4-gutter-4-t > *:nth-child(4n) {\n    margin-right: 0;\n  }\n  .grid-4-gutter-4-t > *:nth-child(-n + 4) {\n    margin-top: 0;\n  }\n  .grid-4-gutter-4-t > *:nth-last-child(-n + 4) {\n    margin-bottom: 0;\n  }\n  .grid-5-gutter-4-t {\n    display: flex;\n    flex-wrap: wrap;\n  }\n  .grid-5-gutter-4-t > * {\n    width: calc((100% / 5) - 1rem);\n    margin: 0.25rem;\n  }\n  .grid-5-gutter-4-t > *:nth-child(5n - 4) {\n    margin-left: 0;\n  }\n  .grid-5-gutter-4-t > *:nth-child(5n) {\n    margin-right: 0;\n  }\n  .grid-5-gutter-4-t > *:nth-child(-n + 5) {\n    margin-top: 0;\n  }\n  .grid-5-gutter-4-t > *:nth-last-child(-n + 5) {\n    margin-bottom: 0;\n  }\n}\n@media screen and (max-width: 520px) {\n  .grid-1-gutter-4-m {\n    display: flex;\n    flex-wrap: wrap;\n  }\n  .grid-1-gutter-4-m > * {\n    width: calc((100% / 1) - 0rem);\n    margin: 0.25rem;\n  }\n  .grid-1-gutter-4-m > *:nth-child(1n - 0) {\n    margin-left: 0;\n  }\n  .grid-1-gutter-4-m > *:nth-child(1n) {\n    margin-right: 0;\n  }\n  .grid-1-gutter-4-m > *:nth-child(-n + 1) {\n    margin-top: 0;\n  }\n  .grid-1-gutter-4-m > *:nth-last-child(-n + 1) {\n    margin-bottom: 0;\n  }\n  .grid-2-gutter-4-m {\n    display: flex;\n    flex-wrap: wrap;\n  }\n  .grid-2-gutter-4-m > * {\n    width: calc((100% / 2) - 1rem);\n    margin: 0.25rem;\n  }\n  .grid-2-gutter-4-m > *:nth-child(2n - 1) {\n    margin-left: 0;\n  }\n  .grid-2-gutter-4-m > *:nth-child(2n) {\n    margin-right: 0;\n  }\n  .grid-2-gutter-4-m > *:nth-child(-n + 2) {\n    margin-top: 0;\n  }\n  .grid-2-gutter-4-m > *:nth-last-child(-n + 2) {\n    margin-bottom: 0;\n  }\n  .grid-3-gutter-4-m {\n    display: flex;\n    flex-wrap: wrap;\n  }\n  .grid-3-gutter-4-m > * {\n    width: calc((100% / 3) - 1rem);\n    margin: 0.25rem;\n  }\n  .grid-3-gutter-4-m > *:nth-child(3n - 2) {\n    margin-left: 0;\n  }\n  .grid-3-gutter-4-m > *:nth-child(3n) {\n    margin-right: 0;\n  }\n  .grid-3-gutter-4-m > *:nth-child(-n + 3) {\n    margin-top: 0;\n  }\n  .grid-3-gutter-4-m > *:nth-last-child(-n + 3) {\n    margin-bottom: 0;\n  }\n  .grid-4-gutter-4-m {\n    display: flex;\n    flex-wrap: wrap;\n  }\n  .grid-4-gutter-4-m > * {\n    width: calc((100% / 4) - 1rem);\n    margin: 0.25rem;\n  }\n  .grid-4-gutter-4-m > *:nth-child(4n - 3) {\n    margin-left: 0;\n  }\n  .grid-4-gutter-4-m > *:nth-child(4n) {\n    margin-right: 0;\n  }\n  .grid-4-gutter-4-m > *:nth-child(-n + 4) {\n    margin-top: 0;\n  }\n  .grid-4-gutter-4-m > *:nth-last-child(-n + 4) {\n    margin-bottom: 0;\n  }\n  .grid-5-gutter-4-m {\n    display: flex;\n    flex-wrap: wrap;\n  }\n  .grid-5-gutter-4-m > * {\n    width: calc((100% / 5) - 1rem);\n    margin: 0.25rem;\n  }\n  .grid-5-gutter-4-m > *:nth-child(5n - 4) {\n    margin-left: 0;\n  }\n  .grid-5-gutter-4-m > *:nth-child(5n) {\n    margin-right: 0;\n  }\n  .grid-5-gutter-4-m > *:nth-child(-n + 5) {\n    margin-top: 0;\n  }\n  .grid-5-gutter-4-m > *:nth-last-child(-n + 5) {\n    margin-bottom: 0;\n  }\n}\n/*\n\n  Helpers\n  -------\n\n  This file is for mixins and helpful generic classes that aren't simple enough\n  to be considered a utility class. Should be used sparingly!\n\n*/\n.screen-reader-text {\n  border: 0;\n  clip: rect(1px, 1px, 1px, 1px);\n  clip-path: inset(50%);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute !important;\n  width: 1px;\n  word-wrap: normal !important;\n}\n.center {\n  top: 50%;\n  left: 50%;\n  -webkit-transform: translate(-50%, -50%);\n  -moz-transform: translate(-50%, -50%);\n  -o-transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n  transform: translate(-50%, -50%);\n}\n.center-h {\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n  -moz-transform: translateX(-50%);\n  -o-transform: translateX(-50%);\n  -ms-transform: translateX(-50%);\n  transform: translateX(-50%);\n}\n.center-v {\n  top: 50%;\n  -webkit-transform: translateY(-50%);\n  -moz-transform: translateY(-50%);\n  -o-transform: translateY(-50%);\n  -ms-transform: translateY(-50%);\n  transform: translateY(-50%);\n}\n/*\n * Hamburgers\n * @description Tasty CSS-animated hamburgers\n * @author Jonathan Suh @jonsuh\n * @site https://jonsuh.com/hamburgers\n * @link https://github.com/jonsuh/hamburgers\n */\n.hamburger {\n  padding: 0;\n  display: inline-block;\n  cursor: pointer;\n  transition-property: opacity, filter;\n  transition-duration: 0.15s;\n  transition-timing-function: linear;\n  font: inherit;\n  color: inherit;\n  text-transform: none;\n  background-color: transparent;\n  border: 0;\n  margin: 0;\n  overflow: visible;\n  position: relative;\n  width: 100%;\n  height: 100%;\n}\n.hamburger:hover {\n  opacity: 0.7;\n}\n.hamburger-box {\n  width: 100%;\n  height: 100%;\n  display: inline-block;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  -webkit-transform: translate(-50%, -50%);\n  -moz-transform: translate(-50%, -50%);\n  -o-transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n  transform: translate(-50%, -50%);\n}\n.hamburger-inner {\n  display: block;\n  width: 100%;\n  height: 2px;\n  border-radius: 4px;\n  position: absolute;\n  background-color: #111111;\n  -webkit-transform: translateY(-50%);\n  -moz-transform: translateY(-50%);\n  -o-transform: translateY(-50%);\n  -ms-transform: translateY(-50%);\n  transform: translateY(-50%);\n}\n.hamburger-inner-1 {\n  top: 0;\n}\n.hamburger-inner-2 {\n  top: 50%;\n}\n.hamburger-inner-3 {\n  top: 100%;\n}\n/*\n\n  Custom\n  ------\n\n  Add any styling that can't be constructed from the generic styles to this\n  file. Include a comment explaining what the styling does.\n\n  This file should be used as a last resort.\n\n*/\n.logo-width {\n  width: 12rem;\n}\n@media screen and (max-width: 768px) {\n  .logo-width {\n    width: 3rem;\n  }\n}\n@media screen and (max-width: 520px) {\n  .logo-width {\n    width: 2rem;\n  }\n}\n.nav-full-right {\n  width: 16rem;\n  -webkit-transform: translate(16rem, 0);\n  -moz-transform: translate(16rem, 0);\n  -o-transform: translate(16rem, 0);\n  -ms-transform: translate(16rem, 0);\n  transform: translate(16rem, 0);\n}\n.application-header,\n.application-content,\n.nav-full-right {\n  -webkit-transition: transform 0.3s;\n  -moz-transition: transform 0.3s;\n  -ms-transition: transform 0.3s;\n  -o-transition: transform 0.3s;\n  transition: transform 0.3s;\n}\n.show-navigation .application-header,\n.show-navigation .application-content {\n  -webkit-transform: translate(-16rem, 0);\n  -moz-transform: translate(-16rem, 0);\n  -o-transform: translate(-16rem, 0);\n  -ms-transform: translate(-16rem, 0);\n  transform: translate(-16rem, 0);\n}\n.show-navigation .nav-full-right {\n  -webkit-transform: translate(0.0001px, 0);\n  -moz-transform: translate(0.0001px, 0);\n  -o-transform: translate(0.0001px, 0);\n  -ms-transform: translate(0.0001px, 0);\n  transform: translate(0.0001px, 0);\n}\n.accordion-header-center {\n  line-height: 3rem;\n}\n.pop-faqs-icon svg {\n  margin-top: 4px;\n}\n.o-50-hover:hover {\n  -webkit-opacity: 0.5;\n  -moz-opacity: 0.5;\n  opacity: 0.5;\n}\n.feedback-container {\n  position: relative;\n  min-height: 8rem;\n  -webkit-transition: all 0.2s ease;\n  -moz-transition: all 0.2s ease;\n  -o-transition: all 0.2s ease;\n  transition: all 0.2s ease;\n  width: 32rem;\n}\n@media screen and (max-width: 555px) {\n  .feedback-container {\n    max-width: 390px;\n  }\n}\n@media screen and (max-width: 425px) {\n  .feedback-container {\n    max-width: 380px;\n  }\n}\n@media screen and (max-width: 375px) {\n  .feedback-container {\n    max-width: 330px;\n  }\n}\n@media screen and (max-width: 320px) {\n  .feedback-container {\n    max-width: 280px;\n  }\n}\n.feedback-button {\n  left: 0;\n  transform: rotate(270deg) translateY(-5rem) translateX(-2.95rem);\n}\n.fade-out-overlay::after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: linear-gradient(rgba(255, 255, 255, 0), #F7F9FA);\n}\n.account-item-rows > a,\n.account-item-rows > div,\n.account-item-rows > li {\n  text-decoration: none;\n}\n.account-item-rows > a:nth-child(even),\n.account-item-rows > div:nth-child(even),\n.account-item-rows > li:nth-child(even) {\n  background-color: #FFFFFF;\n}\n.account-overlay {\n  max-width: 800px;\n  margin: auto;\n  width: 96%;\n  background: #FFFFFF;\n  padding: 5px 20px 20px;\n  flex-direction: column;\n}\n.careerText p {\n  margin-bottom: 1rem;\n}\n@media screen and (max-width: 520px) {\n  .mob-team-img-position {\n    background-position: 50% 30%;\n  }\n}\n.legislation-tile .MuiButton-root:hover {\n  background-color: rgba(132, 97, 156, 0.1);\n}\n.hover-default-tab-button-bg:hover {\n  background-color: rgba(0, 140, 159, 0.15);\n}\n.qa-tile-full .MuiButton-root:hover {\n  background-color: rgba(53, 184, 211, 0.1);\n}\n.qa-tile-semi .MuiButton-root:hover {\n  background-color: rgba(63, 197, 153, 0.1);\n}\n.qa-tile-skimmed .MuiButton-root:hover {\n  background-color: rgba(241, 97, 125, 0.1);\n}\n.MuiIconButton-colorSecondary.Mui-checked {\n  color: inherit;\n}\n.MuiIconButton-colorSecondary:hover {\n  background-color: inherit;\n}\n.bg-news-publication {\n  background-color: #eaf7f0 !important;\n}\n.bg-news-publication:hover {\n  background-color: #c5e8d7 !important;\n}\n.bg-news-publication.darker {\n  background-color: #b3e1cb !important;\n}\n.bg-flavour-full {\n  background-color: #ddf3f7 !important;\n}\n.bg-flavour-full.darker,\n.bg-flavour-full:hover {\n  background-color: #b3e4ee !important;\n}\n.bg-flavour-full .MuiCheckbox-colorSecondary {\n  color: #35b8d3 !important;\n}\n.bg-flavour-full .MuiCheckbox-colorSecondary:hover {\n  background-color: rgba(53, 184, 211, 0.1) !important;\n}\n.bg-flavour-full .MuiCheckbox-colorSecondary .MuiIconButton-colorSecondary:hover {\n  color: #35b8d3 !important;\n}\n.full .MuiCheckbox-colorSecondary {\n  color: #35b8d3 !important;\n}\n.full .MuiCheckbox-colorSecondary:hover {\n  background-color: rgba(53, 184, 211, 0.1) !important;\n}\n.full .MuiCheckbox-colorSecondary .MuiIconButton-colorSecondary:hover {\n  color: #35b8d3 !important;\n}\n.bg-flavour-semi {\n  background-color: #dcf4ec !important;\n}\n.bg-flavour-semi.darker,\n.bg-flavour-semi:hover {\n  background-color: #b5e8d7 !important;\n}\n.bg-flavour-semi .MuiCheckbox-colorSecondary {\n  color: #3FC599 !important;\n}\n.bg-flavour-semi .MuiCheckbox-colorSecondary:hover {\n  background-color: rgba(63, 197, 153, 0.1) !important;\n}\n.bg-flavour-semi .MuiCheckbox-colorSecondary .MuiIconButton-colorSecondary:hover {\n  color: #3FC599 !important;\n}\n.semi .MuiCheckbox-colorSecondary {\n  color: #3FC599 !important;\n}\n.semi .MuiCheckbox-colorSecondary:hover {\n  background-color: rgba(63, 197, 153, 0.1) !important;\n}\n.semi .MuiCheckbox-colorSecondary .MuiIconButton-colorSecondary:hover {\n  color: #3FC599 !important;\n}\n.bg-flavour-skimmed {\n  background-color: #fdeef1 !important;\n}\n.bg-flavour-skimmed.darker,\n.bg-flavour-skimmed:hover {\n  background-color: #f9bfca !important;\n}\n.bg-flavour-skimmed .MuiCheckbox-colorSecondary {\n  color: #F1617D !important;\n}\n.bg-flavour-skimmed .MuiCheckbox-colorSecondary:hover {\n  background-color: rgba(241, 97, 125, 0.1) !important;\n}\n.bg-flavour-skimmed .MuiCheckbox-colorSecondary .MuiIconButton-colorSecondary:hover {\n  color: #F1617D !important;\n}\n.skimmed .MuiCheckbox-colorSecondary {\n  color: #F1617D !important;\n}\n.skimmed .MuiCheckbox-colorSecondary:hover {\n  background-color: rgba(241, 97, 125, 0.1) !important;\n}\n.skimmed .MuiCheckbox-colorSecondary .MuiIconButton-colorSecondary:hover {\n  color: #F1617D !important;\n}\n.b--flavour-full {\n  border-color: #35b8d3;\n}\n.b--flavour-semi {\n  border-color: #3FC599;\n}\n.b--flavour-skimmed {\n  border-color: #F1617D;\n}\n.hover-bg-flavour-full:hover {\n  background-color: #ddf3f7 !important;\n}\n.hover-bg-flavour-full:hover.darker,\n.hover-bg-flavour-full:hover:hover {\n  background-color: #b3e4ee !important;\n}\n.hover-bg-flavour-full:hover .MuiCheckbox-colorSecondary {\n  color: #35b8d3 !important;\n}\n.hover-bg-flavour-full:hover .MuiCheckbox-colorSecondary:hover {\n  background-color: rgba(53, 184, 211, 0.1) !important;\n}\n.hover-bg-flavour-full:hover .MuiCheckbox-colorSecondary .MuiIconButton-colorSecondary:hover {\n  color: #35b8d3 !important;\n}\n.hover-bg-flavour-semi:hover {\n  background-color: #dcf4ec !important;\n}\n.hover-bg-flavour-semi:hover.darker,\n.hover-bg-flavour-semi:hover:hover {\n  background-color: #b5e8d7 !important;\n}\n.hover-bg-flavour-semi:hover .MuiCheckbox-colorSecondary {\n  color: #3FC599 !important;\n}\n.hover-bg-flavour-semi:hover .MuiCheckbox-colorSecondary:hover {\n  background-color: rgba(63, 197, 153, 0.1) !important;\n}\n.hover-bg-flavour-semi:hover .MuiCheckbox-colorSecondary .MuiIconButton-colorSecondary:hover {\n  color: #3FC599 !important;\n}\n.hover-bg-flavour-skimmed:hover {\n  background-color: #fdeef1 !important;\n}\n.hover-bg-flavour-skimmed:hover.darker,\n.hover-bg-flavour-skimmed:hover:hover {\n  background-color: #f9bfca !important;\n}\n.hover-bg-flavour-skimmed:hover .MuiCheckbox-colorSecondary {\n  color: #F1617D !important;\n}\n.hover-bg-flavour-skimmed:hover .MuiCheckbox-colorSecondary:hover {\n  background-color: rgba(241, 97, 125, 0.1) !important;\n}\n.hover-bg-flavour-skimmed:hover .MuiCheckbox-colorSecondary .MuiIconButton-colorSecondary:hover {\n  color: #F1617D !important;\n}\n.btc--flavour-full {\n  border-top-color: #35b8d3;\n}\n.btc--flavour-semi {\n  border-top-color: #3FC599;\n}\n.btc--flavour-skimmed {\n  border-top-color: #F1617D;\n}\n.highlight-yellow {\n  background-color: #FCF8E3 !important;\n}\n.flavour-tabs {\n  font-size: 0.65rem;\n}\n.h1-5 {\n  height: 1.5rem;\n}\nmark {\n  background-color: #fcf8e3;\n  color: inherit;\n}\n.pseudo-arrows > li::after {\n  content: ' > ';\n  margin: 0 0.25rem;\n}\n.pseudo-arrows > li:last-child::after {\n  content: '';\n}\n.w-date {\n  width: 14.28571429%;\n}\n.bg-teal-darken-10 {\n  background-color: #002c47;\n}\n.bg-teal-darken-5 {\n  background-color: #003b61;\n}\n.hover-bg-teal-darken-5:hover {\n  background-color: #003b61;\n}\n.hover-bg-teal-darken-10:hover {\n  background-color: #002c47;\n}\n.MuiSpeedDial-actions.comment-menu-speed-dial-actions {\n  margin-top: -1.5rem;\n  padding-top: 2rem;\n}\n.side-width,\n.ca-left-width {\n  width: 20rem;\n}\n.marketplace-search-button,\n.marketplace-search-button.Mui-disabled,\n.account-nav-button.Mui-disabled {\n  background-color: #0bb9b5;\n}\n.qa-search-button,\n.qa-search-button.Mui-disabled {\n  background-color: #35b8d3;\n}\n.search-drop-down-menu.qa-search-button.MuiButton-contained:hover,\n.search-drop-down-menu.marketplace-search-button.MuiButton-contained:hover {\n  background-color: #2698af;\n}\n.dashboard .qa-search-button,\n.dashboard .qa-search-button.Mui-disabled {\n  background-color: #0bb9b5;\n}\n.dashboard .search-drop-down-menu.qa-search-button.MuiButton-contained:hover,\n.dashboard .search-drop-down-menu.marketplace-search-button.MuiButton-contained:hover {\n  background-color: #088986;\n}\n.faq-header-expanded {\n  background-color: #c7fcfa;\n}\n.faq-header-expanded-content {\n  background-color: #088986;\n}\n.legislation-search-button,\n.legislation-search-button.Mui-disabled {\n  background-color: #84619C;\n}\n.search-drop-down-menu.legislation-search-button.MuiButton-contained:hover {\n  background-color: #694d7d;\n}\n.news-search-button,\n.news-search-button.Mui-disabled {\n  background-color: #0bb9b5;\n}\n.search-drop-down-menu.news-search-button.MuiButton-contained:hover {\n  background-color: #088986;\n}\n.precedents-search-button,\n.precedents-search-button.Mui-disabled {\n  background-color: #004b7a;\n}\n.search-drop-down-menu.precedents-search-button.MuiButton-contained:hover {\n  background-color: #002c47;\n}\n.markets-search-button,\n.markets-search-button.Mui-disabled {\n  background-color: #008C9F;\n}\n.search-drop-down-menu.markets-search-button.MuiButton-contained:hover {\n  background-color: #005f6c;\n}\n.news-date-picker-search-button.MuiButton-root:hover {\n  background-color: #5CBE75;\n}\n.search-drop-down-menu.news-date-picker-search-button.MuiButton-contained:hover {\n  background-color: #42a55b;\n}\n.bg-qa-tab::before {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  height: 3px;\n  width: 100%;\n  -webkit-transition: all 0.2s ease;\n  -moz-transition: all 0.2s ease;\n  -o-transition: all 0.2s ease;\n  transition: all 0.2s ease;\n}\n.bg-qa-tab.selected::before {\n  height: 100%;\n}\n.bg-qa-tab.full:hover::before,\n.bg-qa-tab.full.selected::before {\n  background-color: #35b8d3;\n}\n.bg-qa-tab.semi:hover::before,\n.bg-qa-tab.semi.selected::before {\n  background-color: #3FC599;\n}\n.bg-qa-tab.skimmed:hover::before,\n.bg-qa-tab.skimmed.selected::before {\n  background-color: #F1617D;\n}\n.bg-qa-tab.archive:hover::before,\n.bg-qa-tab.archive.selected::before {\n  background-color: #73797A;\n}\n.bg-qa-tab.legislation:hover::before,\n.bg-qa-tab.legislation.selected::before {\n  background-color: #83619C;\n}\n.popover.bottom > .arrow {\n  position: absolute;\n  top: -11px;\n}\n.popover.bottom > .arrow::after {\n  content: ' ';\n  top: 1px;\n  margin-left: -10px;\n  border-width: 10px;\n  border-top-width: 0;\n  position: absolute;\n  display: block;\n  width: 0;\n  height: 0;\n  border-style: solid;\n  border-color: transparent;\n}\n.ca-filter-link:hover {\n  color: #5CBE75;\n}\n.privacy-filter-link:hover svg g {\n  stroke: #004b7a;\n}\n.filter-link:hover svg g {\n  stroke: #008C9F;\n}\n.account-input-label:hover svg g {\n  stroke: #004b7a;\n}\n.account-input-label:hover svg {\n  fill: #004b7a;\n}\n.account-input-checked svg {\n  color: #004b7a;\n}\n.teal-save-button.MuiButton-root:hover {\n  background-color: #002c47;\n}\n.white-cancel-button.MuiButton-root:hover {\n  background-color: #e6e6e6;\n}\n.react-datepicker__navigation {\n  border: 0.45rem solid transparent;\n}\n.react-datepicker__navigation--next {\n  border-left-color: #ccc;\n}\n.react-datepicker__navigation--previous {\n  border-right-color: #ccc;\n}\n.ca-homepage ol li,\n.ca-homepage ul li {\n  margin: 0.5rem 0;\n}\n.folder-badge {\n  min-width: 1.5rem;\n  height: 1.5rem;\n  border-radius: 0.75rem;\n}\n.form-submit-button:hover {\n  background-color: #0bb9b5;\n}\n.form-cancel-button:hover:hover {\n  background-color: #D5ECFF;\n}\n.trial-select-organisation-button:hover {\n  background-color: #008C9F;\n}\n.trial-select-individual-button:hover {\n  background-color: #008C9F;\n}\n.trial-thank-you-finish-button:hover {\n  background-color: #5CBE75;\n}\n.ca-search-date-submit-button:hover {\n  background-color: #5CBE75;\n}\n.dealwatch-search-date-submit-button:hover {\n  background-color: #128a93;\n}\n@media screen and (max-width: 346px) {\n  .MuiPickersBasePicker-pickerView {\n    padding-right: 1.25rem;\n  }\n}\n.speech-bubble {\n  background-color: #ebf0f4;\n  padding: 10px 16px;\n  position: relative;\n  -webkit-border-radius: 12px;\n  -moz-border-radius: 12px;\n  border-radius: 12px;\n}\n.speech-bubble:after {\n  content: \"\";\n  position: absolute;\n  bottom: -2.25rem;\n  /* value = - border-top-width - border-bottom-width */\n  left: 5.25rem;\n  /* controls horizontal position */\n  border-width: 2.25rem 3rem 0 0;\n  /* vary these values to change the angle of the vertex */\n  border-style: solid;\n  border-color: #ebf0f3 transparent;\n  /* reduce the damage in FF3.0 */\n  display: block;\n  width: 0;\n}\n.markets-overview-tile {\n  font-size: 18px;\n}\n.markets-overview-tile:hover {\n  background: #d3fdff;\n}\n.overlay-parameter-header:before {\n  content: ' ';\n  position: absolute;\n  width: 10px;\n  height: 10px;\n  background: #979797;\n}\n.overlay-parameter-header-enabled:before {\n  background: #73797A;\n}\n.deal-increase {\n  border-left: 5px solid transparent;\n  border-right: 5px solid transparent;\n  border-bottom: 5px solid #5CBE75;\n}\n.deal-decrease {\n  border-left: 5px solid transparent;\n  border-right: 5px solid transparent;\n  border-top: 5px solid #CC0033;\n}\n.comment-controls .mini-speed-dial {\n  min-height: 2rem;\n  height: 2rem;\n  width: 2rem;\n}\n.comment-controls .MuiSpeedDial-directionDown .MuiSpeedDial-actions {\n  padding-top: 42px;\n}\n.transition-fade-out-slow {\n  animation: fadeOut 500ms forwards;\n  animation-delay: 0s;\n}\n@keyframes fadeOut {\n  from {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n    display: none;\n  }\n}\n.indented-section {\n  display: block;\n  padding-left: 2rem;\n}\n.esv-interview-label > p {\n  margin: 0;\n  word-wrap: break-word;\n}\n.esv-interview-hide-break > br {\n  display: none;\n}\n.esv-interview-toolbar-width {\n  width: 100%;\n}\n@media screen and (min-width: 1200px) {\n  .esv-interview-toolbar-width {\n    width: calc(100% - 20rem);\n  }\n}\n@media screen and (min-width: 1500px) {\n  .esv-interview-toolbar-spacing,\n  .esv-footer-spacing {\n    margin-left: auto;\n    margin-right: auto;\n  }\n}\n@media screen and (min-width: 1450px) {\n  .esv-interview-db-l {\n    display: block;\n  }\n  .esv-interview-dn-l {\n    display: none;\n  }\n  .esv-interview-preview-width-l {\n    width: 50rem;\n  }\n}\n.angled-text .rv-xy-plot__axis__tick__text {\n  transform: rotate(-45deg) translate(-2em, 0.5em);\n}\n.compact .rv-discrete-color-legend-item {\n  padding: 0.1rem 0.2rem;\n}\n.rv-discrete-color-legend.vertical {\n  display: flex;\n  flex-wrap: wrap;\n  margin-top: 1rem;\n}\n.rv-discrete-color-legend-item {\n  display: flex;\n  align-items: center;\n  width: 50%;\n  flex-grow: 1;\n}\n.rv-discrete-color-legend-item.vertical {\n  padding-bottom: 0;\n}\n.rv-discrete-color-legend-item .rv-discrete-color-legend-item__color__path {\n  stroke-width: 0.5rem;\n}\n.rv-discrete-color-legend-item .rv-discrete-color-legend-item__color {\n  vertical-align: baseline;\n}\n/* Copyright 2014 Mozilla Foundation\n *\n * Licensed under the Apache License, Version 2.0 (the \"License\");\n * you may not use this file except in compliance with the License.\n * You may obtain a copy of the License at\n *\n *     http://www.apache.org/licenses/LICENSE-2.0\n *\n * Unless required by applicable law or agreed to in writing, software\n * distributed under the License is distributed on an \"AS IS\" BASIS,\n * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.\n * See the License for the specific language governing permissions and\n * limitations under the License.\n */\n.textLayer {\n  position: absolute;\n  left: 0;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  overflow: hidden;\n  opacity: 0.2;\n  line-height: 1.0;\n}\n.textLayer > div {\n  color: transparent;\n  position: absolute;\n  white-space: pre;\n  cursor: text;\n  -webkit-transform-origin: 0% 0%;\n  -moz-transform-origin: 0% 0%;\n  -o-transform-origin: 0% 0%;\n  -ms-transform-origin: 0% 0%;\n  transform-origin: 0% 0%;\n}\n.textLayer .highlight {\n  margin: -1px;\n  padding: 1px;\n  background-color: #b400aa;\n  border-radius: 4px;\n}\n.textLayer .highlight.begin {\n  border-radius: 4px 0px 0px 4px;\n}\n.textLayer .highlight.end {\n  border-radius: 0px 4px 4px 0px;\n}\n.textLayer .highlight.middle {\n  border-radius: 0px;\n}\n.textLayer .highlight.selected {\n  background-color: #006400;\n}\n.textLayer ::selection {\n  background: #0000ff;\n}\n.textLayer ::-moz-selection {\n  background: #0000ff;\n}\n.textLayer .endOfContent {\n  display: block;\n  position: absolute;\n  left: 0px;\n  top: 100%;\n  right: 0px;\n  bottom: 0px;\n  z-index: -1;\n  cursor: default;\n  -webkit-user-select: none;\n  -ms-user-select: none;\n  -moz-user-select: none;\n}\n.textLayer .endOfContent.active {\n  top: 0px;\n}\n.annotationLayer section {\n  position: absolute;\n}\n.annotationLayer .linkAnnotation > a {\n  position: absolute;\n  font-size: 1em;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n.annotationLayer .linkAnnotation > a {\n  background: url(\"data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7\") 0 0 repeat;\n}\n.annotationLayer .linkAnnotation > a:hover {\n  opacity: 0.2;\n  background: #ff0;\n  box-shadow: 0px 2px 10px #ff0;\n}\n.annotationLayer .textAnnotation img {\n  position: absolute;\n  cursor: pointer;\n}\n.annotationLayer .textWidgetAnnotation input,\n.annotationLayer .textWidgetAnnotation textarea,\n.annotationLayer .choiceWidgetAnnotation select,\n.annotationLayer .buttonWidgetAnnotation.checkBox input,\n.annotationLayer .buttonWidgetAnnotation.radioButton input {\n  background-color: rgba(0, 54, 255, 0.13);\n  border: 1px solid transparent;\n  box-sizing: border-box;\n  font-size: 9px;\n  height: 100%;\n  padding: 0 3px;\n  vertical-align: top;\n  width: 100%;\n}\n.annotationLayer .textWidgetAnnotation textarea {\n  font: message-box;\n  font-size: 9px;\n  resize: none;\n}\n.annotationLayer .textWidgetAnnotation input[disabled],\n.annotationLayer .textWidgetAnnotation textarea[disabled],\n.annotationLayer .choiceWidgetAnnotation select[disabled],\n.annotationLayer .buttonWidgetAnnotation.checkBox input[disabled],\n.annotationLayer .buttonWidgetAnnotation.radioButton input[disabled] {\n  background: none;\n  border: 1px solid transparent;\n  cursor: not-allowed;\n}\n.annotationLayer .textWidgetAnnotation input:hover,\n.annotationLayer .textWidgetAnnotation textarea:hover,\n.annotationLayer .choiceWidgetAnnotation select:hover,\n.annotationLayer .buttonWidgetAnnotation.checkBox input:hover,\n.annotationLayer .buttonWidgetAnnotation.radioButton input:hover {\n  border: 1px solid #000;\n}\n.annotationLayer .textWidgetAnnotation input:focus,\n.annotationLayer .textWidgetAnnotation textarea:focus,\n.annotationLayer .choiceWidgetAnnotation select:focus {\n  background: none;\n  border: 1px solid transparent;\n}\n.annotationLayer .textWidgetAnnotation input.comb {\n  font-family: monospace;\n  padding-left: 2px;\n  padding-right: 0;\n}\n.annotationLayer .textWidgetAnnotation input.comb:focus {\n  /*\n   * Letter spacing is placed on the right side of each character. Hence, the\n   * letter spacing of the last character may be placed outside the visible\n   * area, causing horizontal scrolling. We avoid this by extending the width\n   * when the element has focus and revert this when it loses focus.\n   */\n  width: 115%;\n}\n.annotationLayer .buttonWidgetAnnotation.checkBox input,\n.annotationLayer .buttonWidgetAnnotation.radioButton input {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  -ms-appearance: none;\n  appearance: none;\n}\n.annotationLayer .popupWrapper {\n  position: absolute;\n  width: 20em;\n}\n.annotationLayer .popup {\n  position: absolute;\n  z-index: 200;\n  max-width: 20em;\n  background-color: #FFFF99;\n  box-shadow: 0px 2px 5px #333;\n  border-radius: 2px;\n  padding: 0.6em;\n  margin-left: 5px;\n  cursor: pointer;\n  word-wrap: break-word;\n}\n.annotationLayer .popup h1 {\n  font-size: 1em;\n  border-bottom: 1px solid #000000;\n  padding-bottom: 0.2em;\n}\n.annotationLayer .popup p {\n  padding-top: 0.2em;\n}\n.annotationLayer .highlightAnnotation,\n.annotationLayer .underlineAnnotation,\n.annotationLayer .squigglyAnnotation,\n.annotationLayer .strikeoutAnnotation,\n.annotationLayer .lineAnnotation svg line,\n.annotationLayer .fileAttachmentAnnotation {\n  cursor: pointer;\n}\n#pdfViewer {\n  flex: 1;\n  overflow: auto;\n  position: relative;\n  max-height: calc(100vh - 13rem);\n  max-width: 1000px;\n  width: 100%;\n  margin: auto;\n}\n.pdfViewer .canvasWrapper {\n  overflow: hidden;\n}\n.pdfViewer .page {\n  direction: ltr;\n  width: 816px;\n  height: 1056px;\n  margin: 20px auto;\n  position: relative;\n  overflow: visible;\n  border: none;\n  background-clip: content-box;\n  box-shadow: 0 2px 4px 2px rgba(0, 0, 0, 0.2);\n  background-color: white;\n}\n.pdfViewer.removePageBorders .page {\n  margin: 0px auto 10px auto;\n  border: none;\n}\n.pdfViewer.singlePageView {\n  display: inline-block;\n}\n.pdfViewer.singlePageView .page {\n  margin: 0;\n  border: none;\n}\n.pdfViewer .page canvas {\n  margin: 0;\n  display: block;\n}\n.pdfViewer .page canvas[hidden] {\n  display: none;\n}\n.pdfViewer .page .loadingIcon {\n  position: absolute;\n  display: block;\n  left: 0;\n  top: 0;\n  right: 0;\n  bottom: 0;\n}\n.pdfPresentationMode:-webkit-full-screen .pdfViewer .page {\n  margin-bottom: 100%;\n  border: 0;\n}\n.pdfPresentationMode:-moz-full-screen .pdfViewer .page {\n  margin-bottom: 100%;\n  border: 0;\n}\n.pdfPresentationMode:-ms-fullscreen .pdfViewer .page {\n  margin-bottom: 100% !important;\n  border: 0;\n}\n.pdfPresentationMode:fullscreen .pdfViewer .page {\n  margin-bottom: 100%;\n  border: 0;\n}\n.navigation-item-title .archived-label {\n  display: none;\n}\n.archived-label {\n  font-style: normal;\n  font-size: 0.9rem;\n  background: #83619C;\n  padding: 5px;\n  padding-right: 5px;\n  padding-left: 5px;\n  padding-left: 10px;\n  padding-right: 10px;\n  border-radius: 9999px;\n  margin-left: 15px;\n  margin-top: -2px;\n  color: #fff;\n}\n.cd-accordion-menu {\n  /*background: @color-accordion-base;*/\n  list-style: none;\n  margin: 0 auto 1.2em auto;\n  padding: 0;\n}\n.cd-accordion-menu a {\n  text-decoration: none;\n}\n.cd-accordion-menu ul.group {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  position: relative;\n  z-index: 2;\n}\n.cd-accordion-menu .sticky,\n.cd-accordion-menu .toggle {\n  position: relative;\n  z-index: 2;\n}\n.cd-accordion-menu .toggle {\n  background: #FFFFFF;\n}\n.cd-accordion-menu li {\n  padding: 0;\n  margin: 0;\n  position: relative;\n  top: 0;\n  left: 0;\n}\n.cd-accordion-menu input[type=checkbox] {\n  /* hide native checkbox */\n  position: absolute;\n  opacity: 0;\n}\n.cd-accordion-menu .prefix {\n  position: absolute;\n  top: 0;\n  left: 0;\n  font-size: 1.4em;\n  height: 100%;\n  width: 64px;\n  min-width: 10px;\n  padding: 19px 0 0 0;\n  text-transform: uppercase;\n  text-align: center;\n  font-weight: bold;\n  z-index: 20;\n  color: #000;\n  text-decoration: none;\n  line-height: 1.8em;\n}\n@media screen and (max-width: 520px) {\n  .cd-accordion-menu .prefix {\n    width: 28px;\n    font-size: 1.2em;\n    line-height: 1em;\n  }\n}\n.cd-accordion-menu .comment,\n.cd-accordion-menu .selector {\n  cursor: pointer;\n  font-size: 1.4em;\n  width: 2em;\n  height: 4.5em;\n  text-align: center;\n  position: absolute;\n  z-index: 20;\n  box-shadow: none;\n  background: transparent;\n  color: inherit;\n  padding: 0;\n}\n@media screen and (max-width: 520px) {\n  .cd-accordion-menu .comment,\n  .cd-accordion-menu .selector {\n    height: 3.4em;\n  }\n}\n.cd-accordion-menu .comment {\n  right: 3em;\n}\n.cd-accordion-menu .comment i {\n  font-size: 1.2em;\n  margin-top: 1px;\n  position: absolute;\n  display: block;\n  top: 50%;\n  left: 0;\n  width: 100%;\n  letter-spacing: -1px;\n  -webkit-transform: translateY(-50%);\n  -moz-transform: translateY(-50%);\n  -o-transform: translateY(-50%);\n  -ms-transform: translateY(-50%);\n  transform: translateY(-50%);\n}\n.cd-accordion-menu .no-title .comment {\n  right: 1em;\n}\n@media screen and (max-width: 520px) {\n  .cd-accordion-menu .no-title .comment {\n    display: none;\n  }\n}\n.cd-accordion-menu .selector {\n  right: 1em;\n}\n.cd-accordion-menu .selector .indicator {\n  position: absolute;\n  display: block;\n  top: 50%;\n  left: 0;\n  width: 100%;\n  letter-spacing: -1px;\n  -webkit-transform: translateY(-50%);\n  -moz-transform: translateY(-50%);\n  -o-transform: translateY(-50%);\n  -ms-transform: translateY(-50%);\n  transform: translateY(-50%);\n}\n.cd-accordion-menu .selector .indicator .svg-icon {\n  position: relative;\n  font-size: 1.2em;\n}\n.cd-accordion-menu .group-prefix {\n  display: inline-block;\n  font-weight: lighter;\n  vertical-align: middle;\n  font-size: 0.8em;\n  text-transform: uppercase;\n  margin-right: 1em;\n}\n.cd-accordion-menu .sticky-bottom {\n  position: absolute;\n  bottom: 0;\n  width: 100%;\n  display: block;\n  z-index: 1;\n}\n.cd-accordion-menu .sticky-bottom.show.depth-1 {\n  z-index: 34;\n}\n.cd-accordion-menu .sticky-bottom.show.depth-2 {\n  z-index: 35;\n}\n.cd-accordion-menu .sticky-bottom.show.depth-3 {\n  z-index: 36;\n}\n.cd-accordion-menu .sticky-bottom.show.depth-4 {\n  z-index: 37;\n}\n.cd-accordion-menu .sticky-bottom.show.depth-5 {\n  z-index: 38;\n}\n.cd-accordion-menu .sticky-bottom.show.depth-6 {\n  z-index: 39;\n}\n.cd-accordion-menu .sticky-bottom.show.depth-7 {\n  z-index: 40;\n}\n.cd-accordion-menu .highlight.content,\n.cd-accordion-menu .highlight.group,\n.cd-accordion-menu .highlight.content label.content {\n  background: #fcf8e3 !important;\n}\n.cd-accordion-menu label .before {\n  /* icons */\n  content: '';\n  display: inline-block;\n  width: 16px;\n  height: 16px;\n  position: absolute;\n  top: 50%;\n  -webkit-transform: translateY(-50%);\n  -moz-transform: translateY(-50%);\n  -o-transform: translateY(-50%);\n  -ms-transform: translateY(-50%);\n  transform: translateY(-50%);\n  margin: -0.1em 0 0 -0.1em;\n}\n.cd-accordion-menu label {\n  cursor: pointer;\n}\n.cd-accordion-menu label.group .before {\n  background-image: none;\n  color: inherit;\n  line-height: 1em;\n  font-size: 1em;\n  /* arrow icon */\n  left: 18px;\n  -webkit-transform: translateY(-50%);\n  -moz-transform: translateY(-50%);\n  -o-transform: translateY(-50%);\n  -ms-transform: translateY(-50%);\n  transform: translateY(-50%);\n}\n.cd-accordion-menu label .suffix {\n  float: right;\n  font-size: 0.8em;\n  line-height: 1.8em;\n  font-weight: lighter;\n}\n.cd-accordion-menu label.group-header-archived {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.cd-accordion-menu .is-loading label::before {\n  content: ' ';\n  animation: accordion-loader 1.2s infinite linear;\n  border: 2px solid;\n  border-right-color: transparent;\n  border-radius: 50%;\n}\n.cd-accordion-menu .is-loading label .before {\n  display: none;\n}\n@-moz-keyframes accordion-loader {\n  0% {\n    transform: translateY(-50%) rotate(0deg);\n  }\n  100% {\n    transform: translateY(-50%) rotate(360deg);\n  }\n}\n@-webkit-keyframes accordion-loader {\n  0% {\n    transform: translateY(-50%) rotate(0deg);\n  }\n  100% {\n    transform: translateY(-50%) rotate(360deg);\n  }\n}\n@keyframes accordion-loader {\n  0% {\n    transform: translateY(-50%) rotate(0deg);\n  }\n  100% {\n    transform: translateY(-50%) rotate(360deg);\n  }\n}\n.cd-accordion-menu input[type=checkbox]:checked + label .before {\n  /* rotate arrow */\n  -webkit-transform: translateY(-50%);\n  -moz-transform: translateY(-50%);\n  -o-transform: translateY(-50%);\n  -ms-transform: translateY(-50%);\n  transform: translateY(-50%);\n}\n.cd-accordion-menu input[type=checkbox]:checked + label::after {\n  /* show open folder icon if item is checked */\n  background-position: -32px 0;\n}\n.cd-accordion-menu input[type=checkbox]:checked + label + ul,\n.cd-accordion-menu input[type=checkbox]:checked + label:nth-of-type(n) + ul {\n  /* use label:nth-of-type(n) to fix a bug on safari (<= 8.0.8) with multiple adjacent-sibling selectors*/\n  /* show children when item is checked */\n  display: block;\n}\n.no-touch .cd-accordion-menu ul.group label:hover {\n  background: #ededed;\n}\n.cd-accordion-menu li.depth-1 {\n  margin-bottom: 2px;\n}\n.cd-accordion-menu li.depth-1.group {\n  margin-bottom: 0;\n}\n.cd-accordion-menu label.depth-1.group {\n  color: #222;\n  fill: #222;\n  background: #FFF;\n  box-shadow: 0 0 0 1px rgba(127, 127, 127, 0.2) inset;\n  padding-left: 38px;\n}\n.cd-accordion-menu label.depth-1.group .before {\n  left: 16px;\n}\n.cd-accordion-menu label.depth-1.group.expanded {\n  background: #555;\n}\n.cd-accordion-menu label.depth-1.group.expanded:hover {\n  background: #4f4f4f;\n}\n.cd-accordion-menu label.depth-2.group.expanded {\n  background: #767676;\n}\n.cd-accordion-menu label.depth-2.group.expanded:hover {\n  background: #707070;\n}\n.cd-accordion-menu .disabled label.depth-1.group,\n.cd-accordion-menu .disabled label.depth-2.group {\n  color: #666;\n  fill: #666;\n}\n.cd-accordion-menu label.depth-1.group.expanded,\n.cd-accordion-menu label.depth-2.group.expanded {\n  color: #FFF !important;\n  fill: #FFF !important;\n  box-shadow: none !important;\n}\n.cd-accordion-menu .selector.expanded .indicator,\n.cd-accordion-menu .depth-1.pinned .selector .indicator,\n.cd-accordion-menu .depth-2.pinned .selector .indicator {\n  color: #FFF;\n  fill: #FFF;\n}\n.cd-accordion-menu .depth-3 .selector.expanded .indicator {\n  color: inherit;\n  fill: inherit;\n}\n.cd-accordion-menu label.depth-2.group,\n.cd-accordion-menu label.depth-3.group,\n.cd-accordion-menu label.depth-4.group,\n.cd-accordion-menu label.depth-5.group,\n.cd-accordion-menu label.depth-6.group {\n  color: #222;\n  fill: #222;\n  box-shadow: 0 -1px 0 0 rgba(127, 127, 127, 0.2) inset, -1px 0 0 0 rgba(127, 127, 127, 0.2) inset, 1px 0 0 0 rgba(127, 127, 127, 0.2) inset, 0 -1px 0 0 rgba(127, 127, 127, 0.2) inset;\n}\n.cd-accordion-menu label.depth-2.group {\n  background: #e6e6e6;\n  padding-left: 56px;\n}\n.cd-accordion-menu label.depth-2.group .before {\n  left: 34px;\n}\n.cd-accordion-menu label.depth-2.group:hover {\n  background: #dfdfdf;\n}\n.cd-accordion-menu label.depth-3.group {\n  background: #ececec;\n  padding-left: 74px;\n}\n.cd-accordion-menu label.depth-3.group .before {\n  left: 52px;\n}\n.cd-accordion-menu label.depth-3.group:hover {\n  background: #e6e6e6;\n}\n.cd-accordion-menu label.depth-4.group {\n  background: #f2f2f2;\n  padding-left: 92px;\n}\n.cd-accordion-menu label.depth-4.group .before {\n  left: 70px;\n}\n.cd-accordion-menu label.depth-4.group:hover {\n  background: #ececec;\n}\n.cd-accordion-menu label.depth-5.group {\n  background: #f9f9f9;\n  padding-left: 110px;\n}\n.cd-accordion-menu label.depth-5.group .before {\n  left: 88px;\n}\n.cd-accordion-menu label.depth-5.group:hover {\n  background: #f2f2f2;\n}\n.cd-accordion-menu label.depth-6.group {\n  background: #ffffff;\n  padding-left: 128px;\n}\n.cd-accordion-menu label.depth-6.group .before {\n  left: 106px;\n}\n.cd-accordion-menu label.depth-6.group:hover {\n  background: #f9f9f9;\n}\n.cd-accordion-menu label.content {\n  padding-left: 64px;\n}\n.cd-accordion-menu .selectable label.content,\n.cd-accordion-menu .selectable label.group {\n  padding-right: 4em;\n}\n.cd-accordion-menu .content,\n.cd-accordion-menu .content label.content {\n  background: #FFFFFF !important;\n  color: #222222;\n  fill: #222222;\n}\n.cd-accordion-menu .content .selector .indicator,\n.cd-accordion-menu .content label.content .selector .indicator {\n  color: #222222;\n  fill: #222222;\n}\n.cd-accordion-menu .highlight-yellow .content,\n.cd-accordion-menu .highlight-yellow .content label.content {\n  background-color: #FCF8E3 !important;\n}\n.cd-accordion-menu .content label .before,\n.cd-accordion-menu .content label::after {\n  display: none;\n}\n.cd-accordion-menu .content label .prefix {\n  left: 6px;\n  width: 54px;\n  text-align: center;\n  display: inline-block;\n  position: absolute;\n  top: 50%;\n  -webkit-transform: translateY(-50%);\n  -moz-transform: translateY(-50%);\n  -o-transform: translateY(-50%);\n  -ms-transform: translateY(-50%);\n  transform: translateY(-50%);\n  letter-spacing: -0.8px;\n}\n.cd-accordion-menu .content .content-text {\n  padding: 18px 64px 18px 0;\n  font-size: 1.2em;\n  display: block;\n  font-weight: 400;\n}\n@media screen and (max-width: 520px) {\n  .cd-accordion-menu .content .content-text {\n    padding: 0 0.5rem 0 0;\n  }\n}\n.cd-accordion-menu .content .content-text p,\n.cd-accordion-menu .content .content-text ul li {\n  margin: 0.5em 0;\n}\n.cd-accordion-menu label::before {\n  /* this class is used if you're using jquery to animate the accordion */\n  -webkit-transition: transform 0.1s;\n  -moz-transition: transform 0.1s;\n  -ms-transition: transform 0.1s;\n  -o-transition: transform 0.1s;\n  transition: transform 0.1s;\n}\n.flavour-full.flavoured .cd-accordion-menu label.depth-1.group.expanded {\n  background: #35b8d3;\n}\n.flavour-full.flavoured .cd-accordion-menu label.depth-1.group.expanded:hover {\n  background: #2db3ce;\n}\n.flavour-full.flavoured .cd-accordion-menu label.depth-2.group.expanded {\n  background: #71c8d9;\n}\n.flavour-full.flavoured .cd-accordion-menu label.depth-2.group.expanded:hover {\n  background: #67c4d7;\n}\n.flavour-full.flavoured .cd-accordion-menu .disabled label.depth-1.group,\n.flavour-full.flavoured .cd-accordion-menu .disabled label.depth-2.group {\n  color: #666;\n  fill: #666;\n}\n.flavour-semi.flavoured .cd-accordion-menu label.depth-1.group.expanded {\n  background: #3fc599;\n}\n.flavour-semi.flavoured .cd-accordion-menu label.depth-1.group.expanded:hover {\n  background: #39be92;\n}\n.flavour-semi.flavoured .cd-accordion-menu label.depth-2.group.expanded {\n  background: #77cfb2;\n}\n.flavour-semi.flavoured .cd-accordion-menu label.depth-2.group.expanded:hover {\n  background: #6eccad;\n}\n.flavour-semi.flavoured .cd-accordion-menu .disabled label.depth-1.group,\n.flavour-semi.flavoured .cd-accordion-menu .disabled label.depth-2.group {\n  color: #666;\n  fill: #666;\n}\n.flavour-skimmed.flavoured .cd-accordion-menu label.depth-1.group.expanded {\n  background: #f1617d;\n}\n.flavour-skimmed.flavoured .cd-accordion-menu label.depth-1.group.expanded:hover {\n  background: #f05573;\n}\n.flavour-skimmed.flavoured .cd-accordion-menu label.depth-2.group.expanded {\n  background: #f3a1b1;\n}\n.flavour-skimmed.flavoured .cd-accordion-menu label.depth-2.group.expanded:hover {\n  background: #f296a8;\n}\n.flavour-skimmed.flavoured .cd-accordion-menu .disabled label.depth-1.group,\n.flavour-skimmed.flavoured .cd-accordion-menu .disabled label.depth-2.group {\n  color: #666;\n  fill: #666;\n}\n.legislation .cd-accordion-menu label.depth-1.group.expanded {\n  background: #83619C;\n}\n.legislation .cd-accordion-menu label.depth-1.group.expanded:hover {\n  background: #7c5c94;\n}\n.legislation .cd-accordion-menu label.depth-2.group.expanded {\n  background: #a28fb0;\n}\n.legislation .cd-accordion-menu label.depth-2.group.expanded:hover {\n  background: #9c88ab;\n}\n.legislation .cd-accordion-menu .disabled label.depth-1.group,\n.legislation .cd-accordion-menu .disabled label.depth-2.group {\n  color: #666;\n  fill: #666;\n}\n.legislation.flavour-archive .cd-accordion-menu label.depth-1.group.expanded {\n  background: #73797a;\n}\n.legislation.flavour-archive .cd-accordion-menu label.depth-1.group.expanded:hover {\n  background: #6d7273;\n}\n.legislation.flavour-archive .cd-accordion-menu label.depth-2.group.expanded {\n  background: #989898;\n}\n.legislation.flavour-archive .cd-accordion-menu label.depth-2.group.expanded:hover {\n  background: #919191;\n}\n.legislation.flavour-archive .cd-accordion-menu .disabled label.depth-1.group,\n.legislation.flavour-archive .cd-accordion-menu .disabled label.depth-2.group {\n  color: #666;\n  fill: #666;\n}\n.precedents .cd-accordion-menu label.depth-1.group.expanded {\n  background: #011aac;\n}\n.precedents .cd-accordion-menu label.depth-1.group.expanded:hover {\n  background: #01189f;\n}\n.precedents .cd-accordion-menu label.depth-2.group.expanded {\n  background: #0928e6;\n}\n.precedents .cd-accordion-menu label.depth-2.group.expanded:hover {\n  background: #0926da;\n}\n.precedents .cd-accordion-menu .disabled label.depth-1.group,\n.precedents .cd-accordion-menu .disabled label.depth-2.group {\n  color: #666;\n  fill: #666;\n}\n.content-review .cd-accordion-menu label .before {\n  display: none !important;\n}\n.content-review .cd-accordion-menu label {\n  cursor: default !important;\n}\n.ca .cd-accordion-menu label.depth-1,\n.ca .cd-accordion-menu label.depth-1.group.expanded {\n  background: #FFF;\n  color: #F87531 !important;\n  padding-left: 0;\n  font-size: 1.7em;\n  box-shadow: inset 0 -1px #fdd8c5 !important;\n}\n.ca .cd-accordion-menu label.depth-1:hover,\n.ca .cd-accordion-menu label.depth-1.group.expanded:hover {\n  background: #FFF;\n}\n.ca .cd-accordion-menu label.group .before {\n  display: none;\n}\n.ca .cd-accordion-menu label.selector {\n  color: #222;\n  fill: #222;\n}\n.cd-accordion-header {\n  /*position: absolute;\n  width: 96%;\n  left: 50%;\n  height: 0;\n  margin: 0;\n  max-width: @page-max-width;\n  margin-left: auto;\n  margin-right: auto;*/\n  background: transparent;\n  bottom: -3px;\n  /*.transform(translate(-50%, 0));*/\n}\n.cd-accordion-header .prefix.selectable .indicator {\n  border-bottom: 3px solid #EEE;\n  width: auto;\n  left: 50%;\n  -webkit-transform: translate(-50%, -50%);\n  -moz-transform: translate(-50%, -50%);\n  -o-transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n  transform: translate(-50%, -50%);\n}\n.cd-accordion-header .prefix.selectable .indicator::after {\n  display: none;\n}\n.cd-accordion-header .prefix.selectable.selected .indicator {\n  border-bottom: 3px solid;\n}\n.cd-accordion-header .selectable .selector {\n  height: 2.7em;\n}\n@media screen and (max-width: 520px) {\n  .cd-accordion-header .selectable .selector {\n    height: 2.1em;\n  }\n}\n.cd-accordion-header .prefix {\n  pointer-events: none;\n}\n.cd-accordion-header .cd-accordion-menu {\n  width: 100%;\n  margin: 0;\n}\n.cd-accordion-header .cd-accordion-menu .content label {\n  box-shadow: inset 0 -1px rgba(0, 0, 0, 0.2);\n}\n.cd-accordion-header .cd-list-container {\n  width: 100%;\n  /*margin: 0;\n    max-width: @page-max-width;\n    .transform(translate(0,0));\n    -webkit-transition: -webkit-transform 0.2s cubic-bezier(0.2,0.3,0.25,0.9), opacity 0.2s;\n    -moz-transition: -moz-transform 0.2s cubic-bezier(0.2,0.3,0.25,0.9), opacity 0.2s;\n    transition: transform 0.2s cubic-bezier(0.2,0.3,0.25,0.9), opacity 0.2s;*/\n  position: relative;\n  /*    top: 0;\n    left: 0;*/\n}\n.cd-accordion-header .fadeout {\n  display: none;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: #FFFFFF;\n  opacity: 0.6;\n  z-index: 2;\n}\n.cd-accordion-header.view-right {\n  /*max-width: @page-max-width !important;*/\n}\n.cd-accordion-header.view-right .cd-list-container {\n  /*width: 96%;\n      margin: auto;*/\n  -webkit-transform: translate(-700px, 0);\n  -moz-transform: translate(-700px, 0);\n  -o-transform: translate(-700px, 0);\n  -ms-transform: translate(-700px, 0);\n  transform: translate(-700px, 0);\n  pointer-events: none;\n}\n.cd-accordion-header.view-right .cd-list-container .fadeout {\n  display: block;\n}\n@media screen and (min-width: 1270px) {\n  .cd-accordion-header.view-right .cd-list-container {\n    -webkit-transform: translate(-550px, 0);\n    -moz-transform: translate(-550px, 0);\n    -o-transform: translate(-550px, 0);\n    -ms-transform: translate(-550px, 0);\n    transform: translate(-550px, 0);\n  }\n}\n@media screen and (min-width: 1570px) {\n  .cd-accordion-header.view-right .cd-list-container {\n    pointer-events: all;\n    -webkit-transform: translate(-300px, 0);\n    -moz-transform: translate(-300px, 0);\n    -o-transform: translate(-300px, 0);\n    -ms-transform: translate(-300px, 0);\n    transform: translate(-300px, 0);\n  }\n  .cd-accordion-header.view-right .cd-list-container .fadeout {\n    display: none;\n  }\n}\n@media screen and (max-width: 768px) {\n  .cd-accordion-header.view-right .cd-list-container {\n    -webkit-transform: translate(-520px, 0);\n    -moz-transform: translate(-520px, 0);\n    -o-transform: translate(-520px, 0);\n    -ms-transform: translate(-520px, 0);\n    transform: translate(-520px, 0);\n  }\n}\n@media screen and (max-width: 520px) {\n  .cd-accordion-header.view-right .cd-list-container {\n    -webkit-transform: translate(-325px, 0);\n    -moz-transform: translate(-325px, 0);\n    -o-transform: translate(-325px, 0);\n    -ms-transform: translate(-325px, 0);\n    transform: translate(-325px, 0);\n  }\n}\n.cd-accordion-header.view-left {\n  max-width: 970px !important;\n  pointer-events: none;\n}\n.cd-accordion-header.view-left .cd-list-container {\n  width: 100%;\n  margin: auto;\n  -webkit-transform: translate(300px, 0);\n  -moz-transform: translate(300px, 0);\n  -o-transform: translate(300px, 0);\n  -ms-transform: translate(300px, 0);\n  transform: translate(300px, 0);\n}\n.cd-accordion-header li label {\n  -webkit-transition: padding 0.1s;\n  -moz-transition: padding 0.1s;\n  -ms-transition: padding 0.1s;\n  -o-transition: padding 0.1s;\n  transition: padding 0.1s;\n}\n.cd-accordion-header li {\n  position: relative;\n  top: 0;\n  left: 0;\n  z-index: 2;\n}\n.cd-accordion-header li label {\n  padding-top: 7px;\n  padding-bottom: 7px;\n}\n@media screen and (max-width: 520px) {\n  .cd-accordion-header li label {\n    padding-top: 4px;\n    padding-bottom: 4px;\n  }\n}\n.cd-accordion-header .prefix {\n  padding-top: 7px;\n}\n.cd-accordion-header li:last-child {\n  z-index: 1;\n}\n@media screen and (min-width: 1270px) {\n  .has-left .cd-accordion-header.view-left,\n  .has-left .cd-accordion-header.view-main {\n    max-width: 970px !important;\n  }\n  .has-left .cd-accordion-header.view-left .cd-list-container,\n  .has-left .cd-accordion-header.view-main .cd-list-container {\n    width: 96%;\n    margin: auto;\n    -webkit-transform: translate(150px, 0);\n    -moz-transform: translate(150px, 0);\n    -o-transform: translate(150px, 0);\n    -ms-transform: translate(150px, 0);\n    transform: translate(150px, 0);\n  }\n}\n.browser-ie .cd-list-container {\n  -ms-transition: none !important;\n  transition: none !important;\n}\n.accordion-comments {\n  padding: 18px 64px 18px 64px;\n  font-size: 1.8em;\n  display: block;\n  font-weight: 400;\n}\n@media screen and (max-width: 520px) {\n  .accordion-comments {\n    font-size: 1.5em;\n    padding: 18px 0 18px 18px;\n  }\n}\n.accordion-navigator {\n  font-size: 1.4em;\n  line-height: 1.3;\n  margin: 0.6em 0 0 1em;\n}\n.accordion-navigator .navigation-group {\n  margin: 0;\n}\n.accordion-navigator .navigation-group.depth-1 {\n  margin: 0;\n  padding: 0;\n  border: none;\n}\n.accordion-navigator .navigation-group.depth-1 > .navigation-item {\n  border-left: none;\n  padding-left: 0;\n}\n.accordion-navigator .navigation-group.depth-1 > .navigation-item:before,\n.accordion-navigator .navigation-group.depth-1 > .navigation-item:after {\n  display: none;\n}\n.accordion-navigator .navigation-item {\n  padding: 0.5em 0 0em 0.7em;\n  border-left: 2px solid #FAFAFA;\n  position: relative;\n  margin-left: 3px;\n  transition: border-color 0.2s;\n}\n.accordion-navigator a {\n  color: inherit;\n  margin: 0;\n}\n.accordion-navigator .navigation-item-title {\n  display: block;\n  white-space: normal;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  padding-bottom: 0.5em;\n  color: #AAA;\n  fill: #AAA;\n}\n.accordion-navigator .navigation-item-title .prefix {\n  text-transform: uppercase;\n  font-size: 0.8em;\n  font-weight: lighter;\n  margin-right: 0.6em;\n}\n.accordion-navigator .navigation-item-title a {\n  cursor: pointer;\n  transition: color 0.2s;\n}\n.accordion-navigator .navigation-item-title a:hover {\n  text-decoration: none;\n  color: #000;\n  fill: #000;\n}\n.accordion-navigator .active > .navigation-item-title {\n  color: #000;\n  fill: #000;\n}\n.accordion-navigator .active-after.navigation-item {\n  border-color: #000;\n}\n.accordion-navigator .navigation-item:before {\n  content: \" \";\n  display: block;\n  position: absolute;\n  height: 1.3em;\n  width: 0;\n  top: 0;\n  border-left: 2px solid transparent;\n  left: -2px;\n  transition: border-color 0.2s;\n}\n.accordion-navigator .navigation-item.active:before {\n  border-left: 2px solid #000 !important;\n}\n.accordion-navigator .navigation-item:last-child {\n  border-left: 2px solid transparent;\n}\n.accordion-navigator .navigation-item:last-child:before {\n  border-left: 2px solid #FAFAFA;\n}\n.accordion-navigator .navigation-item:after {\n  content: \" \";\n  display: block;\n  position: absolute;\n  top: 1.2em;\n  height: 0;\n  width: 0.3em;\n  border-bottom: 0.2em solid transparent;\n  left: -2px;\n  transition: border-color 0.2s;\n}\n.accordion-navigator .navigation-item.active:after {\n  border-bottom-color: #000;\n}\n.key-picks.row::before {\n  content: '';\n  display: table;\n}\n.key-picks.row::after {\n  content: '';\n  display: table;\n  clear: both;\n}\n.content-view {\n  /* === Sections / Targetted Styles === */\n  /* Smaller Section styles */\n  /* Level 2 heading */\n  /* Level 3 heading */\n  /* === Typography/Headings Styles === */\n  /* Questions - Collapsable */\n  /* === Section / Level Specific Styles === */\n  /* Mobile Devices */\n}\n.content-view.table-of-contents {\n  font-size: 1.2em;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  overflow-x: hidden;\n  overflow-y: hidden;\n}\n.content-view.table-of-contents ul {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  list-style: none;\n  padding-left: 0;\n  -webkit-transition: top ease-in-out 250ms;\n  -moz-transition: top ease-in-out 250ms;\n  -ms-transition: top ease-in-out 250ms;\n  -o-transition: top ease-in-out 250ms;\n  transition: top ease-in-out 250ms;\n}\n.content-view.table-of-contents ul li {\n  padding: 0.5em 1em 0.5em 0.5em;\n  color: #AAA;\n}\n.content-view.table-of-contents ul li a {\n  display: block;\n  text-decoration: none !important;\n  color: inherit;\n}\n.content-view.table-of-contents ul li.highlight {\n  color: #000000;\n}\n.content-view.table-of-contents ul .depth-1 {\n  padding-left: 1.5em;\n  font-weight: bold;\n}\n.content-view.table-of-contents ul .depth-2 {\n  padding-left: 1.5em;\n}\n.content-view.table-of-contents ul .depth-3 {\n  padding-left: 2.5em;\n}\n.content-view.table-of-contents ul .depth-4 {\n  padding-left: 3.5em;\n}\n.content-view.table-of-contents ul .depth-5 {\n  padding-left: 4.5em;\n}\n.content-view.table-of-contents ul .depth-6 {\n  padding-left: 5.5em;\n}\n.content-view.table-of-contents ul li:last-child {\n  margin-bottom: 1em;\n}\n.content-view .lr-treeheader {\n  display: block;\n  font-size: 1.8em;\n  padding: 0.5em;\n}\n.content-view .lr-treeheader a {\n  color: #000;\n  font-weight: 600;\n}\n.content-view .lr-treeheader.lr-container {\n  box-shadow: inset 0 -1px rgba(0, 0, 0, 0.2);\n}\n.content-view .lr-treeheader.lr-container.depth-1 {\n  padding-left: 1em;\n  background: #dfdfdf;\n}\n.content-view .lr-treeheader.lr-container.depth-2 {\n  padding-left: 2em;\n  background: #e6e6e6;\n}\n.content-view .lr-treeheader.lr-container.depth-3 {\n  padding-left: 3em;\n  background: #ececec;\n}\n.content-view .lr-treeheader.lr-container.depth-4 {\n  padding-left: 4em;\n  background: #f2f2f2;\n}\n.content-view .lr-treeheader.lr-container.depth-5 {\n  padding-left: 5em;\n  background: #f9f9f9;\n}\n.content-view .lr-treeheader.lr-container.depth-6 {\n  padding-left: 6em;\n  background: #ffffff;\n}\n.content-view .lr-treeheader a.fc-question {\n  font-size: 1em;\n}\n.content-view .lr-treeheader a:hover {\n  text-decoration: underline !important;\n}\n.content-view .lr-treeheader .lr-breadcrumbs {\n  display: block;\n  font-size: 0.7em;\n  margin-top: 0.2em;\n}\n.content-view .lr-treeheader .lr-breadcrumbs a {\n  color: #006621;\n}\n.content-view .lr-treeheader .lr-breadcrumbs span + span::before {\n  content: \" > \";\n  color: #006621;\n  padding-left: 0.25rem;\n  padding-right: 0.25rem;\n}\n.content-view .lr-treeheader.lr-leaf.depth-1 {\n  margin-top: 1em;\n}\n.content-view .lr-treenode .fc-qa {\n  box-shadow: inset 0 -1px rgba(0, 0, 0, 0.2);\n}\n.content-view .ca-heading-heading {\n  display: flex;\n  flex-direction: column;\n}\n.content-view .section-heading {\n  font-weight: 700;\n  font-size: 2.4em;\n  line-height: 1.4;\n  z-index: 2;\n  position: relative;\n  background-color: #FFFFFF;\n}\n.content-view .section-heading a {\n  color: inherit;\n}\n.content-view .section-heading a:hover {\n  text-decoration: none;\n}\n@media screen and (max-width: 768px) {\n  .content-view .section-heading {\n    font-size: 2.4em;\n  }\n}\n@media screen and (max-width: 520px) {\n  .content-view .section-heading {\n    font-size: 2.2em;\n  }\n}\n.content-view .section-heading .right-align {\n  font-size: 0.6em;\n  font-weight: normal;\n  float: right;\n  color: #999;\n  fill: #999;\n  line-height: 2.6em;\n}\n.content-view .section-heading .right-align i {\n  font-size: 2em;\n  vertical-align: middle;\n}\n.content-view .section-heading .right-align a,\n.content-view .section-heading .right-align a:hover {\n  text-decoration: none;\n  display: inline;\n}\n.content-view .section-heading .right-align .svg-icon {\n  font-size: 1.4em;\n  position: relative;\n  top: 0.1em;\n  margin: 0 0.3em;\n}\n.content-view .section-heading .right-align a:hover {\n  color: #666;\n  fill: #666;\n}\n.content-view .section-heading .right-align .spacer {\n  margin: 0 1em 0 2em;\n}\n.content-view .section-heading .right-align .spacer::before {\n  content: \"|\";\n}\n.content-view .section-heading .right-align .flavoured {\n  font-weight: bold;\n}\n.content-view table:not(.tinymce-generated-content) {\n  width: 100%;\n}\n.content-view table:not(.tinymce-generated-content) td {\n  vertical-align: top;\n}\n.content-view table:not(.tinymce-generated-content) td.button {\n  width: 1em;\n  font-weight: normal;\n}\n.content-view table:not(.tinymce-generated-content) td.button a {\n  color: inherit;\n}\n.content-view table:not(.tinymce-generated-content) .align-middle {\n  vertical-align: middle;\n}\n.content-view .ca-content table {\n  width: unset;\n}\n.content-view .ca-content table td {\n  vertical-align: unset;\n}\n.content-view .checkbox-widget {\n  margin: 0;\n  font-size: 18px;\n}\n.content-view.header {\n  width: 100%;\n  background-color: #E5E5E5;\n}\n.content-view.header .container {\n  max-width: 970px;\n  width: 100%;\n  margin-left: auto;\n  margin-right: auto;\n  padding: 0;\n}\n@media screen and (max-width: 970px) {\n  .content-view.header .container {\n    width: 96%;\n  }\n}\n.content-view.header .container .fc-section-header {\n  padding-left: 0;\n  padding-right: 0;\n}\n.content-view.header .fc-section-checkbox {\n  display: block;\n  background-color: #e5e5e5;\n  font-size: 1.8em;\n  line-height: 1.1em;\n  color: #000000;\n  font-weight: 400;\n  padding: 0.5em 5px;\n}\n@media screen and (max-width: 520px) {\n  .content-view.header .fc-section-checkbox {\n    font-size: 1.5em;\n    padding: 0.5em 0;\n  }\n  .content-view.header .fc-section-checkbox table tr td.button {\n    padding: 0 5px;\n  }\n  .content-view.header .fc-section-checkbox table tr td.button.big {\n    padding: 0 5px 0 0;\n  }\n}\n.content-view.header .fc-section-checkbox table td {\n  vertical-align: middle;\n  height: inherit;\n}\n.content-view.header .fc-section-checkbox table td.button {\n  padding: 0 10px 0 5px;\n}\n.content-view.header .fc-section-checkbox table td.button.big {\n  padding: 0 5px;\n  font-size: 1.1em;\n}\n.content-view.header .fc-section-checkbox input {\n  height: 1.7em;\n  border: 1px solid #000000;\n  padding: 0 10px;\n  font-size: 0.8em;\n  margin-left: 5%;\n  width: 94%;\n  outline: none;\n  display: inline-block;\n  vertical-align: top;\n}\n.content-view .excerpt {\n  font-size: 1.8em;\n  font-weight: 200;\n  margin: 0 0 2em;\n}\n@media screen and (max-width: 520px) {\n  .content-view .excerpt {\n    padding: 0 18px;\n    font-size: 1.3em;\n  }\n}\n.content-view .navigation {\n  font-size: 1.9em;\n}\n.content-view .navigation a {\n  display: block;\n  padding: 0.3em 0.5em;\n  background: #666;\n  color: #FFF;\n  text-decoration: none;\n}\n.content-view .navigation a:focus {\n  text-decoration: none;\n}\n@media screen and (max-width: 520px) {\n  .content-view .navigation {\n    font-size: 1.4em;\n  }\n}\n.content-view .indented {\n  font-size: 7px;\n}\n.content-view .indented .node-crossheading {\n  margin-left: 2em;\n}\n.content-view .indented a {\n  color: inherit;\n  display: block;\n  text-decoration: underline;\n}\n.content-view .indented .fc-section-header {\n  padding-right: 15px;\n}\n.content-view .indented .header-depth-1 {\n  padding-left: 10px;\n}\n.content-view .indented .header-depth-2 {\n  padding-left: 20px;\n}\n.content-view .indented .header-depth-3 {\n  padding-left: 30px;\n}\n.content-view .indented .header-depth-4 {\n  padding-left: 40px;\n}\n.content-view .indented .header-depth-5 {\n  padding-left: 50px;\n}\n.content-view .indented .header-depth-6 {\n  padding-left: 60px;\n}\n@media screen and (max-width: 520px) {\n  .content-view .indented .header-depth-1 {\n    padding-left: 1em;\n  }\n  .content-view .indented .header-depth-2 {\n    padding-left: 2em;\n  }\n  .content-view .indented .header-depth-3 {\n    padding-left: 2.5em;\n    font-size: 1.5em;\n  }\n  .content-view .indented .header-depth-4 {\n    padding-left: 3em;\n  }\n  .content-view .indented .header-depth-5 {\n    padding-left: 3.5em;\n  }\n  .content-view .indented .header-depth-6 {\n    padding-left: 4em;\n  }\n}\n.content-view .padded .fc-section-header,\n.content-view .padded .fc-qa {\n  padding-left: 15px;\n  padding-right: 15px;\n}\n.content-view .fc-section-header {\n  border: none;\n  background-color: #000000;\n  margin: 0px 0;\n  line-height: 1.2em;\n  padding: 0.5em 0;\n  width: 100%;\n  margin: 0;\n}\n.content-view .fc-section-header .number {\n  display: inline-block;\n  margin-right: 1em;\n  font-size: 0.7em;\n  line-height: 1.8em;\n  vertical-align: top;\n  text-transform: uppercase;\n}\n.content-view .fc-section-header.header-depth-1 {\n  border-bottom: none;\n  font-size: 3.0em;\n  color: #FFFFFF;\n}\n.content-view .fc-section-header.header-depth-1 table td.button {\n  color: #FFFFFF;\n}\n.content-view .fc-section-header.header-depth-2 {\n  background-color: #E5E5E5;\n  border-bottom: none;\n  font-weight: 500;\n  font-size: 2.6em;\n}\n.content-view .fc-section-header.header-depth-3 {\n  background-color: #fff;\n  color: #002a5b;\n  border-bottom: 1px solid #E5E5E5;\n  font-size: 2.4em;\n}\n.content-view .fc-section-header.header-depth-4 {\n  background-color: #fff;\n  color: #002a5b;\n  border-bottom: 1px solid #E5E5E5;\n  font-size: 2.2em;\n}\n.content-view .fc-section-header.header-depth-5 {\n  background-color: #fff;\n  color: #002a5b;\n  font-size: 2.0em;\n}\n.content-view .fc-section-header.header-depth-6 {\n  background-color: #fff;\n  color: #002a5b;\n  font-size: 2.0em;\n}\n@media screen and (max-width: 520px) {\n  .content-view .fc-section-header.header-depth-1 {\n    font-size: 2em;\n  }\n  .content-view .fc-section-header.header-depth-2 {\n    font-size: 1.8em;\n  }\n  .content-view .fc-section-header.header-depth-3 {\n    font-size: 1.7em;\n  }\n  .content-view .fc-section-header.header-depth-4 {\n    font-size: 1.6em;\n  }\n  .content-view .fc-section-header.header-depth-5 {\n    font-size: 1.5em;\n  }\n  .content-view .fc-section-header.header-depth-6 {\n    font-size: 1.4em;\n  }\n}\n.content-view .space-maker {\n  opacity: 0;\n}\n.content-view > .fc-section-tree {\n  margin-top: 9px;\n}\n.content-view .small-sections .fc-section-header h1,\n.content-view .small-sections .fc-section-header h2,\n.content-view .small-sections .fc-section-header h3 {\n  line-height: 55px;\n  font-size: 30px;\n}\n.content-view .small-sections .fc-section-header h3,\n.content-view .small-sections .fc-section-header h4,\n.content-view .small-sections .fc-section-header h5 {\n  padding: 0px;\n}\n.content-view .small-sections .pull-right {\n  height: 55px;\n}\n.content-view .fc-section-body .fc-section-header,\n.content-view .panel {\n  background-color: #E5E5E5;\n}\n.content-view .fc-section-tree .fc-section-children .fc-section-body .fc-section-header {\n  background-color: #fff;\n  color: #002a5b;\n}\n.content-view h3,\n.content-view h4,\n.content-view h5,\n.content-view h6 {\n  color: #2c2e83;\n}\n.content-view h1 {\n  font-size: 3.6em;\n  line-height: 40px;\n  padding: 19px 0px 21px 0;\n}\n.content-view h2 {\n  font-size: 3.4em;\n  line-height: 41px;\n}\n.content-view h3 {\n  font-size: 2.8em;\n  line-height: 33px;\n}\n.content-view h4 {\n  font-size: 2.4em;\n  line-height: 28px;\n}\n.content-view h5 {\n  font-size: 2.2em;\n  line-height: 26px;\n}\n.content-view h6 {\n  font-size: 2.0em;\n  line-height: 24px;\n}\n.content-view section h1 {\n  font-size: 3em;\n}\n.content-view ol:not(.tinymce-generated-content) {\n  counter-reset: li;\n}\n.content-view ol:not(.tinymce-generated-content) > li {\n  position: relative;\n  list-style: none;\n  margin-bottom: 0.2em;\n}\n.content-view ol:not(.tinymce-generated-content) > li::before {\n  content: \"(\" counter(li, lower-alpha) \")\";\n  counter-increment: li;\n  position: absolute;\n  left: -2em;\n  font-size: 0.9em;\n  line-height: 1.7em;\n  color: #444;\n}\n.content-view ol:not(.tinymce-generated-content) ol li::before {\n  content: \"(\" counter(li, lower-roman) \")\";\n}\n.content-view .ca-content ol:not(.tinymce-generated-content) > li {\n  list-style: inherit;\n}\n.content-view .ca-content ol:not(.tinymce-generated-content) > li::before {\n  content: none;\n}\n.content-view .ca-content ol:not(.tinymce-generated-content) ol li::before {\n  content: none;\n}\n.content-view .capitalize::first-letter {\n  text-transform: uppercase;\n}\n.content-view .no-border {\n  border: none !important;\n}\n.content-view .fc-qa {\n  padding: 0.7em 2.0em 0.8em 0;\n}\n@media screen and (max-width: 520px) {\n  .content-view .fc-qa {\n    padding: 0.7em 0.5em 0.8em 0;\n  }\n}\n.content-view .fc-qa.expanded {\n  border-bottom: 1px solid #e5e5e5;\n}\n.content-view .fc-qa:last-child {\n  padding-bottom: 2em;\n}\n@media screen and (max-width: 520px) {\n  .content-view .fc-qa:last-child {\n    padding-bottom: 0;\n  }\n}\n.content-view .fc-qa:last-child .fc-answer {\n  border-bottom: none;\n  margin-bottom: 0px;\n}\n.content-view .fc-qa:first-child {\n  padding-top: 1.5em;\n}\n@media screen and (max-width: 520px) {\n  .content-view .fc-qa:first-child {\n    padding-top: 1em;\n  }\n}\n.content-view .fc-qa.selected:last-child {\n  border-bottom: none;\n}\n.content-view .fc-qa.selected + .fc-qa {\n  margin-top: 8px;\n}\n.content-view .fc-qa.selected.highlight {\n  margin: 8px 0;\n  border-left: 8px solid #e5e5e5;\n  padding-left: 10px;\n}\n.content-view .fc-qa table td.button,\n.content-view .fc-section-header table td.button {\n  font-size: 18px;\n  color: #000000;\n  padding: 0 11px;\n}\n@media screen and (max-width: 520px) {\n  .content-view .fc-qa table td.button,\n  .content-view .fc-section-header table td.button {\n    padding: 0 5px;\n  }\n}\n.content-view .fc-answer.section-content {\n  font-size: 1.6em;\n}\n@media screen and (max-width: 520px) {\n}\n.content-view .fc-em {\n  font-style: italic;\n}\n.content-view .fc-p,\n.content-view .fc-indent {\n  padding-left: 2.2em;\n  display: block;\n  position: relative;\n  top: 0;\n  left: 0;\n  margin: 0.5em 0;\n}\n.content-view .fc-p .reference,\n.content-view .fc-indent .reference,\n.content-view .fc-p .fc-reference,\n.content-view .fc-indent .fc-reference {\n  position: absolute;\n  top: 0;\n  left: 0.2em;\n  color: inherit;\n  display: block;\n  font-size: 0.9em;\n  line-height: 1.7em;\n  font-weight: normal;\n}\n.content-view .fc-p .reference .fc-stacked-reference-2,\n.content-view .fc-indent .reference .fc-stacked-reference-2,\n.content-view .fc-p .fc-reference .fc-stacked-reference-2,\n.content-view .fc-indent .fc-reference .fc-stacked-reference-2 {\n  position: absolute;\n  left: -2.6em;\n}\n.content-view .fc-p .reference .fc-stacked-reference-3,\n.content-view .fc-indent .reference .fc-stacked-reference-3,\n.content-view .fc-p .fc-reference .fc-stacked-reference-3,\n.content-view .fc-indent .fc-reference .fc-stacked-reference-3 {\n  position: absolute;\n  left: -5.2em;\n}\n.content-view .fc-p .reference .fc-stacked-reference-4,\n.content-view .fc-indent .reference .fc-stacked-reference-4,\n.content-view .fc-p .fc-reference .fc-stacked-reference-4,\n.content-view .fc-indent .fc-reference .fc-stacked-reference-4 {\n  position: absolute;\n  left: -7.8em;\n}\n.content-view .fc-p.mark,\n.content-view .fc-indent.mark {\n  background-color: #FCF8E3;\n  padding: 0 0 0 2.2em;\n}\n@media screen and (max-width: 520px) {\n  .content-view .fc-p,\n  .content-view .fc-indent {\n    padding-left: 1.3em;\n  }\n  .content-view .fc-p .reference,\n  .content-view .fc-indent .reference,\n  .content-view .fc-p .fc-reference,\n  .content-view .fc-indent .fc-reference {\n    left: 0;\n  }\n  .content-view .fc-p .reference .fc-stacked-reference-2,\n  .content-view .fc-indent .reference .fc-stacked-reference-2,\n  .content-view .fc-p .fc-reference .fc-stacked-reference-2,\n  .content-view .fc-indent .fc-reference .fc-stacked-reference-2 {\n    position: absolute;\n    left: -1.6em;\n  }\n  .content-view .fc-p .reference .fc-stacked-reference-3,\n  .content-view .fc-indent .reference .fc-stacked-reference-3,\n  .content-view .fc-p .fc-reference .fc-stacked-reference-3,\n  .content-view .fc-indent .fc-reference .fc-stacked-reference-3 {\n    position: absolute;\n    left: -3.2em;\n  }\n  .content-view .fc-p .reference .fc-stacked-reference-4,\n  .content-view .fc-indent .reference .fc-stacked-reference-4,\n  .content-view .fc-p .fc-reference .fc-stacked-reference-4,\n  .content-view .fc-indent .fc-reference .fc-stacked-reference-4 {\n    position: absolute;\n    left: -4.8em;\n  }\n}\n.content-view .fc-indent {\n  margin-left: 2.2em;\n}\n.content-view .fc-indent .fc-indent {\n  margin-left: 0;\n}\n.content-view .fc-amend {\n  display: block;\n  position: relative;\n  margin: 2em 0;\n  padding-left: 1em;\n  border-left: 3px solid #EEEEEE;\n}\n.content-view .fc-amend .fc-crossheading > .fc-title {\n  font-weight: bold;\n  margin: 0 0 1em -1em;\n}\n.content-view .fc-amend .fc-schedule {\n  padding-left: 2.2em;\n  position: relative;\n}\n.content-view .fc-amend .fc-schedule .fc-title {\n  margin: 0 0 0 1em;\n}\n.content-view .fc-amend .fc-schedule .fc-part {\n  display: block;\n}\n.content-view .fc-amend .fc-schedule > .reference {\n  left: -1em;\n  font-weight: bold;\n  font-size: 0.8em;\n  line-height: 1.7em;\n}\n.content-view .fc-amend .fc-crossheading,\n.content-view .fc-amend .fc-section,\n.content-view .fc-amend .fc-part,\n.content-view .fc-amend .fc-chapter {\n  padding-left: 2.2em;\n  position: relative;\n}\n.content-view .fc-amend .fc-crossheading > .reference,\n.content-view .fc-amend .fc-section > .reference,\n.content-view .fc-amend .fc-part > .reference,\n.content-view .fc-amend .fc-chapter > .reference {\n  left: -1em;\n  font-weight: bold;\n  font-size: 0.8em;\n  line-height: 1.7em;\n}\n.content-view .fc-amend .fc-section {\n  display: block;\n}\n.content-view .fc-title {\n  font-weight: bold;\n  position: relative;\n}\n.content-view .fc-title .reference {\n  display: inline-block;\n  position: relative;\n  margin-left: -2em;\n  margin-right: 0.5em;\n  font-size: 1em;\n  font-weight: bold;\n}\n.content-view .fc-table {\n  display: table;\n  padding: 0 2em;\n  margin: 1em 0 3em;\n  width: 100%;\n}\n.content-view .fc-table .fc-tr {\n  display: table-row;\n}\n.content-view .fc-table .fc-td {\n  display: table-cell;\n  padding: 0.2em 1em;\n}\n.content-view .fc-table .fc-td > .fc-p {\n  padding-left: 0;\n}\n.content-view .fc-section-qas {\n  border-bottom: 1px solid #E5E5E5;\n}\n.content-view .fc-question {\n  display: table-row;\n  color: #1460d1;\n  font-size: 1.8em;\n  padding: 11px 0px 0px 0px;\n  line-height: 1.3em;\n  margin-bottom: 0px;\n  /*25*/\n  font-weight: 700;\n  text-decoration: none !important;\n}\n.content-view .fc-question .fc-question-number {\n  vertical-align: top;\n  display: table-cell;\n  white-space: nowrap;\n  padding-right: 0.4em;\n}\n.content-view .fc-question .fc-question {\n  vertical-align: top;\n  display: table-cell;\n  font-size: 1em;\n  padding: 0;\n}\n.content-view .fc-question .fc-question-number,\n.content-view .fc-question .fc-question {\n  padding-top: 0.1em;\n}\n@media screen and (max-width: 768px) {\n  .content-view .fc-question .fc-question-number,\n  .content-view .fc-question .fc-question {\n    padding-top: 0.3em;\n  }\n}\n.content-view .fc-question .path {\n  font-weight: normal;\n  font-size: 0.75em;\n  color: #006621;\n  margin: 0.5em 0 0;\n}\n.content-view .fc-question .path span + span:before {\n  content: \" > \";\n  color: #006621;\n}\n.content-view .row .col-fluid {\n  display: table-cell;\n  vertical-align: top;\n  width: 100%;\n  padding: 0 17px;\n}\n.content-view .row .col-checkbox {\n  display: table-cell;\n  vertical-align: top;\n}\n.content-view .row .col-checkbox:first-child {\n  padding: 0 0 0 17px;\n}\n.content-view .row .col-checkbox:last-child {\n  padding: 0 17px 0 0;\n}\n@media screen and (max-width: 768px) {\n  .content-view .row .col-checkbox:last-child {\n    padding-right: 8px;\n  }\n  .content-view .row .col-checkbox:first-child {\n    padding-left: 8px;\n  }\n  .content-view .row .col-fluid {\n    padding: 0 8px;\n  }\n}\n.content-view .fc-qa.review,\n.content-view .fc-section-header.review {\n  padding-left: 18px;\n}\n.content-view .fc-answer.collapse.in {\n  margin-bottom: 8px;\n}\n.content-view .fc-answer {\n  display: block;\n  padding-bottom: 0.8em;\n}\n.content-view .fc-answer p {\n  margin: 0.5em 0;\n}\n.content-view .fc-answer p:last-child {\n  margin-bottom: 0;\n}\n.content-view .fc-answer ol {\n  list-style-type: lower-alpha;\n  padding-left: 2em;\n  margin-bottom: 0px;\n}\n.content-view .fc-answer ol ol {\n  list-style-type: lower-roman;\n}\n.content-view .fc-answer a {\n  overflow: hidden;\n  display: inline;\n  vertical-align: top;\n}\n.content-view .fc-answer-wrap p,\n.content-view .fc-glossary,\n.content-view .fc-legislation {\n  font-weight: 400;\n  color: #231F20;\n  font-size: 1em;\n}\n.content-view .fc-legislation {\n  border-bottom: 1px dashed #A6A6A6;\n  top: 0;\n  left: 0;\n  outline: none;\n  cursor: pointer;\n}\n.content-view .fc-legislation .fc-reference,\n.content-view .fc-legislation .fc-labels {\n  display: none;\n}\n.content-view .fc-legislation .fc-glossary {\n  border-bottom: none;\n}\n.content-view .legislation-reference-title {\n  width: 100%;\n}\n.content-view .legislation-reference-title td.title {\n  max-width: 0;\n  padding-bottom: 0.4em;\n}\n.content-view .legislation-reference-title a {\n  text-overflow: ellipsis;\n  display: block;\n  white-space: nowrap;\n  overflow: hidden;\n}\n.content-view .legislation-reference-body {\n  position: absolute;\n  overflow-x: hidden;\n  overflow-y: scroll;\n  -ms-overflow-style: -ms-autohiding-scrollbar;\n  bottom: 0;\n  top: 6em;\n  z-index: 1;\n  padding-right: 10px;\n  right: 0;\n  left: 15px;\n}\n.content-view .legislation-reference-body .fc-section-body .fc-section-header {\n  background: none;\n  border-bottom: none;\n}\n.content-view .legislation-reference-body .fc-section-body .header-depth-2 {\n  font-size: 1.8em;\n  font-weight: bold;\n}\n.content-view .legislation-reference-body .fc-section-body .header-depth-3 {\n  font-size: 1.8em;\n  font-weight: bold;\n}\n.content-view .legislation-reference-body .fc-section-body .header-depth-4 {\n  font-size: 1.8em;\n  margin-left: 1em;\n}\n.content-view .legislation-reference-body .fc-section-qas {\n  border-bottom: none;\n}\n.content-view .legislation-reference-body .fc-section-qas .fc-qa {\n  border-bottom: none;\n  padding: 0 !important;\n}\n@media screen and (max-width: 768px) {\n  .content-view .legislation-reference-body {\n    top: 6em;\n  }\n}\n.content-view .fc-answer-wrap ul,\n.content-view .fc-answer-wrap ol {\n  font-weight: 400;\n}\n.content-view .fc-glossary {\n  white-space: nowrap;\n  border-bottom: 1px dashed #A6A6A6;\n  top: 0;\n  left: 0;\n  outline: none;\n  cursor: pointer;\n}\n.content-view .fc-glossary.focus {\n  position: relative;\n}\n@media screen and (max-width: 520px) {\n  .content-view .fc-glossary.focus {\n    background: #DDDDDD;\n  }\n}\n.content-view a.fc-cross-reference {\n  color: #1460D1;\n  cursor: pointer;\n  display: inline;\n}\n.content-view a.fc-cross-reference:hover {\n  text-decoration: underline;\n}\n.content-view li p {\n  margin-bottom: 0px;\n}\n.content-view p {\n  margin-bottom: 9px;\n}\n.content-view p a {\n  color: #1460D1;\n}\n.content-view .fc-legislation-reference,\n.content-view .fc-legislation-reference-range,\n.content-view .fc-canonical-case-reference {\n  display: none;\n  visibility: hidden;\n}\n.content-view .fc-case-reference {\n  font-weight: bold;\n}\n.content-view .popover {\n  max-width: 300px;\n}\n.content-view .fc-partialnote,\n.content-view .fc-jurisdictionnote {\n  font-size: 0.8em;\n  font-style: italic;\n  color: #555;\n  display: inline-block;\n  font-weight: normal;\n  padding: 0.4em 1em;\n  background: #EEE;\n}\n@media screen and (max-width: 768px) {\n  .content-view {\n    /* Targetted */\n  }\n  .content-view h1,\n  .content-view .fc-section-header h1 {\n    font-size: 1.7em;\n  }\n  .content-view .fc-section-header h2 {\n    font-size: 1.8em;\n  }\n  .content-view .fc-section-header h3 {\n    font-size: 1.7em;\n  }\n  .content-view .fc-section-header h4 {\n    font-size: 1.6em;\n  }\n  .content-view .fc-section-header h5 {\n    font-size: 1.6em;\n  }\n  .content-view .fc-section-header h6 {\n    font-size: 1.6em;\n  }\n  .content-view .fc-question {\n    padding-left: 0px;\n    padding-right: 20px;\n    font-size: 1.4em;\n  }\n  .content-view .fc-answer > p {\n    padding-left: 0px;\n    padding-right: 20px;\n  }\n  .content-view .fc-answer ol {\n    padding-left: 1.5em;\n    padding-right: 1.5em;\n    margin-bottom: 1em;\n  }\n  .content-view > section > .fc-section-body > .fc-section-children > section > .fc-section-body > .fc-section-children > section > .fc-section-header h3 {\n    padding: 12px 1px 12px 0px;\n  }\n}\n.content-view .reference-range {\n  font-size: 14px;\n}\n@media screen and (max-width: 520px) {\n  .content-view .reference-range {\n    font-size: 11px;\n  }\n}\n@media screen and (max-width: 520px) {\n  .content-view .fc-answer ol {\n    padding-left: 18px;\n  }\n  .content-view .fc-qa:last-child {\n    margin-bottom: 16px;\n  }\n  .content-view .fc-qa:last-child .fc-answer-wrap {\n    padding-bottom: 0px;\n  }\n}\n.content-view.content-review .fc-answer-wrap {\n  font-size: 1.8em;\n  margin: 1.4em 0 0;\n  display: block;\n}\n.content-view .copyright-footer {\n  font-size: 1.4em;\n  line-height: 1.3;\n  padding: 1.5em 2em;\n  color: #888;\n}\n.content-view .large {\n  font-size: 1.8em;\n}\n.content-view .content-text > :not(.ca-content) table:not(.tinymce-generated-content),\n.content-view .content-text > table:not(.tinymce-generated-content) {\n  border-spacing: 1.5em;\n  border-collapse: separate;\n  margin: 0 -1.5em;\n}\n.content-view .content-text [class^=\"icon-bottle\"] {\n  font-size: 1.5em;\n  vertical-align: sub;\n}\n.content-view .bottle-icon {\n  display: inline-block;\n  vertical-align: middle;\n  width: 2.4em;\n  height: 2.4em;\n  background-size: 2.4em !important;\n}\n.content-view .nowrap {\n  white-space: nowrap;\n}\nspan.wj {\n  font-size: 0 !important;\n}\n.flavour-full .section-heading .right-align .flavoured,\n.color-full {\n  color: #35b8d3;\n  fill: #35b8d3;\n}\n.flavour-full .section-heading .right-align .flavoured.active,\n.color-full.active {\n  color: #FFFFFF;\n  fill: #FFFFFF;\n}\n.flavour-semi .section-heading .right-align .flavoured,\n.color-semi {\n  color: #3fc599;\n  fill: #3fc599;\n}\n.flavour-semi .section-heading .right-align .flavoured.active,\n.color-semi.active {\n  color: #FFFFFF;\n  fill: #FFFFFF;\n}\n.flavour-skimmed .section-heading .right-align .flavoured,\n.color-skimmed {\n  color: #f1617d;\n  fill: #f1617d;\n}\n.flavour-skimmed .section-heading .right-align .flavoured.active,\n.color-skimmed.active {\n  color: #FFFFFF;\n  fill: #FFFFFF;\n}\n.flavour-archive .section-heading .right-align .flavoured,\n.color-archive {\n  color: #73797a;\n  fill: #73797a;\n}\n.flavour-archive .section-heading .right-align .flavoured.active,\n.color-archive.active {\n  color: #FFFFFF;\n  fill: #FFFFFF;\n}\n.color-legislation {\n  color: #83619C;\n  fill: #83619C;\n}\n.color-legislation.active {\n  color: #FFFFFF;\n  fill: #FFFFFF;\n}\n.content-depth {\n  font-size: 1em;\n  color: #FFF;\n  margin-right: 0.2em;\n  margin-left: 1em;\n}\n.content-depth .content-depth-text {\n  display: inline-block;\n  vertical-align: middle;\n}\n.content-depth .desc {\n  color: #666;\n}\n.content-depth i {\n  font-size: 1.7em !important;\n  vertical-align: sub;\n}\n.content-depth.full {\n  color: #35b8d3;\n}\n.content-depth.semi {\n  color: #3fc599;\n}\n.content-depth.skimmed {\n  color: #f1617d;\n}\n.popover-container {\n  font-size: 1.6em;\n}\n.popover-container .popover {\n  margin-top: 10px;\n  max-width: 450px;\n  font-size: 0.8em;\n  -webkit-transition: opacity 0.2s;\n  -moz-transition: opacity 0.2s;\n  -ms-transition: opacity 0.2s;\n  -o-transition: opacity 0.2s;\n  transition: opacity 0.2s;\n}\n.popover-container .popover p {\n  margin: 0;\n}\n.popover-container .popover p + p {\n  margin: 1em 0 0;\n}\n@media screen and (max-width: 520px) {\n  .popover-container .popover {\n    font-size: 1em;\n  }\n}\n.popover-container .popover.show {\n  opacity: 1;\n}\n.popover-container .popover.show.fade-leave-active {\n  opacity: 0;\n}\n.comment-body .public-DraftEditor-content h1,\n.comment-body .content-view h1 {\n  font-size: 1.4em;\n  font-weight: normal;\n  margin: 0 0 0.3em;\n  padding: 0;\n  line-height: normal;\n}\n.comment-body .public-DraftEditor-content h2,\n.comment-body .content-view h2,\n.comment-body .public-DraftEditor-content h3,\n.comment-body .content-view h3,\n.comment-body .public-DraftEditor-content h4,\n.comment-body .content-view h4,\n.comment-body .public-DraftEditor-content h5,\n.comment-body .content-view h5,\n.comment-body .public-DraftEditor-content h6,\n.comment-body .content-view h6 {\n  font-size: 1.2em;\n  font-weight: normal;\n  margin: 0 0 0.4em 0.8em;\n  padding: 0;\n  line-height: normal;\n}\n.comment-body .public-DraftEditor-content p,\n.comment-body .content-view p,\n.comment-body .public-DraftEditor-content .paragraph,\n.comment-body .content-view .paragraph {\n  margin: 0 0 0.5em 1em;\n}\n.comment-body .public-DraftEditor-content ol,\n.comment-body .content-view ol,\n.comment-body .public-DraftEditor-content ul,\n.comment-body .content-view ul {\n  margin-left: 0.5em;\n}\n.comment-body .public-DraftEditor-content ol li::before,\n.comment-body .content-view ol li::before {\n  content: \"(\" counter(li) \")\";\n}\n.comment-body .public-DraftEditor-content .paragraph {\n  margin: 0 0 0.5rem 0;\n}\n.svg-base {\n  display: inline-block;\n  line-height: 1;\n}\n.svg-base svg {\n  fill: currentColor;\n  vertical-align: middle;\n  width: 100%;\n  height: 100%;\n}\n.svg-base svg g {\n  stroke: currentColor;\n}\n.svg-base svg path {\n  fill: inherit;\n}\n.icon-base {\n  position: relative;\n  height: auto;\n}\n.icon-base svg {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  left: 0;\n}\n.icon-base:after {\n  content: \"\";\n  display: block;\n  padding-bottom: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
